(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[1498],{

/***/ 65171:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ button_button)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(81724);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button/styled-components.js
var styled_components = __webpack_require__(64823);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button/utils.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function getSharedProps(_ref) {
  var disabled = _ref.disabled,
      isLoading = _ref.isLoading,
      isSelected = _ref.isSelected,
      kind = _ref.kind,
      shape = _ref.shape,
      size = _ref.size;
  return {
    $disabled: disabled,
    $isLoading: isLoading,
    $isSelected: isSelected,
    $kind: kind,
    $shape: shape,
    $size: size
  };
}
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/index.js
var react_is = __webpack_require__(17020);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/helpers/overrides.js
var helpers_overrides = __webpack_require__(78803);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button/button-internals.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/






function RenderEnhancer(props) {
  var Enhancer = props.Enhancer,
      restProps = _objectWithoutProperties(props, ["Enhancer"]);

  if (typeof Enhancer === 'string') {
    return Enhancer;
  }

  if (react_is.isValidElementType(Enhancer)) {
    // $FlowFixMe
    return /*#__PURE__*/react.createElement(Enhancer, restProps);
  } // $FlowFixMe


  return Enhancer;
}

function ButtonInternals(props) {
  var children = props.children,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      startEnhancer = props.startEnhancer,
      endEnhancer = props.endEnhancer;

  var _getOverrides = (0,helpers_overrides/* getOverrides */._O)(overrides.StartEnhancer, styled_components/* StartEnhancer */.$w),
      _getOverrides2 = _slicedToArray(_getOverrides, 2),
      StartEnhancer = _getOverrides2[0],
      startEnhancerProps = _getOverrides2[1];

  var _getOverrides3 = (0,helpers_overrides/* getOverrides */._O)(overrides.EndEnhancer, styled_components/* EndEnhancer */.IY),
      _getOverrides4 = _slicedToArray(_getOverrides3, 2),
      EndEnhancer = _getOverrides4[0],
      endEnhancerProps = _getOverrides4[1];

  var sharedProps = getSharedProps(props);
  return /*#__PURE__*/react.createElement(react.Fragment, null, startEnhancer !== null && startEnhancer !== undefined && /*#__PURE__*/react.createElement(StartEnhancer, _extends({}, sharedProps, startEnhancerProps), /*#__PURE__*/react.createElement(RenderEnhancer, {
    Enhancer: startEnhancer
  })), children, endEnhancer !== null && endEnhancer !== undefined && /*#__PURE__*/react.createElement(EndEnhancer, _extends({}, sharedProps, endEnhancerProps), /*#__PURE__*/react.createElement(RenderEnhancer, {
    Enhancer: endEnhancer
  })));
}
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button/constants.js
var constants = __webpack_require__(83712);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button/default-props.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

var defaultProps = {
  disabled: false,
  isLoading: false,
  isSelected: false,
  kind: constants/* KIND */.Nd.primary,
  overrides: {},
  shape: constants/* SHAPE */.IW.default,
  size: constants/* SIZE */.SK.default
};
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/utils/focusVisible.js
var focusVisible = __webpack_require__(7714);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button/button.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function button_extends() { button_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return button_extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function button_slicedToArray(arr, i) { return button_arrayWithHoles(arr) || button_iterableToArrayLimit(arr, i) || button_unsupportedIterableToArray(arr, i) || button_nonIterableRest(); }

function button_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function button_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return button_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return button_arrayLikeToArray(o, minLen); }

function button_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function button_iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function button_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function button_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = button_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function button_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/








var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isFocusVisible: false
    });

    _defineProperty(_assertThisInitialized(_this), "internalOnClick", function () {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          onClick = _this$props.onClick;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (isLoading) {
        args[0].preventDefault();
        return;
      }

      onClick && onClick.apply(void 0, args);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      if ((0,focusVisible/* isFocusVisible */.pP)(event)) {
        _this.setState({
          isFocusVisible: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }
    });

    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _ref;

      var _this$props2 = this.props,
          _this$props2$override = _this$props2.overrides,
          overrides = _this$props2$override === void 0 ? {} : _this$props2$override,
          size = _this$props2.size,
          kind = _this$props2.kind,
          shape = _this$props2.shape,
          isLoading = _this$props2.isLoading,
          isSelected = _this$props2.isSelected,
          startEnhancer = _this$props2.startEnhancer,
          endEnhancer = _this$props2.endEnhancer,
          children = _this$props2.children,
          forwardedRef = _this$props2.forwardedRef,
          restProps = button_objectWithoutProperties(_this$props2, ["overrides", "size", "kind", "shape", "isLoading", "isSelected", "startEnhancer", "endEnhancer", "children", "forwardedRef"]); // Get overrides


      var _getOverrides = (0,helpers_overrides/* getOverrides */._O)( // adding both (1) BaseButton and (2) Root
      // (1) because it's a Button under the hood
      // (2) because we want consistency with the rest of the components
      overrides.BaseButton || overrides.Root, styled_components/* BaseButton */.SC),
          _getOverrides2 = button_slicedToArray(_getOverrides, 2),
          BaseButton = _getOverrides2[0],
          baseButtonProps = _getOverrides2[1];

      var _getOverrides3 = (0,helpers_overrides/* getOverrides */._O)(overrides.LoadingSpinner, styled_components/* LoadingSpinner */.kt),
          _getOverrides4 = button_slicedToArray(_getOverrides3, 2),
          LoadingSpinner = _getOverrides4[0],
          loadingSpinnerProps = _getOverrides4[1];

      var _getOverrides5 = (0,helpers_overrides/* getOverrides */._O)(overrides.LoadingSpinnerContainer, styled_components/* LoadingSpinnerContainer */.NF),
          _getOverrides6 = button_slicedToArray(_getOverrides5, 2),
          LoadingSpinnerContainer = _getOverrides6[0],
          loadingSpinnerContainerProps = _getOverrides6[1];

      var sharedProps = _objectSpread(_objectSpread({}, getSharedProps(this.props)), {}, {
        $isFocusVisible: this.state.isFocusVisible
      });

      return /*#__PURE__*/react.createElement(BaseButton, button_extends({
        ref: forwardedRef,
        "data-baseweb": "button"
      }, isLoading ? (_ref = {}, _defineProperty(_ref, 'aria-label', "loading ".concat(typeof this.props.children === 'string' ? this.props.children : '')), _defineProperty(_ref, 'aria-busy', 'true'), _ref) : {}, sharedProps, restProps, baseButtonProps, {
        // Applies last to override passed in onClick
        onClick: this.internalOnClick,
        onFocus: (0,focusVisible/* forkFocus */.pL)(_objectSpread(_objectSpread({}, restProps), baseButtonProps), this.handleFocus),
        onBlur: (0,focusVisible/* forkBlur */.iw)(_objectSpread(_objectSpread({}, restProps), baseButtonProps), this.handleBlur)
      }), isLoading ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
        style: {
          opacity: 0,
          display: 'flex',
          height: '0px'
        }
      }, /*#__PURE__*/react.createElement(ButtonInternals, this.props)), /*#__PURE__*/react.createElement(LoadingSpinnerContainer, button_extends({}, sharedProps, loadingSpinnerContainerProps), /*#__PURE__*/react.createElement(LoadingSpinner, button_extends({}, sharedProps, loadingSpinnerProps)))) : /*#__PURE__*/react.createElement(ButtonInternals, this.props));
    }
  }]);

  return Button;
}(react.Component);

_defineProperty(Button, "defaultProps", defaultProps);

var ForwardedButton = /*#__PURE__*/react.forwardRef(function (props, ref) {
  return /*#__PURE__*/react.createElement(Button, button_extends({
    forwardedRef: ref
  }, props));
});
ForwardedButton.displayName = 'Button';
/* harmony default export */ const button_button = (ForwardedButton);

/***/ }),

/***/ 83712:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   IW: () => (/* binding */ SHAPE),
/* harmony export */   Nd: () => (/* binding */ KIND),
/* harmony export */   SK: () => (/* binding */ SIZE)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var KIND = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  minimal: 'minimal'
};
var SHAPE = {
  default: 'default',
  pill: 'pill',
  round: 'round',
  circle: 'circle',
  square: 'square'
};
var SIZE = {
  mini: 'mini',
  default: 'default',
  compact: 'compact',
  large: 'large'
};

/***/ }),

/***/ 64823:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $w: () => (/* binding */ StartEnhancer),
/* harmony export */   IY: () => (/* binding */ EndEnhancer),
/* harmony export */   NF: () => (/* binding */ LoadingSpinnerContainer),
/* harmony export */   SC: () => (/* binding */ BaseButton),
/* harmony export */   kt: () => (/* binding */ LoadingSpinner)
/* harmony export */ });
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89944);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83712);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


var BaseButton = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)('button', function (_ref) {
  var $theme = _ref.$theme,
      $size = _ref.$size,
      $kind = _ref.$kind,
      $shape = _ref.$shape,
      $isLoading = _ref.$isLoading,
      $isSelected = _ref.$isSelected,
      $disabled = _ref.$disabled,
      $isFocusVisible = _ref.$isFocusVisible;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    display: 'inline-flex',
    // need to maintain button width while showing loading spinner
    flexDirection: $isLoading ? 'column' : 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftStyle: 'none',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    outline: 'none',
    boxShadow: $isFocusVisible ? "inset 0 0 0 3px ".concat($theme.colors.accent) : 'none',
    textDecoration: 'none',
    WebkitAppearance: 'none',
    transitionProperty: 'background',
    transitionDuration: $theme.animation.timing200,
    transitionTimingFunction: $theme.animation.linearCurve,
    cursor: 'pointer',
    ':disabled': {
      cursor: 'not-allowed',
      backgroundColor: $theme.colors.buttonDisabledFill,
      color: $theme.colors.buttonDisabledText
    },
    marginLeft: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0
  }, getFontStyles({
    $theme: $theme,
    $size: $size
  })), getBorderRadiiStyles({
    $theme: $theme,
    $size: $size,
    $shape: $shape
  })), getPaddingStyles({
    $theme: $theme,
    $size: $size,
    $shape: $shape
  })), getKindStyles({
    $theme: $theme,
    $kind: $kind,
    $isLoading: $isLoading,
    $isSelected: $isSelected,
    $disabled: $disabled
  })), getShapeStyles({
    $theme: $theme,
    $shape: $shape,
    $size: $size
  }));
});
BaseButton.displayName = "BaseButton";
var EndEnhancer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)('div', function (_ref2) {
  var $theme = _ref2.$theme;
  var marginDirection = $theme.direction === 'rtl' ? 'marginRight' : 'marginLeft';
  return _defineProperty({
    display: 'flex'
  }, marginDirection, $theme.sizing.scale500);
});
EndEnhancer.displayName = "EndEnhancer";
var StartEnhancer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)('div', function (_ref4) {
  var $theme = _ref4.$theme;
  var marginDirection = $theme.direction === 'rtl' ? 'marginLeft' : 'marginRight';
  return _defineProperty({
    display: 'flex'
  }, marginDirection, $theme.sizing.scale500);
});
StartEnhancer.displayName = "StartEnhancer";
var LoadingSpinnerContainer = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)('div', function (_ref6) {
  var $theme = _ref6.$theme,
      $size = _ref6.$size;
  // we don't have a theming value for this
  var margins = '3px';

  if ($size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.mini || $size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.compact) {
    margins = $theme.sizing.scale0;
  }

  if ($size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.large) {
    margins = $theme.sizing.scale100;
  }

  return {
    lineHeight: 0,
    position: 'static',
    marginBottom: margins,
    marginTop: margins
  };
});
LoadingSpinnerContainer.displayName = "LoadingSpinnerContainer";
var LoadingSpinner = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)('span', function (_ref7) {
  var $theme = _ref7.$theme,
      $kind = _ref7.$kind,
      $disabled = _ref7.$disabled,
      $size = _ref7.$size;

  var _getLoadingSpinnerCol = getLoadingSpinnerColors({
    $theme: $theme,
    $kind: $kind,
    $disabled: $disabled
  }),
      foreground = _getLoadingSpinnerCol.foreground,
      background = _getLoadingSpinnerCol.background;

  var dimension = $theme.sizing.scale550;

  if ($size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.mini || $size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.compact) {
    dimension = $theme.sizing.scale500;
  }

  if ($size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.large) {
    dimension = $theme.sizing.scale600;
  }

  return {
    height: dimension,
    width: dimension,
    borderTopLeftRadius: '50%',
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
    borderBottomLeftRadius: '50%',
    borderLeftStyle: 'solid',
    borderTopStyle: 'solid',
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftWidth: $theme.sizing.scale0,
    borderTopWidth: $theme.sizing.scale0,
    borderRightWidth: $theme.sizing.scale0,
    borderBottomWidth: $theme.sizing.scale0,
    borderTopColor: foreground,
    borderLeftColor: background,
    borderBottomColor: background,
    borderRightColor: background,
    boxSizing: 'border-box',
    display: 'inline-block',
    animationDuration: $theme.animation.timing700,
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
    animationName: {
      to: {
        transform: 'rotate(360deg)'
      },
      from: {
        transform: 'rotate(0deg)'
      }
    }
  };
});
LoadingSpinner.displayName = "LoadingSpinner";

function getLoadingSpinnerColors(_ref8) {
  var $theme = _ref8.$theme,
      $kind = _ref8.$kind,
      $disabled = _ref8.$disabled;

  if ($disabled) {
    return {
      foreground: $theme.colors.buttonDisabledSpinnerForeground,
      background: $theme.colors.buttonDisabledSpinnerBackground
    };
  }

  switch ($kind) {
    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .Nd.secondary:
      {
        return {
          foreground: $theme.colors.buttonSecondarySpinnerForeground,
          background: $theme.colors.buttonSecondarySpinnerBackground
        };
      }

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .Nd.tertiary:
      {
        return {
          foreground: $theme.colors.buttonTertiarySpinnerForeground,
          background: $theme.colors.buttonTertiarySpinnerBackground
        };
      }

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .Nd.minimal:
      {
        return {
          foreground: $theme.colors.buttonMinimalSpinnerForeground,
          background: $theme.colors.buttonMinimalSpinnerBackground
        };
      }

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .Nd.primary:
    default:
      {
        return {
          foreground: $theme.colors.buttonPrimarySpinnerForeground,
          background: $theme.colors.buttonPrimarySpinnerBackground
        };
      }
  }
}

function getBorderRadiiStyles(_ref9) {
  var $theme = _ref9.$theme,
      $size = _ref9.$size,
      $shape = _ref9.$shape;
  var value = $theme.borders.buttonBorderRadius;

  if ($shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .IW.pill) {
    if ($size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.compact) {
      value = '30px';
    } else if ($size === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.large) {
      value = '42px';
    } else {
      value = '38px';
    }
  } else if ($shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .IW.circle || $shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .IW.round) {
    value = '50%';
  }

  return {
    borderTopRightRadius: value,
    borderBottomRightRadius: value,
    borderTopLeftRadius: value,
    borderBottomLeftRadius: value
  };
}

function getFontStyles(_ref10) {
  var $theme = _ref10.$theme,
      $size = _ref10.$size;

  switch ($size) {
    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.mini:
      return $theme.typography.font150;

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.compact:
      return $theme.typography.font250;

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.large:
      return $theme.typography.font450;

    default:
      return $theme.typography.font350;
  }
}

function getPaddingStyles(_ref11) {
  var $theme = _ref11.$theme,
      $size = _ref11.$size,
      $shape = _ref11.$shape;
  var iconShape = $shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .IW.square || $shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .IW.circle || $shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .IW.round;

  switch ($size) {
    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.mini:
      return {
        paddingTop: $theme.sizing.scale200,
        paddingBottom: $theme.sizing.scale200,
        paddingLeft: iconShape ? $theme.sizing.scale200 : $theme.sizing.scale300,
        paddingRight: iconShape ? $theme.sizing.scale200 : $theme.sizing.scale300
      };

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.compact:
      return {
        paddingTop: $theme.sizing.scale400,
        paddingBottom: $theme.sizing.scale400,
        paddingLeft: iconShape ? $theme.sizing.scale400 : $theme.sizing.scale500,
        paddingRight: iconShape ? $theme.sizing.scale400 : $theme.sizing.scale500
      };

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.large:
      return {
        paddingTop: $theme.sizing.scale600,
        paddingBottom: $theme.sizing.scale600,
        paddingLeft: iconShape ? $theme.sizing.scale600 : $theme.sizing.scale700,
        paddingRight: iconShape ? $theme.sizing.scale600 : $theme.sizing.scale700
      };

    default:
      return {
        paddingTop: $theme.sizing.scale550,
        paddingBottom: $theme.sizing.scale550,
        paddingLeft: iconShape ? $theme.sizing.scale550 : $theme.sizing.scale600,
        paddingRight: iconShape ? $theme.sizing.scale550 : $theme.sizing.scale600
      };
  }
}

function getKindStyles(_ref12) {
  var $theme = _ref12.$theme,
      $isLoading = _ref12.$isLoading,
      $isSelected = _ref12.$isSelected,
      $kind = _ref12.$kind,
      $disabled = _ref12.$disabled;

  if ($disabled) {
    return Object.freeze({});
  }

  switch ($kind) {
    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .Nd.primary:
      if ($isSelected) {
        return {
          color: $theme.colors.buttonPrimarySelectedText,
          backgroundColor: $theme.colors.buttonPrimarySelectedFill
        };
      }

      return {
        color: $theme.colors.buttonPrimaryText,
        backgroundColor: $theme.colors.buttonPrimaryFill,
        ':hover': {
          backgroundColor: $isLoading ? $theme.colors.buttonPrimaryActive : $theme.colors.buttonPrimaryHover
        },
        ':active': {
          backgroundColor: $theme.colors.buttonPrimaryActive
        }
      };

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .Nd.secondary:
      if ($isSelected) {
        return {
          color: $theme.colors.buttonPrimaryText,
          backgroundColor: $theme.colors.buttonPrimaryFill
        };
      }

      return {
        color: $theme.colors.buttonSecondaryText,
        backgroundColor: $theme.colors.buttonSecondaryFill,
        ':hover': {
          backgroundColor: $isLoading ? $theme.colors.buttonSecondaryActive : $theme.colors.buttonSecondaryHover
        },
        ':active': {
          backgroundColor: $theme.colors.buttonSecondaryActive
        }
      };

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .Nd.tertiary:
      if ($isSelected) {
        return {
          color: $theme.colors.buttonTertiarySelectedText,
          backgroundColor: $theme.colors.buttonTertiarySelectedFill
        };
      }

      return {
        color: $theme.colors.buttonTertiaryText,
        backgroundColor: $theme.colors.buttonTertiaryFill,
        ':hover': {
          backgroundColor: $isLoading ? $theme.colors.buttonTertiaryActive : $theme.colors.buttonTertiaryHover
        },
        ':active': {
          backgroundColor: $theme.colors.buttonTertiaryActive
        }
      };

    case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .KIND */ .Nd.minimal:
      if ($isSelected) {
        return {
          color: $theme.colors.buttonMinimalSelectedText,
          backgroundColor: $theme.colors.buttonMinimalSelectedFill
        };
      }

      return {
        color: $theme.colors.buttonMinimalText,
        backgroundColor: $theme.colors.buttonMinimalFill,
        ':hover': {
          backgroundColor: $isLoading ? $theme.colors.buttonMinimalActive : $theme.colors.buttonMinimalHover
        },
        ':active': {
          backgroundColor: $theme.colors.buttonMinimalActive
        }
      };

    default:
      return Object.freeze({});
  }
}

function getShapeStyles(_ref13) {
  var $theme = _ref13.$theme,
      $shape = _ref13.$shape,
      $size = _ref13.$size;

  if ($shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .IW.circle || $shape === _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SHAPE */ .IW.square) {
    var height, width;

    switch ($size) {
      case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.mini:
        height = '28px';
        width = '28px';
        break;

      case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.compact:
        height = '36px';
        width = '36px';
        break;

      case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.large:
        height = '56px';
        width = '56px';
        break;

      case _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .SIZE */ .SK.default:
      default:
        height = '48px';
        width = '48px';
        break;
    }

    return {
      height: height,
      width: width,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    };
  } else {
    return {};
  }
}

/***/ }),

/***/ 78803:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   De: () => (/* binding */ getOverride),
/* harmony export */   PC: () => (/* binding */ getOverrideProps),
/* harmony export */   Qp: () => (/* binding */ mergeOverrides),
/* harmony export */   _O: () => (/* binding */ getOverrides),
/* harmony export */   b2: () => (/* binding */ mergeOverride),
/* harmony export */   l5: () => (/* binding */ toObjectOverride)
/* harmony export */ });
/* unused harmony exports mergeConfigurationOverrides, useOverrides */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17020);
/* harmony import */ var _utils_deep_merge_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable cup/no-undef */




/**
 * Given an override argument, returns the component implementation override if it exists
 */
// eslint-disable-next-line flowtype/no-weak-types
function getOverride(override) {
  if ((0,react_is__WEBPACK_IMPORTED_MODULE_1__.isValidElementType)(override)) {
    return override;
  } // Check if override is OverrideObjectT


  if (override && _typeof(override) === 'object') {
    // Remove this 'any' once this flow issue is fixed:
    // https://github.com/facebook/flow/issues/6666
    // eslint-disable-next-line flowtype/no-weak-types
    return override.component;
  } // null/undefined


  return override;
}
/**
 * Given an override argument, returns the override props that should be passed
 * to the component when rendering it.
 */

function getOverrideProps(override) {
  if (override && _typeof(override) === 'object') {
    if (_typeof(override.props) === 'object') {
      return _objectSpread(_objectSpread({}, override.props), {}, {
        $style: override.style
      });
    } else {
      return {
        $style: override.style
      };
    }
  }

  return {};
}
/**
 * Coerces an override argument into an override object
 * (sometimes it is just an override component)
 */

function toObjectOverride(override) {
  if ((0,react_is__WEBPACK_IMPORTED_MODULE_1__.isValidElementType)(override)) {
    return {
      // eslint-disable-next-line flowtype/no-weak-types
      component: override
    };
  } // Flow can't figure out that typeof 'function' above will
  // catch React.StatelessFunctionalComponent
  // (probably related to https://github.com/facebook/flow/issues/6666)
  // eslint-disable-next-line flowtype/no-weak-types


  return override || {};
}
/**
 * Get a convenient override array that will always have [component, props]
 */

/* eslint-disable flowtype/no-weak-types */

function getOverrides(override, defaultComponent) {
  var Component = getOverride(override) || defaultComponent;

  if (override && _typeof(override) === 'object' && typeof override.props === 'function') {
    // TODO(v11)
    if (false) {}

    var DynamicOverride = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
      var mappedProps = override.props(props);
      var nextProps = getOverrideProps(_objectSpread(_objectSpread({}, override), {}, {
        props: mappedProps
      }));
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _extends({
        ref: ref
      }, nextProps));
    });
    DynamicOverride.displayName = Component.displayName;
    return [DynamicOverride, {}];
  }

  var props = getOverrideProps(override);
  return [Component, props];
}
/* eslint-enable flowtype/no-weak-types */

/**
 * Merges two overrides objects – this is useful if you want to inject your own
 * overrides into a child component, but also accept further overrides from
 * from upstream. See `mergeOverride` below.
 */

function mergeOverrides() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var merged = Object.assign({}, target, source);
  var allIdentifiers = Object.keys(merged); // const allIdentifiers = Object.keys({...target, ...source});

  return allIdentifiers.reduce(function (acc, name) {
    acc[name] = mergeOverride(toObjectOverride(target[name]), toObjectOverride(source[name]));
    return acc;
  }, {});
}
/**
 * Merges two override objects using the following behavior:
 * - Component implementation from the source (parent) replaces target
 * - Props and styles are both deep merged
 */

function mergeOverride(target, source) {
  // Shallow merge should handle `component`
  var merged = _objectSpread(_objectSpread({}, target), source);

  if (target.props && source.props) {
    merged.props = mergeConfigurationOverrides(target.props, source.props);
  }

  if (target.style && source.style) {
    merged.style = mergeConfigurationOverrides(target.style, source.style);
  }

  return merged;
}
/**
 * Since style or props overrides can be an object *or* a function, we need to handle
 * the case that one of them is a function. We do this by returning a new
 * function that deep merges the result of each style override
 */

function mergeConfigurationOverrides(target, source) {
  // Simple case of both objects
  if (_typeof(target) === 'object' && _typeof(source) === 'object') {
    return (0,_utils_deep_merge_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)({}, target, source);
  } // At least one is a function, return a new composite function


  return function () {
    return (0,_utils_deep_merge_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)({}, typeof target === 'function' ? target.apply(void 0, arguments) : target, typeof source === 'function' ? source.apply(void 0, arguments) : source);
  };
} // Lil' hook for memoized unpacking of overrides

function useOverrides(defaults) {
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return React.useMemo(function () {
    return (// eslint-disable-next-line flowtype/no-weak-types
      Object.keys(defaults).reduce(function (obj, key) {
        obj[key] = getOverrides(overrides[key], defaults[key]);
        return obj;
      }, {})
    );
  }, [overrides]);
}

/***/ }),

/***/ 67618:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: () => (/* binding */ getMediaQuery),
/* harmony export */   R: () => (/* binding */ getMediaQueries)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/**
 * Helper function that generates media queries based on breakpoint, e.g.
 * getMediaQuery(720) => '@media screen and (min-width: 720px)'
 */
var getMediaQuery = function getMediaQuery(breakpoint) {
  return "@media screen and (min-width: ".concat(breakpoint, "px)");
};
var getMediaQueries = function getMediaQueries(breakpoints) {
  return Object.keys(breakpoints).map(function (key) {
    return breakpoints[key];
  }).sort(function (a, b) {
    return a - b;
  }).map(getMediaQuery);
};

/***/ }),

/***/ 94989:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89944);
/* harmony import */ var _helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78803);
/* harmony import */ var _icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50679);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-REACT-ICON
// DO NOT EDIT THIS FILE DIRECTLY, SEE README.md





function Delete(props, ref) {
  var _useStyletron = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .c6)(),
      _useStyletron2 = _slicedToArray(_useStyletron, 2),
      theme = _useStyletron2[1];

  var _props$title = props.title,
      title = _props$title === void 0 ? 'Delete' : _props$title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties(props, ["title", "size", "color", "overrides"]);

  var SvgOverride = (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__/* .mergeOverride */ .b2)( // Icons from the theme target the SVG override in the underlying Icon component
  {
    component: theme.icons && theme.icons.Delete ? theme.icons.Delete : null
  }, overrides && overrides.Svg ? (0,_helpers_overrides_js__WEBPACK_IMPORTED_MODULE_2__/* .toObjectOverride */ .l5)(overrides.Svg) : {});
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A, _extends({
    viewBox: "0 0 24 24",
    ref: ref,
    title: title,
    size: size,
    color: color,
    overrides: {
      Svg: SvgOverride
    }
  }, restProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 7.29289C7.68342 6.90237 8.31658 6.90237 8.70711 7.29289L12 10.5858L15.2929 7.29289C15.6834 6.90237 16.3166 6.90237 16.7071 7.29289C17.0976 7.68342 17.0976 8.31658 16.7071 8.70711L13.4142 12L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L12 13.4142L8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071C6.90237 16.3166 6.90237 15.6834 7.29289 15.2929L10.5858 12L7.29289 8.70711C6.90237 8.31658 6.90237 7.68342 7.29289 7.29289Z"
  }));
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(Delete));

/***/ }),

/***/ 50679:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ icon)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(81724);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/helpers/overrides.js
var helpers_overrides = __webpack_require__(78803);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/styled-components.js
var styled_components = __webpack_require__(50182);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/omit-dollar-prefixed-keys.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// eslint-disable-next-line flowtype/no-weak-types
function omitDollarPrefixedKeys(source) {
  var result = {};

  for (var key in source) {
    if (key[0] !== '$') {
      result[key] = source[key];
    }
  }

  return result;
}
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/icon.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/





function Icon(props, ref) {
  var children = props.children,
      title = props.title,
      size = props.size,
      color = props.color,
      _props$overrides = props.overrides,
      overrides = _props$overrides === void 0 ? {} : _props$overrides,
      restProps = _objectWithoutProperties(props, ["children", "title", "size", "color", "overrides"]);

  var _getOverrides = (0,helpers_overrides/* getOverrides */._O)(overrides.Svg, styled_components/* Svg */.B),
      _getOverrides2 = _slicedToArray(_getOverrides, 2),
      Svg = _getOverrides2[0],
      overrideProps = _getOverrides2[1]; // Determine how/which props are passed based on if the component is a Styletron component.
  // $FlowFixMe: __STYLETRON__ not in React.AbstractcomponentStatics


  var passThroughProps = Svg.__STYLETRON__ ? _objectSpread(_objectSpread({
    title: title,
    $color: color,
    $size: size
  }, restProps), overrideProps) : _objectSpread(_objectSpread({
    title: title,
    color: color,
    size: size
  }, omitDollarPrefixedKeys(restProps)), omitDollarPrefixedKeys(overrideProps));
  return /*#__PURE__*/react.createElement(Svg, _extends({
    "data-baseweb": "icon",
    ref: ref
  }, passThroughProps), title ? /*#__PURE__*/react.createElement("title", null, title) : null, children);
}

/* harmony default export */ const icon = (/*#__PURE__*/react.forwardRef(Icon));

/***/ }),

/***/ 50182:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: () => (/* binding */ Svg),
/* harmony export */   P: () => (/* binding */ getSvgStyles)
/* harmony export */ });
/* harmony import */ var _styles_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89944);
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

function getSvgStyles(_ref) {
  var $theme = _ref.$theme,
      $size = _ref.$size,
      $color = _ref.$color;
  var size = $theme.sizing.scale600;

  if ($size) {
    if ($theme.sizing[$size]) {
      size = $theme.sizing[$size];
    } else if (typeof $size === 'number') {
      size = "".concat($size, "px");
    } else {
      size = $size;
    }
  }

  var color = 'currentColor';

  if ($color) {
    if ($theme.colors[$color]) {
      color = $theme.colors[$color];
    } else {
      color = $color;
    }
  }

  return {
    display: 'inline-block',
    fill: color,
    color: color,
    height: size,
    width: size
  };
}
var Svg = (0,_styles_index_js__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .I4)('svg', getSvgStyles);
Svg.displayName = "Svg";

/***/ }),

/***/ 31277:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  U: () => (/* binding */ LocaleContext)
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(81724);
// EXTERNAL MODULE: ../../node_modules/.pnpm/just-extend@4.1.0/node_modules/just-extend/index.js
var just_extend = __webpack_require__(54685);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/accordion/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale = {
  collapse: 'Collapse',
  expand: 'Expand'
};
/* harmony default export */ const accordion_locale = (locale);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/breadcrumbs/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var locale_locale = {
  ariaLabel: 'Breadcrumbs navigation'
};
/* harmony default export */ const breadcrumbs_locale = (locale_locale);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/datepicker/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var datepicker_locale_locale = {
  ariaLabel: 'Select a date.',
  ariaLabelRange: 'Select a date range.',
  ariaLabelCalendar: 'Calendar.',
  ariaRoleDescriptionCalendarMonth: 'Calendar month',
  previousMonth: 'Previous month.',
  nextMonth: 'Next month.',
  pastWeek: 'Past Week',
  pastMonth: 'Past Month',
  pastThreeMonths: 'Past 3 Months',
  pastSixMonths: 'Past 6 Months',
  pastYear: 'Past Year',
  pastTwoYears: 'Past 2 Years',
  screenReaderMessageInput: 'Press the down arrow key to interact with the calendar and select a date. Press the escape button to close the calendar.',
  selectedDate: 'Selected date is ${date}.',
  selectedDateRange: 'Selected date range is from ${startDate} to ${endDate}.',
  selectSecondDatePrompt: 'Select the second date.',
  quickSelectLabel: 'Choose a date range',
  quickSelectAriaLabel: 'Choose a date range',
  quickSelectPlaceholder: 'None',
  timeSelectEndLabel: 'End time',
  timeSelectStartLabel: 'Start time',
  timePickerAriaLabel12Hour: 'Select a time, 12-hour format.',
  timePickerAriaLabel24Hour: 'Select a time, 24-hour format.',
  timezonePickerAriaLabel: 'Select a timezone.',
  selectedStartDateLabel: 'Selected start date.',
  selectedEndDateLabel: 'Selected end date.',
  dateNotAvailableLabel: 'Not available.',
  dateAvailableLabel: "It's available.",
  selectedLabel: 'Selected.',
  chooseLabel: 'Choose'
};
/* harmony default export */ const datepicker_locale = (datepicker_locale_locale);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/data-table/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var data_table_locale_locale = {
  emptyState: 'No rows match the filter criteria defined. Please remove one or more filters to view more data.',
  loadingState: 'Loading Rows.',
  searchAriaLabel: 'Search by text',
  filterAdd: 'Add Filter',
  filterExclude: 'Exclude',
  filterApply: 'Apply',
  filterAppliedTo: 'filter applied to',
  optionsLabel: 'Select column to filter by',
  optionsSearch: 'Search for a column to filter by...',
  optionsEmpty: 'No columns available.',
  categoricalFilterSelectAll: 'Select All',
  categoricalFilterSelectClear: 'Clear',
  categoricalFilterEmpty: 'No Categories Found',
  datetimeFilterRange: 'Range',
  datetimeFilterRangeDatetime: 'Date, Time',
  datetimeFilterRangeDate: 'Date',
  datetimeFilterRangeTime: 'Time',
  datetimeFilterCategorical: 'Categorical',
  datetimeFilterCategoricalWeekday: 'Weekday',
  datetimeFilterCategoricalMonth: 'Month',
  datetimeFilterCategoricalQuarter: 'Quarter',
  datetimeFilterCategoricalHalf: 'Half',
  datetimeFilterCategoricalFirstHalf: 'H1',
  datetimeFilterCategoricalSecondHalf: 'H2',
  datetimeFilterCategoricalYear: 'Year',
  numericalFilterRange: 'Range',
  numericalFilterSingleValue: 'Single Value',
  booleanFilterTrue: 'true',
  booleanFilterFalse: 'false',
  booleanColumnTrueShort: 'T',
  booleanColumnFalseShort: 'F'
};
/* harmony default export */ const data_table_locale = (data_table_locale_locale);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/button-group/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var button_group_locale_locale = {
  ariaLabel: 'button group'
};
/* harmony default export */ const button_group_locale = (button_group_locale_locale);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/file-uploader/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var file_uploader_locale_locale = {
  dropFilesToUpload: 'Drop files here to upload...',
  or: '',
  browseFiles: 'Browse files',
  retry: 'Retry Upload',
  cancel: 'Cancel'
};
/* harmony default export */ const file_uploader_locale = (file_uploader_locale_locale);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/menu/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var menu_locale_locale = {
  noResultsMsg: 'No results',
  parentMenuItemAriaLabel: "You are currently at an item that opens a nested listbox. Press right arrow to enter that element and left arrow to return."
};
/* harmony default export */ const menu_locale = (menu_locale_locale);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/modal/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var modal_locale_locale = {
  close: 'Close'
};
/* harmony default export */ const modal_locale = (modal_locale_locale);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/drawer/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var drawer_locale_locale = {
  close: 'Close'
};
/* harmony default export */ const drawer_locale = (drawer_locale_locale);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/pagination/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var pagination_locale_locale = {
  prev: 'Prev',
  next: 'Next',
  preposition: 'of'
};
/* harmony default export */ const pagination_locale = (pagination_locale_locale);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/select/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var select_locale_locale = {
  // Remove noResultsMsg prop in the next major version
  noResultsMsg: 'No results found',
  placeholder: 'Select...',
  create: 'Create'
};
/* harmony default export */ const select_locale = (select_locale_locale);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/toast/locale.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var toast_locale_locale = {
  close: 'Close'
};
/* harmony default export */ const toast_locale = (toast_locale_locale);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/locale/en_US.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/












var en_US_en_US = {
  accordion: accordion_locale,
  breadcrumbs: breadcrumbs_locale,
  datepicker: datepicker_locale,
  datatable: data_table_locale,
  buttongroup: button_group_locale,
  fileuploader: file_uploader_locale,
  menu: menu_locale,
  modal: modal_locale,
  drawer: drawer_locale,
  pagination: pagination_locale,
  select: select_locale,
  toast: toast_locale
};
/* harmony default export */ const locale_en_US = (en_US_en_US);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/locale/index.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/



var LocaleContext = /*#__PURE__*/react.createContext(locale_en_US);

var LocaleProvider = function LocaleProvider(props) {
  var locale = props.locale,
      children = props.children;

  if (false) {}

  return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
    value: extend({}, en_US, locale)
  }, children);
};

/* harmony default export */ const esm_locale = ((/* unused pure expression or super */ null && (LocaleProvider)));

/***/ }),

/***/ 89944:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I4: () => (/* binding */ styled),
/* harmony export */   K6: () => (/* binding */ withWrapper),
/* harmony export */   _F: () => (/* binding */ withStyle),
/* harmony export */   c6: () => (/* binding */ useStyletron)
/* harmony export */ });
/* unused harmony exports createThemedStyled, createThemedWithStyle, createThemedUseStyletron */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63200);
/* harmony import */ var styletron_standard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94740);
/* harmony import */ var _theme_provider_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84591);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/





var wrapper = function wrapper(StyledComponent) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_theme_provider_js__WEBPACK_IMPORTED_MODULE_1__/* .ThemeContext */ .D.Consumer, null, function (theme) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledComponent, _extends({
        ref: ref
      }, props, {
        $theme: theme
      }));
    });
  });
};
/* eslint-disable flowtype/generic-spacing */

/* eslint-disable flowtype/no-weak-types */


/* eslint-enable flowtype/generic-spacing */

/* eslint-enable flowtype/no-weak-types */
function createThemedStyled() {
  return (0,styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .createStyled */ .kO)({
    wrapper: wrapper,
    getInitialStyle: styletron_standard__WEBPACK_IMPORTED_MODULE_3__/* .getInitialStyle */ .ws,
    driver: styletron_standard__WEBPACK_IMPORTED_MODULE_3__/* .driver */ .Bd // eslint-disable-next-line flowtype/no-weak-types

  });
}
var styled = createThemedStyled();
function createThemedWithStyle() {
  // eslint-disable-next-line flowtype/no-weak-types
  return styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .withStyle */ ._F;
}
var withStyle = createThemedWithStyle();
function createThemedUseStyletron() {
  return function () {
    // eslint-disable-next-line flowtype/no-weak-types
    var theme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_theme_provider_js__WEBPACK_IMPORTED_MODULE_1__/* .ThemeContext */ .D);

    var _styletronUseStyletro = (0,styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .c6)(),
        _styletronUseStyletro2 = _slicedToArray(_styletronUseStyletro, 1),
        css = _styletronUseStyletro2[0];

    return [css, theme];
  };
}
var useStyletron = createThemedUseStyletron();
function withWrapper( // eslint-disable-next-line flowtype/no-weak-types
StyledElement, wrapperFn) {
  // eslint-disable-next-line flowtype/no-weak-types
  return (0,styletron_react__WEBPACK_IMPORTED_MODULE_2__/* .withWrapper */ .K6)(StyledElement, function (Styled) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_theme_provider_js__WEBPACK_IMPORTED_MODULE_1__/* .ThemeContext */ .D.Consumer, null, function (theme) {
        return wrapperFn(Styled)(_objectSpread(_objectSpread({
          ref: ref
        }, props), {}, {
          $theme: theme
        }));
      });
    });
  });
}

/***/ }),

/***/ 84591:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  D: () => (/* binding */ ThemeContext),
  A: () => (/* binding */ theme_provider)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(81724);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/light-theme/color-tokens.js
var color_tokens = __webpack_require__(7358);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/light-theme/color-semantic-tokens.js
var color_semantic_tokens = __webpack_require__(46167);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/light-theme/color-component-tokens.js
var color_component_tokens = __webpack_require__(94224);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/light-theme/color-deprecated-semantic-tokens.js
var color_deprecated_semantic_tokens = __webpack_require__(83709);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/borders.js
var borders = __webpack_require__(53674);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/lighting.js
var lighting = __webpack_require__(93829);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/typography.js
var typography = __webpack_require__(29792);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/animation.js
var animation = __webpack_require__(92879);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/breakpoints.js
var breakpoints = __webpack_require__(45981);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/grid.js
var grid = __webpack_require__(7533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/media-query.js
var media_query = __webpack_require__(42136);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/sizing.js
var sizing = __webpack_require__(75571);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/light-theme/light-theme.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/












var LightTheme = {
  name: 'light-theme',
  colors: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, color_tokens/* default */.A), (0,color_component_tokens/* default */.A)()), (0,color_deprecated_semantic_tokens/* default */.A)()), (0,color_semantic_tokens/* default */.A)()),
  animation: animation/* default */.A,
  breakpoints: breakpoints/* default */.A,
  borders: borders/* default */.A,
  direction: 'auto',
  grid: grid/* default */.A,
  lighting: lighting/* default */.A,
  mediaQuery: media_query/* default */.A,
  sizing: sizing/* default */.A,
  typography: (0,typography/* default */.A)(),
  // TODO(#2318) Remove it in the next v11 major version.
  // Do not use.
  zIndex: {
    modal: 2000
  }
};
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/theme-provider.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


var ThemeContext = /*#__PURE__*/react.createContext(LightTheme);

var ThemeProvider = function ThemeProvider(props) {
  var theme = props.theme,
      children = props.children;
  return /*#__PURE__*/react.createElement(ThemeContext.Provider, {
    value: theme
  }, children);
};

/* harmony default export */ const theme_provider = (ThemeProvider);

/***/ }),

/***/ 31099:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   E2: () => (/* binding */ hexToRgb),
/* harmony export */   PR: () => (/* binding */ ellipsisText),
/* harmony export */   d2: () => (/* binding */ expandBorderStyles)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function hexToRgb() {
  var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1';
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? "rgba(".concat(parseInt(result[1], 16), ", ").concat(parseInt(result[2], 16), ", ").concat(parseInt(result[3], 16), ", ").concat(alpha, ")") : null;
}
var ellipsisText = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordWrap: 'normal'
};
function expandBorderStyles(borderStyles) {
  return {
    borderTopWidth: borderStyles.borderWidth,
    borderTopStyle: borderStyles.borderStyle,
    borderTopColor: borderStyles.borderColor,
    borderBottomWidth: borderStyles.borderWidth,
    borderBottomStyle: borderStyles.borderStyle,
    borderBottomColor: borderStyles.borderColor,
    borderLeftWidth: borderStyles.borderWidth,
    borderLeftStyle: borderStyles.borderStyle,
    borderLeftColor: borderStyles.borderColor,
    borderRightWidth: borderStyles.borderWidth,
    borderRightStyle: borderStyles.borderStyle,
    borderRightColor: borderStyles.borderColor
  };
}

/***/ }),

/***/ 25450:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ createDarkTheme)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/animation.js
var animation = __webpack_require__(92879);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/borders.js
var borders = __webpack_require__(53674);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/utils/deep-merge.js
var deep_merge = __webpack_require__(75);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/dark-theme/borders.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


// Override border colors for the dark theme
var borders_borders = (0,deep_merge/* default */.A)({}, borders/* default */.A, {
  border100: {
    borderColor: 'hsla(0, 0%, 100%, 0.04)'
  },
  border200: {
    borderColor: 'hsla(0, 0%, 100%, 0.08)'
  },
  border300: {
    borderColor: 'hsla(0, 0%, 100%, 0.12)'
  },
  border400: {
    borderColor: 'hsla(0, 0%, 100%, 0.16)'
  },
  border500: {
    borderColor: 'hsla(0, 0%, 100%, 0.2)'
  },
  border600: {
    borderColor: 'hsla(0, 0%, 100%, 0.24)'
  }
});
/* harmony default export */ const dark_theme_borders = (borders_borders);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/breakpoints.js
var breakpoints = __webpack_require__(45981);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/tokens/colors.js
var colors = __webpack_require__(10919);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/dark-theme/color-tokens.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

// color constants
var darkColorTokens = {
  // Primary Palette
  primaryA: colors/* default */.A.gray200,
  primaryB: colors/* default */.A.gray900,
  primary: colors/* default */.A.white,
  primary50: colors/* default */.A.gray50,
  primary100: colors/* default */.A.gray100,
  primary200: colors/* default */.A.gray200,
  primary300: colors/* default */.A.gray300,
  primary400: colors/* default */.A.gray400,
  primary500: colors/* default */.A.gray500,
  primary600: colors/* default */.A.gray600,
  primary700: colors/* default */.A.gray700,
  // Accent Palette
  accent: colors/* default */.A.blue400,
  accent50: colors/* default */.A.blue50,
  accent100: colors/* default */.A.blue100,
  accent200: colors/* default */.A.blue200,
  accent300: colors/* default */.A.blue300,
  accent400: colors/* default */.A.blue400,
  accent500: colors/* default */.A.blue500,
  accent600: colors/* default */.A.blue600,
  accent700: colors/* default */.A.blue700,
  // Negative Palette
  negative: colors/* default */.A.red500,
  negative50: colors/* default */.A.red50,
  negative100: colors/* default */.A.red100,
  negative200: colors/* default */.A.red200,
  negative300: colors/* default */.A.red300,
  negative400: colors/* default */.A.red400,
  negative500: colors/* default */.A.red500,
  negative600: colors/* default */.A.red600,
  negative700: colors/* default */.A.red700,
  // Warning Palette
  warning: colors/* default */.A.yellow500,
  warning50: colors/* default */.A.yellow50,
  warning100: colors/* default */.A.yellow100,
  warning200: colors/* default */.A.yellow200,
  warning300: colors/* default */.A.yellow300,
  warning400: colors/* default */.A.yellow400,
  warning500: colors/* default */.A.yellow500,
  warning600: colors/* default */.A.yellow600,
  warning700: colors/* default */.A.yellow700,
  // Positive Palette
  positive: colors/* default */.A.green400,
  positive50: colors/* default */.A.green50,
  positive100: colors/* default */.A.green100,
  positive200: colors/* default */.A.green200,
  positive300: colors/* default */.A.green300,
  positive400: colors/* default */.A.green400,
  positive500: colors/* default */.A.green500,
  positive600: colors/* default */.A.green600,
  positive700: colors/* default */.A.green700,
  // Monochrome Palette
  white: colors/* default */.A.white,
  black: colors/* default */.A.black,
  mono100: colors/* default */.A.gray300,
  mono200: colors/* default */.A.gray400,
  mono300: colors/* default */.A.gray500,
  mono400: colors/* default */.A.gray600,
  mono500: colors/* default */.A.gray700,
  // mono600 and mono900 are not in official brand tokens atm
  mono600: '#292929',
  mono700: '#1F1F1F',
  mono800: '#141414',
  mono900: '#111111',
  mono1000: colors/* default */.A.black,
  // Rating Palette,
  rating200: colors/* default */.A.yellow200,
  rating400: colors/* default */.A.yellow400,
  ratingInactiveFill: colors/* default */.A.gray500,
  ratingStroke: colors/* default */.A.gray700
};
/* harmony default export */ const color_tokens = (darkColorTokens);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/dark-theme/color-component-tokens.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

var tagHoverBackground = "rgba(255, 255, 255, 0.2)";
/* ---- Component colors ---- */
// TODO(#2318) Make it a plain object in the next v11 major version
// with values taken from `colorTokens`.
// Due to the legacy `createTheme` type the values
// need to be overrideable through primitives

/* harmony default export */ const color_component_tokens = (function () {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : color_tokens;
  return {
    // Buttons
    buttonPrimaryFill: themePrimitives.primary,
    buttonPrimaryText: themePrimitives.black,
    buttonPrimaryHover: themePrimitives.primary100,
    buttonPrimaryActive: themePrimitives.primary200,
    buttonPrimarySelectedText: themePrimitives.black,
    buttonPrimarySelectedFill: themePrimitives.primary200,
    buttonPrimarySpinnerForeground: themePrimitives.primary700,
    buttonPrimarySpinnerBackground: themePrimitives.primary300,
    buttonSecondaryFill: themePrimitives.primary700,
    buttonSecondaryText: themePrimitives.primary,
    buttonSecondaryHover: themePrimitives.primary600,
    buttonSecondaryActive: themePrimitives.primary500,
    buttonSecondarySelectedText: themePrimitives.primary,
    buttonSecondarySelectedFill: themePrimitives.primary500,
    buttonSecondarySpinnerForeground: themePrimitives.white,
    buttonSecondarySpinnerBackground: themePrimitives.primary400,
    buttonTertiaryFill: 'transparent',
    buttonTertiaryText: themePrimitives.primary,
    buttonTertiaryHover: themePrimitives.primary700,
    buttonTertiaryActive: themePrimitives.primary600,
    buttonTertiarySelectedText: themePrimitives.primary,
    buttonTertiarySelectedFill: themePrimitives.primary600,
    buttonTertiarySpinnerForeground: themePrimitives.primary50,
    buttonTertiarySpinnerBackground: themePrimitives.primary500,
    buttonMinimalFill: 'transparent',
    buttonMinimalText: themePrimitives.primary,
    buttonMinimalHover: themePrimitives.primary700,
    buttonMinimalActive: themePrimitives.primary600,
    buttonMinimalSelectedText: themePrimitives.primary,
    buttonMinimalSelectedFill: themePrimitives.primary600,
    buttonMinimalSpinnerForeground: themePrimitives.primary50,
    buttonMinimalSpinnerBackground: themePrimitives.primary500,
    buttonDisabledFill: themePrimitives.mono600,
    buttonDisabledText: themePrimitives.mono300,
    buttonDisabledSpinnerForeground: themePrimitives.mono200,
    buttonDisabledSpinnerBackground: themePrimitives.mono400,
    // Breadcrumbs
    breadcrumbsText: themePrimitives.mono100,
    breadcrumbsSeparatorFill: themePrimitives.mono200,
    // Datepicker
    datepickerBackground: themePrimitives.mono600,
    datepickerDayFont: themePrimitives.white,
    datepickerDayFontDisabled: themePrimitives.mono100,
    datepickerDayPseudoSelected: themePrimitives.mono500,
    datepickerDayPseudoHighlighted: themePrimitives.mono600,
    // Calendar
    calendarBackground: themePrimitives.mono800,
    calendarForeground: themePrimitives.white,
    calendarForegroundDisabled: themePrimitives.mono300,
    calendarHeaderBackground: themePrimitives.primary700,
    calendarHeaderForeground: themePrimitives.primary,
    calendarHeaderBackgroundActive: themePrimitives.primary600,
    calendarHeaderForegroundDisabled: themePrimitives.primary500,
    calendarDayBackgroundPseudoSelected: themePrimitives.primary700,
    calendarDayForegroundPseudoSelected: themePrimitives.primary,
    calendarDayBackgroundPseudoSelectedHighlighted: themePrimitives.primary600,
    calendarDayForegroundPseudoSelectedHighlighted: themePrimitives.primary,
    calendarDayBackgroundSelected: themePrimitives.primary,
    calendarDayForegroundSelected: themePrimitives.black,
    calendarDayBackgroundSelectedHighlighted: themePrimitives.primary100,
    calendarDayForegroundSelectedHighlighted: themePrimitives.black,
    // Combobox
    comboboxListItemFocus: themePrimitives.mono600,
    comboboxListItemHover: themePrimitives.mono500,
    // FileUploader
    fileUploaderBackgroundColor: themePrimitives.mono700,
    fileUploaderBackgroundColorActive: themePrimitives.mono600,
    fileUploaderBorderColorActive: themePrimitives.primary,
    fileUploaderBorderColorDefault: themePrimitives.mono500,
    fileUploaderMessageColor: themePrimitives.mono100,
    // Links
    linkText: themePrimitives.primary,
    linkVisited: themePrimitives.primary100,
    linkHover: themePrimitives.primary200,
    linkActive: themePrimitives.primary300,
    // List
    listHeaderFill: themePrimitives.mono600,
    listBodyFill: themePrimitives.mono700,
    listIconFill: themePrimitives.mono100,
    listBorder: themePrimitives.mono500,
    // ProgressSteps
    progressStepsCompletedText: themePrimitives.black,
    progressStepsCompletedFill: themePrimitives.primary,
    progressStepsActiveText: themePrimitives.black,
    progressStepsActiveFill: themePrimitives.primary,
    progressStepsIconActiveFill: themePrimitives.primary,
    // Modal
    modalCloseColor: themePrimitives.mono300,
    modalCloseColorHover: themePrimitives.mono400,
    modalCloseColorFocus: themePrimitives.mono400,
    // Notification
    notificationPrimaryBackground: themePrimitives.primary700,
    notificationPrimaryText: themePrimitives.primary200,
    notificationInfoBackground: themePrimitives.accent700,
    notificationInfoText: themePrimitives.accent200,
    notificationPositiveBackground: themePrimitives.positive700,
    notificationPositiveText: themePrimitives.positive200,
    notificationWarningBackground: themePrimitives.warning700,
    notificationWarningText: themePrimitives.warning200,
    notificationNegativeBackground: themePrimitives.negative700,
    notificationNegativeText: themePrimitives.negative200,
    // Tag
    // Custom ramps
    tagFontDisabledRampUnit: '600',
    tagOutlinedDisabledRampUnit: '700',
    tagSolidFontRampUnit: '0',
    tagSolidRampUnit: '500',
    tagOutlinedFontRampUnit: '500',
    tagOutlinedRampUnit: '500',
    // Deprecated
    tagSolidHoverRampUnit: '500',
    tagSolidActiveRampUnit: '400',
    tagSolidDisabledRampUnit: '700',
    tagSolidFontHoverRampUnit: '100',
    tagLightRampUnit: '700',
    tagLightHoverRampUnit: '700',
    tagLightActiveRampUnit: '600',
    tagLightDisabledRampUnit: '700',
    tagLightFontRampUnit: '100',
    tagLightFontHoverRampUnit: '100',
    tagOutlinedActiveRampUnit: '300',
    tagOutlinedHoverRampUnit: '800',
    tagOutlinedFontHoverRampUnit: '100',
    // Neutral
    tagNeutralOutlinedFont: themePrimitives.mono100,
    tagNeutralOutlinedBackground: themePrimitives.mono200,
    tagNeutralSolidFont: themePrimitives.black,
    tagNeutralSolidBackground: themePrimitives.primary200,
    // not much we can do to get the correct gray here
    tagNeutralFontDisabled: themePrimitives.mono400,
    tagNeutralOutlinedDisabled: themePrimitives.mono500,
    // Deprecated
    tagNeutralSolidHover: themePrimitives.mono600,
    tagNeutralSolidActive: themePrimitives.mono500,
    tagNeutralSolidDisabled: themePrimitives.mono700,
    tagNeutralSolidFontHover: themePrimitives.mono200,
    tagNeutralLightBackground: themePrimitives.mono800,
    tagNeutralLightHover: themePrimitives.mono800,
    tagNeutralLightActive: themePrimitives.mono700,
    tagNeutralLightDisabled: themePrimitives.mono700,
    tagNeutralLightFont: themePrimitives.mono200,
    tagNeutralLightFontHover: themePrimitives.mono200,
    tagNeutralOutlinedActive: themePrimitives.mono400,
    tagNeutralOutlinedFontHover: themePrimitives.mono100,
    tagNeutralOutlinedHover: tagHoverBackground,
    // Primary
    tagPrimaryOutlinedFont: themePrimitives.primary200,
    tagPrimaryOutlinedBackground: themePrimitives.primary400,
    tagPrimarySolidFont: themePrimitives.black,
    tagPrimarySolidBackground: themePrimitives.primary200,
    tagPrimaryFontDisabled: themePrimitives.primary600,
    tagPrimaryOutlinedDisabled: themePrimitives.primary700,
    // Deprecated
    tagPrimarySolidHover: themePrimitives.primary700,
    tagPrimarySolidActive: themePrimitives.primary400,
    tagPrimarySolidDisabled: themePrimitives.primary700,
    tagPrimarySolidFontHover: themePrimitives.primary100,
    tagPrimaryLightBackground: themePrimitives.primary700,
    tagPrimaryLightHover: themePrimitives.primary700,
    tagPrimaryLightActive: themePrimitives.primary600,
    tagPrimaryLightDisabled: themePrimitives.primary700,
    tagPrimaryLightFont: themePrimitives.primary100,
    tagPrimaryLightFontHover: themePrimitives.primary100,
    tagPrimaryOutlinedActive: themePrimitives.primary600,
    tagPrimaryOutlinedFontHover: themePrimitives.primary200,
    tagPrimaryOutlinedHover: tagHoverBackground,
    // Accent
    tagAccentOutlinedFont: themePrimitives.accent200,
    tagAccentOutlinedBackground: themePrimitives.accent500,
    tagAccentSolidFont: themePrimitives.white,
    tagAccentSolidBackground: themePrimitives.accent500,
    tagAccentFontDisabled: themePrimitives.accent600,
    tagAccentOutlinedDisabled: themePrimitives.accent700,
    // Deprecated
    tagAccentSolidHover: themePrimitives.accent500,
    tagAccentSolidActive: themePrimitives.accent400,
    tagAccentSolidDisabled: themePrimitives.accent700,
    tagAccentSolidFontHover: themePrimitives.accent100,
    tagAccentLightBackground: themePrimitives.accent700,
    tagAccentLightHover: themePrimitives.accent700,
    tagAccentLightActive: themePrimitives.accent600,
    tagAccentLightDisabled: themePrimitives.accent700,
    tagAccentLightFont: themePrimitives.accent100,
    tagAccentLightFontHover: themePrimitives.accent100,
    tagAccentOutlinedActive: themePrimitives.accent300,
    tagAccentOutlinedFontHover: themePrimitives.accent200,
    tagAccentOutlinedHover: tagHoverBackground,
    // Positive
    tagPositiveOutlinedFont: themePrimitives.positive300,
    tagPositiveOutlinedBackground: themePrimitives.positive500,
    tagPositiveSolidFont: themePrimitives.white,
    tagPositiveSolidBackground: themePrimitives.positive500,
    tagPositiveFontDisabled: themePrimitives.positive600,
    tagPositiveOutlinedDisabled: themePrimitives.positive700,
    // Deprecated
    tagPositiveSolidHover: themePrimitives.positive500,
    tagPositiveSolidActive: themePrimitives.positive400,
    tagPositiveSolidDisabled: themePrimitives.positive700,
    tagPositiveSolidFontHover: themePrimitives.positive100,
    tagPositiveLightBackground: themePrimitives.positive700,
    tagPositiveLightHover: themePrimitives.positive700,
    tagPositiveLightActive: themePrimitives.positive600,
    tagPositiveLightDisabled: themePrimitives.positive700,
    tagPositiveLightFont: themePrimitives.positive100,
    tagPositiveLightFontHover: themePrimitives.positive100,
    tagPositiveOutlinedActive: themePrimitives.positive300,
    tagPositiveOutlinedFontHover: themePrimitives.positive300,
    tagPositiveOutlinedHover: tagHoverBackground,
    // Warning
    tagWarningOutlinedFont: themePrimitives.warning300,
    tagWarningOutlinedBackground: themePrimitives.warning500,
    tagWarningSolidFont: themePrimitives.black,
    tagWarningSolidBackground: themePrimitives.warning500,
    tagWarningFontDisabled: themePrimitives.warning600,
    tagWarningOutlinedDisabled: themePrimitives.warning700,
    // Deprecated
    tagWarningSolidHover: themePrimitives.warning500,
    tagWarningSolidActive: themePrimitives.warning400,
    tagWarningSolidDisabled: themePrimitives.warning700,
    tagWarningSolidFontHover: themePrimitives.warning100,
    tagWarningLightBackground: themePrimitives.warning700,
    tagWarningLightHover: themePrimitives.warning700,
    tagWarningLightActive: themePrimitives.warning600,
    tagWarningLightDisabled: themePrimitives.warning700,
    tagWarningLightFont: themePrimitives.warning100,
    tagWarningLightFontHover: themePrimitives.warning100,
    tagWarningOutlinedActive: themePrimitives.warning300,
    tagWarningOutlinedFontHover: themePrimitives.warning300,
    tagWarningOutlinedHover: tagHoverBackground,
    // Negative
    tagNegativeOutlinedFont: themePrimitives.negative300,
    tagNegativeOutlinedBackground: themePrimitives.negative500,
    tagNegativeSolidFont: themePrimitives.white,
    tagNegativeSolidBackground: themePrimitives.negative500,
    tagNegativeFontDisabled: themePrimitives.negative600,
    tagNegativeOutlinedDisabled: themePrimitives.negative700,
    // Deprecated
    tagNegativeSolidHover: themePrimitives.negative500,
    tagNegativeSolidActive: themePrimitives.negative400,
    tagNegativeSolidDisabled: themePrimitives.negative700,
    tagNegativeSolidFontHover: themePrimitives.negative100,
    tagNegativeLightBackground: themePrimitives.negative700,
    tagNegativeLightHover: themePrimitives.negative700,
    tagNegativeLightActive: themePrimitives.negative600,
    tagNegativeLightDisabled: themePrimitives.negative700,
    tagNegativeLightFont: themePrimitives.negative100,
    tagNegativeLightFontHover: themePrimitives.negative100,
    tagNegativeOutlinedActive: themePrimitives.negative300,
    tagNegativeOutlinedFontHover: themePrimitives.negative300,
    tagNegativeOutlinedHover: tagHoverBackground,
    // Table
    tableHeadBackgroundColor: themePrimitives.mono700,
    tableBackground: themePrimitives.mono800,
    tableStripedBackground: themePrimitives.mono700,
    tableFilter: themePrimitives.mono400,
    tableFilterHeading: themePrimitives.mono300,
    tableFilterBackground: themePrimitives.mono700,
    tableFilterFooterBackground: themePrimitives.mono800,
    // Toast
    toastText: themePrimitives.white,
    toastPrimaryBackground: themePrimitives.primary500,
    toastInfoBackground: themePrimitives.accent500,
    toastPositiveBackground: themePrimitives.positive500,
    toastWarningBackground: themePrimitives.warning500,
    toastNegativeBackground: themePrimitives.negative500,
    // Toggle
    toggleFill: themePrimitives.mono300,
    toggleFillChecked: themePrimitives.primary,
    toggleFillDisabled: themePrimitives.mono600,
    toggleTrackFill: themePrimitives.mono400,
    toggleTrackFillDisabled: themePrimitives.mono700,
    // Tick
    tickFill: themePrimitives.mono1000,
    tickFillHover: themePrimitives.mono700,
    tickFillActive: themePrimitives.mono600,
    tickFillSelected: themePrimitives.primary,
    tickFillSelectedHover: themePrimitives.primary50,
    tickFillSelectedHoverActive: themePrimitives.primary100,
    tickFillError: themePrimitives.negative700,
    tickFillErrorHover: themePrimitives.negative600,
    tickFillErrorHoverActive: themePrimitives.negative500,
    tickFillErrorSelected: themePrimitives.negative500,
    tickFillErrorSelectedHover: themePrimitives.negative600,
    tickFillErrorSelectedHoverActive: themePrimitives.negative700,
    tickFillDisabled: themePrimitives.mono500,
    tickBorder: themePrimitives.mono300,
    tickBorderError: themePrimitives.negative400,
    tickMarkFill: themePrimitives.black,
    tickMarkFillError: themePrimitives.white,
    tickMarkFillDisabled: themePrimitives.mono800,
    // Slider/Toggle
    sliderTrackFill: 'transparent',
    sliderHandleFill: themePrimitives.primaryA,
    sliderHandleFillDisabled: themePrimitives.primary500,
    sliderHandleInnerFill: themePrimitives.primaryA,
    sliderHandleFillHover: themePrimitives.mono300,
    sliderHandleFillActive: themePrimitives.mono300,
    sliderHandleFillSelected: themePrimitives.primary500,
    sliderHandleFillSelectedHover: themePrimitives.primary600,
    sliderHandleFillSelectedActive: themePrimitives.primary700,
    sliderTrackFillHover: themePrimitives.mono500,
    sliderTrackFillActive: themePrimitives.mono400,
    sliderTrackFillSelected: themePrimitives.primary500,
    sliderTrackFillSelectedActive: themePrimitives.primary600,
    sliderTrackFillSelectedHover: themePrimitives.primary700,
    sliderTrackFillDisabled: themePrimitives.mono700,
    sliderHandleInnerFillDisabled: themePrimitives.mono500,
    sliderHandleInnerFillSelectedHover: themePrimitives.primary600,
    sliderHandleInnerFillSelectedActive: themePrimitives.primary700,
    sliderBorder: themePrimitives.white,
    sliderBorderHover: themePrimitives.white,
    sliderBorderDisabled: themePrimitives.mono400,
    // Input
    inputBorder: themePrimitives.mono600,
    inputFill: themePrimitives.mono600,
    inputFillActive: themePrimitives.mono500,
    inputFillError: themePrimitives.negative700,
    inputFillDisabled: themePrimitives.mono800,
    inputFillPositive: themePrimitives.positive700,
    inputTextDisabled: themePrimitives.mono500,
    inputBorderError: themePrimitives.negative400,
    inputBorderPositive: themePrimitives.positive400,
    inputEnhancerFill: themePrimitives.mono500,
    inputEnhancerFillDisabled: themePrimitives.mono700,
    inputEnhancerTextDisabled: themePrimitives.mono500,
    inputPlaceholder: themePrimitives.mono300,
    inputPlaceholderDisabled: themePrimitives.mono500,
    // Menu
    menuFill: themePrimitives.mono600,
    menuFillHover: themePrimitives.mono700,
    menuFontDefault: themePrimitives.mono300,
    menuFontDisabled: themePrimitives.mono400,
    menuFontHighlighted: themePrimitives.white,
    menuFontSelected: themePrimitives.white,
    // Pagination
    paginationTriangleDown: themePrimitives.mono100,
    // Header navigation
    headerNavigationFill: themePrimitives.mono700,
    // Tab
    tabBarFill: themePrimitives.mono1000,
    tabColor: themePrimitives.mono300,
    // Spinner
    spinnerTrackFill: themePrimitives.mono100,
    // Progress bar
    progressbarTrackFill: themePrimitives.mono100,
    // Tooltip
    tooltipBackground: themePrimitives.mono200,
    tooltipText: themePrimitives.mono1000
  };
});
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/dark-theme/color-deprecated-semantic-tokens.js
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


/* ---- DEPRECATED ---- */
/* harmony default export */ const color_deprecated_semantic_tokens = (function () {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : color_tokens;
  return {
    // TODO(#2318) Remove Legacy Semantic Colors values in the next v11 major
    // since it's not used in the component specific tokens
    // and we ship semantic tokens separately

    /* ---- Legacy Semantic Colors ---- */
    // Font Color
    colorPrimary: themePrimitives.mono100,
    colorSecondary: themePrimitives.mono200,
    // Background
    background: themePrimitives.mono1000,
    backgroundAlt: themePrimitives.mono700,
    backgroundInv: themePrimitives.mono100,
    // Foreground
    foreground: themePrimitives.mono100,
    foregroundAlt: themePrimitives.mono300,
    foregroundInv: themePrimitives.mono1000,
    // Borders
    border: themePrimitives.mono600,
    borderAlt: themePrimitives.mono700,
    borderFocus: themePrimitives.primary,
    borderError: themePrimitives.negative,
    // Shadow
    shadowFocus: 'rgba(39, 110, 241, 0.32)',
    shadowError: 'rgba(229, 73, 55, 0.32)'
  };
});
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/util.js
var util = __webpack_require__(31099);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/dark-theme/color-semantic-tokens.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/



/* harmony default export */ const color_semantic_tokens = (function () {
  var foundation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : color_tokens;
  var core = {
    // Background
    backgroundPrimary: foundation.primaryB,
    backgroundSecondary: colors/* default */.A.gray800,
    backgroundTertiary: colors/* default */.A.gray700,
    backgroundInversePrimary: foundation.primaryA,
    backgroundInverseSecondary: colors/* default */.A.gray300,
    // Content
    contentPrimary: foundation.primaryA,
    contentSecondary: colors/* default */.A.gray400,
    contentTertiary: colors/* default */.A.gray500,
    contentInversePrimary: foundation.primaryB,
    contentInverseSecondary: colors/* default */.A.gray600,
    contentInverseTertiary: colors/* default */.A.gray500,
    // Border
    borderOpaque: colors/* default */.A.gray700,
    borderTransparent: (0,util/* hexToRgb */.E2)(foundation.primaryA, '0.08'),
    borderSelected: foundation.primaryA,
    borderInverseOpaque: colors/* default */.A.gray400,
    borderInverseTransparent: (0,util/* hexToRgb */.E2)(foundation.primaryB, '0.2'),
    borderInverseSelected: foundation.primaryB
  };
  var coreExtensions = {
    // Backgrounds
    backgroundStateDisabled: colors/* default */.A.gray800,
    backgroundOverlayDark: (0,util/* hexToRgb */.E2)(colors/* default */.A.black, '0.3'),
    backgroundOverlayLight: (0,util/* hexToRgb */.E2)(colors/* default */.A.black, '0.08'),
    backgroundAccent: foundation.accent,
    backgroundNegative: foundation.negative,
    backgroundWarning: foundation.warning,
    backgroundPositive: foundation.positive,
    backgroundLightAccent: colors/* default */.A.blue700,
    backgroundLightPositive: colors/* default */.A.green700,
    backgroundLightNegative: colors/* default */.A.red700,
    backgroundLightWarning: colors/* default */.A.yellow700,
    backgroundAlwaysDark: colors/* default */.A.gray900,
    backgroundAlwaysLight: colors/* default */.A.gray100,
    // Content
    contentStateDisabled: colors/* default */.A.gray600,
    contentAccent: colors/* default */.A.blue300,
    contentOnColor: colors/* default */.A.white,
    contentOnColorInverse: colors/* default */.A.black,
    contentNegative: colors/* default */.A.red300,
    contentWarning: colors/* default */.A.yellow300,
    contentPositive: colors/* default */.A.green300,
    // Border
    borderStateDisabled: colors/* default */.A.gray800,
    borderAccent: colors/* default */.A.blue400,
    borderAccentLight: colors/* default */.A.blue500,
    borderNegative: colors/* default */.A.red500,
    borderWarning: colors/* default */.A.yellow500,
    borderPositive: colors/* default */.A.green500
  };
  return _objectSpread(_objectSpread({}, core), coreExtensions);
});
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/typography.js
var typography = __webpack_require__(29792);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/grid.js
var grid = __webpack_require__(7533);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/lighting.js
var lighting = __webpack_require__(93829);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/media-query.js
var media_query = __webpack_require__(42136);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/shared/sizing.js
var sizing = __webpack_require__(75571);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/dark-theme/create-dark-theme.js
function create_dark_theme_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function create_dark_theme_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { create_dark_theme_ownKeys(Object(source), true).forEach(function (key) { create_dark_theme_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { create_dark_theme_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function create_dark_theme_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/













function createDarkTheme() {
  var primitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var // Used to override default theme property values derived from primitives
  overrides = arguments.length > 1 ? arguments[1] : undefined;

  // Extract font tokens and color tokens from primitives
  var primaryFontFamily = primitives.primaryFontFamily,
      customColorTokens = _objectWithoutProperties(primitives, ["primaryFontFamily"]); // Assemble color tokens by overriding defaults with custom color tokens


  var colorTokens = create_dark_theme_objectSpread(create_dark_theme_objectSpread({}, color_tokens), customColorTokens);

  var theme = {
    animation: animation/* default */.A,
    borders: dark_theme_borders,
    breakpoints: breakpoints/* default */.A,
    colors: create_dark_theme_objectSpread(create_dark_theme_objectSpread(create_dark_theme_objectSpread(create_dark_theme_objectSpread({}, colorTokens), color_component_tokens(colorTokens)), color_deprecated_semantic_tokens(colorTokens)), color_semantic_tokens(colorTokens)),
    direction: 'auto',
    grid: grid/* default */.A,
    lighting: lighting/* default */.A,
    mediaQuery: media_query/* default */.A,
    sizing: sizing/* default */.A,
    // If primaryFontFamily is not provided, we use our default font tokens
    typography: primaryFontFamily ? (0,typography/* default */.A)({
      primaryFontFamily: primaryFontFamily
    }) : (0,typography/* default */.A)(),
    // TODO(#2318) Remove in v11, the next major version.
    // Do not use.
    zIndex: {
      modal: 2000
    }
  };
  return (0,deep_merge/* default */.A)({}, theme, overrides);
}

/***/ }),

/***/ 94224:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7358);
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

var tagHoverBackground = "rgba(0, 0, 0, 0.08)";
/* ---- Component colors ---- */
// TODO(#2318) Make it a plain object in the next v11 major version
// with values taken from `colorTokens`.
// Due to the legacy `createTheme` type the value need to be
// overrideable through primitives (`foundation` )

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function () {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A;
  return {
    // Buttons
    buttonPrimaryFill: themePrimitives.primary,
    buttonPrimaryText: themePrimitives.white,
    buttonPrimaryHover: themePrimitives.primary700,
    buttonPrimaryActive: themePrimitives.primary600,
    buttonPrimarySelectedFill: themePrimitives.primary600,
    buttonPrimarySelectedText: themePrimitives.white,
    buttonPrimarySpinnerForeground: themePrimitives.primary50,
    buttonPrimarySpinnerBackground: themePrimitives.primary500,
    buttonSecondaryFill: themePrimitives.primary100,
    buttonSecondaryText: themePrimitives.primary,
    buttonSecondaryHover: themePrimitives.primary200,
    buttonSecondaryActive: themePrimitives.primary300,
    buttonSecondarySelectedFill: themePrimitives.primary300,
    buttonSecondarySelectedText: themePrimitives.primary,
    buttonSecondarySpinnerForeground: themePrimitives.primary700,
    buttonSecondarySpinnerBackground: themePrimitives.primary300,
    buttonTertiaryFill: 'transparent',
    buttonTertiaryText: themePrimitives.primary,
    buttonTertiaryHover: themePrimitives.primary50,
    buttonTertiaryActive: themePrimitives.primary100,
    buttonTertiarySelectedFill: themePrimitives.primary100,
    buttonTertiarySelectedText: themePrimitives.primary,
    buttonTertiarySpinnerForeground: themePrimitives.primary700,
    buttonTertiarySpinnerBackground: themePrimitives.primary300,
    buttonMinimalFill: 'transparent',
    buttonMinimalText: themePrimitives.primary,
    buttonMinimalHover: themePrimitives.primary50,
    buttonMinimalActive: themePrimitives.primary100,
    buttonMinimalSelectedFill: themePrimitives.primary100,
    buttonMinimalSelectedText: themePrimitives.primary,
    buttonMinimalSpinnerForeground: themePrimitives.primary700,
    buttonMinimalSpinnerBackground: themePrimitives.primary300,
    buttonDisabledFill: themePrimitives.mono200,
    buttonDisabledText: themePrimitives.mono600,
    buttonDisabledSpinnerForeground: themePrimitives.mono600,
    buttonDisabledSpinnerBackground: themePrimitives.mono400,
    // Breadcrumbs
    breadcrumbsText: themePrimitives.mono900,
    breadcrumbsSeparatorFill: themePrimitives.mono700,
    // Datepicker
    datepickerBackground: themePrimitives.mono100,
    datepickerDayFont: themePrimitives.mono1000,
    datepickerDayFontDisabled: themePrimitives.mono500,
    datepickerDayPseudoSelected: themePrimitives.primary100,
    datepickerDayPseudoHighlighted: themePrimitives.primary200,
    // Calendar
    calendarBackground: themePrimitives.mono100,
    calendarForeground: themePrimitives.mono1000,
    calendarForegroundDisabled: themePrimitives.mono500,
    calendarHeaderBackground: themePrimitives.white,
    calendarHeaderForeground: themePrimitives.primary,
    calendarHeaderBackgroundActive: themePrimitives.primary700,
    calendarHeaderForegroundDisabled: themePrimitives.primary500,
    calendarDayBackgroundPseudoSelected: themePrimitives.primary100,
    calendarDayForegroundPseudoSelected: themePrimitives.mono1000,
    calendarDayBackgroundPseudoSelectedHighlighted: themePrimitives.primary200,
    calendarDayForegroundPseudoSelectedHighlighted: themePrimitives.mono1000,
    calendarDayBackgroundSelected: themePrimitives.primary,
    calendarDayForegroundSelected: themePrimitives.white,
    calendarDayBackgroundSelectedHighlighted: themePrimitives.primary,
    calendarDayForegroundSelectedHighlighted: themePrimitives.white,
    // Combobox
    comboboxListItemFocus: themePrimitives.mono200,
    comboboxListItemHover: themePrimitives.mono300,
    // FileUploader
    fileUploaderBackgroundColor: themePrimitives.mono200,
    fileUploaderBackgroundColorActive: themePrimitives.primary50,
    fileUploaderBorderColorActive: themePrimitives.primary,
    fileUploaderBorderColorDefault: themePrimitives.mono500,
    fileUploaderMessageColor: themePrimitives.mono800,
    // Links
    linkText: themePrimitives.primary,
    linkVisited: themePrimitives.primary700,
    linkHover: themePrimitives.primary600,
    linkActive: themePrimitives.primary500,
    // List
    listHeaderFill: themePrimitives.white,
    listBodyFill: themePrimitives.mono200,
    listIconFill: themePrimitives.mono500,
    listBorder: themePrimitives.mono500,
    // ProgressSteps
    progressStepsCompletedText: themePrimitives.white,
    progressStepsCompletedFill: themePrimitives.primary,
    progressStepsActiveText: themePrimitives.white,
    progressStepsActiveFill: themePrimitives.primary,
    progressStepsIconActiveFill: themePrimitives.primary,
    // Toggle
    toggleFill: themePrimitives.white,
    toggleFillChecked: themePrimitives.primary,
    toggleFillDisabled: themePrimitives.mono600,
    toggleTrackFill: themePrimitives.mono400,
    toggleTrackFillDisabled: themePrimitives.mono300,
    // Tick
    tickFill: themePrimitives.mono100,
    tickFillHover: themePrimitives.mono200,
    tickFillActive: themePrimitives.mono300,
    tickFillSelected: themePrimitives.primary,
    tickFillSelectedHover: themePrimitives.primary700,
    tickFillSelectedHoverActive: themePrimitives.primary600,
    tickFillError: themePrimitives.negative50,
    tickFillErrorHover: themePrimitives.negative100,
    tickFillErrorHoverActive: themePrimitives.negative200,
    tickFillErrorSelected: themePrimitives.negative400,
    tickFillErrorSelectedHover: themePrimitives.negative500,
    tickFillErrorSelectedHoverActive: themePrimitives.negative600,
    tickFillDisabled: themePrimitives.mono600,
    tickBorder: themePrimitives.mono700,
    tickBorderError: themePrimitives.negative400,
    tickMarkFill: themePrimitives.white,
    tickMarkFillError: themePrimitives.white,
    tickMarkFillDisabled: themePrimitives.mono100,
    // Slider/Toggle
    sliderTrackFill: 'transparent',
    sliderHandleFill: themePrimitives.primaryA,
    sliderHandleFillDisabled: themePrimitives.primary400,
    sliderHandleInnerFill: themePrimitives.primaryA,
    sliderTrackFillHover: themePrimitives.mono500,
    sliderTrackFillActive: themePrimitives.mono600,
    sliderTrackFillSelected: themePrimitives.primary,
    sliderTrackFillSelectedHover: themePrimitives.primary,
    sliderTrackFillSelectedActive: themePrimitives.primary500,
    sliderTrackFillDisabled: themePrimitives.mono300,
    sliderHandleFillHover: themePrimitives.white,
    sliderHandleFillActive: themePrimitives.white,
    sliderHandleFillSelected: themePrimitives.white,
    sliderHandleFillSelectedHover: themePrimitives.white,
    sliderHandleFillSelectedActive: themePrimitives.white,
    sliderHandleInnerFillDisabled: themePrimitives.mono400,
    sliderHandleInnerFillSelectedHover: themePrimitives.primary,
    sliderHandleInnerFillSelectedActive: themePrimitives.primary500,
    sliderBorder: themePrimitives.mono500,
    sliderBorderHover: themePrimitives.primary,
    sliderBorderDisabled: themePrimitives.mono600,
    // Inputs
    inputBorder: themePrimitives.mono300,
    inputFill: themePrimitives.mono300,
    inputFillError: themePrimitives.negative50,
    inputFillDisabled: themePrimitives.mono200,
    inputFillActive: themePrimitives.mono200,
    inputFillPositive: themePrimitives.positive50,
    inputTextDisabled: themePrimitives.mono600,
    inputBorderError: themePrimitives.negative200,
    inputBorderPositive: themePrimitives.positive200,
    inputEnhancerFill: themePrimitives.mono300,
    inputEnhancerFillDisabled: themePrimitives.mono300,
    inputEnhancerTextDisabled: themePrimitives.mono600,
    inputPlaceholder: themePrimitives.mono700,
    inputPlaceholderDisabled: themePrimitives.mono600,
    // Menu
    menuFill: themePrimitives.mono100,
    menuFillHover: themePrimitives.mono200,
    menuFontDefault: themePrimitives.mono800,
    menuFontDisabled: themePrimitives.mono500,
    menuFontHighlighted: themePrimitives.mono1000,
    menuFontSelected: themePrimitives.mono1000,
    // Modal
    modalCloseColor: themePrimitives.mono1000,
    modalCloseColorHover: themePrimitives.mono800,
    modalCloseColorFocus: themePrimitives.mono800,
    // Pagination
    paginationTriangleDown: themePrimitives.mono800,
    // Header navigation
    headerNavigationFill: 'transparent',
    // Tab
    tabBarFill: themePrimitives.mono200,
    tabColor: themePrimitives.mono800,
    // Notification
    notificationPrimaryBackground: themePrimitives.primary50,
    notificationPrimaryText: themePrimitives.primary500,
    notificationInfoBackground: themePrimitives.accent50,
    notificationInfoText: themePrimitives.accent500,
    notificationPositiveBackground: themePrimitives.positive50,
    notificationPositiveText: themePrimitives.positive500,
    notificationWarningBackground: themePrimitives.warning50,
    notificationWarningText: themePrimitives.warning500,
    notificationNegativeBackground: themePrimitives.negative50,
    notificationNegativeText: themePrimitives.negative500,
    // Tag
    // Custom ramps
    tagFontDisabledRampUnit: '100',
    tagOutlinedDisabledRampUnit: '200',
    tagSolidFontRampUnit: '0',
    tagSolidRampUnit: '400',
    tagOutlinedFontRampUnit: '400',
    tagOutlinedRampUnit: '200',
    // Deprecated
    tagSolidHoverRampUnit: '50',
    tagSolidActiveRampUnit: '100',
    tagSolidDisabledRampUnit: '50',
    tagSolidFontHoverRampUnit: '500',
    tagLightRampUnit: '50',
    tagLightHoverRampUnit: '100',
    tagLightActiveRampUnit: '100',
    tagLightDisabledRampUnit: '50',
    tagLightFontRampUnit: '500',
    tagLightFontHoverRampUnit: '500',
    tagOutlinedHoverRampUnit: '50',
    tagOutlinedActiveRampUnit: '0',
    tagOutlinedFontHoverRampUnit: '400',
    // Neutral
    tagNeutralFontDisabled: themePrimitives.mono600,
    tagNeutralOutlinedDisabled: themePrimitives.mono400,
    tagNeutralSolidFont: themePrimitives.white,
    tagNeutralSolidBackground: themePrimitives.black,
    tagNeutralOutlinedBackground: themePrimitives.mono600,
    tagNeutralOutlinedFont: themePrimitives.black,
    // Deprecated
    tagNeutralSolidHover: themePrimitives.mono300,
    tagNeutralSolidActive: themePrimitives.mono400,
    tagNeutralSolidDisabled: themePrimitives.mono200,
    tagNeutralSolidFontHover: themePrimitives.mono900,
    tagNeutralLightBackground: themePrimitives.mono300,
    tagNeutralLightHover: themePrimitives.mono300,
    tagNeutralLightActive: themePrimitives.mono400,
    tagNeutralLightDisabled: themePrimitives.mono200,
    tagNeutralLightFont: themePrimitives.mono900,
    tagNeutralLightFontHover: themePrimitives.mono900,
    tagNeutralOutlinedActive: themePrimitives.mono900,
    tagNeutralOutlinedFontHover: themePrimitives.mono800,
    tagNeutralOutlinedHover: tagHoverBackground,
    // Primary
    tagPrimaryFontDisabled: themePrimitives.primary400,
    tagPrimaryOutlinedDisabled: themePrimitives.primary200,
    tagPrimarySolidFont: themePrimitives.white,
    tagPrimarySolidBackground: themePrimitives.primary,
    tagPrimaryOutlinedFontHover: themePrimitives.primary,
    tagPrimaryOutlinedFont: themePrimitives.primary,
    // Deprecated
    tagPrimarySolidHover: themePrimitives.primary100,
    tagPrimarySolidActive: themePrimitives.primary200,
    tagPrimarySolidDisabled: themePrimitives.primary50,
    tagPrimarySolidFontHover: themePrimitives.primary700,
    tagPrimaryLightBackground: themePrimitives.primary50,
    tagPrimaryLightHover: themePrimitives.primary100,
    tagPrimaryLightActive: themePrimitives.primary100,
    tagPrimaryLightDisabled: themePrimitives.primary50,
    tagPrimaryLightFont: themePrimitives.primary500,
    tagPrimaryLightFontHover: themePrimitives.primary500,
    tagPrimaryOutlinedActive: themePrimitives.primary600,
    tagPrimaryOutlinedHover: tagHoverBackground,
    tagPrimaryOutlinedBackground: themePrimitives.primary400,
    // Accent
    tagAccentFontDisabled: themePrimitives.accent200,
    tagAccentOutlinedDisabled: themePrimitives.accent200,
    tagAccentSolidFont: themePrimitives.white,
    tagAccentSolidBackground: themePrimitives.accent400,
    tagAccentOutlinedBackground: themePrimitives.accent200,
    tagAccentOutlinedFont: themePrimitives.accent400,
    // Deprecated
    tagAccentSolidHover: themePrimitives.accent50,
    tagAccentSolidActive: themePrimitives.accent100,
    tagAccentSolidDisabled: themePrimitives.accent50,
    tagAccentSolidFontHover: themePrimitives.accent500,
    tagAccentLightBackground: themePrimitives.accent50,
    tagAccentLightHover: themePrimitives.accent100,
    tagAccentLightActive: themePrimitives.accent100,
    tagAccentLightDisabled: themePrimitives.accent50,
    tagAccentLightFont: themePrimitives.accent500,
    tagAccentLightFontHover: themePrimitives.accent500,
    tagAccentOutlinedActive: themePrimitives.accent600,
    tagAccentOutlinedFontHover: themePrimitives.accent400,
    tagAccentOutlinedHover: tagHoverBackground,
    // Positive
    tagPositiveFontDisabled: themePrimitives.positive200,
    tagPositiveOutlinedDisabled: themePrimitives.positive200,
    tagPositiveSolidFont: themePrimitives.white,
    tagPositiveSolidBackground: themePrimitives.positive400,
    tagPositiveOutlinedBackground: themePrimitives.positive200,
    tagPositiveOutlinedFont: themePrimitives.positive400,
    // Deprecated
    tagPositiveSolidHover: themePrimitives.positive50,
    tagPositiveSolidActive: themePrimitives.positive100,
    tagPositiveSolidDisabled: themePrimitives.positive50,
    tagPositiveSolidFontHover: themePrimitives.positive500,
    tagPositiveLightBackground: themePrimitives.positive50,
    tagPositiveLightHover: themePrimitives.positive100,
    tagPositiveLightActive: themePrimitives.positive100,
    tagPositiveLightDisabled: themePrimitives.positive50,
    tagPositiveLightFont: themePrimitives.positive500,
    tagPositiveLightFontHover: themePrimitives.positive500,
    tagPositiveOutlinedActive: themePrimitives.positive600,
    tagPositiveOutlinedFontHover: themePrimitives.positive400,
    tagPositiveOutlinedHover: tagHoverBackground,
    // Warning
    tagWarningFontDisabled: themePrimitives.warning300,
    tagWarningOutlinedDisabled: themePrimitives.warning300,
    tagWarningSolidFont: themePrimitives.warning700,
    tagWarningSolidBackground: themePrimitives.warning400,
    tagWarningOutlinedBackground: themePrimitives.warning300,
    tagWarningOutlinedFont: themePrimitives.warning600,
    // Deprecated
    tagWarningSolidHover: themePrimitives.warning50,
    tagWarningSolidActive: themePrimitives.warning100,
    tagWarningSolidDisabled: themePrimitives.warning50,
    tagWarningSolidFontHover: themePrimitives.warning500,
    tagWarningLightBackground: themePrimitives.warning50,
    tagWarningLightHover: themePrimitives.warning100,
    tagWarningLightActive: themePrimitives.warning100,
    tagWarningLightDisabled: themePrimitives.warning50,
    tagWarningLightFont: themePrimitives.warning500,
    tagWarningLightFontHover: themePrimitives.warning500,
    tagWarningOutlinedActive: themePrimitives.warning600,
    tagWarningOutlinedFontHover: themePrimitives.warning600,
    tagWarningOutlinedHover: tagHoverBackground,
    // Negative
    tagNegativeFontDisabled: themePrimitives.negative200,
    tagNegativeOutlinedDisabled: themePrimitives.negative200,
    tagNegativeSolidFont: themePrimitives.white,
    tagNegativeSolidBackground: themePrimitives.negative400,
    tagNegativeOutlinedBackground: themePrimitives.negative200,
    tagNegativeOutlinedFont: themePrimitives.negative400,
    // Deprecated
    tagNegativeSolidHover: themePrimitives.negative50,
    tagNegativeSolidActive: themePrimitives.negative100,
    tagNegativeSolidDisabled: themePrimitives.negative50,
    tagNegativeSolidFontHover: themePrimitives.negative500,
    tagNegativeLightBackground: themePrimitives.negative50,
    tagNegativeLightHover: themePrimitives.negative100,
    tagNegativeLightActive: themePrimitives.negative100,
    tagNegativeLightDisabled: themePrimitives.negative50,
    tagNegativeLightFont: themePrimitives.negative500,
    tagNegativeLightFontHover: themePrimitives.negative500,
    tagNegativeOutlinedActive: themePrimitives.negative600,
    tagNegativeOutlinedFontHover: themePrimitives.negative400,
    tagNegativeOutlinedHover: tagHoverBackground,
    // Table
    tableHeadBackgroundColor: themePrimitives.mono100,
    tableBackground: themePrimitives.mono100,
    tableStripedBackground: themePrimitives.mono200,
    tableFilter: themePrimitives.mono600,
    tableFilterHeading: themePrimitives.mono700,
    tableFilterBackground: themePrimitives.mono100,
    tableFilterFooterBackground: themePrimitives.mono200,
    // Toast
    toastText: themePrimitives.white,
    toastPrimaryBackground: themePrimitives.primary500,
    toastInfoBackground: themePrimitives.accent500,
    toastPositiveBackground: themePrimitives.positive500,
    toastWarningBackground: themePrimitives.warning500,
    toastNegativeBackground: themePrimitives.negative500,
    // Spinner
    spinnerTrackFill: themePrimitives.mono900,
    // Progress bar
    progressbarTrackFill: themePrimitives.mono900,
    // Tooltip
    tooltipBackground: themePrimitives.mono900,
    tooltipText: themePrimitives.mono100
  };
});

/***/ }),

/***/ 83709:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7358);
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


/* ---- DEPRECATED ---- */
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function () {
  var themePrimitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A;
  return {
    // TODO(#2318) Remove Legacy Semantic Colors values in the next v11 major
    // since it's not used in the component specific tokens
    // and we ship semantic tokens separately

    /* ---- Legacy Semantic Colors ---- */
    // Font Color
    colorPrimary: themePrimitives.black,
    colorSecondary: themePrimitives.mono800,
    // Background
    background: themePrimitives.white,
    backgroundAlt: themePrimitives.white,
    backgroundInv: themePrimitives.primary,
    // Foreground
    foreground: themePrimitives.black,
    foregroundAlt: themePrimitives.mono800,
    foregroundInv: themePrimitives.white,
    // Borders
    border: themePrimitives.mono500,
    borderAlt: themePrimitives.mono600,
    borderFocus: themePrimitives.primary,
    borderError: themePrimitives.negative,
    // Shadow
    shadowFocus: 'rgba(39, 110, 241, 0.32)',
    shadowError: 'rgba(229, 73, 55, 0.32)'
  };
});

/***/ }),

/***/ 46167:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7358);
/* harmony import */ var _styles_util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31099);
/* harmony import */ var _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10919);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function () {
  var foundation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A;
  var core = {
    // Background
    backgroundPrimary: foundation.primaryB,
    backgroundSecondary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.gray50,
    backgroundTertiary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.gray100,
    backgroundInversePrimary: foundation.primaryA,
    backgroundInverseSecondary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.gray800,
    // Content
    contentPrimary: foundation.primaryA,
    contentSecondary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.gray600,
    contentTertiary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.gray500,
    contentInversePrimary: foundation.primaryB,
    contentInverseSecondary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.gray300,
    contentInverseTertiary: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.gray400,
    // Border
    borderOpaque: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.gray200,
    borderTransparent: (0,_styles_util_js__WEBPACK_IMPORTED_MODULE_2__/* .hexToRgb */ .E2)(foundation.primaryA, '0.08'),
    borderSelected: foundation.primaryA,
    borderInverseOpaque: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.gray700,
    borderInverseTransparent: (0,_styles_util_js__WEBPACK_IMPORTED_MODULE_2__/* .hexToRgb */ .E2)(foundation.primaryB, '0.2'),
    borderInverseSelected: foundation.primaryB
  };
  var coreExtensions = {
    // Backgrounds
    backgroundStateDisabled: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.gray50,
    backgroundOverlayDark: (0,_styles_util_js__WEBPACK_IMPORTED_MODULE_2__/* .hexToRgb */ .E2)(_tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.black, '0.3'),
    backgroundOverlayLight: (0,_styles_util_js__WEBPACK_IMPORTED_MODULE_2__/* .hexToRgb */ .E2)(_tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.black, '0.08'),
    backgroundAccent: foundation.accent,
    backgroundNegative: foundation.negative,
    backgroundWarning: foundation.warning,
    backgroundPositive: foundation.positive,
    backgroundLightAccent: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.blue50,
    backgroundLightNegative: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.red50,
    backgroundLightWarning: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.yellow50,
    backgroundLightPositive: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.green50,
    backgroundAlwaysDark: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.black,
    backgroundAlwaysLight: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.white,
    // Content
    contentStateDisabled: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.gray400,
    contentAccent: foundation.accent,
    contentOnColor: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.white,
    contentOnColorInverse: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.black,
    contentNegative: foundation.negative,
    contentWarning: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.yellow700,
    contentPositive: foundation.positive,
    // Border
    borderStateDisabled: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.gray50,
    borderAccent: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.blue400,
    borderAccentLight: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.blue200,
    borderNegative: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.red200,
    borderWarning: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.yellow200,
    borderPositive: _tokens_colors_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.green200
  };
  return _objectSpread(_objectSpread({}, core), coreExtensions);
});

/***/ }),

/***/ 7358:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10919);
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

// color constants
var lightColorTokens = {
  // Primary Palette
  primaryA: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.black,
  primaryB: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.white,
  primary: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.black,
  primary50: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray50,
  primary100: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray100,
  primary200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray200,
  primary300: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray300,
  primary400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray400,
  primary500: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray500,
  primary600: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray600,
  primary700: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray700,
  // Accent Palette
  accent: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.blue400,
  accent50: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.blue50,
  accent100: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.blue100,
  accent200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.blue200,
  accent300: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.blue300,
  accent400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.blue400,
  accent500: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.blue500,
  accent600: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.blue600,
  accent700: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.blue700,
  // Negative Palette
  negative: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.red400,
  negative50: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.red50,
  negative100: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.red100,
  negative200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.red200,
  negative300: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.red300,
  negative400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.red400,
  negative500: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.red500,
  negative600: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.red600,
  negative700: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.red700,
  // Warning Palette
  warning: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.yellow400,
  warning50: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.yellow50,
  warning100: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.yellow100,
  warning200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.yellow200,
  warning300: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.yellow300,
  warning400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.yellow400,
  warning500: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.yellow500,
  warning600: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.yellow600,
  warning700: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.yellow700,
  // Positive Palette
  positive: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.green500,
  positive50: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.green50,
  positive100: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.green100,
  positive200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.green200,
  positive300: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.green300,
  positive400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.green400,
  positive500: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.green500,
  positive600: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.green600,
  positive700: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.green700,
  // Monochrome Palette
  white: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.white,
  black: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.black,
  mono100: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.white,
  mono200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray50,
  mono300: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray100,
  mono400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray200,
  mono500: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray300,
  mono600: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray400,
  mono700: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray500,
  mono800: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray600,
  mono900: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray700,
  mono1000: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.black,
  // Rating Palette,
  rating200: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.yellow200,
  rating400: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.yellow400,
  ratingInactiveFill: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray100,
  ratingStroke: _tokens_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A.gray300
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (lightColorTokens);

/***/ }),

/***/ 78739:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ createLightTheme)
/* harmony export */ });
/* harmony import */ var _shared_animation_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92879);
/* harmony import */ var _shared_borders_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53674);
/* harmony import */ var _shared_breakpoints_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45981);
/* harmony import */ var _utils_deep_merge_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75);
/* harmony import */ var _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7358);
/* harmony import */ var _color_component_tokens_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94224);
/* harmony import */ var _color_deprecated_semantic_tokens_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83709);
/* harmony import */ var _color_semantic_tokens_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46167);
/* harmony import */ var _shared_typography_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29792);
/* harmony import */ var _shared_grid_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7533);
/* harmony import */ var _shared_lighting_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93829);
/* harmony import */ var _shared_media_query_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42136);
/* harmony import */ var _shared_sizing_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75571);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/













function createLightTheme() {
  var primitives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var // Used to override default theme property values derived from primitives
  overrides = arguments.length > 1 ? arguments[1] : undefined;

  // Extract font tokens and color tokens from primitives
  var primaryFontFamily = primitives.primaryFontFamily,
      customColorTokens = _objectWithoutProperties(primitives, ["primaryFontFamily"]); // Assemble color tokens by overriding defaults with custom color tokens


  var colorTokens = _objectSpread(_objectSpread({}, _color_tokens_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A), customColorTokens);

  var theme = {
    animation: _shared_animation_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A,
    borders: _shared_borders_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A,
    breakpoints: _shared_breakpoints_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A,
    colors: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, colorTokens), (0,_color_component_tokens_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(colorTokens)), (0,_color_deprecated_semantic_tokens_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(colorTokens)), (0,_color_semantic_tokens_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(colorTokens)),
    direction: 'auto',
    grid: _shared_grid_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A,
    lighting: _shared_lighting_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A,
    mediaQuery: _shared_media_query_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A,
    sizing: _shared_sizing_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .A,
    // If primaryFontFamily is not provided, we use our default font tokens
    typography: primaryFontFamily ? (0,_shared_typography_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .A)({
      primaryFontFamily: primaryFontFamily
    }) : (0,_shared_typography_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .A)(),
    // TODO(#2318) Remove in v11, the next major version.
    // Do not use.
    zIndex: {
      modal: 2000
    }
  };
  return (0,_utils_deep_merge_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .A)({}, theme, overrides);
}

/***/ }),

/***/ 92879:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var animation = {
  timing100: '100ms',
  timing200: '200ms',
  timing300: '300ms',
  timing400: '400ms',
  timing500: '500ms',
  timing600: '600ms',
  timing700: '700ms',
  timing800: '800ms',
  timing900: '900ms',
  timing1000: '1000ms',
  easeInCurve: 'cubic-bezier(.8, .2, .6, 1)',
  easeOutCurve: 'cubic-bezier(.2, .8, .4, 1)',
  easeInOutCurve: 'cubic-bezier(0.4, 0, 0.2, 1)',
  easeInQuinticCurve: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
  easeOutQuinticCurve: 'cubic-bezier(0.23, 1, 0.32, 1)',
  easeInOutQuinticCurve: 'cubic-bezier(0.86, 0, 0.07, 1)',
  linearCurve: 'cubic-bezier(0, 0, 1, 1)'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (animation);

/***/ }),

/***/ 53674:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// borderColor is defaulted to the light theme values.
// Dark theme overrides the border colors.
var borders = {
  border100: {
    borderColor: 'hsla(0, 0%, 0%, 0.04)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border200: {
    borderColor: 'hsla(0, 0%, 0%, 0.08)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border300: {
    borderColor: 'hsla(0, 0%, 0%, 0.12)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border400: {
    borderColor: 'hsla(0, 0%, 0%, 0.16)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border500: {
    borderColor: 'hsla(0, 0%, 0%, 0.2)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  border600: {
    borderColor: 'hsla(0, 0%, 0%, 0.24)',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  radius100: '2px',
  radius200: '4px',
  radius300: '8px',
  radius400: '12px',
  radius500: '16px',

  /** Datepicker (Range), Progress Bar, Slider, Tag */
  useRoundedCorners: true,

  /** Button, ButtonGroup */
  buttonBorderRadius: '0px',

  /** Input, Select, Textarea, Checkbox */
  inputBorderRadius: '0px',

  /** Popover, Menu, Tooltip */
  popoverBorderRadius: '0px',

  /** Card, Datepicker, Modal, Toast, Notification */
  surfaceBorderRadius: '0px',

  /** Tag */
  tagBorderRadius: '24px'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (borders);

/***/ }),

/***/ 45981:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var breakpoints = {
  small: 320,
  medium: 600,
  large: 1136
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (breakpoints);

/***/ }),

/***/ 7533:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var grid = {
  columns: [4, 8, 12],
  gutters: [16, 36, 36],
  margins: [16, 36, 64],
  gaps: 0,
  unit: 'px',
  maxWidth: 1280
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (grid);

/***/ }),

/***/ 93829:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var lighting = {
  shadow400: '0 1px 4px hsla(0, 0%, 0%, 0.16)',
  shadow500: '0 2px 8px hsla(0, 0%, 0%, 0.16)',
  shadow600: '0 4px 16px hsla(0, 0%, 0%, 0.16)',
  shadow700: '0 8px 24px hsla(0, 0%, 0%, 0.16)',
  overlay0: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0)',
  overlay100: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.04)',
  overlay200: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.08)',
  overlay300: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.12)',
  overlay400: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.16)',
  overlay500: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.2)',
  overlay600: 'inset 0 0 0 1000px hsla(0, 0%, 0%, 0.24)'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (lighting);

/***/ }),

/***/ 42136:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _helpers_responsive_helpers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67618);
/* harmony import */ var _breakpoints_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45981);
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/


var mediaQuery = {
  small: (0,_helpers_responsive_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .getMediaQuery */ .F)(_breakpoints_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.small),
  medium: (0,_helpers_responsive_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .getMediaQuery */ .F)(_breakpoints_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.medium),
  large: (0,_helpers_responsive_helpers_js__WEBPACK_IMPORTED_MODULE_0__/* .getMediaQuery */ .F)(_breakpoints_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A.large)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (mediaQuery);

/***/ }),

/***/ 75571:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var sizing = {
  scale0: '2px',
  scale100: '4px',
  scale200: '6px',
  scale300: '8px',
  scale400: '10px',
  scale500: '12px',
  scale550: '14px',
  scale600: '16px',
  scale650: '18px',
  scale700: '20px',
  scale750: '22px',
  scale800: '24px',
  scale850: '28px',
  scale900: '32px',
  scale950: '36px',
  scale1000: '40px',
  scale1200: '48px',
  scale1400: '56px',
  scale1600: '64px',
  scale2400: '96px',
  scale3200: '128px',
  scale4800: '192px'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (sizing);

/***/ }),

/***/ 29792:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export defaultFontTokens */
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var defaultFontTokens = {
  primaryFontFamily: 'system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif'
};
var monoFontFamily = '"Lucida Console", Monaco, monospace';
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function () {
  var fontTokens = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultFontTokens;
  var font100 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: '20px'
  };
  var font150 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px'
  };
  var font200 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '20px'
  };
  var font250 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '16px'
  };
  var font300 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '16px',
    fontWeight: 'normal',
    lineHeight: '24px'
  };
  var font350 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px'
  };
  var font400 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '18px',
    fontWeight: 'normal',
    lineHeight: '28px'
  };
  var font450 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '24px'
  };
  var font550 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '28px'
  };
  var font650 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '32px'
  };
  var font750 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '28px',
    fontWeight: 500,
    lineHeight: '36px'
  };
  var font850 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '32px',
    fontWeight: 500,
    lineHeight: '40px'
  };
  var font950 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '36px',
    fontWeight: 500,
    lineHeight: '44px'
  };
  var font1050 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '40px',
    fontWeight: 500,
    lineHeight: '52px'
  };
  var font1150 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '36px',
    fontWeight: 500,
    lineHeight: '44px'
  };
  var font1250 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '44px',
    fontWeight: 500,
    lineHeight: '52px'
  };
  var font1350 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '52px',
    fontWeight: 500,
    lineHeight: '64px'
  };
  var font1450 = {
    fontFamily: fontTokens.primaryFontFamily,
    fontSize: '96px',
    fontWeight: 500,
    lineHeight: '112px'
  };
  return {
    font100: font100,
    font150: font150,
    font200: font200,
    font250: font250,
    font300: font300,
    font350: font350,
    font400: font400,
    font450: font450,
    font550: font550,
    font650: font650,
    font750: font750,
    font850: font850,
    font950: font950,
    font1050: font1050,
    font1150: font1150,
    font1250: font1250,
    font1350: font1350,
    font1450: font1450,
    ParagraphXSmall: font100,
    ParagraphSmall: font200,
    ParagraphMedium: font300,
    ParagraphLarge: font400,
    LabelXSmall: font150,
    LabelSmall: font250,
    LabelMedium: font350,
    LabelLarge: font450,
    HeadingXSmall: font550,
    HeadingSmall: font650,
    HeadingMedium: font750,
    HeadingLarge: font850,
    HeadingXLarge: font950,
    HeadingXXLarge: font1050,
    DisplayXSmall: font1150,
    DisplaySmall: font1250,
    DisplayMedium: font1350,
    DisplayLarge: font1450,
    MonoParagraphXSmall: _objectSpread(_objectSpread({}, font100), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphSmall: _objectSpread(_objectSpread({}, font200), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphMedium: _objectSpread(_objectSpread({}, font300), {}, {
      fontFamily: monoFontFamily
    }),
    MonoParagraphLarge: _objectSpread(_objectSpread({}, font400), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelXSmall: _objectSpread(_objectSpread({}, font150), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelSmall: _objectSpread(_objectSpread({}, font250), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelMedium: _objectSpread(_objectSpread({}, font350), {}, {
      fontFamily: monoFontFamily
    }),
    MonoLabelLarge: _objectSpread(_objectSpread({}, font450), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXSmall: _objectSpread(_objectSpread({}, font550), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingSmall: _objectSpread(_objectSpread({}, font650), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingMedium: _objectSpread(_objectSpread({}, font750), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingLarge: _objectSpread(_objectSpread({}, font850), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXLarge: _objectSpread(_objectSpread({}, font950), {}, {
      fontFamily: monoFontFamily
    }),
    MonoHeadingXXLarge: _objectSpread(_objectSpread({}, font1050), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayXSmall: _objectSpread(_objectSpread({}, font1150), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplaySmall: _objectSpread(_objectSpread({}, font1250), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayMedium: _objectSpread(_objectSpread({}, font1350), {}, {
      fontFamily: monoFontFamily
    }),
    MonoDisplayLarge: _objectSpread(_objectSpread({}, font1450), {}, {
      fontFamily: monoFontFamily
    })
  };
});

/***/ }),

/***/ 4917:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   El: () => (/* binding */ PLACEMENT),
/* harmony export */   Nd: () => (/* binding */ KIND),
/* harmony export */   ZE: () => (/* binding */ TYPE)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var KIND = Object.freeze({
  info: 'info',
  positive: 'positive',
  warning: 'warning',
  negative: 'negative'
});
var TYPE = Object.freeze({
  inline: 'inline',
  toast: 'toast'
});
var PLACEMENT = Object.freeze({
  topLeft: 'topLeft',
  top: 'top',
  topRight: 'topRight',
  bottomRight: 'bottomRight',
  bottom: 'bottom',
  bottomLeft: 'bottomLeft'
});

/***/ }),

/***/ 32777:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  o: () => (/* binding */ ToasterContainer),
  A: () => (/* binding */ toast_toaster)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(81724);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/react-dom/index.js
var react_dom = __webpack_require__(23882);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/helpers/overrides.js
var overrides = __webpack_require__(78803);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/toast/constants.js
var constants = __webpack_require__(4917);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(89944);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/styled-components.js
var styled_components = __webpack_require__(50182);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/toast/styled-components.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/




function getBackgroundColor(kind, type, theme) {
  var _KIND$info$KIND$posit;

  var isInline = type === constants/* TYPE */.ZE.inline;
  return (_KIND$info$KIND$posit = {}, _defineProperty(_KIND$info$KIND$posit, constants/* KIND */.Nd.info, isInline ? theme.colors.notificationInfoBackground : theme.colors.toastInfoBackground), _defineProperty(_KIND$info$KIND$posit, constants/* KIND */.Nd.positive, isInline ? theme.colors.notificationPositiveBackground : theme.colors.toastPositiveBackground), _defineProperty(_KIND$info$KIND$posit, constants/* KIND */.Nd.warning, isInline ? theme.colors.notificationWarningBackground : theme.colors.toastWarningBackground), _defineProperty(_KIND$info$KIND$posit, constants/* KIND */.Nd.negative, isInline ? theme.colors.notificationNegativeBackground : theme.colors.toastNegativeBackground), _KIND$info$KIND$posit)[kind];
}

function getFontColor(kind, theme) {
  var _KIND$info$KIND$posit2;

  return (_KIND$info$KIND$posit2 = {}, _defineProperty(_KIND$info$KIND$posit2, constants/* KIND */.Nd.info, theme.colors.notificationInfoText), _defineProperty(_KIND$info$KIND$posit2, constants/* KIND */.Nd.positive, theme.colors.notificationPositiveText), _defineProperty(_KIND$info$KIND$posit2, constants/* KIND */.Nd.warning, theme.colors.notificationWarningText), _defineProperty(_KIND$info$KIND$posit2, constants/* KIND */.Nd.negative, theme.colors.notificationNegativeText), _KIND$info$KIND$posit2)[kind];
}

function getPlacement(placement) {
  var _PLACEMENT$topLeft$PL;

  return (_PLACEMENT$topLeft$PL = {}, _defineProperty(_PLACEMENT$topLeft$PL, constants/* PLACEMENT */.El.topLeft, {
    top: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column'
  }), _defineProperty(_PLACEMENT$topLeft$PL, constants/* PLACEMENT */.El.top, {
    top: 0,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column'
  }), _defineProperty(_PLACEMENT$topLeft$PL, constants/* PLACEMENT */.El.topRight, {
    top: 0,
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    flexDirection: 'column'
  }), _defineProperty(_PLACEMENT$topLeft$PL, constants/* PLACEMENT */.El.bottomRight, {
    bottom: 0,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    flexDirection: 'column-reverse'
  }), _defineProperty(_PLACEMENT$topLeft$PL, constants/* PLACEMENT */.El.bottom, {
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'column-reverse'
  }), _defineProperty(_PLACEMENT$topLeft$PL, constants/* PLACEMENT */.El.bottomLeft, {
    bottom: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    flexDirection: 'column-reverse'
  }), _PLACEMENT$topLeft$PL)[placement];
} // $FlowFixMe https://github.com/facebook/flow/issues/7745

var styled_components_Root = (0,styled/* styled */.I4)('div', function (props) {
  var $placement = props.$placement,
      $theme = props.$theme;
  return _objectSpread({
    pointerEvents: 'none',
    position: 'fixed',
    right: 0,
    left: 0,
    display: 'flex',
    marginTop: $theme.sizing.scale300,
    marginBottom: $theme.sizing.scale300,
    marginLeft: $theme.sizing.scale600,
    marginRight: $theme.sizing.scale600
  }, getPlacement($placement));
}); // $FlowFixMe https://github.com/facebook/flow/issues/7745

styled_components_Root.displayName = "Root";
var styled_components_InnerContainer = (0,styled/* styled */.I4)('div', {}); // $FlowFixMe https://github.com/facebook/flow/issues/7745

styled_components_InnerContainer.displayName = "InnerContainer";
var styled_components_Body = (0,styled/* styled */.I4)('div', function (props) {
  var $isVisible = props.$isVisible,
      $kind = props.$kind,
      $type = props.$type,
      $theme = props.$theme;
  var isInline = $type === constants/* TYPE */.ZE.inline;
  return _objectSpread(_objectSpread({}, $theme.typography.font250), {}, {
    pointerEvents: 'auto',
    color: isInline ? getFontColor($kind, $theme) : $theme.colors.toastText,
    height: 'auto',
    width: '288px',
    paddingTop: $theme.sizing.scale600,
    paddingRight: $theme.sizing.scale600,
    paddingBottom: $theme.sizing.scale600,
    paddingLeft: $theme.sizing.scale600,
    marginTop: $theme.sizing.scale300,
    marginBottom: $theme.sizing.scale300,
    backgroundColor: getBackgroundColor($kind, $type, $theme) || $theme.colors.accent,
    borderTopLeftRadius: $theme.borders.radius400,
    borderTopRightRadius: $theme.borders.radius400,
    borderBottomRightRadius: $theme.borders.radius400,
    borderBottomLeftRadius: $theme.borders.radius400,
    boxShadow: isInline ? 'none' : $theme.lighting.shadow600,
    opacity: $isVisible ? 1 : 0,
    transitionProperty: 'all',
    transitionDuration: $theme.animation.timing200,
    transitionTimingFunction: $theme.animation.easeInOutCurve,
    display: 'flex',
    justifyContent: 'space-between'
  });
}); // $FlowFixMe https://github.com/facebook/flow/issues/7745

styled_components_Body.displayName = "Body";
var CloseIconSvg = (0,styled/* styled */.I4)('svg', function (props) {
  return _objectSpread(_objectSpread({}, (0,styled_components/* getSvgStyles */.P)(props)), {}, {
    cursor: 'pointer',
    width: props.$size || '16px',
    flexShrink: 0,
    outline: props.$isFocusVisible ? "3px solid ".concat(props.$theme.colors.accent) : 'none'
  });
});
CloseIconSvg.displayName = "CloseIconSvg";
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/delete.js
var icon_delete = __webpack_require__(94989);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/locale/index.js + 13 modules
var locale = __webpack_require__(31277);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/utils/focusVisible.js
var focusVisible = __webpack_require__(7714);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/toast/toast.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function toast_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* global document */








var Toast = /*#__PURE__*/function (_React$Component) {
  _inherits(Toast, _React$Component);

  var _super = _createSuper(Toast);

  function Toast(props) {
    var _this;

    _classCallCheck(this, Toast);

    _this = _super.call(this, props);

    toast_defineProperty(_assertThisInitialized(_this), "autoHideTimeout", void 0);

    toast_defineProperty(_assertThisInitialized(_this), "animateInTimer", void 0);

    toast_defineProperty(_assertThisInitialized(_this), "animateOutCompleteTimer", void 0);

    toast_defineProperty(_assertThisInitialized(_this), "closeRef", void 0);

    toast_defineProperty(_assertThisInitialized(_this), "previouslyFocusedElement", void 0);

    toast_defineProperty(_assertThisInitialized(_this), "state", {
      isVisible: false,
      isRendered: true,
      isFocusVisible: false
    });

    toast_defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      if ((0,focusVisible/* isFocusVisible */.pP)(event)) {
        _this.setState({
          isFocusVisible: true
        });
      }
    });

    toast_defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      if (_this.state.isFocusVisible !== false) {
        _this.setState({
          isFocusVisible: false
        });
      }
    });

    toast_defineProperty(_assertThisInitialized(_this), "animateIn", function () {
      // Defer to next event loop
      _this.animateInTimer = setTimeout(function () {
        _this.setState({
          isVisible: true
        });
      }, 0);
    });

    toast_defineProperty(_assertThisInitialized(_this), "animateOut", function () {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      _this.setState({
        isVisible: false
      }); // Remove the toast from the DOM after animation finishes


      _this.animateOutCompleteTimer = setTimeout(function () {
        _this.setState({
          isRendered: false
        });

        callback();
      }, 600);
    });

    toast_defineProperty(_assertThisInitialized(_this), "dismiss", function () {
      _this.animateOut(_this.props.onClose);

      if (_this.props.autoFocus && _this.previouslyFocusedElement) {
        _this.previouslyFocusedElement.focus();
      }
    });

    toast_defineProperty(_assertThisInitialized(_this), "onFocus", function (e) {
      if (!_this.state.isVisible) return;
      clearTimeout(_this.autoHideTimeout);
      clearTimeout(_this.animateOutCompleteTimer);
      typeof _this.props.onFocus === 'function' && _this.props.onFocus(e);
    });

    toast_defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (e) {
      if (!_this.state.isVisible) return;
      clearTimeout(_this.autoHideTimeout);
      clearTimeout(_this.animateOutCompleteTimer);
      typeof _this.props.onMouseEnter === 'function' && _this.props.onMouseEnter(e);
    });

    toast_defineProperty(_assertThisInitialized(_this), "onBlur", function (e) {
      _this.startTimeout();

      typeof _this.props.onBlur === 'function' && _this.props.onBlur(e);
    });

    toast_defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (e) {
      _this.startTimeout();

      typeof _this.props.onMouseLeave === 'function' && _this.props.onMouseLeave(e);
    });

    _this.closeRef = /*#__PURE__*/react.createRef();
    _this.previouslyFocusedElement = null;
    return _this;
  }

  _createClass(Toast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.animateIn();
      this.startTimeout();

      if (typeof document !== 'undefined' && this.props.autoFocus && this.closeRef && this.closeRef.current && this.closeRef.current.focus && typeof this.closeRef.current.focus === 'function') {
        this.previouslyFocusedElement = document.activeElement; // $FlowFixMe: CloseIcon is `mixed` type so doesn't like `focus` call.

        this.closeRef.current.focus();
        this.setState({
          isFocusVisible: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.autoHideDuration !== prevProps.autoHideDuration || this.props.__updated !== prevProps.__updated) {
        this.startTimeout();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimeout();
    }
  }, {
    key: "startTimeout",
    value: function startTimeout() {
      if (this.props.autoHideDuration) {
        if (this.autoHideTimeout) {
          clearTimeout(this.autoHideTimeout);
        }

        this.autoHideTimeout = setTimeout(this.dismiss, this.props.autoHideDuration);
      }
    }
  }, {
    key: "clearTimeout",
    value: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      [this.autoHideTimeout, this.animateInTimer, this.animateOutCompleteTimer].forEach(function (timerId) {
        if (timerId) {
          clearTimeout(timerId);
        }
      });
    })
  }, {
    key: "getSharedProps",
    value: function getSharedProps() {
      var _this$props = this.props,
          kind = _this$props.kind,
          notificationType = _this$props.notificationType,
          closeable = _this$props.closeable;
      var _this$state = this.state,
          isRendered = _this$state.isRendered,
          isVisible = _this$state.isVisible;
      return {
        $kind: kind,
        $type: notificationType,
        $closeable: closeable,
        $isRendered: isRendered,
        $isVisible: isVisible
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          closeable = _this$props2.closeable;
      var isRendered = this.state.isRendered;
      var _this$props$overrides = this.props.overrides,
          BodyOverride = _this$props$overrides.Body,
          CloseIconOverride = _this$props$overrides.CloseIcon,
          InnerContainerOverride = _this$props$overrides.InnerContainer;

      var _getOverrides = (0,overrides/* getOverrides */._O)(BodyOverride, styled_components_Body),
          _getOverrides2 = _slicedToArray(_getOverrides, 2),
          Body = _getOverrides2[0],
          bodyProps = _getOverrides2[1];

      var _getOverrides3 = (0,overrides/* getOverrides */._O)(InnerContainerOverride, styled_components_InnerContainer),
          _getOverrides4 = _slicedToArray(_getOverrides3, 2),
          InnerContainer = _getOverrides4[0],
          innerContainerProps = _getOverrides4[1];

      var _getOverrides5 = (0,overrides/* getOverrides */._O)(CloseIconOverride, CloseIconSvg),
          _getOverrides6 = _slicedToArray(_getOverrides5, 2),
          CloseIcon = _getOverrides6[0],
          closeIconProps = _getOverrides6[1];

      var closeIconOverrides = (0,overrides/* mergeOverrides */.Qp)({
        Svg: {
          component: CloseIcon
        }
      }, // $FlowFixMe
      {
        Svg: CloseIconOverride
      });
      var sharedProps = this.getSharedProps();

      if (!isRendered) {
        return null;
      }

      return /*#__PURE__*/react.createElement(locale/* LocaleContext */.U.Consumer, null, function (locale) {
        return /*#__PURE__*/react.createElement(Body, _extends({
          role: "alert",
          "data-baseweb": _this2.props['data-baseweb'] || 'toast'
        }, sharedProps, bodyProps, {
          // the properties below have to go after overrides
          onBlur: _this2.onBlur,
          onFocus: _this2.onFocus,
          onMouseEnter: _this2.onMouseEnter,
          onMouseLeave: _this2.onMouseLeave
        }), /*#__PURE__*/react.createElement(InnerContainer, _extends({}, sharedProps, innerContainerProps), typeof children === 'function' ? children({
          dismiss: _this2.dismiss
        }) : children), closeable ? /*#__PURE__*/react.createElement(icon_delete/* default */.A, _extends({
          ref: _this2.closeRef,
          role: "button",
          tabIndex: 0,
          $isFocusVisible: _this2.state.isFocusVisible,
          onClick: _this2.dismiss,
          onKeyPress: function onKeyPress(event) {
            if (event.key === 'Enter') {
              _this2.dismiss();
            }
          },
          title: locale.toast.close
        }, sharedProps, closeIconProps, {
          onFocus: (0,focusVisible/* forkFocus */.pL)(closeIconProps, _this2.handleFocus),
          onBlur: (0,focusVisible/* forkBlur */.iw)(closeIconProps, _this2.handleBlur),
          overrides: closeIconOverrides
        })) : null);
      });
    }
  }]);

  return Toast;
}(react.Component);

toast_defineProperty(Toast, "defaultProps", {
  autoFocus: false,
  autoHideDuration: 0,
  closeable: true,
  kind: constants/* KIND */.Nd.info,
  notificationType: constants/* TYPE */.ZE.toast,
  // Do we need a separate handler for
  // when a notification dismisses automatically
  onClose: function onClose() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  overrides: {}
});

/* harmony default export */ const toast = (Toast);
;// ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/toast/toaster.js
function toaster_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { toaster_typeof = function _typeof(obj) { return typeof obj; }; } else { toaster_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return toaster_typeof(obj); }

function toaster_slicedToArray(arr, i) { return toaster_arrayWithHoles(arr) || toaster_iterableToArrayLimit(arr, i) || toaster_unsupportedIterableToArray(arr, i) || toaster_nonIterableRest(); }

function toaster_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function toaster_iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function toaster_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function toaster_extends() { toaster_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return toaster_extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || toaster_unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function toaster_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return toaster_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return toaster_arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return toaster_arrayLikeToArray(arr); }

function toaster_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function toaster_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function toaster_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { toaster_ownKeys(Object(source), true).forEach(function (key) { toaster_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { toaster_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function toaster_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function toaster_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function toaster_createClass(Constructor, protoProps, staticProps) { if (protoProps) toaster_defineProperties(Constructor.prototype, protoProps); if (staticProps) toaster_defineProperties(Constructor, staticProps); return Constructor; }

function toaster_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) toaster_setPrototypeOf(subClass, superClass); }

function toaster_setPrototypeOf(o, p) { toaster_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return toaster_setPrototypeOf(o, p); }

function toaster_createSuper(Derived) { var hasNativeReflectConstruct = toaster_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = toaster_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = toaster_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return toaster_possibleConstructorReturn(this, result); }; }

function toaster_possibleConstructorReturn(self, call) { if (call && (toaster_typeof(call) === "object" || typeof call === "function")) { return call; } return toaster_assertThisInitialized(self); }

function toaster_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function toaster_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function toaster_getPrototypeOf(o) { toaster_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return toaster_getPrototypeOf(o); }

function toaster_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable cup/no-undef */






var toasterRef = null;
var ToasterContainer = /*#__PURE__*/function (_React$Component) {
  toaster_inherits(ToasterContainer, _React$Component);

  var _super = toaster_createSuper(ToasterContainer);

  function ToasterContainer(_props) {
    var _this;

    toaster_classCallCheck(this, ToasterContainer);

    _this = _super.call(this, _props);

    toaster_defineProperty(toaster_assertThisInitialized(_this), "state", {
      isMounted: false,
      toasts: []
    });

    toaster_defineProperty(toaster_assertThisInitialized(_this), "dismissHandlers", {});

    toaster_defineProperty(toaster_assertThisInitialized(_this), "toastId", 0);

    toaster_defineProperty(toaster_assertThisInitialized(_this), "getToastProps", function (props) {
      var _this$props = _this.props,
          autoFocus = _this$props.autoFocus,
          autoHideDuration = _this$props.autoHideDuration,
          closeable = _this$props.closeable;
      var key = props.key || "toast-".concat(_this.toastId++);
      return toaster_objectSpread(toaster_objectSpread({
        autoFocus: autoFocus,
        autoHideDuration: autoHideDuration,
        closeable: closeable
      }, props), {}, {
        key: key
      });
    });

    toaster_defineProperty(toaster_assertThisInitialized(_this), "show", function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (_this.state.toasts.map(function (t) {
        return t.key;
      }).includes(props.key)) {
        _this.update(props.key, props);

        return props.key;
      }

      var toastProps = _this.getToastProps(props);

      _this.setState(function (_ref) {
        var toasts = _ref.toasts;
        return {
          toasts: [].concat(_toConsumableArray(toasts), [toastProps])
        };
      });

      return toastProps.key;
    });

    toaster_defineProperty(toaster_assertThisInitialized(_this), "update", function (key, props) {
      _this.setState(function (_ref2) {
        var toasts = _ref2.toasts;
        var updatedToasts = toasts.map(function (toast) {
          if (toast.key === key) {
            var updatedToastProps = toaster_objectSpread(toaster_objectSpread(toaster_objectSpread({}, toast), _this.getToastProps(toaster_objectSpread({
              autoHideDuration: toast.autoHideDuration
            }, props))), {}, {
              key: key
            }, _this.props.resetAutoHideTimerOnUpdate ? {
              __updated: (parseInt(toast.__updated) || 0) + 1
            } : {});

            return updatedToastProps;
          }

          return toast;
        });
        return {
          toasts: updatedToasts
        };
      });
    });

    toaster_defineProperty(toaster_assertThisInitialized(_this), "dismiss", function (key) {
      if (_this.dismissHandlers[key]) {
        _this.dismissHandlers[key]();
      }
    });

    toaster_defineProperty(toaster_assertThisInitialized(_this), "clearAll", function () {
      Object.keys(_this.dismissHandlers).forEach(function (key) {
        _this.dismissHandlers[key]();
      });
    });

    toaster_defineProperty(toaster_assertThisInitialized(_this), "clear", function (key) {
      key === undefined ? _this.clearAll() : _this.dismiss(key);
    });

    toaster_defineProperty(toaster_assertThisInitialized(_this), "internalOnClose", function (key) {
      delete _this.dismissHandlers[key];

      _this.setState(function (_ref3) {
        var toasts = _ref3.toasts;
        return {
          toasts: toasts.filter(function (t) {
            return !(t.key === key);
          })
        };
      });
    });

    toaster_defineProperty(toaster_assertThisInitialized(_this), "getOnCloseHandler", function (key, onClose) {
      return function () {
        _this.internalOnClose(key);

        typeof onClose === 'function' && onClose();
      };
    });

    toaster_defineProperty(toaster_assertThisInitialized(_this), "renderToast", function (toastProps) {
      var onClose = toastProps.onClose,
          children = toastProps.children,
          key = toastProps.key,
          restProps = _objectWithoutProperties(toastProps, ["onClose", "children", "key"]);

      var _this$props$overrides = _this.props.overrides,
          BodyOverride = _this$props$overrides.ToastBody,
          CloseIconOverride = _this$props$overrides.ToastCloseIcon,
          InnerContainerOverride = _this$props$overrides.ToastInnerContainer;
      var globalToastOverrides = (0,overrides/* mergeOverrides */.Qp)({
        Body: styled_components_Body,
        CloseIcon: CloseIconSvg,
        InnerContainer: styled_components_InnerContainer
      }, // $FlowFixMe
      {
        Body: BodyOverride,
        CloseIcon: CloseIconOverride,
        InnerContainer: InnerContainerOverride
      });
      var toastOverrides = (0,overrides/* mergeOverrides */.Qp)(globalToastOverrides, toastProps.overrides);
      return /*#__PURE__*/react.createElement(toast, toaster_extends({}, restProps, {
        overrides: toastOverrides,
        key: key,
        onClose: _this.getOnCloseHandler(key, onClose)
      }), function (_ref4) {
        var dismiss = _ref4.dismiss;
        _this.dismissHandlers[key] = dismiss; // $FlowFixMe

        return children;
      });
    });

    toaster_defineProperty(toaster_assertThisInitialized(_this), "getSharedProps", function () {
      var placement = _this.props.placement;
      return {
        $placement: placement
      };
    });

    toasterRef = toaster_assertThisInitialized(_this);
    return _this;
  }

  toaster_createClass(ToasterContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isMounted: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var sharedProps = this.getSharedProps();
      var RootOverride = this.props.overrides.Root;

      var _getOverrides = (0,overrides/* getOverrides */._O)(RootOverride, styled_components_Root),
          _getOverrides2 = toaster_slicedToArray(_getOverrides, 2),
          Root = _getOverrides2[0],
          rootProps = _getOverrides2[1];

      var toastsLength = this.state.toasts.length;
      var toastsToRender = []; // render the toasts from the newest at the start
      // to the oldest at the end
      // eslint-disable-next-line for-direction

      for (var i = toastsLength - 1; i >= 0; i--) {
        toastsToRender.push(this.renderToast(this.state.toasts[i]));
      }

      var root = /*#__PURE__*/react.createElement(Root, toaster_extends({
        "data-baseweb": "toaster"
      }, sharedProps, rootProps), toastsToRender); //Only render the portal in the browser, otherwise render the toasts and children

      if (this.state.isMounted) {
        return /*#__PURE__*/react.createElement(react.Fragment, null, this.props.usePortal && typeof document !== 'undefined' ? /*#__PURE__*/react_dom.createPortal(root, // $FlowFixMe
        document.body) : root, this.props.children);
      } else {
        return /*#__PURE__*/react.createElement(react.Fragment, null, this.props.children);
      }
    }
  }]);

  return ToasterContainer;
}(react.Component);

toaster_defineProperty(ToasterContainer, "defaultProps", {
  autoFocus: false,
  autoHideDuration: 0,
  children: null,
  closeable: true,
  overrides: {},
  placement: constants/* PLACEMENT */.El.top,
  resetAutoHideTimerOnUpdate: true,
  usePortal: true
});

var toaster = {
  getRef: function getRef() {
    return toasterRef;
  },
  show: function show(children) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // toasts can not be added until Toaster is mounted
    // no SSR for the `toaster.show()`
    var toasterInstance = this.getRef();

    if (toasterInstance) {
      return toasterInstance.show(toaster_objectSpread(toaster_objectSpread({}, props), {}, {
        children: children
      }));
    } else if (false) {}
  },
  info: function info(children) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.show(children, toaster_objectSpread(toaster_objectSpread({}, props), {}, {
      kind: constants/* KIND */.Nd.info
    }));
  },
  positive: function positive(children) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.show(children, toaster_objectSpread(toaster_objectSpread({}, props), {}, {
      kind: constants/* KIND */.Nd.positive
    }));
  },
  warning: function warning(children) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.show(children, toaster_objectSpread(toaster_objectSpread({}, props), {}, {
      kind: constants/* KIND */.Nd.warning
    }));
  },
  negative: function negative(children) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.show(children, toaster_objectSpread(toaster_objectSpread({}, props), {}, {
      kind: constants/* KIND */.Nd.negative
    }));
  },
  update: function update(key, props) {
    var toasterInstance = this.getRef();

    if (toasterInstance) {
      toasterInstance.update(key, props);
    } else if (false) {}
  },
  clear: function clear(key) {
    var toasterInstance = this.getRef();

    if (toasterInstance) {
      toasterInstance.clear(key);
    } else if (false) {}
  }
};
/* harmony default export */ const toast_toaster = (toaster);

/***/ }),

/***/ 10919:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
var colors = {
  white: '#FFFFFF',
  gray50: '#F6F6F6',
  gray100: '#EEEEEE',
  gray200: '#E2E2E2',
  gray300: '#CBCBCB',
  gray400: '#AFAFAF',
  gray500: '#757575',
  gray600: '#545454',
  gray700: '#333333',
  gray800: '#1F1F1F',
  gray900: '#141414',
  black: '#000000',
  platinum50: '#F4FAFB',
  platinum100: '#EBF5F7',
  platinum200: '#CCDFE5',
  platinum300: '#A1BDCA',
  platinum400: '#8EA3AD',
  platinum500: '#6C7C83',
  platinum600: '#556268',
  platinum700: '#394145',
  platinum800: '#142328',
  red50: '#FFEFED',
  red100: '#FED7D2',
  red200: '#F1998E',
  red300: '#E85C4A',
  red400: '#E11900',
  red500: '#AB1300',
  red600: '#870F00',
  red700: '#5A0A00',
  orange50: '#FFF3EF',
  orange100: '#FFE1D6',
  orange200: '#FABDA5',
  orange300: '#FA9269',
  orange400: '#FF6937',
  orange500: '#C14F29',
  orange600: '#9A3F21',
  orange700: '#672A16',
  yellow50: '#FFFAF0',
  yellow100: '#FFF2D9',
  yellow200: '#FFE3AC',
  yellow300: '#FFCF70',
  yellow400: '#FFC043',
  yellow500: '#BC8B2C',
  yellow600: '#997328',
  yellow700: '#674D1B',
  green50: '#E6F2ED',
  green100: '#ADDEC9',
  green200: '#66D19E',
  green300: '#06C167',
  green400: '#05944F',
  green500: '#03703C',
  green600: '#03582F',
  green700: '#10462D',
  blue50: '#EFF3FE',
  blue100: '#D4E2FC',
  blue200: '#A0BFF8',
  blue300: '#5B91F5',
  blue400: '#276EF1',
  blue500: '#1E54B7',
  blue600: '#174291',
  blue700: '#102C60',
  cobalt50: '#EBEDFA',
  cobalt100: '#D2D7F0',
  cobalt200: '#949CE3',
  cobalt300: '#535FCF',
  cobalt400: '#0E1FC1',
  cobalt500: '#0A1899',
  cobalt600: '#081270',
  cobalt700: '#050C4D',
  purple50: '#F3F1F9',
  purple100: '#E3DDF2',
  purple200: '#C1B4E2',
  purple300: '#957FCE',
  purple400: '#7356BF',
  purple500: '#574191',
  purple600: '#453473',
  purple700: '#2E224C',
  brown50: '#F6F0EA',
  brown100: '#EBE0DB',
  brown200: '#D2BBB0',
  brown300: '#B18977',
  brown400: '#99644C',
  brown500: '#744C3A',
  brown600: '#5C3C2E',
  brown700: '#3D281E'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (colors);

/***/ }),

/***/ 75:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ deepMerge)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

/* eslint-disable flowtype/no-weak-types */
function deepMerge(target) {
  target = target || {};
  var len = arguments.length <= 1 ? 0 : arguments.length - 1;
  var obj;
  var value;

  for (var i = 0; i < len; i++) {
    obj = (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) || {};

    for (var key in obj) {
      if (_typeof(obj[key]) !== undefined) {
        value = obj[key];

        if (isCloneable(value)) {
          target[key] = deepMerge(
          /* eslint-disable-next-line no-mixed-operators */
          target[key] || Array.isArray(value) && [] || {}, value);
        } else {
          target[key] = value;
        }
      }
    }
  }

  return target;
}
/* eslint-enable flowtype/no-weak-types */

/* eslint-disable-next-line flowtype/no-weak-types */

function isCloneable(obj) {
  /* eslint-disable-next-line eqeqeq */
  return Array.isArray(obj) || {}.toString.call(obj) == '[object Object]';
}

/***/ }),

/***/ 7714:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Pp: () => (/* binding */ initFocusVisible),
/* harmony export */   iw: () => (/* binding */ forkBlur),
/* harmony export */   pL: () => (/* binding */ forkFocus),
/* harmony export */   pP: () => (/* binding */ isFocusVisible)
/* harmony export */ });
/* unused harmony exports teardown, handleBlurVisible */
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// based on:
// - https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/utils/focusVisible.js
// - https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var initialized = false;
var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
} //$FlowFixMe


function teardown(doc) {
  doc.removeEventListener('keydown', handleKeyDown, true);
  doc.removeEventListener('mousedown', handlePointerDown, true);
  doc.removeEventListener('pointerdown', handlePointerDown, true);
  doc.removeEventListener('touchstart', handlePointerDown, true);
  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
} //$FlowFixMe

function isFocusVisible(event) {
  try {
    return event.target.matches(':focus-visible');
  } catch (error) {// browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
  } // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(event.target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */

function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;

  if (typeof document !== 'undefined') {
    window.clearTimeout(hadFocusVisibleRecentlyTimeout);
    hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
      hadFocusVisibleRecently = false;
    }, 100);
  }
} //$FlowFixMe

function initFocusVisible(node) {
  if (!initialized && node != null) {
    initialized = true;
    prepare(node.ownerDocument);
  }
}
var forkFocus = function forkFocus(rootProps, handler) {
  return function (e) {
    if (typeof rootProps.onFocus === 'function') {
      rootProps.onFocus(e);
    }

    handler(e);
  };
};
var forkBlur = function forkBlur(rootProps, handler) {
  return function (e) {
    if (typeof rootProps.onBlur === 'function') {
      rootProps.onBlur(e);
    }

    handler(e);
  };
};

/***/ }),

/***/ 54685:
/***/ ((module) => {

module.exports = extend;

/*
  var obj = {a: 3, b: 5};
  extend(obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 4, b: 5, c: 8}

  var obj = {a: 3, b: 5};
  extend({}, obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 3, b: 5}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3, 4]}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(true, obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3]}

  extend({a: 4, b: 5}); // {a: 4, b: 5}
  extend({a: 4, b: 5}, 3); {a: 4, b: 5}
  extend({a: 4, b: 5}, true); {a: 4, b: 5}
  extend('hello', {a: 4, b: 5}); // throws
  extend(3, {a: 4, b: 5}); // throws
*/

function extend(/* [deep], obj1, obj2, [objn] */) {
  var args = [].slice.call(arguments);
  var deep = false;
  if (typeof args[0] == 'boolean') {
    deep = args.shift();
  }
  var result = args[0];
  if (isUnextendable(result)) {
    throw new Error('extendee must be an object');
  }
  var extenders = args.slice(1);
  var len = extenders.length;
  for (var i = 0; i < len; i++) {
    var extender = extenders[i];
    for (var key in extender) {
      if (extender.hasOwnProperty(key)) {
        var value = extender[key];
        if (deep && isCloneable(value)) {
          var base = Array.isArray(value) ? [] : {};
          result[key] = extend(
            true,
            result.hasOwnProperty(key) && !isUnextendable(result[key])
              ? result[key]
              : base,
            value
          );
        } else {
          result[key] = value;
        }
      }
    }
  }
  return result;
}

function isCloneable(obj) {
  return Array.isArray(obj) || {}.toString.call(obj) == '[object Object]';
}

function isUnextendable(val) {
  return !val || (typeof val != 'object' && typeof val != 'function');
}


/***/ }),

/***/ 77469:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseFlatten = __webpack_require__(89821);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 75887:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGet = __webpack_require__(51855);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 84108:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__(95271),
    getPrototype = __webpack_require__(27556),
    isObjectLike = __webpack_require__(77583);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 10608:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  nu: () => (/* reexport */ ObserverComponent),
  PA: () => (/* reexport */ observer),
  iz: () => (/* reexport */ useLocalObservable)
});

// UNUSED EXPORTS: _observerFinalizationRegistry, clearTimers, enableStaticRendering, isObserverBatched, isUsingStaticRendering, observerBatching, useAsObservableSource, useLocalStore, useObserver, useStaticRendering

// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx@6.13.2/node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(97072);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(81724);
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/assertEnvironment.js


if (!react.useState) {
    throw new Error("mobx-react-lite requires React with Hooks support");
}
if (!mobx_esm.makeObservable) {
    throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
}
//# sourceMappingURL=assertEnvironment.js.map
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/react-dom/index.js
var react_dom = __webpack_require__(23882);
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/reactBatchedUpdates.js

//# sourceMappingURL=reactBatchedUpdates.js.map
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/observerBatching.js

function defaultNoopBatch(callback) {
    callback();
}
function observerBatching(reactionScheduler) {
    if (!reactionScheduler) {
        reactionScheduler = defaultNoopBatch;
        if (false) {}
    }
    (0,mobx_esm.configure)({ reactionScheduler: reactionScheduler });
}
var isObserverBatched = function () {
    if (false) {}
    return true;
};
//# sourceMappingURL=observerBatching.js.map
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/printDebugValue.js

function printDebugValue(v) {
    return (0,mobx_esm.getDependencyTree)(v);
}
//# sourceMappingURL=printDebugValue.js.map
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/staticRendering.js
var globalIsUsingStaticRendering = false;
function staticRendering_enableStaticRendering(enable) {
    globalIsUsingStaticRendering = enable;
}
function isUsingStaticRendering() {
    return globalIsUsingStaticRendering;
}
//# sourceMappingURL=staticRendering.js.map
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/UniversalFinalizationRegistry.js
var REGISTRY_FINALIZE_AFTER = 10000;
var REGISTRY_SWEEP_INTERVAL = 10000;
var TimerBasedFinalizationRegistry = /** @class */ (function () {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (maxAge) {
                if (maxAge === void 0) { maxAge = REGISTRY_FINALIZE_AFTER; }
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function (registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) {
                    _this.scheduleSweep();
                }
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.sweepTimeout === undefined) {
                this.sweepTimeout = setTimeout(this.sweep, REGISTRY_SWEEP_INTERVAL);
            }
        }
    });
    return TimerBasedFinalizationRegistry;
}());

var UniversalFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
    ? FinalizationRegistry
    : TimerBasedFinalizationRegistry;
//# sourceMappingURL=UniversalFinalizationRegistry.js.map
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/utils/observerFinalizationRegistry.js

var observerFinalizationRegistry = new UniversalFinalizationRegistry(function (adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 ? void 0 : _a.dispose();
    adm.reaction = null;
});
//# sourceMappingURL=observerFinalizationRegistry.js.map
// EXTERNAL MODULE: ../../node_modules/.pnpm/use-sync-external-store@1.2.2_react@0.0.0-experimental-4ead6b530/node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(24089);
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/useObserver.js






function createReaction(adm) {
    adm.reaction = new mobx_esm.Reaction("observer".concat(adm.name), function () {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 ? void 0 : _a.call(adm);
    });
}
function useObserver(render, baseComponentName) {
    if (baseComponentName === void 0) { baseComponentName = "observed"; }
    if (isUsingStaticRendering()) {
        return render();
    }
    var admRef = react.useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function (onStoreChange) {
                // Do NOT access admRef here!
                observerFinalizationRegistry.unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function () {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 ? void 0 : _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function () {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        observerFinalizationRegistry.register(admRef, adm, adm);
    }
    react.useDebugValue(adm.reaction, printDebugValue);
    (0,shim.useSyncExternalStore)(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function () {
        try {
            renderResult = render();
        }
        catch (e) {
            exception = e;
        }
    });
    if (exception) {
        throw exception; // re-throw any exceptions caught during rendering
    }
    return renderResult;
}
//# sourceMappingURL=useObserver.js.map
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/observer.js
var _a, _b;



var warnObserverOptionsDeprecated = true;
var hasSymbol = typeof Symbol === "function" && Symbol.for;
var isFunctionNameConfigurable = (_b = (_a = Object.getOwnPropertyDescriptor(function () { }, "name")) === null || _a === void 0 ? void 0 : _a.configurable) !== null && _b !== void 0 ? _b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var ReactForwardRefSymbol = hasSymbol
    ? Symbol.for("react.forward_ref")
    : typeof react.forwardRef === "function" && (0,react.forwardRef)(function (props) { return null; })["$$typeof"];
var ReactMemoSymbol = hasSymbol
    ? Symbol.for("react.memo")
    : typeof react.memo === "function" && (0,react.memo)(function (props) { return null; })["$$typeof"];
// n.b. base case is not used for actual typings or exported in the typing files
function observer(baseComponent, 
// TODO remove in next major
options) {
    var _a;
    if (false) {}
    if (ReactMemoSymbol && baseComponent["$$typeof"] === ReactMemoSymbol) {
        throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    }
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if (isUsingStaticRendering()) {
        return baseComponent;
    }
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if (ReactForwardRefSymbol && baseComponent["$$typeof"] === ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") {
            throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
        }
    }
    var observerComponent = function (props, ref) {
        return useObserver(function () { return render(props, ref); }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if (isFunctionNameConfigurable) {
        Object.defineProperty(observerComponent, "name", {
            value: baseComponent.name,
            writable: true,
            configurable: true
        });
    }
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) {
        ;
        observerComponent.contextTypes = baseComponent.contextTypes;
    }
    if (useForwardRef) {
        // `forwardRef` must be applied prior `memo`
        // `forwardRef(observer(cmp))` throws:
        // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
        observerComponent = (0,react.forwardRef)(observerComponent);
    }
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0,react.memo)(observerComponent);
    copyStaticProperties(baseComponent, observerComponent);
    if (false) {}
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function copyStaticProperties(base, target) {
    Object.keys(base).forEach(function (key) {
        if (!hoistBlackList[key]) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
        }
    });
}
//# sourceMappingURL=observer.js.map
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/ObserverComponent.js

function ObserverComponent(_a) {
    var children = _a.children, render = _a.render;
    var component = children || render;
    if (typeof component !== "function") {
        return null;
    }
    return useObserver(component);
}
if (false) {}
ObserverComponent.displayName = "Observer";

function ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) {
        return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    }
    if (hasProp || hasExtraProp) {
        return null;
    }
    return new Error("Invalid prop `" +
        propFullName +
        "` of type `" +
        typeof props[key] +
        "` supplied to" +
        " `" +
        componentName +
        "`, expected `function`.");
}
//# sourceMappingURL=ObserverComponent.js.map
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/useLocalObservable.js


function useLocalObservable(initializer, annotations) {
    return (0,react.useState)(function () { return (0,mobx_esm.observable)(initializer(), annotations, { autoBind: true }); })[0];
}
//# sourceMappingURL=useLocalObservable.js.map
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/useAsObservableSource.js



function useAsObservableSource_useAsObservableSource(current) {
    if (false)
        {}
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = useState(function () { return observable(current, {}, { deep: false }); })[0];
    runInAction(function () {
        Object.assign(res, current);
    });
    return res;
}
//# sourceMappingURL=useAsObservableSource.js.map
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/useLocalStore.js




function useLocalStore(initializer, current) {
    if (false) {}
    var source = current && useAsObservableSource(current);
    return useState(function () { return observable(initializer(source), undefined, { autoBind: true }); })[0];
}
//# sourceMappingURL=useLocalStore.js.map
;// ../../node_modules/.pnpm/mobx-react-lite@4.0.7_mobx@6.13.2_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js
var es_a;







observerBatching(react_dom.unstable_batchedUpdates);







var clearTimers = (es_a = observerFinalizationRegistry["finalizeAllImmediately"]) !== null && es_a !== void 0 ? es_a : (function () { });
function es_useObserver(fn, baseComponentName) {
    if (baseComponentName === void 0) { baseComponentName = "observed"; }
    if (false) {}
    return useObserverOriginal(fn, baseComponentName);
}

function useStaticRendering(enable) {
    if (false) {}
    enableStaticRendering(enable);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 41111:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addDisposer: () => (/* binding */ addDisposer),
/* harmony export */   addMiddleware: () => (/* binding */ addMiddleware),
/* harmony export */   applyAction: () => (/* binding */ applyAction),
/* harmony export */   applyPatch: () => (/* binding */ applyPatch),
/* harmony export */   applySnapshot: () => (/* binding */ applySnapshot),
/* harmony export */   cast: () => (/* binding */ cast),
/* harmony export */   castFlowReturn: () => (/* binding */ castFlowReturn),
/* harmony export */   castToReferenceSnapshot: () => (/* binding */ castToReferenceSnapshot),
/* harmony export */   castToSnapshot: () => (/* binding */ castToSnapshot),
/* harmony export */   clone: () => (/* binding */ clone),
/* harmony export */   createActionTrackingMiddleware: () => (/* binding */ createActionTrackingMiddleware),
/* harmony export */   createActionTrackingMiddleware2: () => (/* binding */ createActionTrackingMiddleware2),
/* harmony export */   decorate: () => (/* binding */ decorate),
/* harmony export */   destroy: () => (/* binding */ destroy),
/* harmony export */   detach: () => (/* binding */ detach),
/* harmony export */   escapeJsonPath: () => (/* binding */ escapeJsonPath),
/* harmony export */   flow: () => (/* binding */ flow),
/* harmony export */   getChildType: () => (/* binding */ getChildType),
/* harmony export */   getEnv: () => (/* binding */ getEnv),
/* harmony export */   getIdentifier: () => (/* binding */ getIdentifier),
/* harmony export */   getLivelinessChecking: () => (/* binding */ getLivelinessChecking),
/* harmony export */   getMembers: () => (/* binding */ getMembers),
/* harmony export */   getNodeId: () => (/* binding */ getNodeId),
/* harmony export */   getParent: () => (/* binding */ getParent),
/* harmony export */   getParentOfType: () => (/* binding */ getParentOfType),
/* harmony export */   getPath: () => (/* binding */ getPath),
/* harmony export */   getPathParts: () => (/* binding */ getPathParts),
/* harmony export */   getPropertyMembers: () => (/* binding */ getPropertyMembers),
/* harmony export */   getRelativePath: () => (/* binding */ getRelativePath),
/* harmony export */   getRoot: () => (/* binding */ getRoot),
/* harmony export */   getRunningActionContext: () => (/* binding */ getRunningActionContext),
/* harmony export */   getSnapshot: () => (/* binding */ getSnapshot),
/* harmony export */   getType: () => (/* binding */ getType),
/* harmony export */   hasEnv: () => (/* binding */ hasEnv),
/* harmony export */   hasParent: () => (/* binding */ hasParent),
/* harmony export */   hasParentOfType: () => (/* binding */ hasParentOfType),
/* harmony export */   isActionContextChildOf: () => (/* binding */ isActionContextChildOf),
/* harmony export */   isActionContextThisOrChildOf: () => (/* binding */ isActionContextThisOrChildOf),
/* harmony export */   isAlive: () => (/* binding */ isAlive),
/* harmony export */   isArrayType: () => (/* binding */ isArrayType),
/* harmony export */   isFrozenType: () => (/* binding */ isFrozenType),
/* harmony export */   isIdentifierType: () => (/* binding */ isIdentifierType),
/* harmony export */   isLateType: () => (/* binding */ isLateType),
/* harmony export */   isLiteralType: () => (/* binding */ isLiteralType),
/* harmony export */   isMapType: () => (/* binding */ isMapType),
/* harmony export */   isModelType: () => (/* binding */ isModelType),
/* harmony export */   isOptionalType: () => (/* binding */ isOptionalType),
/* harmony export */   isPrimitiveType: () => (/* binding */ isPrimitiveType),
/* harmony export */   isProtected: () => (/* binding */ isProtected),
/* harmony export */   isReferenceType: () => (/* binding */ isReferenceType),
/* harmony export */   isRefinementType: () => (/* binding */ isRefinementType),
/* harmony export */   isRoot: () => (/* binding */ isRoot),
/* harmony export */   isStateTreeNode: () => (/* binding */ isStateTreeNode),
/* harmony export */   isType: () => (/* binding */ isType),
/* harmony export */   isUnionType: () => (/* binding */ isUnionType),
/* harmony export */   isValidReference: () => (/* binding */ isValidReference),
/* harmony export */   joinJsonPath: () => (/* binding */ joinJsonPath),
/* harmony export */   onAction: () => (/* binding */ onAction),
/* harmony export */   onPatch: () => (/* binding */ onPatch),
/* harmony export */   onSnapshot: () => (/* binding */ onSnapshot),
/* harmony export */   process: () => (/* binding */ process$1),
/* harmony export */   protect: () => (/* binding */ protect),
/* harmony export */   recordActions: () => (/* binding */ recordActions),
/* harmony export */   recordPatches: () => (/* binding */ recordPatches),
/* harmony export */   resolveIdentifier: () => (/* binding */ resolveIdentifier),
/* harmony export */   resolvePath: () => (/* binding */ resolvePath),
/* harmony export */   setLivelinessChecking: () => (/* binding */ setLivelinessChecking),
/* harmony export */   setLivelynessChecking: () => (/* binding */ setLivelynessChecking),
/* harmony export */   splitJsonPath: () => (/* binding */ splitJsonPath),
/* harmony export */   t: () => (/* binding */ types),
/* harmony export */   toGenerator: () => (/* binding */ toGenerator),
/* harmony export */   toGeneratorFunction: () => (/* binding */ toGeneratorFunction),
/* harmony export */   tryReference: () => (/* binding */ tryReference),
/* harmony export */   tryResolve: () => (/* binding */ tryResolve),
/* harmony export */   typecheck: () => (/* binding */ typecheck),
/* harmony export */   types: () => (/* binding */ types),
/* harmony export */   unescapeJsonPath: () => (/* binding */ unescapeJsonPath),
/* harmony export */   unprotect: () => (/* binding */ unprotect),
/* harmony export */   walk: () => (/* binding */ walk)
/* harmony export */ });
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97072);
/* provided dependency */ var process = __webpack_require__(85409);


var livelinessChecking = "warn";
/**
 * Defines what MST should do when running into reads / writes to objects that have died.
 * By default it will print a warning.
 * Use the `"error"` option to easy debugging to see where the error was thrown and when the offending read / write took place
 *
 * @param mode `"warn"`, `"error"` or `"ignore"`
 */
function setLivelinessChecking(mode) {
    livelinessChecking = mode;
}
/**
 * Returns the current liveliness checking mode.
 *
 * @returns `"warn"`, `"error"` or `"ignore"`
 */
function getLivelinessChecking() {
    return livelinessChecking;
}
/**
 * @deprecated use setLivelinessChecking instead
 * @hidden
 *
 * Defines what MST should do when running into reads / writes to objects that have died.
 * By default it will print a warning.
 * Use the `"error"` option to easy debugging to see where the error was thrown and when the offending read / write took place
 *
 * @param mode `"warn"`, `"error"` or `"ignore"`
 */
function setLivelynessChecking(mode) {
    setLivelinessChecking(mode);
}

/**
 * @hidden
 */
var Hook;
(function (Hook) {
    Hook["afterCreate"] = "afterCreate";
    Hook["afterAttach"] = "afterAttach";
    Hook["afterCreationFinalization"] = "afterCreationFinalization";
    Hook["beforeDetach"] = "beforeDetach";
    Hook["beforeDestroy"] = "beforeDestroy";
})(Hook || (Hook = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Returns the _actual_ type of the given tree node. (Or throws)
 *
 * @param object
 * @returns
 */
function getType(object) {
    assertIsStateTreeNode(object, 1);
    return getStateTreeNode(object).type;
}
/**
 * Returns the _declared_ type of the given sub property of an object, array or map.
 * In the case of arrays and maps the property name is optional and will be ignored.
 *
 * Example:
 * ```ts
 * const Box = types.model({ x: 0, y: 0 })
 * const box = Box.create()
 *
 * console.log(getChildType(box, "x").name) // 'number'
 * ```
 *
 * @param object
 * @param propertyName
 * @returns
 */
function getChildType(object, propertyName) {
    assertIsStateTreeNode(object, 1);
    return getStateTreeNode(object).getChildType(propertyName);
}
/**
 * Registers a function that will be invoked for each mutation that is applied to the provided model instance, or to any of its children.
 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details. onPatch events are emitted immediately and will not await the end of a transaction.
 * Patches can be used to deeply observe a model tree.
 *
 * @param target the model instance from which to receive patches
 * @param callback the callback that is invoked for each patch. The reversePatch is a patch that would actually undo the emitted patch
 * @returns function to remove the listener
 */
function onPatch(target, callback) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsFunction(callback, 2);
    return getStateTreeNode(target).onPatch(callback);
}
/**
 * Registers a function that is invoked whenever a new snapshot for the given model instance is available.
 * The listener will only be fire at the end of the current MobX (trans)action.
 * See [snapshots](https://github.com/mobxjs/mobx-state-tree#snapshots) for more details.
 *
 * @param target
 * @param callback
 * @returns
 */
function onSnapshot(target, callback) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsFunction(callback, 2);
    return getStateTreeNode(target).onSnapshot(callback);
}
/**
 * Applies a JSON-patch to the given model instance or bails out if the patch couldn't be applied
 * See [patches](https://github.com/mobxjs/mobx-state-tree#patches) for more details.
 *
 * Can apply a single past, or an array of patches.
 *
 * @param target
 * @param patch
 * @returns
 */
function applyPatch(target, patch) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertArg(patch, function (p) { return typeof p === "object"; }, "object or array", 2);
    getStateTreeNode(target).applyPatches(asArray(patch));
}
/**
 * Small abstraction around `onPatch` and `applyPatch`, attaches a patch listener to a tree and records all the patches.
 * Returns a recorder object with the following signature:
 *
 * Example:
 * ```ts
 * export interface IPatchRecorder {
 *      // the recorded patches
 *      patches: IJsonPatch[]
 *      // the inverse of the recorded patches
 *      inversePatches: IJsonPatch[]
 *      // true if currently recording
 *      recording: boolean
 *      // stop recording patches
 *      stop(): void
 *      // resume recording patches
 *      resume(): void
 *      // apply all the recorded patches on the given target (the original subject if omitted)
 *      replay(target?: IAnyStateTreeNode): void
 *      // reverse apply the recorded patches on the given target  (the original subject if omitted)
 *      // stops the recorder if not already stopped
 *      undo(): void
 * }
 * ```
 *
 * The optional filter function allows to skip recording certain patches.
 *
 * @param subject
 * @param filter
 * @returns
 */
function recordPatches(subject, filter) {
    // check all arguments
    assertIsStateTreeNode(subject, 1);
    var data = {
        patches: [],
        inversePatches: []
    };
    // we will generate the immutable copy of patches on demand for public consumption
    var publicData = {};
    var disposer;
    var recorder = {
        get recording() {
            return !!disposer;
        },
        get patches() {
            if (!publicData.patches) {
                publicData.patches = data.patches.slice();
            }
            return publicData.patches;
        },
        get reversedInversePatches() {
            if (!publicData.reversedInversePatches) {
                publicData.reversedInversePatches = data.inversePatches.slice().reverse();
            }
            return publicData.reversedInversePatches;
        },
        get inversePatches() {
            if (!publicData.inversePatches) {
                publicData.inversePatches = data.inversePatches.slice();
            }
            return publicData.inversePatches;
        },
        stop: function () {
            if (disposer) {
                disposer();
                disposer = undefined;
            }
        },
        resume: function () {
            if (disposer)
                return;
            disposer = onPatch(subject, function (patch, inversePatch) {
                // skip patches that are asked to be filtered if there's a filter in place
                if (filter && !filter(patch, inversePatch, getRunningActionContext())) {
                    return;
                }
                data.patches.push(patch);
                data.inversePatches.push(inversePatch);
                // mark immutable public patches as dirty
                publicData.patches = undefined;
                publicData.inversePatches = undefined;
                publicData.reversedInversePatches = undefined;
            });
        },
        replay: function (target) {
            applyPatch(target || subject, data.patches);
        },
        undo: function (target) {
            applyPatch(target || subject, data.inversePatches.slice().reverse());
        }
    };
    recorder.resume();
    return recorder;
}
/**
 * The inverse of `unprotect`.
 *
 * @param target
 */
function protect(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    if (!node.isRoot)
        throw new MstError("`protect` can only be invoked on root nodes");
    node.isProtectionEnabled = true;
}
/**
 * By default it is not allowed to directly modify a model. Models can only be modified through actions.
 * However, in some cases you don't care about the advantages (like replayability, traceability, etc) this yields.
 * For example because you are building a PoC or don't have any middleware attached to your tree.
 *
 * In that case you can disable this protection by calling `unprotect` on the root of your tree.
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *     done: false
 * }).actions(self => ({
 *     toggle() {
 *         self.done = !self.done
 *     }
 * }))
 *
 * const todo = Todo.create()
 * todo.done = true // throws!
 * todo.toggle() // OK
 * unprotect(todo)
 * todo.done = false // OK
 * ```
 */
function unprotect(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    if (!node.isRoot)
        throw new MstError("`unprotect` can only be invoked on root nodes");
    node.isProtectionEnabled = false;
}
/**
 * Returns true if the object is in protected mode, @see protect
 */
function isProtected(target) {
    return getStateTreeNode(target).isProtected;
}
/**
 * Applies a snapshot to a given model instances. Patch and snapshot listeners will be invoked as usual.
 *
 * @param target
 * @param snapshot
 * @returns
 */
function applySnapshot(target, snapshot) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).applySnapshot(snapshot);
}
/**
 * Calculates a snapshot from the given model instance. The snapshot will always reflect the latest state but use
 * structural sharing where possible. Doesn't require MobX transactions to be completed.
 *
 * @param target
 * @param applyPostProcess If true (the default) then postProcessSnapshot gets applied.
 * @returns
 */
function getSnapshot(target, applyPostProcess) {
    if (applyPostProcess === void 0) { applyPostProcess = true; }
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    if (applyPostProcess)
        return node.snapshot;
    return freeze(node.type.getSnapshot(node, false));
}
/**
 * Given a model instance, returns `true` if the object has a parent, that is, is part of another object, map or array.
 *
 * @param target
 * @param depth How far should we look upward? 1 by default.
 * @returns
 */
function hasParent(target, depth) {
    if (depth === void 0) { depth = 1; }
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsNumber(depth, 2, 0);
    var parent = getStateTreeNode(target).parent;
    while (parent) {
        if (--depth === 0)
            return true;
        parent = parent.parent;
    }
    return false;
}
/**
 * Returns the immediate parent of this object, or throws.
 *
 * Note that the immediate parent can be either an object, map or array, and
 * doesn't necessarily refer to the parent model.
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired.
 *
 * @param target
 * @param depth How far should we look upward? 1 by default.
 * @returns
 */
function getParent(target, depth) {
    if (depth === void 0) { depth = 1; }
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsNumber(depth, 2, 0);
    var d = depth;
    var parent = getStateTreeNode(target).parent;
    while (parent) {
        if (--d === 0)
            return parent.storedValue;
        parent = parent.parent;
    }
    throw new MstError("Failed to find the parent of ".concat(getStateTreeNode(target), " at depth ").concat(depth));
}
/**
 * Given a model instance, returns `true` if the object has a parent of given type, that is, is part of another object, map or array
 *
 * @param target
 * @param type
 * @returns
 */
function hasParentOfType(target, type) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsType(type, 2);
    var parent = getStateTreeNode(target).parent;
    while (parent) {
        if (type.is(parent.storedValue))
            return true;
        parent = parent.parent;
    }
    return false;
}
/**
 * Returns the target's parent of a given type, or throws.
 *
 * @param target
 * @param type
 * @returns
 */
function getParentOfType(target, type) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsType(type, 2);
    var parent = getStateTreeNode(target).parent;
    while (parent) {
        if (type.is(parent.storedValue))
            return parent.storedValue;
        parent = parent.parent;
    }
    throw new MstError("Failed to find the parent of ".concat(getStateTreeNode(target), " of a given type"));
}
/**
 * Given an object in a model tree, returns the root object of that tree.
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired.
 *
 * @param target
 * @returns
 */
function getRoot(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).root.storedValue;
}
/**
 * Returns the path of the given object in the model tree
 *
 * @param target
 * @returns
 */
function getPath(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).path;
}
/**
 * Returns the path of the given object as unescaped string array.
 *
 * @param target
 * @returns
 */
function getPathParts(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return splitJsonPath(getStateTreeNode(target).path);
}
/**
 * Returns true if the given object is the root of a model tree.
 *
 * @param target
 * @returns
 */
function isRoot(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).isRoot;
}
/**
 * Resolves a path relatively to a given object.
 * Returns undefined if no value can be found.
 *
 * @param target
 * @param path escaped json path
 * @returns
 */
function resolvePath(target, path) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsString(path, 2);
    var node = resolveNodeByPath(getStateTreeNode(target), path);
    return node ? node.value : undefined;
}
/**
 * Resolves a model instance given a root target, the type and the identifier you are searching for.
 * Returns undefined if no value can be found.
 *
 * @param type
 * @param target
 * @param identifier
 * @returns
 */
function resolveIdentifier(type, target, identifier) {
    // check all arguments
    assertIsType(type, 1);
    assertIsStateTreeNode(target, 2);
    assertIsValidIdentifier(identifier, 3);
    var node = getStateTreeNode(target).root.identifierCache.resolve(type, normalizeIdentifier(identifier));
    return node === null || node === void 0 ? void 0 : node.value;
}
/**
 * Returns the identifier of the target node.
 * This is the *string normalized* identifier, which might not match the type of the identifier attribute
 *
 * @param target
 * @returns
 */
function getIdentifier(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).identifier;
}
/**
 * Tests if a reference is valid (pointing to an existing node and optionally if alive) and returns such reference if the check passes,
 * else it returns undefined.
 *
 * @param getter Function to access the reference.
 * @param checkIfAlive true to also make sure the referenced node is alive (default), false to skip this check.
 * @returns
 */
function tryReference(getter, checkIfAlive) {
    if (checkIfAlive === void 0) { checkIfAlive = true; }
    try {
        var node = getter();
        if (node === undefined || node === null) {
            return undefined;
        }
        else if (isStateTreeNode(node)) {
            if (!checkIfAlive) {
                return node;
            }
            else {
                return isAlive(node) ? node : undefined;
            }
        }
        else {
            throw new MstError("The reference to be checked is not one of node, null or undefined");
        }
    }
    catch (e) {
        if (e instanceof InvalidReferenceError) {
            return undefined;
        }
        throw e;
    }
}
/**
 * Tests if a reference is valid (pointing to an existing node and optionally if alive) and returns if the check passes or not.
 *
 * @param getter Function to access the reference.
 * @param checkIfAlive true to also make sure the referenced node is alive (default), false to skip this check.
 * @returns
 */
function isValidReference(getter, checkIfAlive) {
    if (checkIfAlive === void 0) { checkIfAlive = true; }
    try {
        var node = getter();
        if (node === undefined || node === null) {
            return false;
        }
        else if (isStateTreeNode(node)) {
            return checkIfAlive ? isAlive(node) : true;
        }
        else {
            throw new MstError("The reference to be checked is not one of node, null or undefined");
        }
    }
    catch (e) {
        if (e instanceof InvalidReferenceError) {
            return false;
        }
        throw e;
    }
}
/**
 * Try to resolve a given path relative to a given node.
 *
 * @param target
 * @param path
 * @returns
 */
function tryResolve(target, path) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsString(path, 2);
    var node = resolveNodeByPath(getStateTreeNode(target), path, false);
    if (node === undefined)
        return undefined;
    try {
        return node.value;
    }
    catch (e) {
        // For what ever reason not resolvable (e.g. totally not existing path, or value that cannot be fetched)
        // see test / issue: 'try resolve doesn't work #686'
        return undefined;
    }
}
/**
 * Given two state tree nodes that are part of the same tree,
 * returns the shortest jsonpath needed to navigate from the one to the other
 *
 * @param base
 * @param target
 * @returns
 */
function getRelativePath(base, target) {
    // check all arguments
    assertIsStateTreeNode(base, 1);
    assertIsStateTreeNode(target, 2);
    return getRelativePathBetweenNodes(getStateTreeNode(base), getStateTreeNode(target));
}
/**
 * Returns a deep copy of the given state tree node as new tree.
 * Shorthand for `snapshot(x) = getType(x).create(getSnapshot(x))`
 *
 * _Tip: clone will create a literal copy, including the same identifiers. To modify identifiers etc. during cloning, don't use clone but take a snapshot of the tree, modify it, and create new instance_
 *
 * @param source
 * @param keepEnvironment indicates whether the clone should inherit the same environment (`true`, the default), or not have an environment (`false`). If an object is passed in as second argument, that will act as the environment for the cloned tree.
 * @returns
 */
function clone(source, keepEnvironment) {
    if (keepEnvironment === void 0) { keepEnvironment = true; }
    // check all arguments
    assertIsStateTreeNode(source, 1);
    var node = getStateTreeNode(source);
    return node.type.create(node.snapshot, keepEnvironment === true
        ? node.root.environment
        : keepEnvironment === false
            ? undefined
            : keepEnvironment); // it's an object or something else
}
/**
 * Removes a model element from the state tree, and let it live on as a new state tree
 */
function detach(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    getStateTreeNode(target).detach();
    return target;
}
/**
 * Removes a model element from the state tree, and mark it as end-of-life; the element should not be used anymore
 */
function destroy(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    if (node.isRoot)
        node.die();
    else
        node.parent.removeChild(node.subpath);
}
/**
 * Returns true if the given state tree node is not killed yet.
 * This means that the node is still a part of a tree, and that `destroy`
 * has not been called. If a node is not alive anymore, the only thing one can do with it
 * is requesting it's last path and snapshot
 *
 * @param target
 * @returns
 */
function isAlive(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).observableIsAlive;
}
/**
 * Use this utility to register a function that should be called whenever the
 * targeted state tree node is destroyed. This is a useful alternative to managing
 * cleanup methods yourself using the `beforeDestroy` hook.
 *
 * This methods returns the same disposer that was passed as argument.
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   title: types.string
 * }).actions(self => ({
 *   afterCreate() {
 *     const autoSaveDisposer = reaction(
 *       () => getSnapshot(self),
 *       snapshot => sendSnapshotToServerSomehow(snapshot)
 *     )
 *     // stop sending updates to server if this
 *     // instance is destroyed
 *     addDisposer(self, autoSaveDisposer)
 *   }
 * }))
 * ```
 *
 * @param target
 * @param disposer
 * @returns The same disposer that was passed as argument
 */
function addDisposer(target, disposer) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsFunction(disposer, 2);
    var node = getStateTreeNode(target);
    node.addDisposer(disposer);
    return disposer;
}
/**
 * Returns the environment of the current state tree, or throws. For more info on environments,
 * see [Dependency injection](https://github.com/mobxjs/mobx-state-tree#dependency-injection)
 *
 * Please note that in child nodes access to the root is only possible
 * once the `afterAttach` hook has fired
 *
 * Returns an empty environment if the tree wasn't initialized with an environment
 *
 * @param target
 * @returns
 */
function getEnv(target) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    var node = getStateTreeNode(target);
    var env = node.root.environment;
    if (!env)
        throw new MstError("Failed to find the environment of ".concat(node, " ").concat(node.path));
    return env;
}
/**
 * Returns whether the current state tree has environment or not.
 *
 * @export
 * @param {IStateTreeNode} target
 * @return {boolean}
 */
function hasEnv(target) {
    // check all arguments
    if (false) {}
    var node = getStateTreeNode(target);
    var env = node.root.environment;
    return !!env;
}
/**
 * Performs a depth first walk through a tree.
 */
function walk(target, processor) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertIsFunction(processor, 2);
    var node = getStateTreeNode(target);
    // tslint:disable-next-line:no_unused-variable
    node.getChildren().forEach(function (child) {
        if (isStateTreeNode(child.storedValue))
            walk(child.storedValue, processor);
    });
    processor(node.storedValue);
}
/**
 * Returns a reflection of the model type properties and name for either a model type or model node.
 *
 * @param typeOrNode
 * @returns
 */
function getPropertyMembers(typeOrNode) {
    var type;
    if (isStateTreeNode(typeOrNode)) {
        type = getType(typeOrNode);
    }
    else {
        type = typeOrNode;
    }
    assertArg(type, function (t) { return isModelType(t); }, "model type or model instance", 1);
    return {
        name: type.name,
        properties: __assign({}, type.properties)
    };
}
/**
 * Returns a reflection of the model node, including name, properties, views, volatile state,
 * and actions. `flowActions` is also provided as a separate array of names for any action that
 * came from a flow generator as well.
 *
 * In the case where a model has two actions: `doSomething` and `doSomethingWithFlow`, where
 * `doSomethingWithFlow` is a flow generator, the `actions` array will contain both actions,
 * i.e. ["doSomething", "doSomethingWithFlow"], and the `flowActions` array will contain only
 * the flow action, i.e. ["doSomethingWithFlow"].
 *
 * @param target
 * @returns
 */
function getMembers(target) {
    var type = getStateTreeNode(target).type;
    var reflected = __assign(__assign({}, getPropertyMembers(type)), { actions: [], volatile: [], views: [], flowActions: [] });
    var props = Object.getOwnPropertyNames(target);
    props.forEach(function (key) {
        if (key in reflected.properties)
            return;
        var descriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor.get) {
            if ((0,mobx__WEBPACK_IMPORTED_MODULE_0__.isComputedProp)(target, key))
                reflected.views.push(key);
            else
                reflected.volatile.push(key);
            return;
        }
        if (descriptor.value._isFlowAction === true) {
            reflected.flowActions.push(key);
        }
        if (descriptor.value._isMSTAction === true) {
            reflected.actions.push(key);
        }
        else if ((0,mobx__WEBPACK_IMPORTED_MODULE_0__.isObservableProp)(target, key)) {
            reflected.volatile.push(key);
        }
        else {
            reflected.views.push(key);
        }
    });
    return reflected;
}
/**
 * Casts a node snapshot or instance type to an instance type so it can be assigned to a type instance.
 * Note that this is just a cast for the type system, this is, it won't actually convert a snapshot to an instance,
 * but just fool typescript into thinking so.
 * Either way, casting when outside an assignation operation won't compile.
 *
 * Example:
 * ```ts
 * const ModelA = types.model({
 *   n: types.number
 * }).actions(self => ({
 *   setN(aNumber: number) {
 *     self.n = aNumber
 *   }
 * }))
 *
 * const ModelB = types.model({
 *   innerModel: ModelA
 * }).actions(self => ({
 *   someAction() {
 *     // this will allow the compiler to assign a snapshot to the property
 *     self.innerModel = cast({ a: 5 })
 *   }
 * }))
 * ```
 *
 * @param snapshotOrInstance Snapshot or instance
 * @returns The same object cast as an instance
 */
function cast(snapshotOrInstance) {
    return snapshotOrInstance;
}
/**
 * Casts a node instance type to a snapshot type so it can be assigned to a type snapshot (e.g. to be used inside a create call).
 * Note that this is just a cast for the type system, this is, it won't actually convert an instance to a snapshot,
 * but just fool typescript into thinking so.
 *
 * Example:
 * ```ts
 * const ModelA = types.model({
 *   n: types.number
 * }).actions(self => ({
 *   setN(aNumber: number) {
 *     self.n = aNumber
 *   }
 * }))
 *
 * const ModelB = types.model({
 *   innerModel: ModelA
 * })
 *
 * const a = ModelA.create({ n: 5 });
 * // this will allow the compiler to use a model as if it were a snapshot
 * const b = ModelB.create({ innerModel: castToSnapshot(a)})
 * ```
 *
 * @param snapshotOrInstance Snapshot or instance
 * @returns The same object cast as an input (creation) snapshot
 */
function castToSnapshot(snapshotOrInstance) {
    return snapshotOrInstance;
}
/**
 * Casts a node instance type to a reference snapshot type so it can be assigned to a reference snapshot (e.g. to be used inside a create call).
 * Note that this is just a cast for the type system, this is, it won't actually convert an instance to a reference snapshot,
 * but just fool typescript into thinking so.
 *
 * Example:
 * ```ts
 * const ModelA = types.model({
 *   id: types.identifier,
 *   n: types.number
 * }).actions(self => ({
 *   setN(aNumber: number) {
 *     self.n = aNumber
 *   }
 * }))
 *
 * const ModelB = types.model({
 *   refA: types.reference(ModelA)
 * })
 *
 * const a = ModelA.create({ id: 'someId', n: 5 });
 * // this will allow the compiler to use a model as if it were a reference snapshot
 * const b = ModelB.create({ refA: castToReferenceSnapshot(a)})
 * ```
 *
 * @param instance Instance
 * @returns The same object cast as a reference snapshot (string or number)
 */
function castToReferenceSnapshot(instance) {
    return instance;
}
/**
 * Returns the unique node id (not to be confused with the instance identifier) for a
 * given instance.
 * This id is a number that is unique for each instance.
 *
 * @export
 * @param target
 * @returns
 */
function getNodeId(target) {
    assertIsStateTreeNode(target, 1);
    return getStateTreeNode(target).nodeId;
}

/**
 * @internal
 * @hidden
 */
var BaseNode = /** @class */ (function () {
    function BaseNode(type, parent, subpath, environment) {
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: type
        });
        Object.defineProperty(this, "environment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: environment
        });
        Object.defineProperty(this, "_escapedSubpath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_subpath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_subpathUponDeath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_pathUponDeath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "storedValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // usually the same type as the value, but not always (such as with references)
        Object.defineProperty(this, "aliveAtom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: NodeLifeCycle.INITIALIZING
        });
        Object.defineProperty(this, "_hookSubscribers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_parent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pathAtom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.environment = environment;
        this.baseSetParent(parent, subpath);
    }
    Object.defineProperty(BaseNode.prototype, "subpath", {
        get: function () {
            return this._subpath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "subpathUponDeath", {
        get: function () {
            return this._subpathUponDeath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "pathUponDeath", {
        get: function () {
            return this._pathUponDeath;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "value", {
        get: function () {
            return this.type.getValue(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (val) {
            var wasAlive = this.isAlive;
            this._state = val;
            var isAlive = this.isAlive;
            if (this.aliveAtom && wasAlive !== isAlive) {
                this.aliveAtom.reportChanged();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "fireInternalHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (name) {
            if (this._hookSubscribers) {
                this._hookSubscribers.emit(name, this, name);
            }
        }
    });
    Object.defineProperty(BaseNode.prototype, "registerHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (hook, hookHandler) {
            if (!this._hookSubscribers) {
                this._hookSubscribers = new EventHandlers();
            }
            return this._hookSubscribers.register(hook, hookHandler);
        }
    });
    Object.defineProperty(BaseNode.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "getReconciliationType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.type;
        }
    });
    Object.defineProperty(BaseNode.prototype, "baseSetParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath) {
            this._parent = parent;
            this._subpath = subpath;
            this._escapedSubpath = undefined; // regenerate when needed
            if (this.pathAtom) {
                this.pathAtom.reportChanged();
            }
        }
    });
    Object.defineProperty(BaseNode.prototype, "path", {
        /*
         * Returns (escaped) path representation as string
         */
        get: function () {
            return this.getEscapedPath(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "getEscapedPath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (reportObserved) {
            if (reportObserved) {
                if (!this.pathAtom) {
                    this.pathAtom = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.createAtom)("path");
                }
                this.pathAtom.reportObserved();
            }
            if (!this.parent)
                return "";
            // regenerate escaped subpath if needed
            if (this._escapedSubpath === undefined) {
                this._escapedSubpath = !this._subpath ? "" : escapeJsonPath(this._subpath);
            }
            return this.parent.getEscapedPath(reportObserved) + "/" + this._escapedSubpath;
        }
    });
    Object.defineProperty(BaseNode.prototype, "isRoot", {
        get: function () {
            return this.parent === null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "isAlive", {
        get: function () {
            return this.state !== NodeLifeCycle.DEAD;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "isDetaching", {
        get: function () {
            return this.state === NodeLifeCycle.DETACHING;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "observableIsAlive", {
        get: function () {
            if (!this.aliveAtom) {
                this.aliveAtom = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.createAtom)("alive");
            }
            this.aliveAtom.reportObserved();
            return this.isAlive;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseNode.prototype, "baseFinalizeCreation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (whenFinalized) {
            if (devMode()) {
                if (!this.isAlive) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: cannot finalize the creation of a node that is already dead");
                }
            }
            // goal: afterCreate hooks runs depth-first. After attach runs parent first, so on afterAttach the parent has completed already
            if (this.state === NodeLifeCycle.CREATED) {
                if (this.parent) {
                    if (this.parent.state !== NodeLifeCycle.FINALIZED) {
                        // parent not ready yet, postpone
                        return;
                    }
                    this.fireHook(Hook.afterAttach);
                }
                this.state = NodeLifeCycle.FINALIZED;
                if (whenFinalized) {
                    whenFinalized();
                }
            }
        }
    });
    Object.defineProperty(BaseNode.prototype, "baseFinalizeDeath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this._hookSubscribers) {
                this._hookSubscribers.clearAll();
            }
            this._subpathUponDeath = this._subpath;
            this._pathUponDeath = this.getEscapedPath(false);
            this.baseSetParent(null, "");
            this.state = NodeLifeCycle.DEAD;
        }
    });
    Object.defineProperty(BaseNode.prototype, "baseAboutToDie", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.fireHook(Hook.beforeDestroy);
        }
    });
    return BaseNode;
}());

/**
 * @internal
 * @hidden
 */
var ScalarNode = /** @class */ (function (_super) {
    __extends(ScalarNode, _super);
    function ScalarNode(simpleType, parent, subpath, environment, initialSnapshot) {
        var _this = _super.call(this, simpleType, parent, subpath, environment) || this;
        try {
            _this.storedValue = simpleType.createNewInstance(initialSnapshot);
        }
        catch (e) {
            // short-cut to die the instance, to avoid the snapshot computed starting to throw...
            _this.state = NodeLifeCycle.DEAD;
            throw e;
        }
        _this.state = NodeLifeCycle.CREATED;
        // for scalar nodes there's no point in firing this event since it would fire on the constructor, before
        // anybody can actually register for/listen to it
        // this.fireHook(Hook.AfterCreate)
        _this.finalizeCreation();
        return _this;
    }
    Object.defineProperty(ScalarNode.prototype, "root", {
        get: function () {
            // future optimization: store root ref in the node and maintain it
            if (!this.parent)
                throw new MstError("This scalar node is not part of a tree");
            return this.parent.root;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScalarNode.prototype, "setParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (newParent, subpath) {
            var parentChanged = this.parent !== newParent;
            var subpathChanged = this.subpath !== subpath;
            if (!parentChanged && !subpathChanged) {
                return;
            }
            if (devMode()) {
                if (!subpath) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: subpath expected");
                }
                if (!newParent) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: parent expected");
                }
                if (parentChanged) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: scalar nodes cannot change their parent");
                }
            }
            this.environment = undefined; // use parent's
            this.baseSetParent(this.parent, subpath);
        }
    });
    Object.defineProperty(ScalarNode.prototype, "snapshot", {
        get: function () {
            return freeze(this.getSnapshot());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScalarNode.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.type.getSnapshot(this);
        }
    });
    Object.defineProperty(ScalarNode.prototype, "toString", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var path = (this.isAlive ? this.path : this.pathUponDeath) || "<root>";
            return "".concat(this.type.name, "@").concat(path).concat(this.isAlive ? "" : " [dead]");
        }
    });
    Object.defineProperty(ScalarNode.prototype, "die", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.isAlive || this.state === NodeLifeCycle.DETACHING)
                return;
            this.aboutToDie();
            this.finalizeDeath();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "finalizeCreation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.baseFinalizeCreation();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "aboutToDie", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.baseAboutToDie();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "finalizeDeath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.baseFinalizeDeath();
        }
    });
    Object.defineProperty(ScalarNode.prototype, "fireHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (name) {
            this.fireInternalHook(name);
        }
    });
    return ScalarNode;
}(BaseNode));
ScalarNode.prototype.die = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.action)(ScalarNode.prototype.die);

var nextNodeId = 1;
var ObservableInstanceLifecycle;
(function (ObservableInstanceLifecycle) {
    // the actual observable instance has not been created yet
    ObservableInstanceLifecycle[ObservableInstanceLifecycle["UNINITIALIZED"] = 0] = "UNINITIALIZED";
    // the actual observable instance is being created
    ObservableInstanceLifecycle[ObservableInstanceLifecycle["CREATING"] = 1] = "CREATING";
    // the actual observable instance has been created
    ObservableInstanceLifecycle[ObservableInstanceLifecycle["CREATED"] = 2] = "CREATED";
})(ObservableInstanceLifecycle || (ObservableInstanceLifecycle = {}));
var InternalEvents;
(function (InternalEvents) {
    InternalEvents["Dispose"] = "dispose";
    InternalEvents["Patch"] = "patch";
    InternalEvents["Snapshot"] = "snapshot";
})(InternalEvents || (InternalEvents = {}));
var snapshotReactionOptions = {
    onError: function (e) {
        throw e;
    }
};
/**
 * @internal
 * @hidden
 */
var ObjectNode = /** @class */ (function (_super) {
    __extends(ObjectNode, _super);
    function ObjectNode(complexType, parent, subpath, environment, initialValue) {
        var _this = _super.call(this, complexType, parent, subpath, environment) || this;
        Object.defineProperty(_this, "nodeId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ++nextNodeId
        });
        Object.defineProperty(_this, "identifierAttribute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "identifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // Identifier is always normalized to string, even if the identifier property isn't
        Object.defineProperty(_this, "unnormalizedIdentifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "identifierCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "isProtectionEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(_this, "middlewares", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "hasSnapshotPostProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "_applyPatches", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_applySnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_autoUnbox", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        }); // unboxing is disabled when reading child nodes
        Object.defineProperty(_this, "_isRunningAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        }); // only relevant for root
        Object.defineProperty(_this, "_hasSnapshotReaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "_observableInstanceState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ObservableInstanceLifecycle.UNINITIALIZED
        });
        Object.defineProperty(_this, "_childNodes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_initialSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_cachedInitialSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_cachedInitialSnapshotCreated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(_this, "_snapshotComputed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_snapshotUponDeath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // #region internal event handling
        Object.defineProperty(_this, "_internalEvents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this._snapshotComputed = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.computed)(function () { return freeze(_this.getSnapshot()); });
        _this.unbox = _this.unbox.bind(_this);
        _this._initialSnapshot = freeze(initialValue);
        _this.identifierAttribute = complexType.identifierAttribute;
        if (!parent) {
            _this.identifierCache = new IdentifierCache();
        }
        _this._childNodes = complexType.initializeChildNodes(_this, _this._initialSnapshot);
        // identifier can not be changed during lifecycle of a node
        // so we safely can read it from initial snapshot
        _this.identifier = null;
        _this.unnormalizedIdentifier = null;
        if (_this.identifierAttribute && _this._initialSnapshot) {
            var id = _this._initialSnapshot[_this.identifierAttribute];
            if (id === undefined) {
                // try with the actual node if not (for optional identifiers)
                var childNode = _this._childNodes[_this.identifierAttribute];
                if (childNode) {
                    id = childNode.value;
                }
            }
            if (typeof id !== "string" && typeof id !== "number") {
                throw new MstError("Instance identifier '".concat(_this.identifierAttribute, "' for type '").concat(_this.type.name, "' must be a string or a number"));
            }
            // normalize internal identifier to string
            _this.identifier = normalizeIdentifier(id);
            _this.unnormalizedIdentifier = id;
        }
        if (!parent) {
            _this.identifierCache.addNodeToCache(_this);
        }
        else {
            parent.root.identifierCache.addNodeToCache(_this);
        }
        return _this;
    }
    Object.defineProperty(ObjectNode.prototype, "applyPatches", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (patches) {
            this.createObservableInstanceIfNeeded();
            this._applyPatches(patches);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot) {
            this.createObservableInstanceIfNeeded();
            this._applySnapshot(snapshot);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "createObservableInstanceIfNeeded", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fireHooks) {
            if (fireHooks === void 0) { fireHooks = true; }
            if (this._observableInstanceState === ObservableInstanceLifecycle.UNINITIALIZED) {
                this.createObservableInstance(fireHooks);
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "createObservableInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fireHooks) {
            var e_1, _a, e_2, _b;
            if (fireHooks === void 0) { fireHooks = true; }
            if (devMode()) {
                if (this.state !== NodeLifeCycle.INITIALIZING) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: the creation of the observable instance must be done on the initializing phase");
                }
            }
            this._observableInstanceState = ObservableInstanceLifecycle.CREATING;
            // make sure the parent chain is created as well
            // array with parent chain from parent to child
            var parentChain = [];
            var parent = this.parent;
            // for performance reasons we never go back further than the most direct
            // uninitialized parent
            // this is done to avoid traversing the whole tree to the root when using
            // the same reference again
            while (parent &&
                parent._observableInstanceState === ObservableInstanceLifecycle.UNINITIALIZED) {
                parentChain.unshift(parent);
                parent = parent.parent;
            }
            try {
                // initialize the uninitialized parent chain from parent to child
                for (var parentChain_1 = __values(parentChain), parentChain_1_1 = parentChain_1.next(); !parentChain_1_1.done; parentChain_1_1 = parentChain_1.next()) {
                    var p = parentChain_1_1.value;
                    // delay firing hooks until after all parents have been created
                    p.createObservableInstanceIfNeeded(false);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (parentChain_1_1 && !parentChain_1_1.done && (_a = parentChain_1.return)) _a.call(parentChain_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var type = this.type;
            try {
                this.storedValue = type.createNewInstance(this._childNodes);
                this.preboot();
                this._isRunningAction = true;
                type.finalizeNewInstance(this, this.storedValue);
            }
            catch (e) {
                // short-cut to die the instance, to avoid the snapshot computed starting to throw...
                this.state = NodeLifeCycle.DEAD;
                throw e;
            }
            finally {
                this._isRunningAction = false;
            }
            this._observableInstanceState = ObservableInstanceLifecycle.CREATED;
            this._snapshotComputed.trackAndCompute();
            if (this.isRoot)
                this._addSnapshotReaction();
            this._childNodes = EMPTY_OBJECT;
            this.state = NodeLifeCycle.CREATED;
            if (fireHooks) {
                this.fireHook(Hook.afterCreate);
                // Note that the parent might not be finalized at this point
                // so afterAttach won't be called until later in that case
                this.finalizeCreation();
                try {
                    // fire the hooks of the parents that we created
                    for (var _c = __values(parentChain.reverse()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var p = _d.value;
                        p.fireHook(Hook.afterCreate);
                        // This will call afterAttach on the child if necessary
                        p.finalizeCreation();
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "root", {
        get: function () {
            var parent = this.parent;
            return parent ? parent.root : this;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObjectNode.prototype, "clearParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.parent)
                return;
            // detach if attached
            this.fireHook(Hook.beforeDetach);
            var previousState = this.state;
            this.state = NodeLifeCycle.DETACHING;
            var root = this.root;
            var newEnv = root.environment;
            var newIdCache = root.identifierCache.splitCache(this);
            try {
                this.parent.removeChild(this.subpath);
                this.baseSetParent(null, "");
                this.environment = newEnv;
                this.identifierCache = newIdCache;
            }
            finally {
                this.state = previousState;
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "setParent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (newParent, subpath) {
            var parentChanged = newParent !== this.parent;
            var subpathChanged = subpath !== this.subpath;
            if (!parentChanged && !subpathChanged) {
                return;
            }
            if (devMode()) {
                if (!subpath) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: subpath expected");
                }
                if (!newParent) {
                    // istanbul ignore next
                    throw new MstError("assertion failed: new parent expected");
                }
                if (this.parent && parentChanged) {
                    throw new MstError("A node cannot exists twice in the state tree. Failed to add ".concat(this, " to path '").concat(newParent.path, "/").concat(subpath, "'."));
                }
                if (!this.parent && newParent.root === this) {
                    throw new MstError("A state tree is not allowed to contain itself. Cannot assign ".concat(this, " to path '").concat(newParent.path, "/").concat(subpath, "'"));
                }
                if (!this.parent && !!this.environment && this.environment !== newParent.root.environment) {
                    throw new MstError("A state tree cannot be made part of another state tree as long as their environments are different.");
                }
            }
            if (parentChanged) {
                // attach to new parent
                this.environment = undefined; // will use root's
                newParent.root.identifierCache.mergeCache(this);
                this.baseSetParent(newParent, subpath);
                this.fireHook(Hook.afterAttach);
            }
            else if (subpathChanged) {
                // moving to a new subpath on the same parent
                this.baseSetParent(this.parent, subpath);
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "fireHook", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (name) {
            var _this = this;
            this.fireInternalHook(name);
            var fn = this.storedValue && typeof this.storedValue === "object" && this.storedValue[name];
            if (typeof fn === "function") {
                // we check for it to allow old mobx peer dependencies that don't have the method to work (even when still bugged)
                if (mobx__WEBPACK_IMPORTED_MODULE_0__._allowStateChangesInsideComputed) {
                    (0,mobx__WEBPACK_IMPORTED_MODULE_0__._allowStateChangesInsideComputed)(function () {
                        fn.apply(_this.storedValue);
                    });
                }
                else {
                    fn.apply(this.storedValue);
                }
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "snapshot", {
        // advantage of using computed for a snapshot is that nicely respects transactions etc.
        get: function () {
            if (this.hasSnapshotPostProcessor) {
                this.createObservableInstanceIfNeeded();
            }
            return this._snapshotComputed.get();
        },
        enumerable: false,
        configurable: true
    });
    // NOTE: we use this method to get snapshot without creating @computed overhead
    Object.defineProperty(ObjectNode.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.isAlive)
                return this._snapshotUponDeath;
            return this._observableInstanceState === ObservableInstanceLifecycle.CREATED
                ? this._getActualSnapshot()
                : this._getCachedInitialSnapshot();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_getActualSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.type.getSnapshot(this);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_getCachedInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this._cachedInitialSnapshotCreated) {
                var type = this.type;
                var childNodes = this._childNodes;
                var snapshot = this._initialSnapshot;
                this._cachedInitialSnapshot = type.processInitialSnapshot(childNodes, snapshot);
                this._cachedInitialSnapshotCreated = true;
            }
            return this._cachedInitialSnapshot;
        }
    });
    Object.defineProperty(ObjectNode.prototype, "isRunningAction", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this._isRunningAction)
                return true;
            if (this.isRoot)
                return false;
            return this.parent.isRunningAction();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "assertAlive", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (context) {
            var livelinessChecking = getLivelinessChecking();
            if (!this.isAlive && livelinessChecking !== "ignore") {
                var error = this._getAssertAliveError(context);
                switch (livelinessChecking) {
                    case "error":
                        throw new MstError(error);
                    case "warn":
                        warnError(error);
                }
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_getAssertAliveError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (context) {
            var escapedPath = this.getEscapedPath(false) || this.pathUponDeath || "";
            var subpath = (context.subpath && escapeJsonPath(context.subpath)) || "";
            var actionContext = context.actionContext || getCurrentActionContext();
            // try to use a real action context if possible since it includes the action name
            if (actionContext && actionContext.type !== "action" && actionContext.parentActionEvent) {
                actionContext = actionContext.parentActionEvent;
            }
            var actionFullPath = "";
            if (actionContext && actionContext.name != null) {
                // try to use the context, and if it not available use the node one
                var actionPath = (actionContext && actionContext.context && getPath(actionContext.context)) || escapedPath;
                actionFullPath = "".concat(actionPath, ".").concat(actionContext.name, "()");
            }
            return "You are trying to read or write to an object that is no longer part of a state tree. (Object type: '".concat(this.type.name, "', Path upon death: '").concat(escapedPath, "', Subpath: '").concat(subpath, "', Action: '").concat(actionFullPath, "'). Either detach nodes first, or don't use objects after removing / replacing them in the tree.");
        }
    });
    Object.defineProperty(ObjectNode.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (subpath) {
            this.assertAlive({
                subpath: subpath
            });
            this._autoUnbox = false;
            try {
                return this._observableInstanceState === ObservableInstanceLifecycle.CREATED
                    ? this.type.getChildNode(this, subpath)
                    : this._childNodes[subpath];
            }
            finally {
                this._autoUnbox = true;
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.assertAlive(EMPTY_OBJECT);
            this._autoUnbox = false;
            try {
                return this._observableInstanceState === ObservableInstanceLifecycle.CREATED
                    ? this.type.getChildren(this)
                    : convertChildNodesToArray(this._childNodes);
            }
            finally {
                this._autoUnbox = true;
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (propertyName) {
            return this.type.getChildType(propertyName);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "isProtected", {
        get: function () {
            return this.root.isProtectionEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObjectNode.prototype, "assertWritable", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (context) {
            this.assertAlive(context);
            if (!this.isRunningAction() && this.isProtected) {
                throw new MstError("Cannot modify '".concat(this, "', the object is protected and can only be modified by using an action."));
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (subpath) {
            this.type.removeChild(this, subpath);
        }
    });
    // bound on the constructor
    Object.defineProperty(ObjectNode.prototype, "unbox", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNode) {
            if (!childNode)
                return childNode;
            this.assertAlive({
                subpath: childNode.subpath || childNode.subpathUponDeath
            });
            return this._autoUnbox ? childNode.value : childNode;
        }
    });
    Object.defineProperty(ObjectNode.prototype, "toString", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var path = (this.isAlive ? this.path : this.pathUponDeath) || "<root>";
            var identifier = this.identifier ? "(id: ".concat(this.identifier, ")") : "";
            return "".concat(this.type.name, "@").concat(path).concat(identifier).concat(this.isAlive ? "" : " [dead]");
        }
    });
    Object.defineProperty(ObjectNode.prototype, "finalizeCreation", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            this.baseFinalizeCreation(function () {
                var e_3, _a;
                try {
                    for (var _b = __values(_this.getChildren()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var child = _c.value;
                        child.finalizeCreation();
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                _this.fireInternalHook(Hook.afterCreationFinalization);
            });
        }
    });
    Object.defineProperty(ObjectNode.prototype, "detach", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.isAlive)
                throw new MstError("Error while detaching, node is not alive.");
            this.clearParent();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "preboot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var self = this;
            this._applyPatches = createActionInvoker(this.storedValue, "@APPLY_PATCHES", function (patches) {
                patches.forEach(function (patch) {
                    if (!patch.path) {
                        self.type.applySnapshot(self, patch.value);
                        return;
                    }
                    var parts = splitJsonPath(patch.path);
                    var node = resolveNodeByPathParts(self, parts.slice(0, -1));
                    node.applyPatchLocally(parts[parts.length - 1], patch);
                });
            });
            this._applySnapshot = createActionInvoker(this.storedValue, "@APPLY_SNAPSHOT", function (snapshot) {
                // if the snapshot is the same as the current one, avoid performing a reconcile
                if (snapshot === self.snapshot)
                    return;
                // else, apply it by calling the type logic
                return self.type.applySnapshot(self, snapshot);
            });
            addHiddenFinalProp(this.storedValue, "$treenode", this);
            addHiddenFinalProp(this.storedValue, "toJSON", toJSON);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "die", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.isAlive || this.state === NodeLifeCycle.DETACHING)
                return;
            this.aboutToDie();
            this.finalizeDeath();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "aboutToDie", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this._observableInstanceState === ObservableInstanceLifecycle.UNINITIALIZED) {
                return;
            }
            this.getChildren().forEach(function (node) {
                node.aboutToDie();
            });
            // beforeDestroy should run before the disposers since else we could end up in a situation where
            // a disposer added with addDisposer at this stage (beforeDestroy) is actually never released
            this.baseAboutToDie();
            this._internalEventsEmit(InternalEvents.Dispose);
            this._internalEventsClear(InternalEvents.Dispose);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "finalizeDeath", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            // invariant: not called directly but from "die"
            this.getChildren().forEach(function (node) {
                node.finalizeDeath();
            });
            this.root.identifierCache.notifyDied(this);
            // "kill" the computed prop and just store the last snapshot
            var snapshot = this.snapshot;
            this._snapshotUponDeath = snapshot;
            this._internalEventsClearAll();
            this.baseFinalizeDeath();
        }
    });
    Object.defineProperty(ObjectNode.prototype, "onSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (onChange) {
            this._addSnapshotReaction();
            return this._internalEventsRegister(InternalEvents.Snapshot, onChange);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "emitSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot) {
            this._internalEventsEmit(InternalEvents.Snapshot, snapshot);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "onPatch", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (handler) {
            return this._internalEventsRegister(InternalEvents.Patch, handler);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "emitPatch", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (basePatch, source) {
            if (this._internalEventsHasSubscribers(InternalEvents.Patch)) {
                // calculate the relative path of the patch
                var path = source.path.substr(this.path.length) + (basePatch.path ? "/" + basePatch.path : "");
                var localizedPatch = extend({}, basePatch, { path: path });
                var _a = __read(splitPatch(localizedPatch), 2), patch = _a[0], reversePatch = _a[1];
                this._internalEventsEmit(InternalEvents.Patch, patch, reversePatch);
            }
            if (this.parent)
                this.parent.emitPatch(basePatch, source);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "hasDisposer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (disposer) {
            return this._internalEventsHas(InternalEvents.Dispose, disposer);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "addDisposer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (disposer) {
            if (!this.hasDisposer(disposer)) {
                this._internalEventsRegister(InternalEvents.Dispose, disposer, true);
                return;
            }
            throw new MstError("cannot add a disposer when it is already registered for execution");
        }
    });
    Object.defineProperty(ObjectNode.prototype, "removeDisposer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (disposer) {
            if (!this._internalEventsHas(InternalEvents.Dispose, disposer)) {
                throw new MstError("cannot remove a disposer which was never registered for execution");
            }
            this._internalEventsUnregister(InternalEvents.Dispose, disposer);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "removeMiddleware", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (middleware) {
            if (this.middlewares) {
                var index = this.middlewares.indexOf(middleware);
                if (index >= 0) {
                    this.middlewares.splice(index, 1);
                }
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "addMiddleWare", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (handler, includeHooks) {
            var _this = this;
            if (includeHooks === void 0) { includeHooks = true; }
            var middleware = { handler: handler, includeHooks: includeHooks };
            if (!this.middlewares)
                this.middlewares = [middleware];
            else
                this.middlewares.push(middleware);
            return function () {
                _this.removeMiddleware(middleware);
            };
        }
    });
    Object.defineProperty(ObjectNode.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (subpath, patch) {
            this.assertWritable({
                subpath: subpath
            });
            this.createObservableInstanceIfNeeded();
            this.type.applyPatchLocally(this, subpath, patch);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_addSnapshotReaction", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            if (!this._hasSnapshotReaction) {
                var snapshotDisposer = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.reaction)(function () { return _this.snapshot; }, function (snapshot) { return _this.emitSnapshot(snapshot); }, snapshotReactionOptions);
                this.addDisposer(snapshotDisposer);
                this._hasSnapshotReaction = true;
            }
        }
    });
    // we proxy the methods to avoid creating an EventHandlers instance when it is not needed
    Object.defineProperty(ObjectNode.prototype, "_internalEventsHasSubscribers", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            return !!this._internalEvents && this._internalEvents.hasSubscribers(event);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsRegister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, eventHandler, atTheBeginning) {
            if (atTheBeginning === void 0) { atTheBeginning = false; }
            if (!this._internalEvents) {
                this._internalEvents = new EventHandlers();
            }
            return this._internalEvents.register(event, eventHandler, atTheBeginning);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsHas", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, eventHandler) {
            return !!this._internalEvents && this._internalEvents.has(event, eventHandler);
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsUnregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, eventHandler) {
            if (this._internalEvents) {
                this._internalEvents.unregister(event, eventHandler);
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsEmit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (this._internalEvents) {
                (_a = this._internalEvents).emit.apply(_a, __spreadArray([event], __read(args), false));
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsClear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            if (this._internalEvents) {
                this._internalEvents.clear(event);
            }
        }
    });
    Object.defineProperty(ObjectNode.prototype, "_internalEventsClearAll", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this._internalEvents) {
                this._internalEvents.clearAll();
            }
        }
    });
    return ObjectNode;
}(BaseNode));
ObjectNode.prototype.createObservableInstance = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.action)(ObjectNode.prototype.createObservableInstance);
ObjectNode.prototype.detach = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.action)(ObjectNode.prototype.detach);
ObjectNode.prototype.die = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.action)(ObjectNode.prototype.die);

var _a;
/**
 * @internal
 * @hidden
 */
var TypeFlags;
(function (TypeFlags) {
    TypeFlags[TypeFlags["String"] = 1] = "String";
    TypeFlags[TypeFlags["Number"] = 2] = "Number";
    TypeFlags[TypeFlags["Boolean"] = 4] = "Boolean";
    TypeFlags[TypeFlags["Date"] = 8] = "Date";
    TypeFlags[TypeFlags["Literal"] = 16] = "Literal";
    TypeFlags[TypeFlags["Array"] = 32] = "Array";
    TypeFlags[TypeFlags["Map"] = 64] = "Map";
    TypeFlags[TypeFlags["Object"] = 128] = "Object";
    TypeFlags[TypeFlags["Frozen"] = 256] = "Frozen";
    TypeFlags[TypeFlags["Optional"] = 512] = "Optional";
    TypeFlags[TypeFlags["Reference"] = 1024] = "Reference";
    TypeFlags[TypeFlags["Identifier"] = 2048] = "Identifier";
    TypeFlags[TypeFlags["Late"] = 4096] = "Late";
    TypeFlags[TypeFlags["Refinement"] = 8192] = "Refinement";
    TypeFlags[TypeFlags["Union"] = 16384] = "Union";
    TypeFlags[TypeFlags["Null"] = 32768] = "Null";
    TypeFlags[TypeFlags["Undefined"] = 65536] = "Undefined";
    TypeFlags[TypeFlags["Integer"] = 131072] = "Integer";
    TypeFlags[TypeFlags["Custom"] = 262144] = "Custom";
    TypeFlags[TypeFlags["SnapshotProcessor"] = 524288] = "SnapshotProcessor";
    TypeFlags[TypeFlags["Lazy"] = 1048576] = "Lazy";
    TypeFlags[TypeFlags["Finite"] = 2097152] = "Finite";
    TypeFlags[TypeFlags["Float"] = 4194304] = "Float";
})(TypeFlags || (TypeFlags = {}));
/**
 * @internal
 * @hidden
 */
var cannotDetermineSubtype = "cannotDetermine";
/** @hidden */
var $type = Symbol("$type");
/**
 * A base type produces a MST node (Node in the state tree)
 *
 * @internal
 * @hidden
 */
var BaseType = /** @class */ (function () {
    function BaseType(name) {
        Object.defineProperty(this, _a, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // these are just to make inner types avaialable to inherited classes
        Object.defineProperty(this, "C", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "S", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "T", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "N", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name;
    }
    Object.defineProperty(BaseType.prototype, "create", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot, environment) {
            typecheckInternal(this, snapshot);
            return this.instantiate(null, "", environment, snapshot).value;
        }
    });
    Object.defineProperty(BaseType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, applyPostProcess) {
            // istanbul ignore next
            throw new MstError("unimplemented method");
        }
    });
    Object.defineProperty(BaseType.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            return type === this;
        }
    });
    Object.defineProperty(BaseType.prototype, "validate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var node = getStateTreeNodeSafe(value);
            if (node) {
                var valueType = getType(value);
                return this.isAssignableFrom(valueType)
                    ? typeCheckSuccess()
                    : typeCheckFailure(context, value);
                // it is tempting to compare snapshots, but in that case we should always clone on assignments...
            }
            return this.isValidSnapshot(value, context);
        }
    });
    Object.defineProperty(BaseType.prototype, "is", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (thing) {
            return this.validate(thing, [{ path: "", type: this }]).length === 0;
        }
    });
    Object.defineProperty(BaseType.prototype, "Type", {
        get: function () {
            // istanbul ignore next
            throw new MstError("Factory.Type should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.Type`");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseType.prototype, "TypeWithoutSTN", {
        get: function () {
            // istanbul ignore next
            throw new MstError("Factory.TypeWithoutSTN should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.TypeWithoutSTN`");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseType.prototype, "SnapshotType", {
        get: function () {
            // istanbul ignore next
            throw new MstError("Factory.SnapshotType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.SnapshotType`");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseType.prototype, "CreationType", {
        get: function () {
            // istanbul ignore next
            throw new MstError("Factory.CreationType should not be actually called. It is just a Type signature that can be used at compile time with Typescript, by using `typeof type.CreationType`");
        },
        enumerable: false,
        configurable: true
    });
    return BaseType;
}());
_a = $type;
BaseType.prototype.create = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.action)(BaseType.prototype.create);
/**
 * A complex type produces a MST node (Node in the state tree)
 *
 * @internal
 * @hidden
 */
var ComplexType = /** @class */ (function (_super) {
    __extends(ComplexType, _super);
    function ComplexType(name) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "identifierAttribute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(ComplexType.prototype, "create", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot, environment) {
            if (snapshot === void 0) { snapshot = this.getDefaultSnapshot(); }
            return _super.prototype.create.call(this, snapshot, environment);
        }
    });
    Object.defineProperty(ComplexType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            node.createObservableInstanceIfNeeded();
            return node.storedValue;
        }
    });
    Object.defineProperty(ComplexType.prototype, "isMatchingSnapshotId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, snapshot) {
            return (!current.identifierAttribute ||
                current.identifier === normalizeIdentifier(snapshot[current.identifierAttribute]));
        }
    });
    Object.defineProperty(ComplexType.prototype, "tryToReconcileNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue) {
            if (current.isDetaching)
                return false;
            if (current.snapshot === newValue) {
                // newValue is the current snapshot of the node, noop
                return true;
            }
            if (isStateTreeNode(newValue) && getStateTreeNode(newValue) === current) {
                // the current node is the same as the new one
                return true;
            }
            if (current.type === this &&
                isMutable(newValue) &&
                !isStateTreeNode(newValue) &&
                this.isMatchingSnapshotId(current, newValue)) {
                // the newValue has no node, so can be treated like a snapshot
                // we can reconcile
                current.applySnapshot(newValue);
                return true;
            }
            return false;
        }
    });
    Object.defineProperty(ComplexType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            var nodeReconciled = this.tryToReconcileNode(current, newValue);
            if (nodeReconciled) {
                current.setParent(parent, subpath);
                return current;
            }
            // current node cannot be recycled in any way
            current.die(); // noop if detaching
            // attempt to reuse the new one
            if (isStateTreeNode(newValue) && this.isAssignableFrom(getType(newValue))) {
                // newValue is a Node as well, move it here..
                var newNode = getStateTreeNode(newValue);
                newNode.setParent(parent, subpath);
                return newNode;
            }
            // nothing to do, we have to create a new node
            return this.instantiate(parent, subpath, undefined, newValue);
        }
    });
    Object.defineProperty(ComplexType.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return null;
        }
    });
    return ComplexType;
}(BaseType));
ComplexType.prototype.create = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.action)(ComplexType.prototype.create);
/**
 * @internal
 * @hidden
 */
var SimpleType = /** @class */ (function (_super) {
    __extends(SimpleType, _super);
    function SimpleType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SimpleType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot) {
            return snapshot;
        }
    });
    Object.defineProperty(SimpleType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            // if we ever find a case where scalar nodes can be accessed without iterating through its parent
            // uncomment this to make sure the parent chain is created when this is accessed
            // if (node.parent) {
            //     node.parent.createObservableInstanceIfNeeded()
            // }
            return node.storedValue;
        }
    });
    Object.defineProperty(SimpleType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            return node.storedValue;
        }
    });
    Object.defineProperty(SimpleType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            // reconcile only if type and value are still the same, and only if the node is not detaching
            if (!current.isDetaching && current.type === this && current.storedValue === newValue) {
                return current;
            }
            var res = this.instantiate(parent, subpath, undefined, newValue);
            current.die(); // noop if detaching
            return res;
        }
    });
    Object.defineProperty(SimpleType.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return null;
        }
    });
    return SimpleType;
}(BaseType));
/**
 * Returns if a given value represents a type.
 *
 * @param value Value to check.
 * @returns `true` if the value is a type.
 */
function isType(value) {
    return typeof value === "object" && value && value.isType === true;
}
/**
 * @internal
 * @hidden
 */
function assertIsType(type, argNumber) {
    assertArg(type, isType, "mobx-state-tree type", argNumber);
}

var runningActions = new Map();
/**
 * Note: Consider migrating to `createActionTrackingMiddleware2`, it is easier to use.
 *
 * Convenience utility to create action based middleware that supports async processes more easily.
 * All hooks are called for both synchronous and asynchronous actions. Except that either `onSuccess` or `onFail` is called
 *
 * The create middleware tracks the process of an action (assuming it passes the `filter`).
 * `onResume` can return any value, which will be passed as second argument to any other hook. This makes it possible to keep state during a process.
 *
 * See the `atomic` middleware for an example
 *
 * @param hooks
 * @returns
 */
function createActionTrackingMiddleware(hooks) {
    return function actionTrackingMiddleware(call, next, abort) {
        switch (call.type) {
            case "action": {
                if (!hooks.filter || hooks.filter(call) === true) {
                    var context = hooks.onStart(call);
                    hooks.onResume(call, context);
                    runningActions.set(call.id, {
                        call: call,
                        context: context,
                        async: false
                    });
                    try {
                        var res = next(call);
                        hooks.onSuspend(call, context);
                        if (runningActions.get(call.id).async === false) {
                            runningActions.delete(call.id);
                            hooks.onSuccess(call, context, res);
                        }
                        return res;
                    }
                    catch (e) {
                        runningActions.delete(call.id);
                        hooks.onFail(call, context, e);
                        throw e;
                    }
                }
                else {
                    return next(call);
                }
            }
            case "flow_spawn": {
                var root = runningActions.get(call.rootId);
                root.async = true;
                return next(call);
            }
            case "flow_resume":
            case "flow_resume_error": {
                var root = runningActions.get(call.rootId);
                hooks.onResume(call, root.context);
                try {
                    return next(call);
                }
                finally {
                    hooks.onSuspend(call, root.context);
                }
            }
            case "flow_throw": {
                var root = runningActions.get(call.rootId);
                runningActions.delete(call.rootId);
                hooks.onFail(call, root.context, call.args[0]);
                return next(call);
            }
            case "flow_return": {
                var root = runningActions.get(call.rootId);
                runningActions.delete(call.rootId);
                hooks.onSuccess(call, root.context, call.args[0]);
                return next(call);
            }
        }
    };
}

var RunningAction = /** @class */ (function () {
    function RunningAction(hooks, call) {
        Object.defineProperty(this, "hooks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: hooks
        });
        Object.defineProperty(this, "call", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: call
        });
        Object.defineProperty(this, "flowsPending", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "running", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        if (hooks) {
            hooks.onStart(call);
        }
    }
    Object.defineProperty(RunningAction.prototype, "finish", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (error) {
            if (this.running) {
                this.running = false;
                if (this.hooks) {
                    this.hooks.onFinish(this.call, error);
                }
            }
        }
    });
    Object.defineProperty(RunningAction.prototype, "incFlowsPending", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.flowsPending++;
        }
    });
    Object.defineProperty(RunningAction.prototype, "decFlowsPending", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.flowsPending--;
        }
    });
    Object.defineProperty(RunningAction.prototype, "hasFlowsPending", {
        get: function () {
            return this.flowsPending > 0;
        },
        enumerable: false,
        configurable: true
    });
    return RunningAction;
}());
/**
 * Convenience utility to create action based middleware that supports async processes more easily.
 * The flow is like this:
 * - for each action: if filter passes -> `onStart` -> (inner actions recursively) -> `onFinish`
 *
 * Example: if we had an action `a` that called inside an action `b1`, then `b2` the flow would be:
 * - `filter(a)`
 * - `onStart(a)`
 *   - `filter(b1)`
 *   - `onStart(b1)`
 *   - `onFinish(b1)`
 *   - `filter(b2)`
 *   - `onStart(b2)`
 *   - `onFinish(b2)`
 * - `onFinish(a)`
 *
 * The flow is the same no matter if the actions are sync or async.
 *
 * See the `atomic` middleware for an example
 *
 * @param hooks
 * @returns
 */
function createActionTrackingMiddleware2(middlewareHooks) {
    var runningActions = new Map();
    return function actionTrackingMiddleware(call, next) {
        // find parentRunningAction
        var parentRunningAction = call.parentActionEvent
            ? runningActions.get(call.parentActionEvent.id)
            : undefined;
        if (call.type === "action") {
            var newCall = __assign(__assign({}, call), { 
                // make a shallow copy of the parent action env
                env: parentRunningAction && parentRunningAction.call.env, parentCall: parentRunningAction && parentRunningAction.call });
            var passesFilter = !middlewareHooks.filter || middlewareHooks.filter(newCall);
            var hooks = passesFilter ? middlewareHooks : undefined;
            var runningAction = new RunningAction(hooks, newCall);
            runningActions.set(call.id, runningAction);
            var res = void 0;
            try {
                res = next(call);
            }
            catch (e) {
                runningActions.delete(call.id);
                runningAction.finish(e);
                throw e;
            }
            // sync action finished
            if (!runningAction.hasFlowsPending) {
                runningActions.delete(call.id);
                runningAction.finish();
            }
            return res;
        }
        else {
            if (!parentRunningAction) {
                return next(call);
            }
            switch (call.type) {
                case "flow_spawn": {
                    parentRunningAction.incFlowsPending();
                    return next(call);
                }
                case "flow_resume":
                case "flow_resume_error": {
                    return next(call);
                }
                case "flow_throw": {
                    var error = call.args[0];
                    try {
                        return next(call);
                    }
                    finally {
                        parentRunningAction.decFlowsPending();
                        if (!parentRunningAction.hasFlowsPending) {
                            runningActions.delete(call.parentActionEvent.id);
                            parentRunningAction.finish(error);
                        }
                    }
                }
                case "flow_return": {
                    try {
                        return next(call);
                    }
                    finally {
                        parentRunningAction.decFlowsPending();
                        if (!parentRunningAction.hasFlowsPending) {
                            runningActions.delete(call.parentActionEvent.id);
                            parentRunningAction.finish();
                        }
                    }
                }
            }
        }
    };
}

function serializeArgument(node, actionName, index, arg) {
    if (arg instanceof Date)
        return { $MST_DATE: arg.getTime() };
    if (isPrimitive(arg))
        return arg;
    // We should not serialize MST nodes, even if we can, because we don't know if the receiving party can handle a raw snapshot instead of an
    // MST type instance. So if one wants to serialize a MST node that was pass in, either explitly pass: 1: an id, 2: a (relative) path, 3: a snapshot
    if (isStateTreeNode(arg))
        return serializeTheUnserializable("[MSTNode: ".concat(getType(arg).name, "]"));
    if (typeof arg === "function")
        return serializeTheUnserializable("[function]");
    if (typeof arg === "object" && !isPlainObject(arg) && !isArray(arg))
        return serializeTheUnserializable("[object ".concat((arg && arg.constructor && arg.constructor.name) || "Complex Object", "]"));
    try {
        // Check if serializable, cycle free etc...
        // MWE: there must be a better way....
        JSON.stringify(arg); // or throws
        return arg;
    }
    catch (e) {
        return serializeTheUnserializable("" + e);
    }
}
function deserializeArgument(adm, value) {
    if (value && typeof value === "object" && "$MST_DATE" in value)
        return new Date(value["$MST_DATE"]);
    return value;
}
function serializeTheUnserializable(baseType) {
    return {
        $MST_UNSERIALIZABLE: true,
        type: baseType
    };
}
/**
 * Applies an action or a series of actions in a single MobX transaction.
 * Does not return any value
 * Takes an action description as produced by the `onAction` middleware.
 *
 * @param target
 * @param actions
 */
function applyAction(target, actions) {
    // check all arguments
    assertIsStateTreeNode(target, 1);
    assertArg(actions, function (a) { return typeof a === "object"; }, "object or array", 2);
    (0,mobx__WEBPACK_IMPORTED_MODULE_0__.runInAction)(function () {
        asArray(actions).forEach(function (action) { return baseApplyAction(target, action); });
    });
}
function baseApplyAction(target, action) {
    var resolvedTarget = tryResolve(target, action.path || "");
    if (!resolvedTarget)
        throw new MstError("Invalid action path: ".concat(action.path || ""));
    var node = getStateTreeNode(resolvedTarget);
    // Reserved functions
    if (action.name === "@APPLY_PATCHES") {
        return applyPatch.call(null, resolvedTarget, action.args[0]);
    }
    if (action.name === "@APPLY_SNAPSHOT") {
        return applySnapshot.call(null, resolvedTarget, action.args[0]);
    }
    if (!(typeof resolvedTarget[action.name] === "function"))
        throw new MstError("Action '".concat(action.name, "' does not exist in '").concat(node.path, "'"));
    return resolvedTarget[action.name].apply(resolvedTarget, action.args ? action.args.map(function (v) { return deserializeArgument(node, v); }) : []);
}
/**
 * Small abstraction around `onAction` and `applyAction`, attaches an action listener to a tree and records all the actions emitted.
 * Returns an recorder object with the following signature:
 *
 * Example:
 * ```ts
 * export interface IActionRecorder {
 *      // the recorded actions
 *      actions: ISerializedActionCall[]
 *      // true if currently recording
 *      recording: boolean
 *      // stop recording actions
 *      stop(): void
 *      // resume recording actions
 *      resume(): void
 *      // apply all the recorded actions on the given object
 *      replay(target: IAnyStateTreeNode): void
 * }
 * ```
 *
 * The optional filter function allows to skip recording certain actions.
 *
 * @param subject
 * @returns
 */
function recordActions(subject, filter) {
    // check all arguments
    assertIsStateTreeNode(subject, 1);
    var actions = [];
    var listener = function (call) {
        var recordThis = filter ? filter(call, getRunningActionContext()) : true;
        if (recordThis) {
            actions.push(call);
        }
    };
    var disposer;
    var recorder = {
        actions: actions,
        get recording() {
            return !!disposer;
        },
        stop: function () {
            if (disposer) {
                disposer();
                disposer = undefined;
            }
        },
        resume: function () {
            if (disposer)
                return;
            disposer = onAction(subject, listener);
        },
        replay: function (target) {
            applyAction(target, actions);
        }
    };
    recorder.resume();
    return recorder;
}
/**
 * Registers a function that will be invoked for each action that is called on the provided model instance, or to any of its children.
 * See [actions](https://github.com/mobxjs/mobx-state-tree#actions) for more details. onAction events are emitted only for the outermost called action in the stack.
 * Action can also be intercepted by middleware using addMiddleware to change the function call before it will be run.
 *
 * Not all action arguments might be serializable. For unserializable arguments, a struct like `{ $MST_UNSERIALIZABLE: true, type: "someType" }` will be generated.
 * MST Nodes are considered non-serializable as well (they could be serialized as there snapshot, but it is uncertain whether an replaying party will be able to handle such a non-instantiated snapshot).
 * Rather, when using `onAction` middleware, one should consider in passing arguments which are 1: an id, 2: a (relative) path, or 3: a snapshot. Instead of a real MST node.
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.array(Todo)
 * }).actions(self => ({
 *   add(todo) {
 *     self.todos.push(todo);
 *   }
 * }))
 *
 * const s = TodoStore.create({ todos: [] })
 *
 * let disposer = onAction(s, (call) => {
 *   console.log(call);
 * })
 *
 * s.add({ task: "Grab a coffee" })
 * // Logs: { name: "add", path: "", args: [{ task: "Grab a coffee" }] }
 * ```
 *
 * @param target
 * @param listener
 * @param attachAfter (default false) fires the listener *after* the action has executed instead of before.
 * @returns
 */
function onAction(target, listener, attachAfter) {
    if (attachAfter === void 0) { attachAfter = false; }
    // check all arguments
    assertIsStateTreeNode(target, 1);
    if (devMode()) {
        if (!isRoot(target))
            warnError("Warning: Attaching onAction listeners to non root nodes is dangerous: No events will be emitted for actions initiated higher up in the tree.");
        if (!isProtected(target))
            warnError("Warning: Attaching onAction listeners to non protected nodes is dangerous: No events will be emitted for direct modifications without action.");
    }
    return addMiddleware(target, function handler(rawCall, next) {
        if (rawCall.type === "action" && rawCall.id === rawCall.rootId) {
            var sourceNode_1 = getStateTreeNode(rawCall.context);
            var info = {
                name: rawCall.name,
                path: getRelativePathBetweenNodes(getStateTreeNode(target), sourceNode_1),
                args: rawCall.args.map(function (arg, index) {
                    return serializeArgument(sourceNode_1, rawCall.name, index, arg);
                })
            };
            if (attachAfter) {
                var res = next(rawCall);
                listener(info);
                return res;
            }
            else {
                listener(info);
                return next(rawCall);
            }
        }
        else {
            return next(rawCall);
        }
    });
}

var nextActionId = 1;
var currentActionContext;
/**
 * @internal
 * @hidden
 */
function getCurrentActionContext() {
    return currentActionContext;
}
/**
 * @internal
 * @hidden
 */
function getNextActionId() {
    return nextActionId++;
}
// TODO: optimize away entire action context if there is no middleware in tree?
/**
 * @internal
 * @hidden
 */
function runWithActionContext(context, fn) {
    var node = getStateTreeNode(context.context);
    if (context.type === "action") {
        node.assertAlive({
            actionContext: context
        });
    }
    var baseIsRunningAction = node._isRunningAction;
    node._isRunningAction = true;
    var previousContext = currentActionContext;
    currentActionContext = context;
    try {
        return runMiddleWares(node, context, fn);
    }
    finally {
        currentActionContext = previousContext;
        node._isRunningAction = baseIsRunningAction;
    }
}
/**
 * @internal
 * @hidden
 */
function getParentActionContext(parentContext) {
    if (!parentContext)
        return undefined;
    if (parentContext.type === "action")
        return parentContext;
    return parentContext.parentActionEvent;
}
/**
 * @internal
 * @hidden
 */
function createActionInvoker(target, name, fn) {
    var res = function () {
        var id = getNextActionId();
        var parentContext = currentActionContext;
        var parentActionContext = getParentActionContext(parentContext);
        return runWithActionContext({
            type: "action",
            name: name,
            id: id,
            args: argsToArray(arguments),
            context: target,
            tree: getRoot(target),
            rootId: parentContext ? parentContext.rootId : id,
            parentId: parentContext ? parentContext.id : 0,
            allParentIds: parentContext ? __spreadArray(__spreadArray([], __read(parentContext.allParentIds), false), [parentContext.id], false) : [],
            parentEvent: parentContext,
            parentActionEvent: parentActionContext
        }, fn);
    };
    res._isMSTAction = true;
    res._isFlowAction = fn._isFlowAction;
    return res;
}
/**
 * Middleware can be used to intercept any action is invoked on the subtree where it is attached.
 * If a tree is protected (by default), this means that any mutation of the tree will pass through your middleware.
 *
 * For more details, see the [middleware docs](concepts/middleware.md)
 *
 * @param target Node to apply the middleware to.
 * @param middleware Middleware to apply.
 * @returns A callable function to dispose the middleware.
 */
function addMiddleware(target, handler, includeHooks) {
    if (includeHooks === void 0) { includeHooks = true; }
    var node = getStateTreeNode(target);
    if (devMode()) {
        if (!node.isProtectionEnabled) {
            warnError("It is recommended to protect the state tree before attaching action middleware, as otherwise it cannot be guaranteed that all changes are passed through middleware. See `protect`");
        }
    }
    return node.addMiddleWare(handler, includeHooks);
}
/**
 * Binds middleware to a specific action.
 *
 * Example:
 * ```ts
 * type.actions(self => {
 *   function takeA____() {
 *       self.toilet.donate()
 *       self.wipe()
 *       self.wipe()
 *       self.toilet.flush()
 *   }
 *   return {
 *     takeA____: decorate(atomic, takeA____)
 *   }
 * })
 * ```
 *
 * @param handler
 * @param fn
 * @param includeHooks
 * @returns The original function
 */
function decorate(handler, fn, includeHooks) {
    if (includeHooks === void 0) { includeHooks = true; }
    var middleware = { handler: handler, includeHooks: includeHooks };
    fn.$mst_middleware = fn.$mst_middleware || [];
    fn.$mst_middleware.push(middleware);
    return fn;
}
var CollectedMiddlewares = /** @class */ (function () {
    function CollectedMiddlewares(node, fn) {
        Object.defineProperty(this, "arrayIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "inArrayIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "middlewares", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        // we just push middleware arrays into an array of arrays to avoid making copies
        if (fn.$mst_middleware) {
            this.middlewares.push(fn.$mst_middleware);
        }
        var n = node;
        // Find all middlewares. Optimization: cache this?
        while (n) {
            if (n.middlewares)
                this.middlewares.push(n.middlewares);
            n = n.parent;
        }
    }
    Object.defineProperty(CollectedMiddlewares.prototype, "isEmpty", {
        get: function () {
            return this.middlewares.length <= 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectedMiddlewares.prototype, "getNextMiddleware", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var array = this.middlewares[this.arrayIndex];
            if (!array)
                return undefined;
            var item = array[this.inArrayIndex++];
            if (!item) {
                this.arrayIndex++;
                this.inArrayIndex = 0;
                return this.getNextMiddleware();
            }
            return item;
        }
    });
    return CollectedMiddlewares;
}());
function runMiddleWares(node, baseCall, originalFn) {
    var middlewares = new CollectedMiddlewares(node, originalFn);
    // Short circuit
    if (middlewares.isEmpty)
        return (0,mobx__WEBPACK_IMPORTED_MODULE_0__.action)(originalFn).apply(null, baseCall.args);
    var result = null;
    function runNextMiddleware(call) {
        var middleware = middlewares.getNextMiddleware();
        var handler = middleware && middleware.handler;
        if (!handler) {
            return (0,mobx__WEBPACK_IMPORTED_MODULE_0__.action)(originalFn).apply(null, call.args);
        }
        // skip hooks if asked to
        if (!middleware.includeHooks && Hook[call.name]) {
            return runNextMiddleware(call);
        }
        var nextInvoked = false;
        function next(call2, callback) {
            nextInvoked = true;
            // the result can contain
            // - the non manipulated return value from an action
            // - the non manipulated abort value
            // - one of the above but manipulated through the callback function
            result = runNextMiddleware(call2);
            if (callback) {
                result = callback(result);
            }
        }
        var abortInvoked = false;
        function abort(value) {
            abortInvoked = true;
            // overwrite the result
            // can be manipulated through middlewares earlier in the queue using the callback fn
            result = value;
        }
        handler(call, next, abort);
        if (devMode()) {
            if (!nextInvoked && !abortInvoked) {
                var node2 = getStateTreeNode(call.tree);
                throw new MstError("Neither the next() nor the abort() callback within the middleware ".concat(handler.name, " for the action: \"").concat(call.name, "\" on the node: ").concat(node2.type.name, " was invoked."));
            }
            else if (nextInvoked && abortInvoked) {
                var node2 = getStateTreeNode(call.tree);
                throw new MstError("The next() and abort() callback within the middleware ".concat(handler.name, " for the action: \"").concat(call.name, "\" on the node: ").concat(node2.type.name, " were invoked."));
            }
        }
        return result;
    }
    return runNextMiddleware(baseCall);
}

/**
 * Returns the currently executing MST action context, or undefined if none.
 */
function getRunningActionContext() {
    var current = getCurrentActionContext();
    while (current && current.type !== "action") {
        current = current.parentActionEvent;
    }
    return current;
}
function _isActionContextThisOrChildOf(actionContext, sameOrParent, includeSame) {
    var parentId = typeof sameOrParent === "number" ? sameOrParent : sameOrParent.id;
    var current = includeSame
        ? actionContext
        : actionContext.parentActionEvent;
    while (current) {
        if (current.id === parentId) {
            return true;
        }
        current = current.parentActionEvent;
    }
    return false;
}
/**
 * Returns if the given action context is a parent of this action context.
 */
function isActionContextChildOf(actionContext, parent) {
    return _isActionContextThisOrChildOf(actionContext, parent, false);
}
/**
 * Returns if the given action context is this or a parent of this action context.
 */
function isActionContextThisOrChildOf(actionContext, parentOrThis) {
    return _isActionContextThisOrChildOf(actionContext, parentOrThis, true);
}

function safeStringify(value) {
    try {
        return JSON.stringify(value);
    }
    catch (e) {
        // istanbul ignore next
        return "<Unserializable: ".concat(e, ">");
    }
}
/**
 * @internal
 * @hidden
 */
function prettyPrintValue(value) {
    return typeof value === "function"
        ? "<function".concat(value.name ? " " + value.name : "", ">")
        : isStateTreeNode(value)
            ? "<".concat(value, ">")
            : "`".concat(safeStringify(value), "`");
}
function shortenPrintValue(valueInString) {
    return valueInString.length < 280
        ? valueInString
        : "".concat(valueInString.substring(0, 272), "......").concat(valueInString.substring(valueInString.length - 8));
}
function toErrorString(error) {
    var value = error.value;
    var type = error.context[error.context.length - 1].type;
    var fullPath = error.context
        .map(function (_a) {
        var path = _a.path;
        return path;
    })
        .filter(function (path) { return path.length > 0; })
        .join("/");
    var pathPrefix = fullPath.length > 0 ? "at path \"/".concat(fullPath, "\" ") : "";
    var currentTypename = isStateTreeNode(value)
        ? "value of type ".concat(getStateTreeNode(value).type.name, ":")
        : isPrimitive(value)
            ? "value"
            : "snapshot";
    var isSnapshotCompatible = type && isStateTreeNode(value) && type.is(getStateTreeNode(value).snapshot);
    return ("".concat(pathPrefix).concat(currentTypename, " ").concat(prettyPrintValue(value), " is not assignable ").concat(type ? "to type: `".concat(type.name, "`") : "") +
        (error.message ? " (".concat(error.message, ")") : "") +
        (type
            ? isPrimitiveType(type) || isPrimitive(value)
                ? "."
                : ", expected an instance of `".concat(type.name, "` or a snapshot like `").concat(type.describe(), "` instead.") +
                    (isSnapshotCompatible
                        ? " (Note that a snapshot of the provided value is compatible with the targeted type)"
                        : "")
            : "."));
}
/**
 * @internal
 * @hidden
 */
function getContextForPath(context, path, type) {
    return context.concat([{ path: path, type: type }]);
}
/**
 * @internal
 * @hidden
 */
function typeCheckSuccess() {
    return EMPTY_ARRAY;
}
/**
 * @internal
 * @hidden
 */
function typeCheckFailure(context, value, message) {
    return [{ context: context, value: value, message: message }];
}
/**
 * @internal
 * @hidden
 */
function flattenTypeErrors(errors) {
    return errors.reduce(function (a, i) { return a.concat(i); }, []);
}
// TODO; doublecheck: typecheck should only needed to be invoked from: type.create and array / map / value.property will change
/**
 * @internal
 * @hidden
 */
function typecheckInternal(type, value) {
    // runs typeChecking if it is in dev-mode or through a process.env.ENABLE_TYPE_CHECK flag
    if (isTypeCheckingEnabled()) {
        typecheck(type, value);
    }
}
/**
 * Run's the typechecker for the given type on the given value, which can be a snapshot or an instance.
 * Throws if the given value is not according the provided type specification.
 * Use this if you need typechecks even in a production build (by default all automatic runtime type checks will be skipped in production builds)
 *
 * @param type Type to check against.
 * @param value Value to be checked, either a snapshot or an instance.
 */
function typecheck(type, value) {
    var errors = type.validate(value, [{ path: "", type: type }]);
    if (errors.length > 0) {
        throw new MstError(validationErrorsToString(type, value, errors));
    }
}
function validationErrorsToString(type, value, errors) {
    if (errors.length === 0) {
        return undefined;
    }
    return ("Error while converting ".concat(shortenPrintValue(prettyPrintValue(value)), " to `").concat(type.name, "`:\n\n    ") + errors.map(toErrorString).join("\n    "));
}

var identifierCacheId = 0;
/**
 * @internal
 * @hidden
 */
var IdentifierCache = /** @class */ (function () {
    function IdentifierCache() {
        Object.defineProperty(this, "cacheId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: identifierCacheId++
        });
        // n.b. in cache all identifiers are normalized to strings
        Object.defineProperty(this, "cache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: mobx__WEBPACK_IMPORTED_MODULE_0__.observable.map()
        });
        // last time the cache (array) for a given time changed
        // n.b. it is not really the time, but just an integer that gets increased after each modification to the array
        Object.defineProperty(this, "lastCacheModificationPerId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: mobx__WEBPACK_IMPORTED_MODULE_0__.observable.map()
        });
    }
    Object.defineProperty(IdentifierCache.prototype, "updateLastCacheModificationPerId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (identifier) {
            var lcm = this.lastCacheModificationPerId.get(identifier);
            // we start at 1 since 0 means no update since cache creation
            this.lastCacheModificationPerId.set(identifier, lcm === undefined ? 1 : lcm + 1);
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "getLastCacheModificationPerId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (identifier) {
            var modificationId = this.lastCacheModificationPerId.get(identifier) || 0;
            return "".concat(this.cacheId, "-").concat(modificationId);
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "addNodeToCache", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, lastCacheUpdate) {
            if (lastCacheUpdate === void 0) { lastCacheUpdate = true; }
            if (node.identifierAttribute) {
                var identifier = node.identifier;
                if (!this.cache.has(identifier)) {
                    this.cache.set(identifier, mobx__WEBPACK_IMPORTED_MODULE_0__.observable.array([], mobxShallow));
                }
                var set = this.cache.get(identifier);
                if (set.indexOf(node) !== -1)
                    throw new MstError("Already registered");
                set.push(node);
                if (lastCacheUpdate) {
                    this.updateLastCacheModificationPerId(identifier);
                }
            }
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "mergeCache", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            var _this = this;
            (0,mobx__WEBPACK_IMPORTED_MODULE_0__.values)(node.identifierCache.cache).forEach(function (nodes) {
                return nodes.forEach(function (child) {
                    _this.addNodeToCache(child);
                });
            });
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "notifyDied", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            if (node.identifierAttribute) {
                var id = node.identifier;
                var set = this.cache.get(id);
                if (set) {
                    set.remove(node);
                    // remove empty sets from cache
                    if (!set.length) {
                        this.cache.delete(id);
                    }
                    this.updateLastCacheModificationPerId(node.identifier);
                }
            }
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "splitCache", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (splitNode) {
            var _this = this;
            var newCache = new IdentifierCache();
            // The slash is added here so we only match children of the splitNode. In version 5.1.8 and
            // earlier there was no trailing slash, so non children that started with the same path string
            // were being matched incorrectly.
            var basePath = splitNode.path + "/";
            (0,mobx__WEBPACK_IMPORTED_MODULE_0__.entries)(this.cache).forEach(function (_a) {
                var _b = __read(_a, 2), id = _b[0], nodes = _b[1];
                var modified = false;
                for (var i = nodes.length - 1; i >= 0; i--) {
                    var node = nodes[i];
                    if (node === splitNode || node.path.indexOf(basePath) === 0) {
                        newCache.addNodeToCache(node, false); // no need to update lastUpdated since it is a whole new cache
                        nodes.splice(i, 1);
                        // remove empty sets from cache
                        if (!nodes.length) {
                            _this.cache.delete(id);
                        }
                        modified = true;
                    }
                }
                if (modified) {
                    _this.updateLastCacheModificationPerId(id);
                }
            });
            return newCache;
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type, identifier) {
            var set = this.cache.get(identifier);
            if (!set)
                return false;
            return set.some(function (candidate) { return type.isAssignableFrom(candidate.type); });
        }
    });
    Object.defineProperty(IdentifierCache.prototype, "resolve", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type, identifier) {
            var set = this.cache.get(identifier);
            if (!set)
                return null;
            var matches = set.filter(function (candidate) { return type.isAssignableFrom(candidate.type); });
            switch (matches.length) {
                case 0:
                    return null;
                case 1:
                    return matches[0];
                default:
                    throw new MstError("Cannot resolve a reference to type '".concat(type.name, "' with id: '").concat(identifier, "' unambigously, there are multiple candidates: ").concat(matches
                        .map(function (n) { return n.path; })
                        .join(", ")));
            }
        }
    });
    return IdentifierCache;
}());

/**
 * @internal
 * @hidden
 */
function createObjectNode(type, parent, subpath, environment, initialValue) {
    var existingNode = getStateTreeNodeSafe(initialValue);
    if (existingNode) {
        if (existingNode.parent) {
            // istanbul ignore next
            throw new MstError("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '".concat(parent ? parent.path : "", "/").concat(subpath, "', but it lives already at '").concat(existingNode.path, "'"));
        }
        if (parent) {
            existingNode.setParent(parent, subpath);
        }
        // else it already has no parent since it is a pre-requisite
        return existingNode;
    }
    // not a node, a snapshot
    return new ObjectNode(type, parent, subpath, environment, initialValue);
}
/**
 * @internal
 * @hidden
 */
function createScalarNode(type, parent, subpath, environment, initialValue) {
    return new ScalarNode(type, parent, subpath, environment, initialValue);
}
/**
 * @internal
 * @hidden
 */
function isNode(value) {
    return value instanceof ScalarNode || value instanceof ObjectNode;
}

/**
 * @internal
 * @hidden
 */
var NodeLifeCycle;
(function (NodeLifeCycle) {
    NodeLifeCycle[NodeLifeCycle["INITIALIZING"] = 0] = "INITIALIZING";
    NodeLifeCycle[NodeLifeCycle["CREATED"] = 1] = "CREATED";
    NodeLifeCycle[NodeLifeCycle["FINALIZED"] = 2] = "FINALIZED";
    NodeLifeCycle[NodeLifeCycle["DETACHING"] = 3] = "DETACHING";
    NodeLifeCycle[NodeLifeCycle["DEAD"] = 4] = "DEAD"; // no coming back from this one
})(NodeLifeCycle || (NodeLifeCycle = {}));
/**
 * Returns true if the given value is a node in a state tree.
 * More precisely, that is, if the value is an instance of a
 * `types.model`, `types.array` or `types.map`.
 *
 * @param value
 * @returns true if the value is a state tree node.
 */
function isStateTreeNode(value) {
    return !!(value && value.$treenode);
}
/**
 * @internal
 * @hidden
 */
function assertIsStateTreeNode(value, argNumber) {
    assertArg(value, isStateTreeNode, "mobx-state-tree node", argNumber);
}
/**
 * @internal
 * @hidden
 */
function getStateTreeNode(value) {
    if (!isStateTreeNode(value)) {
        // istanbul ignore next
        throw new MstError("Value ".concat(value, " is no MST Node"));
    }
    return value.$treenode;
}
/**
 * @internal
 * @hidden
 */
function getStateTreeNodeSafe(value) {
    return (value && value.$treenode) || null;
}
/**
 * @internal
 * @hidden
 */
function toJSON() {
    return getStateTreeNode(this).snapshot;
}
var doubleDot = function (_) { return ".."; };
/**
 * @internal
 * @hidden
 */
function getRelativePathBetweenNodes(base, target) {
    // PRE condition target is (a child of) base!
    if (base.root !== target.root) {
        throw new MstError("Cannot calculate relative path: objects '".concat(base, "' and '").concat(target, "' are not part of the same object tree"));
    }
    var baseParts = splitJsonPath(base.path);
    var targetParts = splitJsonPath(target.path);
    var common = 0;
    for (; common < baseParts.length; common++) {
        if (baseParts[common] !== targetParts[common])
            break;
    }
    // TODO: assert that no targetParts paths are "..", "." or ""!
    return baseParts.slice(common).map(doubleDot).join("/") + joinJsonPath(targetParts.slice(common));
}
/**
 * @internal
 * @hidden
 */
function resolveNodeByPath(base, path, failIfResolveFails) {
    if (failIfResolveFails === void 0) { failIfResolveFails = true; }
    return resolveNodeByPathParts(base, splitJsonPath(path), failIfResolveFails);
}
/**
 * @internal
 * @hidden
 */
function resolveNodeByPathParts(base, pathParts, failIfResolveFails) {
    if (failIfResolveFails === void 0) { failIfResolveFails = true; }
    var current = base;
    try {
        for (var i = 0; i < pathParts.length; i++) {
            var part = pathParts[i];
            if (part === "..") {
                current = current.parent;
                if (current)
                    continue; // not everything has a parent
            }
            else if (part === ".") {
                continue;
            }
            else if (current) {
                if (current instanceof ScalarNode) {
                    // check if the value of a scalar resolves to a state tree node (e.g. references)
                    // then we can continue resolving...
                    var value = current.value;
                    if (isStateTreeNode(value)) {
                        current = getStateTreeNode(value);
                        // fall through
                    }
                }
                if (current instanceof ObjectNode) {
                    var subType = current.getChildType(part);
                    if (subType) {
                        current = current.getChildNode(part);
                        if (current)
                            continue;
                    }
                }
            }
            throw new MstError("Could not resolve '".concat(part, "' in path '").concat(joinJsonPath(pathParts.slice(0, i)) || "/", "' while resolving '").concat(joinJsonPath(pathParts), "'"));
        }
    }
    catch (e) {
        if (!failIfResolveFails) {
            return undefined;
        }
        throw e;
    }
    return current;
}
/**
 * @internal
 * @hidden
 */
function convertChildNodesToArray(childNodes) {
    if (!childNodes)
        return EMPTY_ARRAY;
    var keys = Object.keys(childNodes);
    if (!keys.length)
        return EMPTY_ARRAY;
    var result = new Array(keys.length);
    keys.forEach(function (key, index) {
        result[index] = childNodes[key];
    });
    return result;
}

// based on: https://github.com/mobxjs/mobx-utils/blob/master/src/async-action.ts
/*
    All contents of this file are deprecated.

    The term `process` has been replaced with `flow` to avoid conflicts with the
    global `process` object.

    Refer to `flow.ts` for any further changes to this implementation.
*/
var DEPRECATION_MESSAGE = "See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information. " +
    "Note that the middleware event types starting with `process` now start with `flow`.";
/**
 * @hidden
 *
 * @deprecated has been renamed to `flow()`.
 * See https://github.com/mobxjs/mobx-state-tree/issues/399 for more information.
 * Note that the middleware event types starting with `process` now start with `flow`.
 *
 * @returns {Promise}
 */
function process$1(asyncAction) {
    deprecated("process", "`process()` has been renamed to `flow()`. " + DEPRECATION_MESSAGE);
    return flow(asyncAction);
}

var plainObjectString = Object.toString();
/**
 * @internal
 * @hidden
 */
var EMPTY_ARRAY = Object.freeze([]);
/**
 * @internal
 * @hidden
 */
var EMPTY_OBJECT = Object.freeze({});
/**
 * @internal
 * @hidden
 */
var mobxShallow = (0,mobx__WEBPACK_IMPORTED_MODULE_0__._getGlobalState)().useProxies
    ? { deep: false }
    : { deep: false, proxy: false };
Object.freeze(mobxShallow);
/**
 * @internal
 * @hidden
 */
var MstError = /** @class */ (function (_super) {
    __extends(MstError, _super);
    function MstError(message) {
        if (message === void 0) { message = "Illegal state"; }
        return _super.call(this, "[mobx-state-tree] ".concat(message)) || this;
    }
    return MstError;
}(Error));
/**
 * @internal
 * @hidden
 */
function identity(_) {
    return _;
}
/**
 * @internal
 * @hidden
 */
var isInteger = Number.isInteger;
/**
 * @internal
 * @hidden
 */
function isFloat(val) {
    return Number(val) === val && val % 1 !== 0;
}
/**
 * @internal
 * @hidden
 */
function isFinite(val) {
    return Number.isFinite(val);
}
/**
 * @internal
 * @hidden
 */
function isArray(val) {
    return Array.isArray(val) || (0,mobx__WEBPACK_IMPORTED_MODULE_0__.isObservableArray)(val);
}
/**
 * @internal
 * @hidden
 */
function asArray(val) {
    if (!val)
        return EMPTY_ARRAY;
    if (isArray(val))
        return val;
    return [val];
}
/**
 * @internal
 * @hidden
 */
function extend(a) {
    var b = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        b[_i - 1] = arguments[_i];
    }
    for (var i = 0; i < b.length; i++) {
        var current = b[i];
        for (var key in current)
            a[key] = current[key];
    }
    return a;
}
/**
 * @internal
 * @hidden
 */
function isPlainObject(value) {
    var _a;
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null)
        return true;
    return ((_a = proto.constructor) === null || _a === void 0 ? void 0 : _a.toString()) === plainObjectString;
}
/**
 * @internal
 * @hidden
 */
function isMutable(value) {
    return (value !== null &&
        typeof value === "object" &&
        !(value instanceof Date) &&
        !(value instanceof RegExp));
}
/**
 * @internal
 * @hidden
 */
function isPrimitive(value, includeDate) {
    if (includeDate === void 0) { includeDate = true; }
    return (value === null ||
        value === undefined ||
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean" ||
        (includeDate && value instanceof Date));
}
/**
 * @internal
 * @hidden
 * Freeze a value and return it (if not in production)
 */
function freeze(value) {
    if (!devMode())
        return value;
    return isPrimitive(value) || (0,mobx__WEBPACK_IMPORTED_MODULE_0__.isObservableArray)(value) ? value : Object.freeze(value);
}
/**
 * @internal
 * @hidden
 * Recursively freeze a value (if not in production)
 */
function deepFreeze(value) {
    if (!devMode())
        return value;
    freeze(value);
    if (isPlainObject(value)) {
        Object.keys(value).forEach(function (propKey) {
            if (!isPrimitive(value[propKey]) && !Object.isFrozen(value[propKey])) {
                deepFreeze(value[propKey]);
            }
        });
    }
    return value;
}
/**
 * @internal
 * @hidden
 */
function isSerializable(value) {
    return typeof value !== "function";
}
/**
 * @internal
 * @hidden
 */
function defineProperty(object, key, descriptor) {
    (0,mobx__WEBPACK_IMPORTED_MODULE_0__.isObservableObject)(object)
        ? (0,mobx__WEBPACK_IMPORTED_MODULE_0__.defineProperty)(object, key, descriptor)
        : Object.defineProperty(object, key, descriptor);
}
/**
 * @internal
 * @hidden
 */
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
/**
 * @internal
 * @hidden
 */
function addHiddenWritableProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
/**
 * @internal
 * @hidden
 */
var EventHandler = /** @class */ (function () {
    function EventHandler() {
        Object.defineProperty(this, "handlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
    }
    Object.defineProperty(EventHandler.prototype, "hasSubscribers", {
        get: function () {
            return this.handlers.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventHandler.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn, atTheBeginning) {
            var _this = this;
            if (atTheBeginning === void 0) { atTheBeginning = false; }
            if (atTheBeginning) {
                this.handlers.unshift(fn);
            }
            else {
                this.handlers.push(fn);
            }
            return function () {
                _this.unregister(fn);
            };
        }
    });
    Object.defineProperty(EventHandler.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            return this.handlers.indexOf(fn) >= 0;
        }
    });
    Object.defineProperty(EventHandler.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            var index = this.handlers.indexOf(fn);
            if (index >= 0) {
                this.handlers.splice(index, 1);
            }
        }
    });
    Object.defineProperty(EventHandler.prototype, "clear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.handlers.length = 0;
        }
    });
    Object.defineProperty(EventHandler.prototype, "emit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // make a copy just in case it changes
            var handlers = this.handlers.slice();
            handlers.forEach(function (f) { return f.apply(void 0, __spreadArray([], __read(args), false)); });
        }
    });
    return EventHandler;
}());
/**
 * @internal
 * @hidden
 */
var EventHandlers = /** @class */ (function () {
    function EventHandlers() {
        Object.defineProperty(this, "eventHandlers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    Object.defineProperty(EventHandlers.prototype, "hasSubscribers", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var handler = this.eventHandlers && this.eventHandlers[event];
            return !!handler && handler.hasSubscribers;
        }
    });
    Object.defineProperty(EventHandlers.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, fn, atTheBeginning) {
            if (atTheBeginning === void 0) { atTheBeginning = false; }
            if (!this.eventHandlers) {
                this.eventHandlers = {};
            }
            var handler = this.eventHandlers[event];
            if (!handler) {
                handler = this.eventHandlers[event] = new EventHandler();
            }
            return handler.register(fn, atTheBeginning);
        }
    });
    Object.defineProperty(EventHandlers.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, fn) {
            var handler = this.eventHandlers && this.eventHandlers[event];
            return !!handler && handler.has(fn);
        }
    });
    Object.defineProperty(EventHandlers.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, fn) {
            var handler = this.eventHandlers && this.eventHandlers[event];
            if (handler) {
                handler.unregister(fn);
            }
        }
    });
    Object.defineProperty(EventHandlers.prototype, "clear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            if (this.eventHandlers) {
                delete this.eventHandlers[event];
            }
        }
    });
    Object.defineProperty(EventHandlers.prototype, "clearAll", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.eventHandlers = undefined;
        }
    });
    Object.defineProperty(EventHandlers.prototype, "emit", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            var _a;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var handler = this.eventHandlers && this.eventHandlers[event];
            if (handler) {
                (_a = handler).emit.apply(_a, __spreadArray([], __read(args), false));
            }
        }
    });
    return EventHandlers;
}());
/**
 * @internal
 * @hidden
 */
function argsToArray(args) {
    var res = new Array(args.length);
    for (var i = 0; i < args.length; i++)
        res[i] = args[i];
    return res;
}
/**
 * @internal
 * @hidden
 */
function stringStartsWith(str, beginning) {
    return str.indexOf(beginning) === 0;
}
/**
 * @internal
 * @hidden
 */
var deprecated = function (id, message) {
    // skip if running production
    if (!devMode())
        return;
    // warn if hasn't been warned before
    if (deprecated.ids && !deprecated.ids.hasOwnProperty(id)) {
        warnError("Deprecation warning: " + message);
    }
    // mark as warned to avoid duplicate warn message
    if (deprecated.ids)
        deprecated.ids[id] = true;
};
deprecated.ids = {};
/**
 * @internal
 * @hidden
 */
function warnError(msg) {
    console.warn(new Error("[mobx-state-tree] ".concat(msg)));
}
/**
 * @internal
 * @hidden
 */
function isTypeCheckingEnabled() {
    return (devMode() ||
        (typeof process !== "undefined" && ({"NODE_ENV":"production"}) && ({"NODE_ENV":"production"}).ENABLE_TYPE_CHECK === "true"));
}
/**
 * @internal
 * @hidden
 */
function devMode() {
    return "production" !== "production";
}
/**
 * @internal
 * @hidden
 */
function assertArg(value, fn, typeName, argNumber) {
    if (devMode()) {
        if (!fn(value)) {
            // istanbul ignore next
            throw new MstError("expected ".concat(typeName, " as argument ").concat(asArray(argNumber).join(" or "), ", got ").concat(value, " instead"));
        }
    }
}
/**
 * @internal
 * @hidden
 */
function assertIsFunction(value, argNumber) {
    assertArg(value, function (fn) { return typeof fn === "function"; }, "function", argNumber);
}
/**
 * @internal
 * @hidden
 */
function assertIsNumber(value, argNumber, min, max) {
    assertArg(value, function (n) { return typeof n === "number"; }, "number", argNumber);
    if (min !== undefined) {
        assertArg(value, function (n) { return n >= min; }, "number greater than ".concat(min), argNumber);
    }
    if (max !== undefined) {
        assertArg(value, function (n) { return n <= max; }, "number lesser than ".concat(max), argNumber);
    }
}
/**
 * @internal
 * @hidden
 */
function assertIsString(value, argNumber, canBeEmpty) {
    if (canBeEmpty === void 0) { canBeEmpty = true; }
    assertArg(value, function (s) { return typeof s === "string"; }, "string", argNumber);
    if (!canBeEmpty) {
        assertArg(value, function (s) { return s !== ""; }, "not empty string", argNumber);
    }
}
/**
 * @internal
 * @hidden
 */
function setImmediateWithFallback(fn) {
    if (typeof queueMicrotask === "function") {
        queueMicrotask(fn);
    }
    else if (typeof setImmediate === "function") {
        setImmediate(fn);
    }
    else {
        setTimeout(fn, 1);
    }
}

/**
 * See [asynchronous actions](concepts/async-actions.md).
 *
 * @returns The flow as a promise.
 */
function flow(generator) {
    return createFlowSpawner(generator.name, generator);
}
/**
 * @deprecated Not needed since TS3.6.
 * Used for TypeScript to make flows that return a promise return the actual promise result.
 *
 * @param val
 * @returns
 */
function castFlowReturn(val) {
    return val;
}
/**
 * @experimental
 * experimental api - might change on minor/patch releases
 *
 * Convert a promise-returning function to a generator-returning one.
 * This is intended to allow for usage of `yield*` in async actions to
 * retain the promise return type.
 *
 * Example:
 * ```ts
 * function getDataAsync(input: string): Promise<number> { ... }
 * const getDataGen = toGeneratorFunction(getDataAsync);
 *
 * const someModel.actions(self => ({
 *   someAction: flow(function*() {
 *     // value is typed as number
 *     const value = yield* getDataGen("input value");
 *     ...
 *   })
 * }))
 * ```
 */
function toGeneratorFunction(p) {
    return function () {
        var _i;
        var args = [];
        for (_i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, p.apply(void 0, __spreadArray([], __read(args), false))];
                case 1: return [2 /*return*/, (_a.sent())];
            }
        });
    };
}
/**
 * @experimental
 * experimental api - might change on minor/patch releases
 *
 * Convert a promise to a generator yielding that promise
 * This is intended to allow for usage of `yield*` in async actions to
 * retain the promise return type.
 *
 * Example:
 * ```ts
 * function getDataAsync(input: string): Promise<number> { ... }
 *
 * const someModel.actions(self => ({
 *   someAction: flow(function*() {
 *     // value is typed as number
 *     const value = yield* toGenerator(getDataAsync("input value"));
 *     ...
 *   })
 * }))
 * ```
 */
function toGenerator(p) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, p];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}
/**
 * @internal
 * @hidden
 */
function createFlowSpawner(name, generator) {
    var spawner = function flowSpawner() {
        // Implementation based on https://github.com/tj/co/blob/master/index.js
        var runId = getNextActionId();
        var parentContext = getCurrentActionContext();
        if (!parentContext) {
            throw new MstError("a mst flow must always have a parent context");
        }
        var parentActionContext = getParentActionContext(parentContext);
        if (!parentActionContext) {
            throw new MstError("a mst flow must always have a parent action context");
        }
        var contextBase = {
            name: name,
            id: runId,
            tree: parentContext.tree,
            context: parentContext.context,
            parentId: parentContext.id,
            allParentIds: __spreadArray(__spreadArray([], __read(parentContext.allParentIds), false), [parentContext.id], false),
            rootId: parentContext.rootId,
            parentEvent: parentContext,
            parentActionEvent: parentActionContext
        };
        var args = arguments;
        function wrap(fn, type, arg) {
            fn.$mst_middleware = spawner.$mst_middleware; // pick up any middleware attached to the flow
            return runWithActionContext(__assign(__assign({}, contextBase), { type: type, args: [arg] }), fn);
        }
        return new Promise(function (resolve, reject) {
            var gen;
            var init = function asyncActionInit() {
                gen = generator.apply(null, arguments);
                onFulfilled(undefined); // kick off the flow
            };
            init.$mst_middleware = spawner.$mst_middleware;
            runWithActionContext(__assign(__assign({}, contextBase), { type: "flow_spawn", args: argsToArray(args) }), init);
            function onFulfilled(res) {
                var ret;
                try {
                    // prettier-ignore
                    var cancelError = wrap(function (r) { ret = gen.next(r); }, "flow_resume", res);
                    if (cancelError instanceof Error) {
                        ret = gen.throw(cancelError);
                    }
                }
                catch (e) {
                    // prettier-ignore
                    setImmediateWithFallback(function () {
                        wrap(function (r) { reject(e); }, "flow_throw", e);
                    });
                    return;
                }
                next(ret);
                return;
            }
            function onRejected(err) {
                var ret;
                try {
                    // prettier-ignore
                    wrap(function (r) { ret = gen.throw(r); }, "flow_resume_error", err); // or yieldError?
                }
                catch (e) {
                    // prettier-ignore
                    setImmediateWithFallback(function () {
                        wrap(function (r) { reject(e); }, "flow_throw", e);
                    });
                    return;
                }
                next(ret);
            }
            function next(ret) {
                if (ret.done) {
                    // prettier-ignore
                    setImmediateWithFallback(function () {
                        wrap(function (r) { resolve(r); }, "flow_return", ret.value);
                    });
                    return;
                }
                // TODO: support more type of values? See https://github.com/tj/co/blob/249bbdc72da24ae44076afd716349d2089b31c4c/index.js#L100
                if (!ret.value || typeof ret.value.then !== "function") {
                    // istanbul ignore next
                    throw new MstError("Only promises can be yielded to `async`, got: " + ret);
                }
                return ret.value.then(onFulfilled, onRejected);
            }
        });
    };
    spawner._isFlowAction = true;
    return spawner;
}

/**
 * @internal
 * @hidden
 */
function splitPatch(patch) {
    if (!("oldValue" in patch))
        throw new MstError("Patches without `oldValue` field cannot be inversed");
    return [stripPatch(patch), invertPatch(patch)];
}
/**
 * @internal
 * @hidden
 */
function stripPatch(patch) {
    // strips `oldvalue` information from the patch, so that it becomes a patch conform the json-patch spec
    // this removes the ability to undo the patch
    switch (patch.op) {
        case "add":
            return { op: "add", path: patch.path, value: patch.value };
        case "remove":
            return { op: "remove", path: patch.path };
        case "replace":
            return { op: "replace", path: patch.path, value: patch.value };
    }
}
function invertPatch(patch) {
    switch (patch.op) {
        case "add":
            return {
                op: "remove",
                path: patch.path
            };
        case "remove":
            return {
                op: "add",
                path: patch.path,
                value: patch.oldValue
            };
        case "replace":
            return {
                op: "replace",
                path: patch.path,
                value: patch.oldValue
            };
    }
}
/**
 * Simple simple check to check it is a number.
 */
function isNumber(x) {
    return typeof x === "number";
}
/**
 * Escape slashes and backslashes.
 *
 * http://tools.ietf.org/html/rfc6901
 */
function escapeJsonPath(path) {
    if (isNumber(path) === true) {
        return "" + path;
    }
    if (path.indexOf("/") === -1 && path.indexOf("~") === -1)
        return path;
    return path.replace(/~/g, "~0").replace(/\//g, "~1");
}
/**
 * Unescape slashes and backslashes.
 */
function unescapeJsonPath(path) {
    return path.replace(/~1/g, "/").replace(/~0/g, "~");
}
/**
 * Generates a json-path compliant json path from path parts.
 *
 * @param path
 * @returns
 */
function joinJsonPath(path) {
    // `/` refers to property with an empty name, while `` refers to root itself!
    if (path.length === 0)
        return "";
    var getPathStr = function (p) { return p.map(escapeJsonPath).join("/"); };
    if (path[0] === "." || path[0] === "..") {
        // relative
        return getPathStr(path);
    }
    else {
        // absolute
        return "/" + getPathStr(path);
    }
}
/**
 * Splits and decodes a json path into several parts.
 *
 * @param path
 * @returns
 */
function splitJsonPath(path) {
    // `/` refers to property with an empty name, while `` refers to root itself!
    var parts = path.split("/").map(unescapeJsonPath);
    var valid = path === "" ||
        path === "." ||
        path === ".." ||
        stringStartsWith(path, "/") ||
        stringStartsWith(path, "./") ||
        stringStartsWith(path, "../");
    if (!valid) {
        throw new MstError("a json path must be either rooted, empty or relative, but got '".concat(path, "'"));
    }
    // '/a/b/c' -> ["a", "b", "c"]
    // '../../b/c' -> ["..", "..", "b", "c"]
    // '' -> []
    // '/' -> ['']
    // './a' -> [".", "a"]
    // /./a' -> [".", "a"] equivalent to './a'
    if (parts[0] === "") {
        parts.shift();
    }
    return parts;
}

/** @hidden */
var $preProcessorFailed = Symbol("$preProcessorFailed");
var SnapshotProcessor = /** @class */ (function (_super) {
    __extends(SnapshotProcessor, _super);
    function SnapshotProcessor(_subtype, _processors, name) {
        var _this = _super.call(this, name || _subtype.name) || this;
        Object.defineProperty(_this, "_subtype", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subtype
        });
        Object.defineProperty(_this, "_processors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _processors
        });
        return _this;
    }
    Object.defineProperty(SnapshotProcessor.prototype, "flags", {
        get: function () {
            return this._subtype.flags | TypeFlags.SnapshotProcessor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SnapshotProcessor.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return "snapshotProcessor(".concat(this._subtype.describe(), ")");
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "preProcessSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (sn) {
            if (this._processors.preProcessor) {
                return this._processors.preProcessor.call(null, sn);
            }
            return sn;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "preProcessSnapshotSafe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (sn) {
            try {
                return this.preProcessSnapshot(sn);
            }
            catch (e) {
                return $preProcessorFailed;
            }
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "postProcessSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (sn, node) {
            if (this._processors.postProcessor) {
                return this._processors.postProcessor.call(null, sn, node.storedValue);
            }
            return sn;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "_fixNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            var _this = this;
            // the node has to use these methods rather than the original type ones
            proxyNodeTypeMethods(node.type, this, "create");
            if (node instanceof ObjectNode) {
                node.hasSnapshotPostProcessor = !!this._processors.postProcessor;
            }
            var oldGetSnapshot = node.getSnapshot;
            node.getSnapshot = function () { return _this.postProcessSnapshot(oldGetSnapshot.call(node), node); };
            if (!isUnionType(this._subtype)) {
                node.getReconciliationType = function () {
                    return _this;
                };
            }
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            var processedInitialValue = isStateTreeNode(initialValue)
                ? initialValue
                : this.preProcessSnapshot(initialValue);
            var node = this._subtype.instantiate(parent, subpath, environment, processedInitialValue);
            this._fixNode(node);
            return node;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            var node = this._subtype.reconcile(current, isStateTreeNode(newValue) ? newValue : this.preProcessSnapshot(newValue), parent, subpath);
            if (node !== current) {
                this._fixNode(node);
            }
            return node;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, applyPostProcess) {
            if (applyPostProcess === void 0) { applyPostProcess = true; }
            var sn = this._subtype.getSnapshot(node);
            return applyPostProcess ? this.postProcessSnapshot(sn, node) : sn;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var processedSn = this.preProcessSnapshotSafe(value);
            if (processedSn === $preProcessorFailed) {
                return typeCheckFailure(context, value, "Failed to preprocess value");
            }
            return this._subtype.validate(processedSn, context);
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._subtype;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "is", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (thing) {
            var value = isType(thing)
                ? this._subtype
                : isStateTreeNode(thing)
                    ? getSnapshot(thing, false)
                    : this.preProcessSnapshotSafe(thing);
            if (value === $preProcessorFailed) {
                return false;
            }
            return this._subtype.validate(value, [{ path: "", type: this._subtype }]).length === 0;
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            return this._subtype.isAssignableFrom(type);
        }
    });
    Object.defineProperty(SnapshotProcessor.prototype, "isMatchingSnapshotId", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, snapshot) {
            if (!(this._subtype instanceof ComplexType)) {
                return false;
            }
            var processedSn = this.preProcessSnapshot(snapshot);
            return this._subtype.isMatchingSnapshotId(current, processedSn);
        }
    });
    return SnapshotProcessor;
}(BaseType));
function proxyNodeTypeMethods(nodeType, snapshotProcessorType) {
    var e_1, _a;
    var methods = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        methods[_i - 2] = arguments[_i];
    }
    try {
        for (var methods_1 = __values(methods), methods_1_1 = methods_1.next(); !methods_1_1.done; methods_1_1 = methods_1.next()) {
            var method = methods_1_1.value;
            nodeType[method] = snapshotProcessorType[method].bind(snapshotProcessorType);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (methods_1_1 && !methods_1_1.done && (_a = methods_1.return)) _a.call(methods_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/**
 * `types.snapshotProcessor` - Runs a pre/post snapshot processor before/after serializing a given type.
 *
 * Example:
 * ```ts
 * const Todo1 = types.model({ text: types.string })
 * // in the backend the text type must be null when empty
 * interface BackendTodo {
 *     text: string | null
 * }
 *
 * const Todo2 = types.snapshotProcessor(Todo1, {
 *     // from snapshot to instance
 *     preProcessor(snapshot: BackendTodo) {
 *         return {
 *             text: sn.text || "";
 *         }
 *     },
 *
 *     // from instance to snapshot
 *     postProcessor(snapshot, node): BackendTodo {
 *         return {
 *             text: !sn.text ? null : sn.text
 *         }
 *     }
 * })
 * ```
 *
 * @param type Type to run the processors over.
 * @param processors Processors to run.
 * @param name Type name, or undefined to inherit the inner type one.
 * @returns
 */
function snapshotProcessor(type, processors, name) {
    assertIsType(type, 1);
    if (devMode()) {
        if (processors.postProcessor && typeof processors.postProcessor !== "function") {
            // istanbul ignore next
            throw new MstError("postSnapshotProcessor must be a function");
        }
        if (processors.preProcessor && typeof processors.preProcessor !== "function") {
            // istanbul ignore next
            throw new MstError("preSnapshotProcessor must be a function");
        }
    }
    return new SnapshotProcessor(type, processors, name);
}

var needsIdentifierError = "Map.put can only be used to store complex values that have an identifier type attribute";
function tryCollectModelTypes(type, modelTypes) {
    var e_1, _a;
    var subtypes = type.getSubTypes();
    if (subtypes === cannotDetermineSubtype) {
        return false;
    }
    if (subtypes) {
        var subtypesArray = asArray(subtypes);
        try {
            for (var subtypesArray_1 = __values(subtypesArray), subtypesArray_1_1 = subtypesArray_1.next(); !subtypesArray_1_1.done; subtypesArray_1_1 = subtypesArray_1.next()) {
                var subtype = subtypesArray_1_1.value;
                if (!tryCollectModelTypes(subtype, modelTypes))
                    return false;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (subtypesArray_1_1 && !subtypesArray_1_1.done && (_a = subtypesArray_1.return)) _a.call(subtypesArray_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    if (type instanceof ModelType) {
        modelTypes.push(type);
    }
    return true;
}
/**
 * @internal
 * @hidden
 */
var MapIdentifierMode;
(function (MapIdentifierMode) {
    MapIdentifierMode[MapIdentifierMode["UNKNOWN"] = 0] = "UNKNOWN";
    MapIdentifierMode[MapIdentifierMode["YES"] = 1] = "YES";
    MapIdentifierMode[MapIdentifierMode["NO"] = 2] = "NO";
})(MapIdentifierMode || (MapIdentifierMode = {}));
var MSTMap = /** @class */ (function (_super) {
    __extends(MSTMap, _super);
    function MSTMap(initialData, name) {
        return _super.call(this, initialData, mobx__WEBPACK_IMPORTED_MODULE_0__.observable.ref.enhancer, name) || this;
    }
    Object.defineProperty(MSTMap.prototype, "get", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key) {
            // maybe this is over-enthousiastic? normalize numeric keys to strings
            return _super.prototype.get.call(this, "" + key);
        }
    });
    Object.defineProperty(MSTMap.prototype, "has", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key) {
            return _super.prototype.has.call(this, "" + key);
        }
    });
    Object.defineProperty(MSTMap.prototype, "delete", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key) {
            return _super.prototype.delete.call(this, "" + key);
        }
    });
    Object.defineProperty(MSTMap.prototype, "set", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key, value) {
            return _super.prototype.set.call(this, "" + key, value);
        }
    });
    Object.defineProperty(MSTMap.prototype, "put", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            if (!value)
                throw new MstError("Map.put cannot be used to set empty values");
            if (isStateTreeNode(value)) {
                var node = getStateTreeNode(value);
                if (devMode()) {
                    if (!node.identifierAttribute) {
                        throw new MstError(needsIdentifierError);
                    }
                }
                if (node.identifier === null) {
                    throw new MstError(needsIdentifierError);
                }
                this.set(node.identifier, value);
                return value;
            }
            else if (!isMutable(value)) {
                throw new MstError("Map.put can only be used to store complex values");
            }
            else {
                var mapNode = getStateTreeNode(this);
                var mapType = mapNode.type;
                if (mapType.identifierMode !== MapIdentifierMode.YES) {
                    throw new MstError(needsIdentifierError);
                }
                var idAttr = mapType.mapIdentifierAttribute;
                var id = value[idAttr];
                if (!isValidIdentifier(id)) {
                    // try again but this time after creating a node for the value
                    // since it might be an optional identifier
                    var newNode = this.put(mapType.getChildType().create(value, mapNode.environment));
                    return this.put(getSnapshot(newNode));
                }
                var key = normalizeIdentifier(id);
                this.set(key, value);
                return this.get(key);
            }
        }
    });
    return MSTMap;
}(mobx__WEBPACK_IMPORTED_MODULE_0__.ObservableMap));
/**
 * @internal
 * @hidden
 */
var MapType = /** @class */ (function (_super) {
    __extends(MapType, _super);
    function MapType(name, _subType, hookInitializers) {
        if (hookInitializers === void 0) { hookInitializers = []; }
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subType
        });
        Object.defineProperty(_this, "identifierMode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: MapIdentifierMode.UNKNOWN
        });
        Object.defineProperty(_this, "mapIdentifierAttribute", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Map
        });
        Object.defineProperty(_this, "hookInitializers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        _this._determineIdentifierMode();
        _this.hookInitializers = hookInitializers;
        return _this;
    }
    Object.defineProperty(MapType.prototype, "hooks", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (hooks) {
            var hookInitializers = this.hookInitializers.length > 0 ? this.hookInitializers.concat(hooks) : [hooks];
            return new MapType(this.name, this._subType, hookInitializers);
        }
    });
    Object.defineProperty(MapType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            this._determineIdentifierMode();
            return createObjectNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(MapType.prototype, "_determineIdentifierMode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (this.identifierMode !== MapIdentifierMode.UNKNOWN) {
                return;
            }
            var modelTypes = [];
            if (tryCollectModelTypes(this._subType, modelTypes)) {
                var identifierAttribute = modelTypes.reduce(function (current, type) {
                    if (!type.identifierAttribute)
                        return current;
                    if (current && current !== type.identifierAttribute) {
                        throw new MstError("The objects in a map should all have the same identifier attribute, expected '".concat(current, "', but child of type '").concat(type.name, "' declared attribute '").concat(type.identifierAttribute, "' as identifier"));
                    }
                    return type.identifierAttribute;
                }, undefined);
                if (identifierAttribute) {
                    this.identifierMode = MapIdentifierMode.YES;
                    this.mapIdentifierAttribute = identifierAttribute;
                }
                else {
                    this.identifierMode = MapIdentifierMode.NO;
                }
            }
        }
    });
    Object.defineProperty(MapType.prototype, "initializeChildNodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (objNode, initialSnapshot) {
            if (initialSnapshot === void 0) { initialSnapshot = {}; }
            var subType = objNode.type._subType;
            var result = {};
            Object.keys(initialSnapshot).forEach(function (name) {
                result[name] = subType.instantiate(objNode, name, undefined, initialSnapshot[name]);
            });
            return result;
        }
    });
    Object.defineProperty(MapType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNodes) {
            return new MSTMap(childNodes, this.name);
        }
    });
    Object.defineProperty(MapType.prototype, "finalizeNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, instance) {
            (0,mobx__WEBPACK_IMPORTED_MODULE_0__._interceptReads)(instance, node.unbox);
            var type = node.type;
            type.hookInitializers.forEach(function (initializer) {
                var hooks = initializer(instance);
                Object.keys(hooks).forEach(function (name) {
                    var hook = hooks[name];
                    var actionInvoker = createActionInvoker(instance, name, hook);
                    (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(instance, name, actionInvoker);
                });
            });
            (0,mobx__WEBPACK_IMPORTED_MODULE_0__.intercept)(instance, this.willChange);
            (0,mobx__WEBPACK_IMPORTED_MODULE_0__.observe)(instance, this.didChange);
        }
    });
    Object.defineProperty(MapType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.name;
        }
    });
    Object.defineProperty(MapType.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            // return (node.storedValue as ObservableMap<any>).values()
            return (0,mobx__WEBPACK_IMPORTED_MODULE_0__.values)(node.storedValue);
        }
    });
    Object.defineProperty(MapType.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, key) {
            var childNode = node.storedValue.get("" + key);
            if (!childNode)
                throw new MstError("Not a child " + key);
            return childNode;
        }
    });
    Object.defineProperty(MapType.prototype, "willChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (change) {
            var node = getStateTreeNode(change.object);
            var key = change.name;
            node.assertWritable({ subpath: key });
            var mapType = node.type;
            var subType = mapType._subType;
            switch (change.type) {
                case "update":
                    {
                        var newValue = change.newValue;
                        var oldValue = change.object.get(key);
                        if (newValue === oldValue)
                            return null;
                        typecheckInternal(subType, newValue);
                        change.newValue = subType.reconcile(node.getChildNode(key), change.newValue, node, key);
                        mapType.processIdentifier(key, change.newValue);
                    }
                    break;
                case "add":
                    {
                        typecheckInternal(subType, change.newValue);
                        change.newValue = subType.instantiate(node, key, undefined, change.newValue);
                        mapType.processIdentifier(key, change.newValue);
                    }
                    break;
            }
            return change;
        }
    });
    Object.defineProperty(MapType.prototype, "processIdentifier", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (expected, node) {
            if (this.identifierMode === MapIdentifierMode.YES && node instanceof ObjectNode) {
                var identifier = node.identifier;
                if (identifier !== expected)
                    throw new MstError("A map of objects containing an identifier should always store the object under their own identifier. Trying to store key '".concat(identifier, "', but expected: '").concat(expected, "'"));
            }
        }
    });
    Object.defineProperty(MapType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            var res = {};
            node.getChildren().forEach(function (childNode) {
                res[childNode.subpath] = childNode.snapshot;
            });
            return res;
        }
    });
    Object.defineProperty(MapType.prototype, "processInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNodes) {
            var processed = {};
            Object.keys(childNodes).forEach(function (key) {
                processed[key] = childNodes[key].getSnapshot();
            });
            return processed;
        }
    });
    Object.defineProperty(MapType.prototype, "didChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (change) {
            var node = getStateTreeNode(change.object);
            switch (change.type) {
                case "update":
                    return void node.emitPatch({
                        op: "replace",
                        path: escapeJsonPath(change.name),
                        value: change.newValue.snapshot,
                        oldValue: change.oldValue ? change.oldValue.snapshot : undefined
                    }, node);
                case "add":
                    return void node.emitPatch({
                        op: "add",
                        path: escapeJsonPath(change.name),
                        value: change.newValue.snapshot,
                        oldValue: undefined
                    }, node);
                case "delete":
                    // a node got deleted, get the old snapshot and make the node die
                    var oldSnapshot = change.oldValue.snapshot;
                    change.oldValue.die();
                    // emit the patch
                    return void node.emitPatch({
                        op: "remove",
                        path: escapeJsonPath(change.name),
                        oldValue: oldSnapshot
                    }, node);
            }
        }
    });
    Object.defineProperty(MapType.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, subpath, patch) {
            var target = node.storedValue;
            switch (patch.op) {
                case "add":
                case "replace":
                    target.set(subpath, patch.value);
                    break;
                case "remove":
                    target.delete(subpath);
                    break;
            }
        }
    });
    Object.defineProperty(MapType.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, snapshot) {
            typecheckInternal(this, snapshot);
            var target = node.storedValue;
            var currentKeys = {};
            Array.from(target.keys()).forEach(function (key) {
                currentKeys[key] = false;
            });
            if (snapshot) {
                // Don't use target.replace, as it will throw away all existing items first
                for (var key in snapshot) {
                    target.set(key, snapshot[key]);
                    currentKeys["" + key] = true;
                }
            }
            Object.keys(currentKeys).forEach(function (key) {
                if (currentKeys[key] === false)
                    target.delete(key);
            });
        }
    });
    Object.defineProperty(MapType.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._subType;
        }
    });
    Object.defineProperty(MapType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var _this = this;
            if (!isPlainObject(value)) {
                return typeCheckFailure(context, value, "Value is not a plain object");
            }
            return flattenTypeErrors(Object.keys(value).map(function (path) {
                return _this._subType.validate(value[path], getContextForPath(context, path, _this._subType));
            }));
        }
    });
    Object.defineProperty(MapType.prototype, "getDefaultSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return EMPTY_OBJECT;
        }
    });
    Object.defineProperty(MapType.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, subpath) {
            node.storedValue.delete(subpath);
        }
    });
    return MapType;
}(ComplexType));
MapType.prototype.applySnapshot = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.action)(MapType.prototype.applySnapshot);
/**
 * `types.map` - Creates a key based collection type who's children are all of a uniform declared type.
 * If the type stored in a map has an identifier, it is mandatory to store the child under that identifier in the map.
 *
 * This type will always produce [observable maps](https://mobx.js.org/api.html#observablemap)
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   id: types.identifier,
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.map(Todo)
 * })
 *
 * const s = TodoStore.create({ todos: {} })
 * unprotect(s)
 * s.todos.set(17, { task: "Grab coffee", id: 17 })
 * s.todos.put({ task: "Grab cookie", id: 18 }) // put will infer key from the identifier
 * console.log(s.todos.get(17).task) // prints: "Grab coffee"
 * ```
 *
 * @param subtype
 * @returns
 */
function map(subtype) {
    return new MapType("Map<string, ".concat(subtype.name, ">"), subtype);
}
/**
 * Returns if a given value represents a map type.
 *
 * @param type
 * @returns `true` if it is a map type.
 */
function isMapType(type) {
    return isType(type) && (type.flags & TypeFlags.Map) > 0;
}

/**
 * @internal
 * @hidden
 */
var ArrayType = /** @class */ (function (_super) {
    __extends(ArrayType, _super);
    function ArrayType(name, _subType, hookInitializers) {
        if (hookInitializers === void 0) { hookInitializers = []; }
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subType
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Array
        });
        Object.defineProperty(_this, "hookInitializers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        _this.hookInitializers = hookInitializers;
        return _this;
    }
    Object.defineProperty(ArrayType.prototype, "hooks", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (hooks) {
            var hookInitializers = this.hookInitializers.length > 0 ? this.hookInitializers.concat(hooks) : [hooks];
            return new ArrayType(this.name, this._subType, hookInitializers);
        }
    });
    Object.defineProperty(ArrayType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            return createObjectNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(ArrayType.prototype, "initializeChildNodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (objNode, snapshot) {
            if (snapshot === void 0) { snapshot = []; }
            var subType = objNode.type._subType;
            var result = {};
            snapshot.forEach(function (item, index) {
                var subpath = "" + index;
                result[subpath] = subType.instantiate(objNode, subpath, undefined, item);
            });
            return result;
        }
    });
    Object.defineProperty(ArrayType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNodes) {
            var options = __assign(__assign({}, mobxShallow), { name: this.name });
            return mobx__WEBPACK_IMPORTED_MODULE_0__.observable.array(convertChildNodesToArray(childNodes), options);
        }
    });
    Object.defineProperty(ArrayType.prototype, "finalizeNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, instance) {
            (0,mobx__WEBPACK_IMPORTED_MODULE_0__._getAdministration)(instance).dehancer = node.unbox;
            var type = node.type;
            type.hookInitializers.forEach(function (initializer) {
                var hooks = initializer(instance);
                Object.keys(hooks).forEach(function (name) {
                    var hook = hooks[name];
                    var actionInvoker = createActionInvoker(instance, name, hook);
                    (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(instance, name, actionInvoker);
                });
            });
            (0,mobx__WEBPACK_IMPORTED_MODULE_0__.intercept)(instance, this.willChange);
            (0,mobx__WEBPACK_IMPORTED_MODULE_0__.observe)(instance, this.didChange);
        }
    });
    Object.defineProperty(ArrayType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.name;
        }
    });
    Object.defineProperty(ArrayType.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            return node.storedValue.slice();
        }
    });
    Object.defineProperty(ArrayType.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, key) {
            var index = Number(key);
            if (index < node.storedValue.length)
                return node.storedValue[index];
            throw new MstError("Not a child: " + key);
        }
    });
    Object.defineProperty(ArrayType.prototype, "willChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (change) {
            var node = getStateTreeNode(change.object);
            node.assertWritable({ subpath: "" + change.index });
            var subType = node.type._subType;
            var childNodes = node.getChildren();
            switch (change.type) {
                case "update":
                    {
                        if (change.newValue === change.object[change.index])
                            return null;
                        var updatedNodes = reconcileArrayChildren(node, subType, [childNodes[change.index]], [change.newValue], [change.index]);
                        if (!updatedNodes) {
                            return null;
                        }
                        change.newValue = updatedNodes[0];
                    }
                    break;
                case "splice":
                    {
                        var index_1 = change.index, removedCount = change.removedCount, added = change.added;
                        var addedNodes = reconcileArrayChildren(node, subType, childNodes.slice(index_1, index_1 + removedCount), added, added.map(function (_, i) { return index_1 + i; }));
                        if (!addedNodes) {
                            return null;
                        }
                        change.added = addedNodes;
                        // update paths of remaining items
                        for (var i = index_1 + removedCount; i < childNodes.length; i++) {
                            childNodes[i].setParent(node, "" + (i + added.length - removedCount));
                        }
                    }
                    break;
            }
            return change;
        }
    });
    Object.defineProperty(ArrayType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            return node.getChildren().map(function (childNode) { return childNode.snapshot; });
        }
    });
    Object.defineProperty(ArrayType.prototype, "processInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNodes) {
            var processed = [];
            Object.keys(childNodes).forEach(function (key) {
                processed.push(childNodes[key].getSnapshot());
            });
            return processed;
        }
    });
    Object.defineProperty(ArrayType.prototype, "didChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (change) {
            var node = getStateTreeNode(change.object);
            switch (change.type) {
                case "update":
                    return void node.emitPatch({
                        op: "replace",
                        path: "" + change.index,
                        value: change.newValue.snapshot,
                        oldValue: change.oldValue ? change.oldValue.snapshot : undefined
                    }, node);
                case "splice":
                    // Perf: emit one patch for clear and replace ops.
                    if (change.removedCount && change.addedCount === change.object.length) {
                        return void node.emitPatch({
                            op: "replace",
                            path: "",
                            value: node.snapshot,
                            oldValue: change.removed.map(function (node) { return node.snapshot; })
                        }, node);
                    }
                    for (var i = change.removedCount - 1; i >= 0; i--)
                        node.emitPatch({
                            op: "remove",
                            path: "" + (change.index + i),
                            oldValue: change.removed[i].snapshot
                        }, node);
                    for (var i = 0; i < change.addedCount; i++)
                        node.emitPatch({
                            op: "add",
                            path: "" + (change.index + i),
                            value: change.added[i].snapshot,
                            oldValue: undefined
                        }, node);
                    return;
            }
        }
    });
    Object.defineProperty(ArrayType.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, subpath, patch) {
            var target = node.storedValue;
            var index = subpath === "-" ? target.length : Number(subpath);
            switch (patch.op) {
                case "replace":
                    target[index] = patch.value;
                    break;
                case "add":
                    target.splice(index, 0, patch.value);
                    break;
                case "remove":
                    target.splice(index, 1);
                    break;
            }
        }
    });
    Object.defineProperty(ArrayType.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, snapshot) {
            typecheckInternal(this, snapshot);
            var target = node.storedValue;
            target.replace(snapshot);
        }
    });
    Object.defineProperty(ArrayType.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._subType;
        }
    });
    Object.defineProperty(ArrayType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var _this = this;
            if (!isArray(value)) {
                return typeCheckFailure(context, value, "Value is not an array");
            }
            return flattenTypeErrors(value.map(function (item, index) {
                return _this._subType.validate(item, getContextForPath(context, "" + index, _this._subType));
            }));
        }
    });
    Object.defineProperty(ArrayType.prototype, "getDefaultSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return EMPTY_ARRAY;
        }
    });
    Object.defineProperty(ArrayType.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, subpath) {
            node.storedValue.splice(Number(subpath), 1);
        }
    });
    return ArrayType;
}(ComplexType));
ArrayType.prototype.applySnapshot = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.action)(ArrayType.prototype.applySnapshot);
/**
 * `types.array` - Creates an index based collection type who's children are all of a uniform declared type.
 *
 * This type will always produce [observable arrays](https://mobx.js.org/api.html#observablearray)
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   task: types.string
 * })
 *
 * const TodoStore = types.model({
 *   todos: types.array(Todo)
 * })
 *
 * const s = TodoStore.create({ todos: [] })
 * unprotect(s) // needed to allow modifying outside of an action
 * s.todos.push({ task: "Grab coffee" })
 * console.log(s.todos[0]) // prints: "Grab coffee"
 * ```
 *
 * @param subtype
 * @returns
 */
function array(subtype) {
    assertIsType(subtype, 1);
    return new ArrayType("".concat(subtype.name, "[]"), subtype);
}
function reconcileArrayChildren(parent, childType, oldNodes, newValues, newPaths) {
    var nothingChanged = true;
    for (var i = 0;; i++) {
        var hasNewNode = i <= newValues.length - 1;
        var oldNode = oldNodes[i];
        var newValue = hasNewNode ? newValues[i] : undefined;
        var newPath = "" + newPaths[i];
        // for some reason, instead of newValue we got a node, fallback to the storedValue
        // TODO: https://github.com/mobxjs/mobx-state-tree/issues/340#issuecomment-325581681
        if (isNode(newValue))
            newValue = newValue.storedValue;
        if (!oldNode && !hasNewNode) {
            // both are empty, end
            break;
        }
        else if (!hasNewNode) {
            // new one does not exists
            nothingChanged = false;
            oldNodes.splice(i, 1);
            if (oldNode instanceof ObjectNode) {
                // since it is going to be returned by pop/splice/shift better create it before killing it
                // so it doesn't end up in an undead state
                oldNode.createObservableInstanceIfNeeded();
            }
            oldNode.die();
            i--;
        }
        else if (!oldNode) {
            // there is no old node, create it
            // check if already belongs to the same parent. if so, avoid pushing item in. only swapping can occur.
            if (isStateTreeNode(newValue) && getStateTreeNode(newValue).parent === parent) {
                // this node is owned by this parent, but not in the reconcilable set, so it must be double
                throw new MstError("Cannot add an object to a state tree if it is already part of the same or another state tree. Tried to assign an object to '".concat(parent.path, "/").concat(newPath, "', but it lives already at '").concat(getStateTreeNode(newValue).path, "'"));
            }
            nothingChanged = false;
            var newNode = valueAsNode(childType, parent, newPath, newValue);
            oldNodes.splice(i, 0, newNode);
        }
        else if (areSame(oldNode, newValue)) {
            // both are the same, reconcile
            oldNodes[i] = valueAsNode(childType, parent, newPath, newValue, oldNode);
        }
        else {
            // nothing to do, try to reorder
            var oldMatch = undefined;
            // find a possible candidate to reuse
            for (var j = i; j < oldNodes.length; j++) {
                if (areSame(oldNodes[j], newValue)) {
                    oldMatch = oldNodes.splice(j, 1)[0];
                    break;
                }
            }
            nothingChanged = false;
            var newNode = valueAsNode(childType, parent, newPath, newValue, oldMatch);
            oldNodes.splice(i, 0, newNode);
        }
    }
    return nothingChanged ? null : oldNodes;
}
/**
 * Convert a value to a node at given parent and subpath. Attempts to reuse old node if possible and given.
 */
function valueAsNode(childType, parent, subpath, newValue, oldNode) {
    // ensure the value is valid-ish
    typecheckInternal(childType, newValue);
    function getNewNode() {
        // the new value has a MST node
        if (isStateTreeNode(newValue)) {
            var childNode = getStateTreeNode(newValue);
            childNode.assertAlive(EMPTY_OBJECT);
            // the node lives here
            if (childNode.parent !== null && childNode.parent === parent) {
                childNode.setParent(parent, subpath);
                return childNode;
            }
        }
        // there is old node and new one is a value/snapshot
        if (oldNode) {
            return childType.reconcile(oldNode, newValue, parent, subpath);
        }
        // nothing to do, create from scratch
        return childType.instantiate(parent, subpath, undefined, newValue);
    }
    var newNode = getNewNode();
    if (oldNode && oldNode !== newNode) {
        if (oldNode instanceof ObjectNode) {
            // since it is going to be returned by pop/splice/shift better create it before killing it
            // so it doesn't end up in an undead state
            oldNode.createObservableInstanceIfNeeded();
        }
        oldNode.die();
    }
    return newNode;
}
/**
 * Check if a node holds a value.
 */
function areSame(oldNode, newValue) {
    // never consider dead old nodes for reconciliation
    if (!oldNode.isAlive) {
        return false;
    }
    // the new value has the same node
    if (isStateTreeNode(newValue)) {
        var newNode = getStateTreeNode(newValue);
        return newNode.isAlive && newNode === oldNode;
    }
    // the provided value is the snapshot of the old node
    if (oldNode.snapshot === newValue) {
        return true;
    }
    // Non object nodes don't get reconciled
    if (!(oldNode instanceof ObjectNode)) {
        return false;
    }
    var oldNodeType = oldNode.getReconciliationType();
    // new value is a snapshot with the correct identifier
    return (oldNode.identifier !== null &&
        oldNode.identifierAttribute &&
        isPlainObject(newValue) &&
        oldNodeType.is(newValue) &&
        oldNodeType.isMatchingSnapshotId(oldNode, newValue));
}
/**
 * Returns if a given value represents an array type.
 *
 * @param type
 * @returns `true` if the type is an array type.
 */
function isArrayType(type) {
    return isType(type) && (type.flags & TypeFlags.Array) > 0;
}

var PRE_PROCESS_SNAPSHOT = "preProcessSnapshot";
var POST_PROCESS_SNAPSHOT = "postProcessSnapshot";
function objectTypeToString() {
    return getStateTreeNode(this).toString();
}
var defaultObjectOptions = {
    name: "AnonymousModel",
    properties: {},
    initializers: EMPTY_ARRAY
};
function toPropertiesObject(declaredProps) {
    var keysList = Object.keys(declaredProps);
    var alreadySeenKeys = new Set();
    keysList.forEach(function (key) {
        if (alreadySeenKeys.has(key)) {
            throw new MstError("".concat(key, " is declared twice in the model. Model should not contain the same keys"));
        }
        alreadySeenKeys.add(key);
    });
    // loop through properties and ensures that all items are types
    return keysList.reduce(function (props, key) {
        // warn if user intended a HOOK
        if (key in Hook) {
            throw new MstError("Hook '".concat(key, "' was defined as property. Hooks should be defined as part of the actions"));
        }
        // the user intended to use a view
        var descriptor = Object.getOwnPropertyDescriptor(declaredProps, key);
        if ("get" in descriptor) {
            throw new MstError("Getters are not supported as properties. Please use views instead");
        }
        // undefined and null are not valid
        var value = descriptor.value;
        if (value === null || value === undefined) {
            throw new MstError("The default value of an attribute cannot be null or undefined as the type cannot be inferred. Did you mean `types.maybe(someType)`?");
        }
        // its a primitive, convert to its type
        else if (isPrimitive(value)) {
            props[key] = optional(getPrimitiveFactoryFromValue(value), value);
        }
        // map defaults to empty object automatically for models
        else if (value instanceof MapType) {
            props[key] = optional(value, {});
        }
        else if (value instanceof ArrayType) {
            props[key] = optional(value, []);
        }
        // its already a type
        else if (isType(value)) ;
        // its a function, maybe the user wanted a view?
        else if (devMode() && typeof value === "function") {
            throw new MstError("Invalid type definition for property '".concat(key, "', it looks like you passed a function. Did you forget to invoke it, or did you intend to declare a view / action?"));
        }
        // no other complex values
        else if (devMode() && typeof value === "object") {
            throw new MstError("Invalid type definition for property '".concat(key, "', it looks like you passed an object. Try passing another model type or a types.frozen."));
        }
        else {
            throw new MstError("Invalid type definition for property '".concat(key, "', cannot infer a type from a value like '").concat(value, "' (").concat(typeof value, ")"));
        }
        return props;
    }, __assign({}, declaredProps));
}
/**
 * @internal
 * @hidden
 */
var ModelType = /** @class */ (function (_super) {
    __extends(ModelType, _super);
    function ModelType(opts) {
        var _this = _super.call(this, opts.name || defaultObjectOptions.name) || this;
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Object
        });
        /*
         * The original object definition
         */
        Object.defineProperty(_this, "initializers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "properties", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "preProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "postProcessor", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "propertyNames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "named", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (name) {
                return _this.cloneAndEnhance({ name: name });
            }
        });
        Object.defineProperty(_this, "props", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (properties) {
                return _this.cloneAndEnhance({ properties: properties });
            }
        });
        Object.defineProperty(_this, "preProcessSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (preProcessor) {
                var currentPreprocessor = _this.preProcessor;
                if (!currentPreprocessor)
                    return _this.cloneAndEnhance({ preProcessor: preProcessor });
                else
                    return _this.cloneAndEnhance({
                        preProcessor: function (snapshot) { return currentPreprocessor(preProcessor(snapshot)); }
                    });
            }
        });
        Object.defineProperty(_this, "postProcessSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (postProcessor) {
                var currentPostprocessor = _this.postProcessor;
                if (!currentPostprocessor)
                    return _this.cloneAndEnhance({ postProcessor: postProcessor });
                else
                    return _this.cloneAndEnhance({
                        postProcessor: function (snapshot) { return postProcessor(currentPostprocessor(snapshot)); }
                    });
            }
        });
        Object.assign(_this, defaultObjectOptions, opts);
        // ensures that any default value gets converted to its related type
        _this.properties = toPropertiesObject(_this.properties);
        freeze(_this.properties); // make sure nobody messes with it
        _this.propertyNames = Object.keys(_this.properties);
        _this.identifierAttribute = _this._getIdentifierAttribute();
        return _this;
    }
    Object.defineProperty(ModelType.prototype, "_getIdentifierAttribute", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var identifierAttribute = undefined;
            this.forAllProps(function (propName, propType) {
                if (propType.flags & TypeFlags.Identifier) {
                    if (identifierAttribute)
                        throw new MstError("Cannot define property '".concat(propName, "' as object identifier, property '").concat(identifierAttribute, "' is already defined as identifier property"));
                    identifierAttribute = propName;
                }
            });
            return identifierAttribute;
        }
    });
    Object.defineProperty(ModelType.prototype, "cloneAndEnhance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (opts) {
            return new ModelType({
                name: opts.name || this.name,
                properties: Object.assign({}, this.properties, opts.properties),
                initializers: this.initializers.concat(opts.initializers || []),
                preProcessor: opts.preProcessor || this.preProcessor,
                postProcessor: opts.postProcessor || this.postProcessor
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "actions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            var _this = this;
            var actionInitializer = function (self) {
                _this.instantiateActions(self, fn(self));
                return self;
            };
            return this.cloneAndEnhance({ initializers: [actionInitializer] });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiateActions", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (self, actions) {
            // check if return is correct
            if (!isPlainObject(actions))
                throw new MstError("actions initializer should return a plain object containing actions");
            // bind actions to the object created
            Object.keys(actions).forEach(function (name) {
                // warn if preprocessor was given
                if (name === PRE_PROCESS_SNAPSHOT)
                    throw new MstError("Cannot define action '".concat(PRE_PROCESS_SNAPSHOT, "', it should be defined using 'type.preProcessSnapshot(fn)' instead"));
                // warn if postprocessor was given
                if (name === POST_PROCESS_SNAPSHOT)
                    throw new MstError("Cannot define action '".concat(POST_PROCESS_SNAPSHOT, "', it should be defined using 'type.postProcessSnapshot(fn)' instead"));
                var action2 = actions[name];
                // apply hook composition
                var baseAction = self[name];
                if (name in Hook && baseAction) {
                    var specializedAction_1 = action2;
                    action2 = function () {
                        baseAction.apply(null, arguments);
                        specializedAction_1.apply(null, arguments);
                    };
                }
                // the goal of this is to make sure actions using "this" can call themselves,
                // while still allowing the middlewares to register them
                var middlewares = action2.$mst_middleware; // make sure middlewares are not lost
                var boundAction = action2.bind(actions);
                boundAction._isFlowAction = action2._isFlowAction || false;
                boundAction.$mst_middleware = middlewares;
                var actionInvoker = createActionInvoker(self, name, boundAction);
                actions[name] = actionInvoker;
                (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(self, name, actionInvoker);
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "volatile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            var _this = this;
            if (typeof fn !== "function") {
                throw new MstError("You passed an ".concat(typeof fn, " to volatile state as an argument, when function is expected"));
            }
            var stateInitializer = function (self) {
                _this.instantiateVolatileState(self, fn(self));
                return self;
            };
            return this.cloneAndEnhance({ initializers: [stateInitializer] });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiateVolatileState", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (self, state) {
            // check views return
            if (!isPlainObject(state))
                throw new MstError("volatile state initializer should return a plain object containing state");
            (0,mobx__WEBPACK_IMPORTED_MODULE_0__.set)(self, state);
        }
    });
    Object.defineProperty(ModelType.prototype, "extend", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            var _this = this;
            var initializer = function (self) {
                var _a = fn(self), actions = _a.actions, views = _a.views, state = _a.state, rest = __rest(_a, ["actions", "views", "state"]);
                for (var key in rest)
                    throw new MstError("The `extend` function should return an object with a subset of the fields 'actions', 'views' and 'state'. Found invalid key '".concat(key, "'"));
                if (state)
                    _this.instantiateVolatileState(self, state);
                if (views)
                    _this.instantiateViews(self, views);
                if (actions)
                    _this.instantiateActions(self, actions);
                return self;
            };
            return this.cloneAndEnhance({ initializers: [initializer] });
        }
    });
    Object.defineProperty(ModelType.prototype, "views", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            var _this = this;
            var viewInitializer = function (self) {
                _this.instantiateViews(self, fn(self));
                return self;
            };
            return this.cloneAndEnhance({ initializers: [viewInitializer] });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiateViews", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (self, views) {
            // check views return
            if (!isPlainObject(views))
                throw new MstError("views initializer should return a plain object containing views");
            Object.getOwnPropertyNames(views).forEach(function (key) {
                var _a;
                // is this a computed property?
                var descriptor = Object.getOwnPropertyDescriptor(views, key);
                if ("get" in descriptor) {
                    (0,mobx__WEBPACK_IMPORTED_MODULE_0__.defineProperty)(self, key, descriptor);
                    (0,mobx__WEBPACK_IMPORTED_MODULE_0__.makeObservable)(self, (_a = {}, _a[key] = mobx__WEBPACK_IMPORTED_MODULE_0__.computed, _a));
                }
                else if (typeof descriptor.value === "function") {
                    (!devMode() ? addHiddenFinalProp : addHiddenWritableProp)(self, key, descriptor.value);
                }
                else {
                    throw new MstError("A view member should either be a function or getter based property");
                }
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            var value = isStateTreeNode(initialValue)
                ? initialValue
                : this.applySnapshotPreProcessor(initialValue);
            return createObjectNode(this, parent, subpath, environment, value);
            // Optimization: record all prop- view- and action names after first construction, and generate an optimal base class
            // that pre-reserves all these fields for fast object-member lookups
        }
    });
    Object.defineProperty(ModelType.prototype, "initializeChildNodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (objNode, initialSnapshot) {
            if (initialSnapshot === void 0) { initialSnapshot = {}; }
            var type = objNode.type;
            var result = {};
            type.forAllProps(function (name, childType) {
                result[name] = childType.instantiate(objNode, name, undefined, initialSnapshot[name]);
            });
            return result;
        }
    });
    Object.defineProperty(ModelType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNodes) {
            var options = __assign(__assign({}, mobxShallow), { name: this.name });
            return mobx__WEBPACK_IMPORTED_MODULE_0__.observable.object(childNodes, EMPTY_OBJECT, options);
        }
    });
    Object.defineProperty(ModelType.prototype, "finalizeNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, instance) {
            addHiddenFinalProp(instance, "toString", objectTypeToString);
            this.forAllProps(function (name) {
                (0,mobx__WEBPACK_IMPORTED_MODULE_0__._interceptReads)(instance, name, node.unbox);
            });
            this.initializers.reduce(function (self, fn) { return fn(self); }, instance);
            (0,mobx__WEBPACK_IMPORTED_MODULE_0__.intercept)(instance, this.willChange);
            (0,mobx__WEBPACK_IMPORTED_MODULE_0__.observe)(instance, this.didChange);
        }
    });
    Object.defineProperty(ModelType.prototype, "willChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (chg) {
            // TODO: mobx typings don't seem to take into account that newValue can be set even when removing a prop
            var change = chg;
            var node = getStateTreeNode(change.object);
            var subpath = change.name;
            node.assertWritable({ subpath: subpath });
            var childType = node.type.properties[subpath];
            // only properties are typed, state are stored as-is references
            if (childType) {
                typecheckInternal(childType, change.newValue);
                change.newValue = childType.reconcile(node.getChildNode(subpath), change.newValue, node, subpath);
            }
            return change;
        }
    });
    Object.defineProperty(ModelType.prototype, "didChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (chg) {
            // TODO: mobx typings don't seem to take into account that newValue can be set even when removing a prop
            var change = chg;
            var childNode = getStateTreeNode(change.object);
            var childType = childNode.type.properties[change.name];
            if (!childType) {
                // don't emit patches for volatile state
                return;
            }
            var oldChildValue = change.oldValue ? change.oldValue.snapshot : undefined;
            childNode.emitPatch({
                op: "replace",
                path: escapeJsonPath(change.name),
                value: change.newValue.snapshot,
                oldValue: oldChildValue
            }, childNode);
        }
    });
    Object.defineProperty(ModelType.prototype, "getChildren", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            var _this = this;
            var res = [];
            this.forAllProps(function (name) {
                res.push(_this.getChildNode(node, name));
            });
            return res;
        }
    });
    Object.defineProperty(ModelType.prototype, "getChildNode", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, key) {
            var _a;
            if (!(key in this.properties))
                throw new MstError("Not a value property: " + key);
            var adm = (0,mobx__WEBPACK_IMPORTED_MODULE_0__._getAdministration)(node.storedValue, key);
            var childNode = (_a = adm.raw) === null || _a === void 0 ? void 0 : _a.call(adm);
            if (!childNode)
                throw new MstError("Node not available for property " + key);
            return childNode;
        }
    });
    Object.defineProperty(ModelType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, applyPostProcess) {
            var _this = this;
            if (applyPostProcess === void 0) { applyPostProcess = true; }
            var res = {};
            this.forAllProps(function (name, type) {
                try {
                    // TODO: FIXME, make sure the observable ref is used!
                    var atom = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.getAtom)(node.storedValue, name);
                    atom.reportObserved();
                }
                catch (e) {
                    throw new MstError("".concat(name, " property is declared twice"));
                }
                res[name] = _this.getChildNode(node, name).snapshot;
            });
            if (applyPostProcess) {
                return this.applySnapshotPostProcessor(res);
            }
            return res;
        }
    });
    Object.defineProperty(ModelType.prototype, "processInitialSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (childNodes) {
            var processed = {};
            Object.keys(childNodes).forEach(function (key) {
                processed[key] = childNodes[key].getSnapshot();
            });
            return this.applySnapshotPostProcessor(processed);
        }
    });
    Object.defineProperty(ModelType.prototype, "applyPatchLocally", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, subpath, patch) {
            if (!(patch.op === "replace" || patch.op === "add")) {
                throw new MstError("object does not support operation ".concat(patch.op));
            }
            node.storedValue[subpath] = patch.value;
        }
    });
    Object.defineProperty(ModelType.prototype, "applySnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, snapshot) {
            typecheckInternal(this, snapshot);
            var preProcessedSnapshot = this.applySnapshotPreProcessor(snapshot);
            this.forAllProps(function (name) {
                node.storedValue[name] = preProcessedSnapshot[name];
            });
        }
    });
    Object.defineProperty(ModelType.prototype, "applySnapshotPreProcessor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot) {
            var processor = this.preProcessor;
            return processor ? processor.call(null, snapshot) : snapshot;
        }
    });
    Object.defineProperty(ModelType.prototype, "applySnapshotPostProcessor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot) {
            var postProcessor = this.postProcessor;
            if (postProcessor)
                return postProcessor.call(null, snapshot);
            return snapshot;
        }
    });
    Object.defineProperty(ModelType.prototype, "getChildType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (propertyName) {
            assertIsString(propertyName, 1);
            return this.properties[propertyName];
        }
    });
    Object.defineProperty(ModelType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var _this = this;
            var snapshot = this.applySnapshotPreProcessor(value);
            if (!isPlainObject(snapshot)) {
                return typeCheckFailure(context, snapshot, "Value is not a plain object");
            }
            return flattenTypeErrors(this.propertyNames.map(function (key) {
                return _this.properties[key].validate(snapshot[key], getContextForPath(context, key, _this.properties[key]));
            }));
        }
    });
    Object.defineProperty(ModelType.prototype, "forAllProps", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (fn) {
            var _this = this;
            this.propertyNames.forEach(function (key) { return fn(key, _this.properties[key]); });
        }
    });
    Object.defineProperty(ModelType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            // optimization: cache
            return ("{ " +
                this.propertyNames.map(function (key) { return key + ": " + _this.properties[key].describe(); }).join("; ") +
                " }");
        }
    });
    Object.defineProperty(ModelType.prototype, "getDefaultSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return EMPTY_OBJECT;
        }
    });
    Object.defineProperty(ModelType.prototype, "removeChild", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node, subpath) {
            node.storedValue[subpath] = undefined;
        }
    });
    return ModelType;
}(ComplexType));
ModelType.prototype.applySnapshot = (0,mobx__WEBPACK_IMPORTED_MODULE_0__.action)(ModelType.prototype.applySnapshot);
/**
 * `types.model` - Creates a new model type by providing a name, properties, volatile state and actions.
 *
 * See the [model type](/concepts/trees#creating-models) description or the [getting started](intro/getting-started.md#getting-started-1) tutorial.
 */
function model() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (devMode() && typeof args[0] !== "string" && args[1]) {
        throw new MstError("Model creation failed. First argument must be a string when two arguments are provided");
    }
    var name = typeof args[0] === "string" ? args.shift() : "AnonymousModel";
    var properties = args.shift() || {};
    return new ModelType({ name: name, properties: properties });
}
/**
 * `types.compose` - Composes a new model from one or more existing model types.
 * This method can be invoked in two forms:
 * Given 2 or more model types, the types are composed into a new Type.
 * Given first parameter as a string and 2 or more model types,
 * the types are composed into a new Type with the given name
 */
function compose() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // TODO: just join the base type names if no name is provided
    var hasTypename = typeof args[0] === "string";
    var typeName = hasTypename ? args[0] : "AnonymousModel";
    if (hasTypename) {
        args.shift();
    }
    // check all parameters
    if (devMode()) {
        args.forEach(function (type, i) {
            assertArg(type, isModelType, "mobx-state-tree model type", hasTypename ? i + 2 : i + 1);
        });
    }
    return args
        .reduce(function (prev, cur) {
        return prev.cloneAndEnhance({
            name: prev.name + "_" + cur.name,
            properties: cur.properties,
            initializers: cur.initializers,
            preProcessor: function (snapshot) {
                return cur.applySnapshotPreProcessor(prev.applySnapshotPreProcessor(snapshot));
            },
            postProcessor: function (snapshot) {
                return cur.applySnapshotPostProcessor(prev.applySnapshotPostProcessor(snapshot));
            }
        });
    })
        .named(typeName);
}
/**
 * Returns if a given value represents a model type.
 *
 * @param type
 * @returns
 */
function isModelType(type) {
    return isType(type) && (type.flags & TypeFlags.Object) > 0;
}

// TODO: implement CoreType using types.custom ?
/**
 * @internal
 * @hidden
 */
var CoreType = /** @class */ (function (_super) {
    __extends(CoreType, _super);
    function CoreType(name, flags, checker, initializer) {
        if (initializer === void 0) { initializer = identity; }
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: flags
        });
        Object.defineProperty(_this, "checker", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: checker
        });
        Object.defineProperty(_this, "initializer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: initializer
        });
        _this.flags = flags;
        return _this;
    }
    Object.defineProperty(CoreType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.name;
        }
    });
    Object.defineProperty(CoreType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            return createScalarNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(CoreType.prototype, "createNewInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (snapshot) {
            return this.initializer(snapshot);
        }
    });
    Object.defineProperty(CoreType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (isPrimitive(value) && this.checker(value)) {
                return typeCheckSuccess();
            }
            var typeName = this.name === "Date" ? "Date or a unix milliseconds timestamp" : this.name;
            return typeCheckFailure(context, value, "Value is not a ".concat(typeName));
        }
    });
    return CoreType;
}(SimpleType));
/**
 * `types.string` - Creates a type that can only contain a string value.
 * This type is used for string values by default
 *
 * Example:
 * ```ts
 * const Person = types.model({
 *   firstName: types.string,
 *   lastName: "Doe"
 * })
 * ```
 */
// tslint:disable-next-line:variable-name
var string = new CoreType("string", TypeFlags.String, function (v) { return typeof v === "string"; });
/**
 * `types.number` - Creates a type that can only contain a numeric value.
 * This type is used for numeric values by default
 *
 * Example:
 * ```ts
 * const Vector = types.model({
 *   x: types.number,
 *   y: 1.5
 * })
 * ```
 */
// tslint:disable-next-line:variable-name
var number = new CoreType("number", TypeFlags.Number, function (v) { return typeof v === "number"; });
/**
 * `types.integer` - Creates a type that can only contain an integer value.
 *
 * Example:
 * ```ts
 * const Size = types.model({
 *   width: types.integer,
 *   height: 10
 * })
 * ```
 */
// tslint:disable-next-line:variable-name
var integer = new CoreType("integer", TypeFlags.Integer, function (v) { return isInteger(v); });
/**
 * `types.float` - Creates a type that can only contain an float value.
 *
 * Example:
 * ```ts
 * const Size = types.model({
 *   width: types.float,
 *   height: 10
 * })
 * ```
 */
// tslint:disable-next-line:variable-name
var float = new CoreType("float", TypeFlags.Float, function (v) { return isFloat(v); });
/**
 * `types.finite` - Creates a type that can only contain an finite value.
 *
 * Example:
 * ```ts
 * const Size = types.model({
 *   width: types.finite,
 *   height: 10
 * })
 * ```
 */
// tslint:disable-next-line:variable-name
var finite = new CoreType("finite", TypeFlags.Finite, function (v) { return isFinite(v); });
/**
 * `types.boolean` - Creates a type that can only contain a boolean value.
 * This type is used for boolean values by default
 *
 * Example:
 * ```ts
 * const Thing = types.model({
 *   isCool: types.boolean,
 *   isAwesome: false
 * })
 * ```
 */
// tslint:disable-next-line:variable-name
var boolean = new CoreType("boolean", TypeFlags.Boolean, function (v) { return typeof v === "boolean"; });
/**
 * `types.null` - The type of the value `null`
 */
var nullType = new CoreType("null", TypeFlags.Null, function (v) { return v === null; });
/**
 * `types.undefined` - The type of the value `undefined`
 */
var undefinedType = new CoreType("undefined", TypeFlags.Undefined, function (v) { return v === undefined; });
var _DatePrimitive = new CoreType("Date", TypeFlags.Date, function (v) { return typeof v === "number" || v instanceof Date; }, function (v) { return (v instanceof Date ? v : new Date(v)); });
_DatePrimitive.getSnapshot = function (node) {
    return node.storedValue.getTime();
};
/**
 * `types.Date` - Creates a type that can only contain a javascript Date value.
 *
 * Example:
 * ```ts
 * const LogLine = types.model({
 *   timestamp: types.Date,
 * })
 *
 * LogLine.create({ timestamp: new Date() })
 * ```
 */
var DatePrimitive = _DatePrimitive;
/**
 * @internal
 * @hidden
 */
function getPrimitiveFactoryFromValue(value) {
    switch (typeof value) {
        case "string":
            return string;
        case "number":
            return number; // In the future, isInteger(value) ? integer : number would be interesting, but would be too breaking for now
        case "boolean":
            return boolean;
        case "object":
            if (value instanceof Date)
                return DatePrimitive;
    }
    throw new MstError("Cannot determine primitive type from value " + value);
}
/**
 * Returns if a given value represents a primitive type.
 *
 * @param type
 * @returns
 */
function isPrimitiveType(type) {
    return (isType(type) &&
        (type.flags &
            (TypeFlags.String |
                TypeFlags.Number |
                TypeFlags.Integer |
                TypeFlags.Boolean |
                TypeFlags.Date)) >
            0);
}

/**
 * @internal
 * @hidden
 */
var Literal = /** @class */ (function (_super) {
    __extends(Literal, _super);
    function Literal(value) {
        var _this = _super.call(this, JSON.stringify(value)) || this;
        Object.defineProperty(_this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Literal
        });
        _this.value = value;
        return _this;
    }
    Object.defineProperty(Literal.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            return createScalarNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Literal.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return JSON.stringify(this.value);
        }
    });
    Object.defineProperty(Literal.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (isPrimitive(value) && value === this.value) {
                return typeCheckSuccess();
            }
            return typeCheckFailure(context, value, "Value is not a literal ".concat(JSON.stringify(this.value)));
        }
    });
    return Literal;
}(SimpleType));
/**
 * `types.literal` - The literal type will return a type that will match only the exact given type.
 * The given value must be a primitive, in order to be serialized to a snapshot correctly.
 * You can use literal to match exact strings for example the exact male or female string.
 *
 * Example:
 * ```ts
 * const Person = types.model({
 *     name: types.string,
 *     gender: types.union(types.literal('male'), types.literal('female'))
 * })
 * ```
 *
 * @param value The value to use in the strict equal check
 * @returns
 */
function literal(value) {
    // check that the given value is a primitive
    assertArg(value, isPrimitive, "primitive", 1);
    return new Literal(value);
}
/**
 * Returns if a given value represents a literal type.
 *
 * @param type
 * @returns
 */
function isLiteralType(type) {
    return isType(type) && (type.flags & TypeFlags.Literal) > 0;
}

var Refinement = /** @class */ (function (_super) {
    __extends(Refinement, _super);
    function Refinement(name, _subtype, _predicate, _message) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_subtype", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subtype
        });
        Object.defineProperty(_this, "_predicate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _predicate
        });
        Object.defineProperty(_this, "_message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _message
        });
        return _this;
    }
    Object.defineProperty(Refinement.prototype, "flags", {
        get: function () {
            return this._subtype.flags | TypeFlags.Refinement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Refinement.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.name;
        }
    });
    Object.defineProperty(Refinement.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            // create the child type
            return this._subtype.instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Refinement.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            return this._subtype.isAssignableFrom(type);
        }
    });
    Object.defineProperty(Refinement.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var subtypeErrors = this._subtype.validate(value, context);
            if (subtypeErrors.length > 0)
                return subtypeErrors;
            var snapshot = isStateTreeNode(value) ? getStateTreeNode(value).snapshot : value;
            if (!this._predicate(snapshot)) {
                return typeCheckFailure(context, value, this._message(value));
            }
            return typeCheckSuccess();
        }
    });
    Object.defineProperty(Refinement.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            return this._subtype.reconcile(current, newValue, parent, subpath);
        }
    });
    Object.defineProperty(Refinement.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._subtype;
        }
    });
    return Refinement;
}(BaseType));
/**
 * `types.refinement` - Creates a type that is more specific than the base type, e.g. `types.refinement(types.string, value => value.length > 5)` to create a type of strings that can only be longer then 5.
 *
 * @param name
 * @param type
 * @param predicate
 * @returns
 */
function refinement() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var name = typeof args[0] === "string" ? args.shift() : isType(args[0]) ? args[0].name : null;
    var type = args[0];
    var predicate = args[1];
    var message = args[2] ? args[2] : function (v) { return "Value does not respect the refinement predicate"; };
    // ensures all parameters are correct
    assertIsType(type, [1, 2]);
    assertIsString(name, 1);
    assertIsFunction(predicate, [2, 3]);
    assertIsFunction(message, [3, 4]);
    return new Refinement(name, type, predicate, message);
}
/**
 * Returns if a given value is a refinement type.
 *
 * @param type
 * @returns
 */
function isRefinementType(type) {
    return (type.flags & TypeFlags.Refinement) > 0;
}

/**
 * `types.enumeration` - Can be used to create an string based enumeration.
 * (note: this methods is just sugar for a union of string literals)
 *
 * Example:
 * ```ts
 * const TrafficLight = types.model({
 *   color: types.enumeration("Color", ["Red", "Orange", "Green"])
 * })
 * ```
 *
 * @param name descriptive name of the enumeration (optional)
 * @param options possible values this enumeration can have
 * @returns
 */
function enumeration(name, options) {
    var realOptions = typeof name === "string" ? options : name;
    // check all options
    if (devMode()) {
        realOptions.forEach(function (option, i) {
            assertIsString(option, i + 1);
        });
    }
    var type = union.apply(void 0, __spreadArray([], __read(realOptions.map(function (option) { return literal("" + option); })), false));
    if (typeof name === "string")
        type.name = name;
    return type;
}

/**
 * @internal
 * @hidden
 */
var Union = /** @class */ (function (_super) {
    __extends(Union, _super);
    function Union(name, _types, options) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_types", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _types
        });
        Object.defineProperty(_this, "_dispatcher", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(_this, "_eager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        options = __assign({ eager: true, dispatcher: undefined }, options);
        _this._dispatcher = options.dispatcher;
        if (!options.eager)
            _this._eager = false;
        return _this;
    }
    Object.defineProperty(Union.prototype, "flags", {
        get: function () {
            var result = TypeFlags.Union;
            this._types.forEach(function (type) {
                result |= type.flags;
            });
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Union.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            return this._types.some(function (subType) { return subType.isAssignableFrom(type); });
        }
    });
    Object.defineProperty(Union.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return "(" + this._types.map(function (factory) { return factory.describe(); }).join(" | ") + ")";
        }
    });
    Object.defineProperty(Union.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            var type = this.determineType(initialValue, undefined);
            if (!type)
                throw new MstError("No matching type for union " + this.describe()); // can happen in prod builds
            return type.instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Union.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            var type = this.determineType(newValue, current.getReconciliationType());
            if (!type)
                throw new MstError("No matching type for union " + this.describe()); // can happen in prod builds
            return type.reconcile(current, newValue, parent, subpath);
        }
    });
    Object.defineProperty(Union.prototype, "determineType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, reconcileCurrentType) {
            // try the dispatcher, if defined
            if (this._dispatcher) {
                return this._dispatcher(value);
            }
            // find the most accommodating type
            // if we are using reconciliation try the current node type first (fix for #1045)
            if (reconcileCurrentType) {
                if (reconcileCurrentType.is(value)) {
                    return reconcileCurrentType;
                }
                return this._types.filter(function (t) { return t !== reconcileCurrentType; }).find(function (type) { return type.is(value); });
            }
            else {
                return this._types.find(function (type) { return type.is(value); });
            }
        }
    });
    Object.defineProperty(Union.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (this._dispatcher) {
                return this._dispatcher(value).validate(value, context);
            }
            var allErrors = [];
            var applicableTypes = 0;
            for (var i = 0; i < this._types.length; i++) {
                var type = this._types[i];
                var errors = type.validate(value, context);
                if (errors.length === 0) {
                    if (this._eager)
                        return typeCheckSuccess();
                    else
                        applicableTypes++;
                }
                else {
                    allErrors.push(errors);
                }
            }
            if (applicableTypes === 1)
                return typeCheckSuccess();
            return typeCheckFailure(context, value, "No type is applicable for the union").concat(flattenTypeErrors(allErrors));
        }
    });
    Object.defineProperty(Union.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._types;
        }
    });
    return Union;
}(BaseType));
/**
 * `types.union` - Create a union of multiple types. If the correct type cannot be inferred unambiguously from a snapshot, provide a dispatcher function of the form `(snapshot) => Type`.
 *
 * @param optionsOrType
 * @param otherTypes
 * @returns
 */
function union(optionsOrType) {
    var otherTypes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        otherTypes[_i - 1] = arguments[_i];
    }
    var options = isType(optionsOrType) ? undefined : optionsOrType;
    var types = isType(optionsOrType) ? __spreadArray([optionsOrType], __read(otherTypes), false) : otherTypes;
    var name = "(" + types.map(function (type) { return type.name; }).join(" | ") + ")";
    // check all options
    if (devMode()) {
        if (options) {
            assertArg(options, function (o) { return isPlainObject(o); }, "object { eager?: boolean, dispatcher?: Function }", 1);
        }
        types.forEach(function (type, i) {
            assertIsType(type, options ? i + 2 : i + 1);
        });
    }
    return new Union(name, types, options);
}
/**
 * Returns if a given value represents a union type.
 *
 * @param type
 * @returns
 */
function isUnionType(type) {
    return (type.flags & TypeFlags.Union) > 0;
}

/**
 * @hidden
 * @internal
 */
var OptionalValue = /** @class */ (function (_super) {
    __extends(OptionalValue, _super);
    function OptionalValue(_subtype, _defaultValue, optionalValues) {
        var _this = _super.call(this, _subtype.name) || this;
        Object.defineProperty(_this, "_subtype", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _subtype
        });
        Object.defineProperty(_this, "_defaultValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _defaultValue
        });
        Object.defineProperty(_this, "optionalValues", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: optionalValues
        });
        return _this;
    }
    Object.defineProperty(OptionalValue.prototype, "flags", {
        get: function () {
            return this._subtype.flags | TypeFlags.Optional;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OptionalValue.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._subtype.describe() + "?";
        }
    });
    Object.defineProperty(OptionalValue.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            if (this.optionalValues.indexOf(initialValue) >= 0) {
                var defaultInstanceOrSnapshot = this.getDefaultInstanceOrSnapshot();
                return this._subtype.instantiate(parent, subpath, environment, defaultInstanceOrSnapshot);
            }
            return this._subtype.instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            return this._subtype.reconcile(current, this.optionalValues.indexOf(newValue) < 0 && this._subtype.is(newValue)
                ? newValue
                : this.getDefaultInstanceOrSnapshot(), parent, subpath);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "getDefaultInstanceOrSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var defaultInstanceOrSnapshot = typeof this._defaultValue === "function"
                ? this._defaultValue()
                : this._defaultValue;
            // while static values are already snapshots and checked on types.optional
            // generator functions must always be rechecked just in case
            if (typeof this._defaultValue === "function") {
                typecheckInternal(this, defaultInstanceOrSnapshot);
            }
            return defaultInstanceOrSnapshot;
        }
    });
    Object.defineProperty(OptionalValue.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            // defaulted values can be skipped
            if (this.optionalValues.indexOf(value) >= 0) {
                return typeCheckSuccess();
            }
            // bounce validation to the sub-type
            return this._subtype.validate(value, context);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            return this._subtype.isAssignableFrom(type);
        }
    });
    Object.defineProperty(OptionalValue.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this._subtype;
        }
    });
    return OptionalValue;
}(BaseType));
function checkOptionalPreconditions(type, defaultValueOrFunction) {
    // make sure we never pass direct instances
    if (typeof defaultValueOrFunction !== "function" && isStateTreeNode(defaultValueOrFunction)) {
        throw new MstError("default value cannot be an instance, pass a snapshot or a function that creates an instance/snapshot instead");
    }
    assertIsType(type, 1);
    if (devMode()) {
        // we only check default values if they are passed directly
        // if they are generator functions they will be checked once they are generated
        // we don't check generator function results here to avoid generating a node just for type-checking purposes
        // which might generate side-effects
        if (typeof defaultValueOrFunction !== "function") {
            typecheckInternal(type, defaultValueOrFunction);
        }
    }
}
/**
 * `types.optional` - Can be used to create a property with a default value.
 *
 * Depending on the third argument (`optionalValues`) there are two ways of operation:
 * - If the argument is not provided, then if a value is not provided in the snapshot (`undefined` or missing),
 *   it will default to the provided `defaultValue`
 * - If the argument is provided, then if the value in the snapshot matches one of the optional values inside the array then it will
 *   default to the provided `defaultValue`. Additionally, if one of the optional values inside the array is `undefined` then a missing
 *   property is also valid.
 *
 *   Note that it is also possible to include values of the same type as the intended subtype as optional values,
 *   in this case the optional value will be transformed into the `defaultValue` (e.g. `types.optional(types.string, "unnamed", [undefined, ""])`
 *   will transform the snapshot values `undefined` (and therefore missing) and empty strings into the string `"unnamed"` when it gets
 *   instantiated).
 *
 * If `defaultValue` is a function, the function will be invoked for every new instance.
 * Applying a snapshot in which the optional value is one of the optional values (or `undefined`/_not_ present if none are provided) causes the
 * value to be reset.
 *
 * Example:
 * ```ts
 * const Todo = types.model({
 *   title: types.string,
 *   subtitle1: types.optional(types.string, "", [null]),
 *   subtitle2: types.optional(types.string, "", [null, undefined]),
 *   done: types.optional(types.boolean, false),
 *   created: types.optional(types.Date, () => new Date()),
 * })
 *
 * // if done is missing / undefined it will become false
 * // if created is missing / undefined it will get a freshly generated timestamp
 * // if subtitle1 is null it will default to "", but it cannot be missing or undefined
 * // if subtitle2 is null or undefined it will default to ""; since it can be undefined it can also be missing
 * const todo = Todo.create({ title: "Get coffee", subtitle1: null })
 * ```
 *
 * @param type
 * @param defaultValueOrFunction
 * @param optionalValues an optional array with zero or more primitive values (string, number, boolean, null or undefined)
 *                       that will be converted into the default. `[ undefined ]` is assumed when none is provided
 * @returns
 */
function optional(type, defaultValueOrFunction, optionalValues) {
    checkOptionalPreconditions(type, defaultValueOrFunction);
    return new OptionalValue(type, defaultValueOrFunction, optionalValues ? optionalValues : undefinedAsOptionalValues);
}
var undefinedAsOptionalValues = [undefined];
/**
 * Returns if a value represents an optional type.
 *
 * @template IT
 * @param type
 * @returns
 */
function isOptionalType(type) {
    return isType(type) && (type.flags & TypeFlags.Optional) > 0;
}

var optionalUndefinedType = optional(undefinedType, undefined);
var optionalNullType = optional(nullType, null);
/**
 * `types.maybe` - Maybe will make a type nullable, and also optional.
 * The value `undefined` will be used to represent nullability.
 *
 * @param type
 * @returns
 */
function maybe(type) {
    assertIsType(type, 1);
    return union(type, optionalUndefinedType);
}
/**
 * `types.maybeNull` - Maybe will make a type nullable, and also optional.
 * The value `null` will be used to represent no value.
 *
 * @param type
 * @returns
 */
function maybeNull(type) {
    assertIsType(type, 1);
    return union(type, optionalNullType);
}

var Late = /** @class */ (function (_super) {
    __extends(Late, _super);
    function Late(name, _definition) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "_definition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _definition
        });
        Object.defineProperty(_this, "_subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        return _this;
    }
    Object.defineProperty(Late.prototype, "flags", {
        get: function () {
            return (this._subType ? this._subType.flags : 0) | TypeFlags.Late;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Late.prototype, "getSubType", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (mustSucceed) {
            if (!this._subType) {
                var t = undefined;
                try {
                    t = this._definition();
                }
                catch (e) {
                    if (e instanceof ReferenceError)
                        // can happen in strict ES5 code when a definition is self refering
                        t = undefined;
                    else
                        throw e;
                }
                if (mustSucceed && t === undefined)
                    throw new MstError("Late type seems to be used too early, the definition (still) returns undefined");
                if (t) {
                    if (devMode() && !isType(t))
                        throw new MstError("Failed to determine subtype, make sure types.late returns a type definition.");
                    this._subType = t;
                }
            }
            return this._subType;
        }
    });
    Object.defineProperty(Late.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            return this.getSubType(true).instantiate(parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(Late.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            return this.getSubType(true).reconcile(current, newValue, parent, subpath);
        }
    });
    Object.defineProperty(Late.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var t = this.getSubType(false);
            return t ? t.name : "<uknown late type>";
        }
    });
    Object.defineProperty(Late.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            var t = this.getSubType(false);
            if (!t) {
                // See #916; the variable the definition closure is pointing to wasn't defined yet, so can't be evaluted yet here
                return typeCheckSuccess();
            }
            return t.validate(value, context);
        }
    });
    Object.defineProperty(Late.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            var t = this.getSubType(false);
            return t ? t.isAssignableFrom(type) : false;
        }
    });
    Object.defineProperty(Late.prototype, "getSubTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var subtype = this.getSubType(false);
            return subtype ? subtype : cannotDetermineSubtype;
        }
    });
    return Late;
}(BaseType));
/**
 * `types.late` - Defines a type that gets implemented later. This is useful when you have to deal with circular dependencies.
 * Please notice that when defining circular dependencies TypeScript isn't smart enough to inference them.
 *
 * Example:
 * ```ts
 *   // TypeScript isn't smart enough to infer self referencing types.
 *  const Node = types.model({
 *       children: types.array(types.late((): IAnyModelType => Node)) // then typecast each array element to Instance<typeof Node>
 *  })
 * ```
 *
 * @param name The name to use for the type that will be returned.
 * @param type A function that returns the type that will be defined.
 * @returns
 */
function late(nameOrType, maybeType) {
    var name = typeof nameOrType === "string" ? nameOrType : "late(".concat(nameOrType.toString(), ")");
    var type = typeof nameOrType === "string" ? maybeType : nameOrType;
    // checks that the type is actually a late type
    if (devMode()) {
        if (!(typeof type === "function" && type.length === 0))
            throw new MstError("Invalid late type, expected a function with zero arguments that returns a type, got: " +
                type);
    }
    return new Late(name, type);
}
/**
 * Returns if a given value represents a late type.
 *
 * @param type
 * @returns
 */
function isLateType(type) {
    return isType(type) && (type.flags & TypeFlags.Late) > 0;
}

function lazy(name, options) {
    // TODO: fix this unknown casting to be stricter
    return new Lazy(name, options);
}
/**
 * @internal
 * @hidden
 */
var Lazy = /** @class */ (function (_super) {
    __extends(Lazy, _super);
    function Lazy(name, options) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Lazy
        });
        Object.defineProperty(_this, "loadedType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(_this, "pendingNodeList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: mobx__WEBPACK_IMPORTED_MODULE_0__.observable.array()
        });
        (0,mobx__WEBPACK_IMPORTED_MODULE_0__.when)(function () {
            return _this.pendingNodeList.length > 0 &&
                _this.pendingNodeList.some(function (node) {
                    return node.isAlive && _this.options.shouldLoadPredicate(node.parent ? node.parent.value : null);
                });
        }, function () {
            _this.options.loadType().then((0,mobx__WEBPACK_IMPORTED_MODULE_0__.action)(function (type) {
                _this.loadedType = type;
                _this.pendingNodeList.forEach(function (node) {
                    if (!node.parent)
                        return;
                    if (!_this.loadedType)
                        return;
                    node.parent.applyPatches([
                        {
                            op: "replace",
                            path: "/".concat(node.subpath),
                            value: node.snapshot
                        }
                    ]);
                });
            }));
        });
        return _this;
    }
    Object.defineProperty(Lazy.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return "<lazy ".concat(this.name, ">");
        }
    });
    Object.defineProperty(Lazy.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, value) {
            var _this = this;
            if (this.loadedType) {
                return this.loadedType.instantiate(parent, subpath, environment, value);
            }
            var node = createScalarNode(this, parent, subpath, environment, deepFreeze(value));
            this.pendingNodeList.push(node);
            (0,mobx__WEBPACK_IMPORTED_MODULE_0__.when)(function () { return !node.isAlive; }, function () { return _this.pendingNodeList.splice(_this.pendingNodeList.indexOf(node), 1); });
            return node;
        }
    });
    Object.defineProperty(Lazy.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (this.loadedType) {
                return this.loadedType.validate(value, context);
            }
            if (!isSerializable(value)) {
                return typeCheckFailure(context, value, "Value is not serializable and cannot be lazy");
            }
            return typeCheckSuccess();
        }
    });
    Object.defineProperty(Lazy.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, value, parent, subpath) {
            if (this.loadedType) {
                current.die();
                return this.loadedType.instantiate(parent, subpath, parent.environment, value);
            }
            return _super.prototype.reconcile.call(this, current, value, parent, subpath);
        }
    });
    return Lazy;
}(SimpleType));

/**
 * @internal
 * @hidden
 */
var Frozen = /** @class */ (function (_super) {
    __extends(Frozen, _super);
    function Frozen(subType) {
        var _this = _super.call(this, subType ? "frozen(".concat(subType.name, ")") : "frozen") || this;
        Object.defineProperty(_this, "subType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: subType
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Frozen
        });
        return _this;
    }
    Object.defineProperty(Frozen.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return "<any immutable value>";
        }
    });
    Object.defineProperty(Frozen.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, value) {
            // create the node
            return createScalarNode(this, parent, subpath, environment, deepFreeze(value));
        }
    });
    Object.defineProperty(Frozen.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (!isSerializable(value)) {
                return typeCheckFailure(context, value, "Value is not serializable and cannot be frozen");
            }
            if (this.subType)
                return this.subType.validate(value, context);
            return typeCheckSuccess();
        }
    });
    return Frozen;
}(SimpleType));
var untypedFrozenInstance = new Frozen();
/**
 * `types.frozen` - Frozen can be used to store any value that is serializable in itself (that is valid JSON).
 * Frozen values need to be immutable or treated as if immutable. They need be serializable as well.
 * Values stored in frozen will snapshotted as-is by MST, and internal changes will not be tracked.
 *
 * This is useful to store complex, but immutable values like vectors etc. It can form a powerful bridge to parts of your application that should be immutable, or that assume data to be immutable.
 *
 * Note: if you want to store free-form state that is mutable, or not serializeable, consider using volatile state instead.
 *
 * Frozen properties can be defined in three different ways
 * 1. `types.frozen(SubType)` - provide a valid MST type and frozen will check if the provided data conforms the snapshot for that type
 * 2. `types.frozen({ someDefaultValue: true})` - provide a primitive value, object or array, and MST will infer the type from that object, and also make it the default value for the field
 * 3. `types.frozen<TypeScriptType>()` - provide a typescript type, to help in strongly typing the field (design time only)
 *
 * Example:
 * ```ts
 * const GameCharacter = types.model({
 *   name: string,
 *   location: types.frozen({ x: 0, y: 0})
 * })
 *
 * const hero = GameCharacter.create({
 *   name: "Mario",
 *   location: { x: 7, y: 4 }
 * })
 *
 * hero.location = { x: 10, y: 2 } // OK
 * hero.location.x = 7 // Not ok!
 * ```
 *
 * ```ts
 * type Point = { x: number, y: number }
 *    const Mouse = types.model({
 *         loc: types.frozen<Point>()
 *    })
 * ```
 *
 * @param defaultValueOrType
 * @returns
 */
function frozen(arg) {
    if (arguments.length === 0)
        return untypedFrozenInstance;
    else if (isType(arg))
        return new Frozen(arg);
    else
        return optional(untypedFrozenInstance, arg);
}
/**
 * Returns if a given value represents a frozen type.
 *
 * @param type
 * @returns
 */
function isFrozenType(type) {
    return isType(type) && (type.flags & TypeFlags.Frozen) > 0;
}

function getInvalidationCause(hook) {
    switch (hook) {
        case Hook.beforeDestroy:
            return "destroy";
        case Hook.beforeDetach:
            return "detach";
        default:
            return undefined;
    }
}
var StoredReference = /** @class */ (function () {
    function StoredReference(value, targetType) {
        Object.defineProperty(this, "targetType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: targetType
        });
        Object.defineProperty(this, "identifier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "node", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resolvedReference", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (isValidIdentifier(value)) {
            this.identifier = value;
        }
        else if (isStateTreeNode(value)) {
            var targetNode = getStateTreeNode(value);
            if (!targetNode.identifierAttribute)
                throw new MstError("Can only store references with a defined identifier attribute.");
            var id = targetNode.unnormalizedIdentifier;
            if (id === null || id === undefined) {
                throw new MstError("Can only store references to tree nodes with a defined identifier.");
            }
            this.identifier = id;
        }
        else {
            throw new MstError("Can only store references to tree nodes or identifiers, got: '".concat(value, "'"));
        }
    }
    Object.defineProperty(StoredReference.prototype, "updateResolvedReference", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            var normalizedId = normalizeIdentifier(this.identifier);
            var root = node.root;
            var lastCacheModification = root.identifierCache.getLastCacheModificationPerId(normalizedId);
            if (!this.resolvedReference ||
                this.resolvedReference.lastCacheModification !== lastCacheModification) {
                var targetType = this.targetType;
                // reference was initialized with the identifier of the target
                var target = root.identifierCache.resolve(targetType, normalizedId);
                if (!target) {
                    throw new InvalidReferenceError("[mobx-state-tree] Failed to resolve reference '".concat(this.identifier, "' to type '").concat(this.targetType.name, "' (from node: ").concat(node.path, ")"));
                }
                this.resolvedReference = {
                    node: target,
                    lastCacheModification: lastCacheModification
                };
            }
        }
    });
    Object.defineProperty(StoredReference.prototype, "resolvedValue", {
        get: function () {
            this.updateResolvedReference(this.node);
            return this.resolvedReference.node.value;
        },
        enumerable: false,
        configurable: true
    });
    return StoredReference;
}());
/**
 * @internal
 * @hidden
 */
var InvalidReferenceError = /** @class */ (function (_super) {
    __extends(InvalidReferenceError, _super);
    function InvalidReferenceError(m) {
        var _this = _super.call(this, m) || this;
        Object.setPrototypeOf(_this, InvalidReferenceError.prototype);
        return _this;
    }
    return InvalidReferenceError;
}(Error));
/**
 * @internal
 * @hidden
 */
var BaseReferenceType = /** @class */ (function (_super) {
    __extends(BaseReferenceType, _super);
    function BaseReferenceType(targetType, onInvalidated) {
        var _this = _super.call(this, "reference(".concat(targetType.name, ")")) || this;
        Object.defineProperty(_this, "targetType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: targetType
        });
        Object.defineProperty(_this, "onInvalidated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: onInvalidated
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Reference
        });
        return _this;
    }
    Object.defineProperty(BaseReferenceType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.name;
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "isAssignableFrom", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (type) {
            return this.targetType.isAssignableFrom(type);
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            return isValidIdentifier(value)
                ? typeCheckSuccess()
                : typeCheckFailure(context, value, "Value is not a valid identifier, which is a string or a number");
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "fireInvalidated", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (cause, storedRefNode, referenceId, refTargetNode) {
            // to actually invalidate a reference we need an alive parent,
            // since it is a scalar value (immutable-ish) and we need to change it
            // from the parent
            var storedRefParentNode = storedRefNode.parent;
            if (!storedRefParentNode || !storedRefParentNode.isAlive) {
                return;
            }
            var storedRefParentValue = storedRefParentNode.storedValue;
            if (!storedRefParentValue) {
                return;
            }
            this.onInvalidated({
                cause: cause,
                parent: storedRefParentValue,
                invalidTarget: refTargetNode ? refTargetNode.storedValue : undefined,
                invalidId: referenceId,
                replaceRef: function (newRef) {
                    applyPatch(storedRefNode.root.storedValue, {
                        op: "replace",
                        value: newRef,
                        path: storedRefNode.path
                    });
                },
                removeRef: function () {
                    if (isModelType(storedRefParentNode.type)) {
                        this.replaceRef(undefined);
                    }
                    else {
                        applyPatch(storedRefNode.root.storedValue, {
                            op: "remove",
                            path: storedRefNode.path
                        });
                    }
                }
            });
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "addTargetNodeWatcher", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (storedRefNode, referenceId) {
            var _this = this;
            // this will make sure the target node becomes created
            var refTargetValue = this.getValue(storedRefNode);
            if (!refTargetValue) {
                return undefined;
            }
            var refTargetNode = getStateTreeNode(refTargetValue);
            var hookHandler = function (_, refTargetNodeHook) {
                var cause = getInvalidationCause(refTargetNodeHook);
                if (!cause) {
                    return;
                }
                _this.fireInvalidated(cause, storedRefNode, referenceId, refTargetNode);
            };
            var refTargetDetachHookDisposer = refTargetNode.registerHook(Hook.beforeDetach, hookHandler);
            var refTargetDestroyHookDisposer = refTargetNode.registerHook(Hook.beforeDestroy, hookHandler);
            return function () {
                refTargetDetachHookDisposer();
                refTargetDestroyHookDisposer();
            };
        }
    });
    Object.defineProperty(BaseReferenceType.prototype, "watchTargetNodeForInvalidations", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (storedRefNode, identifier, customGetSet) {
            var _this = this;
            if (!this.onInvalidated) {
                return;
            }
            var onRefTargetDestroyedHookDisposer;
            // get rid of the watcher hook when the stored ref node is destroyed
            // detached is ignored since scalar nodes (where the reference resides) cannot be detached
            storedRefNode.registerHook(Hook.beforeDestroy, function () {
                if (onRefTargetDestroyedHookDisposer) {
                    onRefTargetDestroyedHookDisposer();
                }
            });
            var startWatching = function (sync) {
                // re-create hook in case the stored ref gets reattached
                if (onRefTargetDestroyedHookDisposer) {
                    onRefTargetDestroyedHookDisposer();
                }
                // make sure the target node is actually there and initialized
                var storedRefParentNode = storedRefNode.parent;
                var storedRefParentValue = storedRefParentNode && storedRefParentNode.storedValue;
                if (storedRefParentNode && storedRefParentNode.isAlive && storedRefParentValue) {
                    var refTargetNodeExists = void 0;
                    if (customGetSet) {
                        refTargetNodeExists = !!customGetSet.get(identifier, storedRefParentValue);
                    }
                    else {
                        refTargetNodeExists = storedRefNode.root.identifierCache.has(_this.targetType, normalizeIdentifier(identifier));
                    }
                    if (!refTargetNodeExists) {
                        // we cannot change the reference in sync mode
                        // since we are in the middle of a reconciliation/instantiation and the change would be overwritten
                        // for those cases just let the wrong reference be assigned and fail upon usage
                        // (like current references do)
                        // this means that effectively this code will only run when it is created from a snapshot
                        if (!sync) {
                            _this.fireInvalidated("invalidSnapshotReference", storedRefNode, identifier, null);
                        }
                    }
                    else {
                        onRefTargetDestroyedHookDisposer = _this.addTargetNodeWatcher(storedRefNode, identifier);
                    }
                }
            };
            if (storedRefNode.state === NodeLifeCycle.FINALIZED) {
                // already attached, so the whole tree is ready
                startWatching(true);
            }
            else {
                if (!storedRefNode.isRoot) {
                    // start watching once the whole tree is ready
                    storedRefNode.root.registerHook(Hook.afterCreationFinalization, function () {
                        // make sure to attach it so it can start listening
                        if (storedRefNode.parent) {
                            storedRefNode.parent.createObservableInstanceIfNeeded();
                        }
                    });
                }
                // start watching once the node is attached somewhere / parent changes
                storedRefNode.registerHook(Hook.afterAttach, function () {
                    startWatching(false);
                });
            }
        }
    });
    return BaseReferenceType;
}(SimpleType));
/**
 * @internal
 * @hidden
 */
var IdentifierReferenceType = /** @class */ (function (_super) {
    __extends(IdentifierReferenceType, _super);
    function IdentifierReferenceType(targetType, onInvalidated) {
        return _super.call(this, targetType, onInvalidated) || this;
    }
    Object.defineProperty(IdentifierReferenceType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (storedRefNode) {
            if (!storedRefNode.isAlive)
                return undefined;
            var storedRef = storedRefNode.storedValue;
            return storedRef.resolvedValue;
        }
    });
    Object.defineProperty(IdentifierReferenceType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (storedRefNode) {
            var ref = storedRefNode.storedValue;
            return ref.identifier;
        }
    });
    Object.defineProperty(IdentifierReferenceType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            var identifier = isStateTreeNode(initialValue) ? getIdentifier(initialValue) : initialValue;
            var storedRef = new StoredReference(initialValue, this.targetType);
            var storedRefNode = createScalarNode(this, parent, subpath, environment, storedRef);
            storedRef.node = storedRefNode;
            this.watchTargetNodeForInvalidations(storedRefNode, identifier, undefined);
            return storedRefNode;
        }
    });
    Object.defineProperty(IdentifierReferenceType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            if (!current.isDetaching && current.type === this) {
                var compareByValue = isStateTreeNode(newValue);
                var ref = current.storedValue;
                if ((!compareByValue && ref.identifier === newValue) ||
                    (compareByValue && ref.resolvedValue === newValue)) {
                    current.setParent(parent, subpath);
                    return current;
                }
            }
            var newNode = this.instantiate(parent, subpath, undefined, newValue);
            current.die(); // noop if detaching
            return newNode;
        }
    });
    return IdentifierReferenceType;
}(BaseReferenceType));
/**
 * @internal
 * @hidden
 */
var CustomReferenceType = /** @class */ (function (_super) {
    __extends(CustomReferenceType, _super);
    function CustomReferenceType(targetType, options, onInvalidated) {
        var _this = _super.call(this, targetType, onInvalidated) || this;
        Object.defineProperty(_this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        return _this;
    }
    Object.defineProperty(CustomReferenceType.prototype, "getValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (storedRefNode) {
            if (!storedRefNode.isAlive)
                return undefined;
            var referencedNode = this.options.get(storedRefNode.storedValue, storedRefNode.parent ? storedRefNode.parent.storedValue : null);
            return referencedNode;
        }
    });
    Object.defineProperty(CustomReferenceType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (storedRefNode) {
            return storedRefNode.storedValue;
        }
    });
    Object.defineProperty(CustomReferenceType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, newValue) {
            var identifier = isStateTreeNode(newValue)
                ? this.options.set(newValue, parent ? parent.storedValue : null)
                : newValue;
            var storedRefNode = createScalarNode(this, parent, subpath, environment, identifier);
            this.watchTargetNodeForInvalidations(storedRefNode, identifier, this.options);
            return storedRefNode;
        }
    });
    Object.defineProperty(CustomReferenceType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            var newIdentifier = isStateTreeNode(newValue)
                ? this.options.set(newValue, current ? current.storedValue : null)
                : newValue;
            if (!current.isDetaching && current.type === this && current.storedValue === newIdentifier) {
                current.setParent(parent, subpath);
                return current;
            }
            var newNode = this.instantiate(parent, subpath, undefined, newIdentifier);
            current.die(); // noop if detaching
            return newNode;
        }
    });
    return CustomReferenceType;
}(BaseReferenceType));
/**
 * `types.reference` - Creates a reference to another type, which should have defined an identifier.
 * See also the [reference and identifiers](https://github.com/mobxjs/mobx-state-tree#references-and-identifiers) section.
 */
function reference(subType, options) {
    assertIsType(subType, 1);
    if (devMode()) {
        if (arguments.length === 2 && typeof arguments[1] === "string") {
            // istanbul ignore next
            throw new MstError("References with base path are no longer supported. Please remove the base path.");
        }
    }
    var getSetOptions = options ? options : undefined;
    var onInvalidated = options
        ? options.onInvalidated
        : undefined;
    if (getSetOptions && (getSetOptions.get || getSetOptions.set)) {
        if (devMode()) {
            if (!getSetOptions.get || !getSetOptions.set) {
                throw new MstError("reference options must either contain both a 'get' and a 'set' method or none of them");
            }
        }
        return new CustomReferenceType(subType, {
            get: getSetOptions.get,
            set: getSetOptions.set
        }, onInvalidated);
    }
    else {
        return new IdentifierReferenceType(subType, onInvalidated);
    }
}
/**
 * Returns if a given value represents a reference type.
 *
 * @param type
 * @returns
 */
function isReferenceType(type) {
    return (type.flags & TypeFlags.Reference) > 0;
}
/**
 * `types.safeReference` - A safe reference is like a standard reference, except that it accepts the undefined value by default
 * and automatically sets itself to undefined (when the parent is a model) / removes itself from arrays and maps
 * when the reference it is pointing to gets detached/destroyed.
 *
 * The optional options parameter object accepts a parameter named `acceptsUndefined`, which is set to true by default, so it is suitable
 * for model properties.
 * When used inside collections (arrays/maps), it is recommended to set this option to false so it can't take undefined as value,
 * which is usually the desired in those cases.
 * Additionally, the optional options parameter object accepts a parameter named `onInvalidated`, which will be called when the reference target node that the reference is pointing to is about to be detached/destroyed
 *
 * Strictly speaking it is a `types.maybe(types.reference(X))` (when `acceptsUndefined` is set to true, the default) and
 * `types.reference(X)` (when `acceptsUndefined` is set to false), both of them with a customized `onInvalidated` option.
 *
 * @param subType
 * @param options
 * @returns
 */
function safeReference(subType, options) {
    var refType = reference(subType, __assign(__assign({}, options), { onInvalidated: function (ev) {
            if (options && options.onInvalidated) {
                options.onInvalidated(ev);
            }
            ev.removeRef();
        } }));
    if (options && options.acceptsUndefined === false) {
        return refType;
    }
    else {
        return maybe(refType);
    }
}

var BaseIdentifierType = /** @class */ (function (_super) {
    __extends(BaseIdentifierType, _super);
    function BaseIdentifierType(name, validType) {
        var _this = _super.call(this, name) || this;
        Object.defineProperty(_this, "validType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: validType
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Identifier
        });
        return _this;
    }
    Object.defineProperty(BaseIdentifierType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            if (!parent || !(parent.type instanceof ModelType))
                throw new MstError("Identifier types can only be instantiated as direct child of a model type");
            return createScalarNode(this, parent, subpath, environment, initialValue);
        }
    });
    Object.defineProperty(BaseIdentifierType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, newValue, parent, subpath) {
            // we don't consider detaching here since identifier are scalar nodes, and scalar nodes cannot be detached
            if (current.storedValue !== newValue)
                throw new MstError("Tried to change identifier from '".concat(current.storedValue, "' to '").concat(newValue, "'. Changing identifiers is not allowed."));
            current.setParent(parent, subpath);
            return current;
        }
    });
    Object.defineProperty(BaseIdentifierType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (typeof value !== this.validType) {
                return typeCheckFailure(context, value, "Value is not a valid ".concat(this.describe(), ", expected a ").concat(this.validType));
            }
            return typeCheckSuccess();
        }
    });
    return BaseIdentifierType;
}(SimpleType));
/**
 * @internal
 * @hidden
 */
var IdentifierType = /** @class */ (function (_super) {
    __extends(IdentifierType, _super);
    function IdentifierType() {
        var _this = _super.call(this, "identifier", "string") || this;
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Identifier
        });
        return _this;
    }
    Object.defineProperty(IdentifierType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return "identifier";
        }
    });
    return IdentifierType;
}(BaseIdentifierType));
/**
 * @internal
 * @hidden
 */
var IdentifierNumberType = /** @class */ (function (_super) {
    __extends(IdentifierNumberType, _super);
    function IdentifierNumberType() {
        return _super.call(this, "identifierNumber", "number") || this;
    }
    Object.defineProperty(IdentifierNumberType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            return node.storedValue;
        }
    });
    Object.defineProperty(IdentifierNumberType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return "identifierNumber";
        }
    });
    return IdentifierNumberType;
}(BaseIdentifierType));
/**
 * `types.identifier` - Identifiers are used to make references, lifecycle events and reconciling works.
 * Inside a state tree, for each type can exist only one instance for each given identifier.
 * For example there couldn't be 2 instances of user with id 1. If you need more, consider using references.
 * Identifier can be used only as type property of a model.
 * This type accepts as parameter the value type of the identifier field that can be either string or number.
 *
 * Example:
 * ```ts
 *  const Todo = types.model("Todo", {
 *      id: types.identifier,
 *      title: types.string
 *  })
 * ```
 *
 * @returns
 */
var identifier = new IdentifierType();
/**
 * `types.identifierNumber` - Similar to `types.identifier`. This one will serialize from / to a number when applying snapshots
 *
 * Example:
 * ```ts
 *  const Todo = types.model("Todo", {
 *      id: types.identifierNumber,
 *      title: types.string
 *  })
 * ```
 *
 * @returns
 */
var identifierNumber = new IdentifierNumberType();
/**
 * Returns if a given value represents an identifier type.
 *
 * @param type
 * @returns
 */
function isIdentifierType(type) {
    return isType(type) && (type.flags & TypeFlags.Identifier) > 0;
}
/**
 * @internal
 * @hidden
 */
function normalizeIdentifier(id) {
    return "" + id;
}
/**
 * @internal
 * @hidden
 */
function isValidIdentifier(id) {
    return typeof id === "string" || typeof id === "number";
}
/**
 * @internal
 * @hidden
 */
function assertIsValidIdentifier(id, argNumber) {
    assertArg(id, isValidIdentifier, "string or number (identifier)", argNumber);
}

/**
 * `types.custom` - Creates a custom type. Custom types can be used for arbitrary immutable values, that have a serializable representation. For example, to create your own Date representation, Decimal type etc.
 *
 * The signature of the options is:
 * ```ts
 * export interface CustomTypeOptions<S, T> {
 *     // Friendly name
 *     name: string
 *     // given a serialized value and environment, how to turn it into the target type
 *     fromSnapshot(snapshot: S, env: any): T
 *     // return the serialization of the current value
 *     toSnapshot(value: T): S
 *     // if true, this is a converted value, if false, it's a snapshot
 *     isTargetType(value: T | S): value is T
 *     // a non empty string is assumed to be a validation error
 *     getValidationMessage?(snapshot: S): string
 * }
 * ```
 *
 * Example:
 * ```ts
 * const DecimalPrimitive = types.custom<string, Decimal>({
 *     name: "Decimal",
 *     fromSnapshot(value: string) {
 *         return new Decimal(value)
 *     },
 *     toSnapshot(value: Decimal) {
 *         return value.toString()
 *     },
 *     isTargetType(value: string | Decimal): boolean {
 *         return value instanceof Decimal
 *     },
 *     getValidationMessage(value: string): string {
 *         if (/^-?\d+\.\d+$/.test(value)) return "" // OK
 *         return `'${value}' doesn't look like a valid decimal number`
 *     }
 * })
 *
 * const Wallet = types.model({
 *     balance: DecimalPrimitive
 * })
 * ```
 *
 * @param options
 * @returns
 */
function custom(options) {
    return new CustomType(options);
}
/**
 * @internal
 * @hidden
 */
var CustomType = /** @class */ (function (_super) {
    __extends(CustomType, _super);
    function CustomType(options) {
        var _this = _super.call(this, options.name) || this;
        Object.defineProperty(_this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: options
        });
        Object.defineProperty(_this, "flags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: TypeFlags.Custom
        });
        return _this;
    }
    Object.defineProperty(CustomType.prototype, "describe", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.name;
        }
    });
    Object.defineProperty(CustomType.prototype, "isValidSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value, context) {
            if (this.options.isTargetType(value))
                return typeCheckSuccess();
            var typeError = this.options.getValidationMessage(value);
            if (typeError) {
                return typeCheckFailure(context, value, "Invalid value for type '".concat(this.name, "': ").concat(typeError));
            }
            return typeCheckSuccess();
        }
    });
    Object.defineProperty(CustomType.prototype, "getSnapshot", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (node) {
            return this.options.toSnapshot(node.storedValue);
        }
    });
    Object.defineProperty(CustomType.prototype, "instantiate", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (parent, subpath, environment, initialValue) {
            var valueToStore = this.options.isTargetType(initialValue)
                ? initialValue
                : this.options.fromSnapshot(initialValue, parent && parent.root.environment);
            return createScalarNode(this, parent, subpath, environment, valueToStore);
        }
    });
    Object.defineProperty(CustomType.prototype, "reconcile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (current, value, parent, subpath) {
            var isSnapshot = !this.options.isTargetType(value);
            // in theory customs use scalar nodes which cannot be detached, but still...
            if (!current.isDetaching) {
                var unchanged = current.type === this &&
                    (isSnapshot ? value === current.snapshot : value === current.storedValue);
                if (unchanged) {
                    current.setParent(parent, subpath);
                    return current;
                }
            }
            var valueToStore = isSnapshot
                ? this.options.fromSnapshot(value, parent.root.environment)
                : value;
            var newNode = this.instantiate(parent, subpath, undefined, valueToStore);
            current.die(); // noop if detaching
            return newNode;
        }
    });
    return CustomType;
}(SimpleType));

// we import the types to re-export them inside types.
var types = {
    enumeration: enumeration,
    model: model,
    compose: compose,
    custom: custom,
    reference: reference,
    safeReference: safeReference,
    union: union,
    optional: optional,
    literal: literal,
    maybe: maybe,
    maybeNull: maybeNull,
    refinement: refinement,
    string: string,
    boolean: boolean,
    number: number,
    integer: integer,
    float: float,
    finite: finite,
    Date: DatePrimitive,
    map: map,
    array: array,
    frozen: frozen,
    identifier: identifier,
    identifierNumber: identifierNumber,
    late: late,
    lazy: lazy,
    undefined: undefinedType,
    null: nullType,
    snapshotProcessor: snapshotProcessor
};




/***/ }),

/***/ 97072:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $mobx: () => (/* binding */ $mobx),
/* harmony export */   FlowCancellationError: () => (/* binding */ FlowCancellationError),
/* harmony export */   ObservableMap: () => (/* binding */ ObservableMap),
/* harmony export */   ObservableSet: () => (/* binding */ ObservableSet),
/* harmony export */   Reaction: () => (/* binding */ Reaction),
/* harmony export */   _allowStateChanges: () => (/* binding */ allowStateChanges),
/* harmony export */   _allowStateChangesInsideComputed: () => (/* binding */ runInAction),
/* harmony export */   _allowStateReadsEnd: () => (/* binding */ allowStateReadsEnd),
/* harmony export */   _allowStateReadsStart: () => (/* binding */ allowStateReadsStart),
/* harmony export */   _autoAction: () => (/* binding */ autoAction),
/* harmony export */   _endAction: () => (/* binding */ _endAction),
/* harmony export */   _getAdministration: () => (/* binding */ getAdministration),
/* harmony export */   _getGlobalState: () => (/* binding */ getGlobalState),
/* harmony export */   _interceptReads: () => (/* binding */ interceptReads),
/* harmony export */   _isComputingDerivation: () => (/* binding */ isComputingDerivation),
/* harmony export */   _resetGlobalState: () => (/* binding */ resetGlobalState),
/* harmony export */   _startAction: () => (/* binding */ _startAction),
/* harmony export */   action: () => (/* binding */ action),
/* harmony export */   autorun: () => (/* binding */ autorun),
/* harmony export */   comparer: () => (/* binding */ comparer),
/* harmony export */   computed: () => (/* binding */ computed),
/* harmony export */   configure: () => (/* binding */ configure),
/* harmony export */   createAtom: () => (/* binding */ createAtom),
/* harmony export */   defineProperty: () => (/* binding */ apiDefineProperty),
/* harmony export */   entries: () => (/* binding */ entries),
/* harmony export */   extendObservable: () => (/* binding */ extendObservable),
/* harmony export */   flow: () => (/* binding */ flow),
/* harmony export */   flowResult: () => (/* binding */ flowResult),
/* harmony export */   get: () => (/* binding */ get),
/* harmony export */   getAtom: () => (/* binding */ getAtom),
/* harmony export */   getDebugName: () => (/* binding */ getDebugName),
/* harmony export */   getDependencyTree: () => (/* binding */ getDependencyTree),
/* harmony export */   getObserverTree: () => (/* binding */ getObserverTree),
/* harmony export */   has: () => (/* binding */ has),
/* harmony export */   intercept: () => (/* binding */ intercept),
/* harmony export */   isAction: () => (/* binding */ isAction),
/* harmony export */   isBoxedObservable: () => (/* binding */ isObservableValue),
/* harmony export */   isComputed: () => (/* binding */ isComputed),
/* harmony export */   isComputedProp: () => (/* binding */ isComputedProp),
/* harmony export */   isFlow: () => (/* binding */ isFlow),
/* harmony export */   isFlowCancellationError: () => (/* binding */ isFlowCancellationError),
/* harmony export */   isObservable: () => (/* binding */ isObservable),
/* harmony export */   isObservableArray: () => (/* binding */ isObservableArray),
/* harmony export */   isObservableMap: () => (/* binding */ isObservableMap),
/* harmony export */   isObservableObject: () => (/* binding */ isObservableObject),
/* harmony export */   isObservableProp: () => (/* binding */ isObservableProp),
/* harmony export */   isObservableSet: () => (/* binding */ isObservableSet),
/* harmony export */   keys: () => (/* binding */ keys),
/* harmony export */   makeAutoObservable: () => (/* binding */ makeAutoObservable),
/* harmony export */   makeObservable: () => (/* binding */ makeObservable),
/* harmony export */   observable: () => (/* binding */ observable),
/* harmony export */   observe: () => (/* binding */ observe),
/* harmony export */   onBecomeObserved: () => (/* binding */ onBecomeObserved),
/* harmony export */   onBecomeUnobserved: () => (/* binding */ onBecomeUnobserved),
/* harmony export */   onReactionError: () => (/* binding */ onReactionError),
/* harmony export */   override: () => (/* binding */ override),
/* harmony export */   ownKeys: () => (/* binding */ apiOwnKeys),
/* harmony export */   reaction: () => (/* binding */ reaction),
/* harmony export */   remove: () => (/* binding */ remove),
/* harmony export */   runInAction: () => (/* binding */ runInAction),
/* harmony export */   set: () => (/* binding */ set),
/* harmony export */   spy: () => (/* binding */ spy),
/* harmony export */   toJS: () => (/* binding */ toJS),
/* harmony export */   trace: () => (/* binding */ trace),
/* harmony export */   transaction: () => (/* binding */ transaction),
/* harmony export */   untracked: () => (/* binding */ untracked),
/* harmony export */   values: () => (/* binding */ values),
/* harmony export */   when: () => (/* binding */ when)
/* harmony export */ });
var niceErrors = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function _(annotationType, key) {
    return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function _(index, length) {
    return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function _(other) {
    return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
  },
  20: function _(other) {
    return "Cannot initialize map from " + other;
  },
  21: function _(dataStructure) {
    return "Cannot convert to map from '" + dataStructure + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function _(thing) {
    return "Cannot obtain administration from " + thing;
  },
  25: function _(property, name) {
    return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
  },
  26: "please specify a property",
  27: function _(property, name) {
    return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
  },
  28: function _(thing) {
    return "Cannot obtain atom from " + thing;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function _(name, derivation) {
    return "Cycle detected in computation " + name + ": " + derivation;
  },
  33: function _(name) {
    return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function _(name) {
    return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function _(method) {
    return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
};
var errors =  false ? 0 : {};
function die(error) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (false) { var e; }
  throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}

var mockGlobal = {};
function getGlobal() {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof __webpack_require__.g !== "undefined") {
    return __webpack_require__.g;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  return mockGlobal;
}

// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/Object.toString();
function assertProxies() {
  if (!hasProxy) {
    die( false ? 0 : "Proxy not available");
  }
}
function warnAboutProxyRequirement(msg) {
  if (false) {}
}
function getNextId() {
  return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
  var invoked = false;
  return function () {
    if (invoked) {
      return;
    }
    invoked = true;
    return func.apply(this, arguments);
  };
}
var noop = function noop() {};
function isFunction(fn) {
  return typeof fn === "function";
}
function isStringish(value) {
  var t = typeof value;
  switch (t) {
    case "string":
    case "symbol":
    case "number":
      return true;
  }
  return false;
}
function isObject(value) {
  return value !== null && typeof value === "object";
}
function isPlainObject(value) {
  if (!isObject(value)) {
    return false;
  }
  var proto = Object.getPrototypeOf(value);
  if (proto == null) {
    return true;
  }
  var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
  var constructor = obj == null ? void 0 : obj.constructor;
  if (!constructor) {
    return false;
  }
  if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) {
    return true;
  }
  return false;
}
function addHiddenProp(object, propName, value) {
  defineProperty(object, propName, {
    enumerable: false,
    writable: true,
    configurable: true,
    value: value
  });
}
function addHiddenFinalProp(object, propName, value) {
  defineProperty(object, propName, {
    enumerable: false,
    writable: false,
    configurable: true,
    value: value
  });
}
function createInstanceofPredicate(name, theClass) {
  var propName = "isMobX" + name;
  theClass.prototype[propName] = true;
  return function (x) {
    return isObject(x) && x[propName] === true;
  };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */
function isES6Map(thing) {
  return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */
function isPlainES6Map(thing) {
  var mapProto = Object.getPrototypeOf(thing);
  var objectProto = Object.getPrototypeOf(mapProto);
  var nullProto = Object.getPrototypeOf(objectProto);
  return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */
function isES6Set(thing) {
  return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */
function getPlainObjectKeys(object) {
  var keys = Object.keys(object);
  // Not supported in IE, so there are not going to be symbol props anyway...
  if (!hasGetOwnPropertySymbols) {
    return keys;
  }
  var symbols = Object.getOwnPropertySymbols(object);
  if (!symbols.length) {
    return keys;
  }
  return [].concat(keys, symbols.filter(function (s) {
    return objectPrototype.propertyIsEnumerable.call(object, s);
  }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function (obj) {
  return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */Object.getOwnPropertyNames;
function stringifyKey(key) {
  if (typeof key === "string") {
    return key;
  }
  if (typeof key === "symbol") {
    return key.toString();
  }
  return new String(key).toString();
}
function toPrimitive(value) {
  return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
  return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
  // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
  var res = {};
  // Note: without polyfill for ownKeys, symbols won't be picked up
  ownKeys(target).forEach(function (key) {
    res[key] = getDescriptor(target, key);
  });
  return res;
};
function getFlag(flags, mask) {
  return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
  if (newValue) {
    flags |= mask;
  } else {
    flags &= ~mask;
  }
  return flags;
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var storedAnnotationsSymbol = /*#__PURE__*/Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */
function createDecoratorAnnotation(annotation) {
  function decorator(target, property) {
    if (is20223Decorator(property)) {
      return annotation.decorate_20223_(target, property);
    } else {
      storeAnnotation(target, property, annotation);
    }
  }
  return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */
function storeAnnotation(prototype, key, annotation) {
  if (!hasProp(prototype, storedAnnotationsSymbol)) {
    addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
  }
  // @override must override something
  if (false) { var fieldName; }
  // Cannot re-decorate
  assertNotDecorated(prototype, annotation, key);
  // Ignore override
  if (!isOverride(annotation)) {
    prototype[storedAnnotationsSymbol][key] = annotation;
  }
}
function assertNotDecorated(prototype, annotation, key) {
  if (false) { var requestedAnnotationType, currentAnnotationType, fieldName; }
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */
function collectStoredAnnotations(target) {
  if (!hasProp(target, storedAnnotationsSymbol)) {
    // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
  }
  return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
  return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {
  if (false) {}
}

var $mobx = /*#__PURE__*/Symbol("mobx administration");
var Atom = /*#__PURE__*/function () {
  /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */
  function Atom(name_) {
    if (name_ === void 0) {
      name_ =  false ? 0 : "Atom";
    }
    this.name_ = void 0;
    this.flags_ = 0;
    this.observers_ = new Set();
    this.lastAccessedBy_ = 0;
    this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
    // onBecomeObservedListeners
    this.onBOL = void 0;
    // onBecomeUnobservedListeners
    this.onBUOL = void 0;
    this.name_ = name_;
  }
  // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
  var _proto = Atom.prototype;
  _proto.onBO = function onBO() {
    if (this.onBOL) {
      this.onBOL.forEach(function (listener) {
        return listener();
      });
    }
  };
  _proto.onBUO = function onBUO() {
    if (this.onBUOL) {
      this.onBUOL.forEach(function (listener) {
        return listener();
      });
    }
  }
  /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */;
  _proto.reportObserved = function reportObserved$1() {
    return reportObserved(this);
  }
  /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */;
  _proto.reportChanged = function reportChanged() {
    startBatch();
    propagateChanged(this);
    endBatch();
  };
  _proto.toString = function toString() {
    return this.name_;
  };
  return _createClass(Atom, [{
    key: "isBeingObserved",
    get: function get() {
      return getFlag(this.flags_, Atom.isBeingObservedMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
    }
  }, {
    key: "isPendingUnobservation",
    get: function get() {
      return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
    }
  }, {
    key: "diffValue",
    get: function get() {
      return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
    }
  }]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
  if (onBecomeObservedHandler === void 0) {
    onBecomeObservedHandler = noop;
  }
  if (onBecomeUnobservedHandler === void 0) {
    onBecomeUnobservedHandler = noop;
  }
  var atom = new Atom(name);
  // default `noop` listener will not initialize the hook Set
  if (onBecomeObservedHandler !== noop) {
    onBecomeObserved(atom, onBecomeObservedHandler);
  }
  if (onBecomeUnobservedHandler !== noop) {
    onBecomeUnobserved(atom, onBecomeUnobservedHandler);
  }
  return atom;
}

function identityComparer(a, b) {
  return a === b;
}
function structuralComparer(a, b) {
  return deepEqual(a, b);
}
function shallowComparer(a, b) {
  return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
  if (Object.is) {
    return Object.is(a, b);
  }
  return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
  identity: identityComparer,
  structural: structuralComparer,
  "default": defaultComparer,
  shallow: shallowComparer
};

function deepEnhancer(v, _, name) {
  // it is an observable already, done
  if (isObservable(v)) {
    return v;
  }
  // something that can be converted and mutated?
  if (Array.isArray(v)) {
    return observable.array(v, {
      name: name
    });
  }
  if (isPlainObject(v)) {
    return observable.object(v, undefined, {
      name: name
    });
  }
  if (isES6Map(v)) {
    return observable.map(v, {
      name: name
    });
  }
  if (isES6Set(v)) {
    return observable.set(v, {
      name: name
    });
  }
  if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
    if (isGenerator(v)) {
      return flow(v);
    } else {
      return autoAction(name, v);
    }
  }
  return v;
}
function shallowEnhancer(v, _, name) {
  if (v === undefined || v === null) {
    return v;
  }
  if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) {
    return v;
  }
  if (Array.isArray(v)) {
    return observable.array(v, {
      name: name,
      deep: false
    });
  }
  if (isPlainObject(v)) {
    return observable.object(v, undefined, {
      name: name,
      deep: false
    });
  }
  if (isES6Map(v)) {
    return observable.map(v, {
      name: name,
      deep: false
    });
  }
  if (isES6Set(v)) {
    return observable.set(v, {
      name: name,
      deep: false
    });
  }
  if (false) {}
}
function referenceEnhancer(newValue) {
  // never turn into an observable
  return newValue;
}
function refStructEnhancer(v, oldValue) {
  if (false) {}
  if (deepEqual(v, oldValue)) {
    return oldValue;
  }
  return v;
}

var OVERRIDE = "override";
var override = /*#__PURE__*/createDecoratorAnnotation({
  annotationType_: OVERRIDE,
  make_: make_,
  extend_: extend_,
  decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
  return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
  // Must not be plain object
  if (false) {}
  // Must override something
  if (false) {}
  return 0 /* MakeResult.Cancel */;
}
function extend_(adm, key, descriptor, proxyTrap) {
  die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
  console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}

function createActionAnnotation(name, options) {
  return {
    annotationType_: name,
    options_: options,
    make_: make_$1,
    extend_: extend_$1,
    decorate_20223_: decorate_20223_$1
  };
}
function make_$1(adm, key, descriptor, source) {
  var _this$options_;
  // bound
  if ((_this$options_ = this.options_) != null && _this$options_.bound) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */ : 1 /* MakeResult.Break */;
  }
  // own
  if (source === adm.target_) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */ : 2 /* MakeResult.Continue */;
  }
  // prototype
  if (isAction(descriptor.value)) {
    // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */;
  }
  var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
  defineProperty(source, key, actionDescriptor);
  return 2 /* MakeResult.Continue */;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
  var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
  return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
  if (false) {}
  var kind = context.kind,
    name = context.name,
    addInitializer = context.addInitializer;
  var ann = this;
  var _createAction = function _createAction(m) {
    var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
    return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
  };
  // Backwards/Legacy behavior, expects makeObservable(this)
  if (kind == "field") {
    addInitializer(function () {
      storeAnnotation(this, name, ann);
    });
    return;
  }
  if (kind == "method") {
    var _this$options_2;
    if (!isAction(mthd)) {
      mthd = _createAction(mthd);
    }
    if ((_this$options_2 = this.options_) != null && _this$options_2.bound) {
      addInitializer(function () {
        var self = this;
        var bound = self[name].bind(self);
        bound.isMobxAction = true;
        self[name] = bound;
      });
    }
    return mthd;
  }
  die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
  var annotationType_ = _ref.annotationType_;
  var value = _ref2.value;
  if (false) {}
}
function createActionDescriptor(adm, annotation, key, descriptor,
// provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
  var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
  if (safeDescriptors === void 0) {
    safeDescriptors = globalState.safeDescriptors;
  }
  assertActionDescriptor(adm, annotation, key, descriptor);
  var value = descriptor.value;
  if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
    var _adm$proxy_;
    value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
  }
  return {
    value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false,
    // https://github.com/mobxjs/mobx/discussions/3140
    (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: safeDescriptors ? adm.isPlainObject_ : true,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: false,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: safeDescriptors ? false : true
  };
}

function createFlowAnnotation(name, options) {
  return {
    annotationType_: name,
    options_: options,
    make_: make_$2,
    extend_: extend_$2,
    decorate_20223_: decorate_20223_$2
  };
}
function make_$2(adm, key, descriptor, source) {
  var _this$options_;
  // own
  if (source === adm.target_) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */ : 2 /* MakeResult.Continue */;
  }
  // prototype
  // bound - must annotate protos to support super.flow()
  if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
    if (this.extend_(adm, key, descriptor, false) === null) {
      return 0 /* MakeResult.Cancel */;
    }
  }
  if (isFlow(descriptor.value)) {
    // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */;
  }
  var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
  defineProperty(source, key, flowDescriptor);
  return 2 /* MakeResult.Continue */;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
  var _this$options_2;
  var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
  return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
  var _this$options_3;
  if (false) {}
  var name = context.name,
    addInitializer = context.addInitializer;
  if (!isFlow(mthd)) {
    mthd = flow(mthd);
  }
  if ((_this$options_3 = this.options_) != null && _this$options_3.bound) {
    addInitializer(function () {
      var self = this;
      var bound = self[name].bind(self);
      bound.isMobXFlow = true;
      self[name] = bound;
    });
  }
  return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
  var annotationType_ = _ref.annotationType_;
  var value = _ref2.value;
  if (false) {}
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound,
// provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
  if (safeDescriptors === void 0) {
    safeDescriptors = globalState.safeDescriptors;
  }
  assertFlowDescriptor(adm, annotation, key, descriptor);
  var value = descriptor.value;
  // In case of flow.bound, the descriptor can be from already annotated prototype
  if (!isFlow(value)) {
    value = flow(value);
  }
  if (bound) {
    var _adm$proxy_;
    // We do not keep original function around, so we bind the existing flow
    value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    // This is normally set by `flow`, but `bind` returns new function...
    value.isMobXFlow = true;
  }
  return {
    value: value,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: safeDescriptors ? adm.isPlainObject_ : true,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: false,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: safeDescriptors ? false : true
  };
}

function createComputedAnnotation(name, options) {
  return {
    annotationType_: name,
    options_: options,
    make_: make_$3,
    extend_: extend_$3,
    decorate_20223_: decorate_20223_$3
  };
}
function make_$3(adm, key, descriptor) {
  return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */ : 1 /* MakeResult.Break */;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
  assertComputedDescriptor(adm, this, key, descriptor);
  return adm.defineComputedProperty_(key, _extends({}, this.options_, {
    get: descriptor.get,
    set: descriptor.set
  }), proxyTrap);
}
function decorate_20223_$3(get, context) {
  if (false) {}
  var ann = this;
  var key = context.name,
    addInitializer = context.addInitializer;
  addInitializer(function () {
    var adm = asObservableObject(this)[$mobx];
    var options = _extends({}, ann.options_, {
      get: get,
      context: this
    });
    options.name || (options.name =  false ? 0 : "ObservableObject." + key.toString());
    adm.values_.set(key, new ComputedValue(options));
  });
  return function () {
    return this[$mobx].getObservablePropValue_(key);
  };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
  var annotationType_ = _ref.annotationType_;
  var get = _ref2.get;
  if (false) {}
}

function createObservableAnnotation(name, options) {
  return {
    annotationType_: name,
    options_: options,
    make_: make_$4,
    extend_: extend_$4,
    decorate_20223_: decorate_20223_$4
  };
}
function make_$4(adm, key, descriptor) {
  return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */ : 1 /* MakeResult.Break */;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
  var _this$options_$enhanc, _this$options_;
  assertObservableDescriptor(adm, this, key, descriptor);
  return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
  if (false) {}
  var ann = this;
  var kind = context.kind,
    name = context.name;
  // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
  //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
  //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
  //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
  //   from an object whose class did not declare it` error.
  // TODO: it seems that this will not be required anymore in the final version of the spec
  // See TODO: link
  var initializedObjects = new WeakSet();
  function initializeObservable(target, value) {
    var _ann$options_$enhance, _ann$options_;
    var adm = asObservableObject(target)[$mobx];
    var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer,  false ? 0 : "ObservableObject." + name.toString(), false);
    adm.values_.set(name, observable);
    initializedObjects.add(target);
  }
  if (kind == "accessor") {
    return {
      get: function get() {
        if (!initializedObjects.has(this)) {
          initializeObservable(this, desc.get.call(this));
        }
        return this[$mobx].getObservablePropValue_(name);
      },
      set: function set(value) {
        if (!initializedObjects.has(this)) {
          initializeObservable(this, value);
        }
        return this[$mobx].setObservablePropValue_(name, value);
      },
      init: function init(value) {
        if (!initializedObjects.has(this)) {
          initializeObservable(this, value);
        }
        return value;
      }
    };
  }
  return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
  var annotationType_ = _ref.annotationType_;
  if (false) {}
}

var AUTO = "true";
var autoAnnotation = /*#__PURE__*/createAutoAnnotation();
function createAutoAnnotation(options) {
  return {
    annotationType_: AUTO,
    options_: options,
    make_: make_$5,
    extend_: extend_$5,
    decorate_20223_: decorate_20223_$5
  };
}
function make_$5(adm, key, descriptor, source) {
  var _this$options_3, _this$options_4;
  // getter -> computed
  if (descriptor.get) {
    return computed.make_(adm, key, descriptor, source);
  }
  // lone setter -> action setter
  if (descriptor.set) {
    // TODO make action applicable to setter and delegate to action.make_
    var set = createAction(key.toString(), descriptor.set);
    // own
    if (source === adm.target_) {
      return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: set
      }) === null ? 0 /* MakeResult.Cancel */ : 2 /* MakeResult.Continue */;
    }
    // proto
    defineProperty(source, key, {
      configurable: true,
      set: set
    });
    return 2 /* MakeResult.Continue */;
  }
  // function on proto -> autoAction/flow
  if (source !== adm.target_ && typeof descriptor.value === "function") {
    var _this$options_2;
    if (isGenerator(descriptor.value)) {
      var _this$options_;
      var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
      return flowAnnotation.make_(adm, key, descriptor, source);
    }
    var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
    return actionAnnotation.make_(adm, key, descriptor, source);
  }
  // other -> observable
  // Copy props from proto as well, see test:
  // "decorate should work with Object.create"
  var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
  // if function respect autoBind option
  if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
    var _adm$proxy_;
    descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
  }
  return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
  var _this$options_5, _this$options_6;
  // getter -> computed
  if (descriptor.get) {
    return computed.extend_(adm, key, descriptor, proxyTrap);
  }
  // lone setter -> action setter
  if (descriptor.set) {
    // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
      configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
      set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
  }
  // other -> observable
  // if function respect autoBind option
  if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
    var _adm$proxy_2;
    descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
  }
  var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
  return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
  die("'" + this.annotationType_ + "' cannot be used as a decorator");
}

var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
  deep: true,
  name: undefined,
  defaultDecorator: undefined,
  proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
  return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/createObservableAnnotation(OBSERVABLE_REF, {
  enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/createObservableAnnotation(OBSERVABLE_SHALLOW, {
  enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/createObservableAnnotation(OBSERVABLE_STRUCT, {
  enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
  return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
  var _options$defaultDecor;
  return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
  var _annotation$options_$, _annotation$options_;
  return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v, arg2, arg3) {
  // @observable someProp; (2022.3 Decorators)
  if (is20223Decorator(arg2)) {
    return observableAnnotation.decorate_20223_(v, arg2);
  }
  // @observable someProp;
  if (isStringish(arg2)) {
    storeAnnotation(v, arg2, observableAnnotation);
    return;
  }
  // already observable - ignore
  if (isObservable(v)) {
    return v;
  }
  // plain object
  if (isPlainObject(v)) {
    return observable.object(v, arg2, arg3);
  }
  // Array
  if (Array.isArray(v)) {
    return observable.array(v, arg2);
  }
  // Map
  if (isES6Map(v)) {
    return observable.map(v, arg2);
  }
  // Set
  if (isES6Set(v)) {
    return observable.set(v, arg2);
  }
  // other object - ignore
  if (typeof v === "object" && v !== null) {
    return v;
  }
  // anything else
  return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
  box: function box(value, options) {
    var o = asCreateObservableOptions(options);
    return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
  },
  array: function array(initialValues, options) {
    var o = asCreateObservableOptions(options);
    return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
  },
  map: function map(initialValues, options) {
    var o = asCreateObservableOptions(options);
    return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
  },
  set: function set(initialValues, options) {
    var o = asCreateObservableOptions(options);
    return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
  },
  object: function object(props, decorators, options) {
    return initObservable(function () {
      return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
    });
  },
  ref: /*#__PURE__*/createDecoratorAnnotation(observableRefAnnotation),
  shallow: /*#__PURE__*/createDecoratorAnnotation(observableShallowAnnotation),
  deep: observableDecoratorAnnotation,
  struct: /*#__PURE__*/createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/assign(createObservable, observableFactories);

var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/createComputedAnnotation(COMPUTED_STRUCT, {
  equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2) {
  if (is20223Decorator(arg2)) {
    // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
  }
  if (isStringish(arg2)) {
    // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
  }
  if (isPlainObject(arg1)) {
    // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
  }
  // computed(expr, options?)
  if (false) {}
  var opts = isPlainObject(arg2) ? arg2 : {};
  opts.get = arg1;
  opts.name || (opts.name = arg1.name || ""); /* for generated name */
  return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/createDecoratorAnnotation(computedStructAnnotation);

var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/getDescriptor(function () {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
  value: "action",
  configurable: true,
  writable: false,
  enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
  if (autoAction === void 0) {
    autoAction = false;
  }
  if (false) {}
  function res() {
    return executeAction(actionName, autoAction, fn, ref || this, arguments);
  }
  res.isMobxAction = true;
  res.toString = function () {
    return fn.toString();
  };
  if (isFunctionNameConfigurable) {
    tmpNameDescriptor.value = actionName;
    defineProperty(res, "name", tmpNameDescriptor);
  }
  return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
  var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
  try {
    return fn.apply(scope, args);
  } catch (err) {
    runInfo.error_ = err;
    throw err;
  } finally {
    _endAction(runInfo);
  }
}
function _startAction(actionName, canRunAsDerivation,
// true for autoAction
scope, args) {
  var notifySpy_ =  false && 0;
  var startTime_ = 0;
  if (false) { var flattenedArgs; }
  var prevDerivation_ = globalState.trackingDerivation;
  var runAsAction = !canRunAsDerivation || !prevDerivation_;
  startBatch();
  var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
  if (runAsAction) {
    untrackedStart();
    prevAllowStateChanges_ = allowStateChangesStart(true);
  }
  var prevAllowStateReads_ = allowStateReadsStart(true);
  var runInfo = {
    runAsAction_: runAsAction,
    prevDerivation_: prevDerivation_,
    prevAllowStateChanges_: prevAllowStateChanges_,
    prevAllowStateReads_: prevAllowStateReads_,
    notifySpy_: notifySpy_,
    startTime_: startTime_,
    actionId_: nextActionId++,
    parentActionId_: currentActionId
  };
  currentActionId = runInfo.actionId_;
  return runInfo;
}
function _endAction(runInfo) {
  if (currentActionId !== runInfo.actionId_) {
    die(30);
  }
  currentActionId = runInfo.parentActionId_;
  if (runInfo.error_ !== undefined) {
    globalState.suppressReactionErrors = true;
  }
  allowStateChangesEnd(runInfo.prevAllowStateChanges_);
  allowStateReadsEnd(runInfo.prevAllowStateReads_);
  endBatch();
  if (runInfo.runAsAction_) {
    untrackedEnd(runInfo.prevDerivation_);
  }
  if (false) {}
  globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
  var prev = allowStateChangesStart(allowStateChanges);
  try {
    return func();
  } finally {
    allowStateChangesEnd(prev);
  }
}
function allowStateChangesStart(allowStateChanges) {
  var prev = globalState.allowStateChanges;
  globalState.allowStateChanges = allowStateChanges;
  return prev;
}
function allowStateChangesEnd(prev) {
  globalState.allowStateChanges = prev;
}

var CREATE = "create";
var ObservableValue = /*#__PURE__*/function (_Atom) {
  function ObservableValue(value, enhancer, name_, notifySpy, equals) {
    var _this;
    if (name_ === void 0) {
      name_ =  false ? 0 : "ObservableValue";
    }
    if (notifySpy === void 0) {
      notifySpy = true;
    }
    if (equals === void 0) {
      equals = comparer["default"];
    }
    _this = _Atom.call(this, name_) || this;
    _this.enhancer = void 0;
    _this.name_ = void 0;
    _this.equals = void 0;
    _this.hasUnreportedChange_ = false;
    _this.interceptors_ = void 0;
    _this.changeListeners_ = void 0;
    _this.value_ = void 0;
    _this.dehancer = void 0;
    _this.enhancer = enhancer;
    _this.name_ = name_;
    _this.equals = equals;
    _this.value_ = enhancer(value, undefined, name_);
    if (false) {}
    return _this;
  }
  _inheritsLoose(ObservableValue, _Atom);
  var _proto = ObservableValue.prototype;
  _proto.dehanceValue = function dehanceValue(value) {
    if (this.dehancer !== undefined) {
      return this.dehancer(value);
    }
    return value;
  };
  _proto.set = function set(newValue) {
    var oldValue = this.value_;
    newValue = this.prepareNewValue_(newValue);
    if (newValue !== globalState.UNCHANGED) {
      var notifySpy = isSpyEnabled();
      if (false) {}
      this.setNewValue_(newValue);
      if (false) {}
    }
  };
  _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
    checkIfStateModificationsAreAllowed(this);
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        object: this,
        type: UPDATE,
        newValue: newValue
      });
      if (!change) {
        return globalState.UNCHANGED;
      }
      newValue = change.newValue;
    }
    // apply modifier
    newValue = this.enhancer(newValue, this.value_, this.name_);
    return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
  };
  _proto.setNewValue_ = function setNewValue_(newValue) {
    var oldValue = this.value_;
    this.value_ = newValue;
    this.reportChanged();
    if (hasListeners(this)) {
      notifyListeners(this, {
        type: UPDATE,
        object: this,
        newValue: newValue,
        oldValue: oldValue
      });
    }
  };
  _proto.get = function get() {
    this.reportObserved();
    return this.dehanceValue(this.value_);
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  _proto.observe_ = function observe_(listener, fireImmediately) {
    if (fireImmediately) {
      listener({
        observableKind: "value",
        debugObjectName: this.name_,
        object: this,
        type: UPDATE,
        newValue: this.value_,
        oldValue: undefined
      });
    }
    return registerListener(this, listener);
  };
  _proto.raw = function raw() {
    // used by MST ot get undehanced value
    return this.value_;
  };
  _proto.toJSON = function toJSON() {
    return this.get();
  };
  _proto.toString = function toString() {
    return this.name_ + "[" + this.value_ + "]";
  };
  _proto.valueOf = function valueOf() {
    return toPrimitive(this.get());
  };
  _proto[Symbol.toPrimitive] = function () {
    return this.valueOf();
  };
  return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/createInstanceofPredicate("ObservableValue", ObservableValue);

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /*#__PURE__*/function () {
  /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */
  function ComputedValue(options) {
    this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
    this.observing_ = [];
    // nodes we are looking at. Our value depends on these nodes
    this.newObserving_ = null;
    // during tracking it's an array with new observed observers
    this.observers_ = new Set();
    this.runId_ = 0;
    this.lastAccessedBy_ = 0;
    this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    this.unboundDepsCount_ = 0;
    this.value_ = new CaughtException(null);
    this.name_ = void 0;
    this.triggeredBy_ = void 0;
    this.flags_ = 0;
    this.derivation = void 0;
    // N.B: unminified as it is used by MST
    this.setter_ = void 0;
    this.isTracing_ = TraceMode.NONE;
    this.scope_ = void 0;
    this.equals_ = void 0;
    this.requiresReaction_ = void 0;
    this.keepAlive_ = void 0;
    this.onBOL = void 0;
    this.onBUOL = void 0;
    if (!options.get) {
      die(31);
    }
    this.derivation = options.get;
    this.name_ = options.name || ( false ? 0 : "ComputedValue");
    if (options.set) {
      this.setter_ = createAction( false ? 0 : "ComputedValue-setter", options.set);
    }
    this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
    this.scope_ = options.context;
    this.requiresReaction_ = options.requiresReaction;
    this.keepAlive_ = !!options.keepAlive;
  }
  var _proto = ComputedValue.prototype;
  _proto.onBecomeStale_ = function onBecomeStale_() {
    propagateMaybeChanged(this);
  };
  _proto.onBO = function onBO() {
    if (this.onBOL) {
      this.onBOL.forEach(function (listener) {
        return listener();
      });
    }
  };
  _proto.onBUO = function onBUO() {
    if (this.onBUOL) {
      this.onBUOL.forEach(function (listener) {
        return listener();
      });
    }
  }
  // to check for cycles
  ;
  /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */
  _proto.get = function get() {
    if (this.isComputing) {
      die(32, this.name_, this.derivation);
    }
    if (globalState.inBatch === 0 &&
    // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_) {
      if (shouldCompute(this)) {
        this.warnAboutUntrackedRead_();
        startBatch(); // See perf test 'computed memoization'
        this.value_ = this.computeValue_(false);
        endBatch();
      }
    } else {
      reportObserved(this);
      if (shouldCompute(this)) {
        var prevTrackingContext = globalState.trackingContext;
        if (this.keepAlive_ && !prevTrackingContext) {
          globalState.trackingContext = this;
        }
        if (this.trackAndCompute()) {
          propagateChangeConfirmed(this);
        }
        globalState.trackingContext = prevTrackingContext;
      }
    }
    var result = this.value_;
    if (isCaughtException(result)) {
      throw result.cause;
    }
    return result;
  };
  _proto.set = function set(value) {
    if (this.setter_) {
      if (this.isRunningSetter) {
        die(33, this.name_);
      }
      this.isRunningSetter = true;
      try {
        this.setter_.call(this.scope_, value);
      } finally {
        this.isRunningSetter = false;
      }
    } else {
      die(34, this.name_);
    }
  };
  _proto.trackAndCompute = function trackAndCompute() {
    // N.B: unminified as it is used by MST
    var oldValue = this.value_;
    var wasSuspended = /* see #1208 */this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
    var newValue = this.computeValue_(true);
    var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
    if (changed) {
      this.value_ = newValue;
      if (false) {}
    }
    return changed;
  };
  _proto.computeValue_ = function computeValue_(track) {
    this.isComputing = true;
    // don't allow state changes during computation
    var prev = allowStateChangesStart(false);
    var res;
    if (track) {
      res = trackDerivedFunction(this, this.derivation, this.scope_);
    } else {
      if (globalState.disableErrorBoundaries === true) {
        res = this.derivation.call(this.scope_);
      } else {
        try {
          res = this.derivation.call(this.scope_);
        } catch (e) {
          res = new CaughtException(e);
        }
      }
    }
    allowStateChangesEnd(prev);
    this.isComputing = false;
    return res;
  };
  _proto.suspend_ = function suspend_() {
    if (!this.keepAlive_) {
      clearObserving(this);
      this.value_ = undefined; // don't hold on to computed value!
      if (false) {}
    }
  };
  _proto.observe_ = function observe_(listener, fireImmediately) {
    var _this = this;
    var firstTime = true;
    var prevValue = undefined;
    return autorun(function () {
      // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
      var newValue = _this.get();
      if (!firstTime || fireImmediately) {
        var prevU = untrackedStart();
        listener({
          observableKind: "computed",
          debugObjectName: _this.name_,
          type: UPDATE,
          object: _this,
          newValue: newValue,
          oldValue: prevValue
        });
        untrackedEnd(prevU);
      }
      firstTime = false;
      prevValue = newValue;
    });
  };
  _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
    if (true) {
      return;
    }
    if (this.isTracing_ !== TraceMode.NONE) {
      console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute.");
    }
    if (typeof this.requiresReaction_ === "boolean" ? this.requiresReaction_ : globalState.computedRequiresReaction) {
      console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute.");
    }
  };
  _proto.toString = function toString() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  };
  _proto.valueOf = function valueOf() {
    return toPrimitive(this.get());
  };
  _proto[Symbol.toPrimitive] = function () {
    return this.valueOf();
  };
  return _createClass(ComputedValue, [{
    key: "isComputing",
    get: function get() {
      return getFlag(this.flags_, ComputedValue.isComputingMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
    }
  }, {
    key: "isRunningSetter",
    get: function get() {
      return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
    }
  }, {
    key: "isBeingObserved",
    get: function get() {
      return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
    }
  }, {
    key: "isPendingUnobservation",
    get: function get() {
      return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
    }
  }, {
    key: "diffValue",
    get: function get() {
      return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
    }
  }]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/createInstanceofPredicate("ComputedValue", ComputedValue);

var IDerivationState_;
(function (IDerivationState_) {
  // before being run or (outside batch and not being observed)
  // at this point derivation is not holding any data about dependency tree
  IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
  // no shallow dependency changed since last computation
  // won't recalculate derivation
  // this is what makes mobx fast
  IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
  // some deep dependency changed, but don't know if shallow dependency changed
  // will require to check first if UP_TO_DATE or POSSIBLY_STALE
  // currently only ComputedValue will propagate POSSIBLY_STALE
  //
  // having this state is second big optimization:
  // don't have to recompute on every dependency change, but only when it's needed
  IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
  // A shallow dependency has changed since last computation and the derivation
  // will need to recompute when it's needed next.
  IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function (TraceMode) {
  TraceMode[TraceMode["NONE"] = 0] = "NONE";
  TraceMode[TraceMode["LOG"] = 1] = "LOG";
  TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
  this.cause = void 0;
  this.cause = cause;
  // Empty
};
function isCaughtException(e) {
  return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
  switch (derivation.dependenciesState_) {
    case IDerivationState_.UP_TO_DATE_:
      return false;
    case IDerivationState_.NOT_TRACKING_:
    case IDerivationState_.STALE_:
      return true;
    case IDerivationState_.POSSIBLY_STALE_:
      {
        // state propagation can occur outside of action/reactive context #2195
        var prevAllowStateReads = allowStateReadsStart(true);
        var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
        var obs = derivation.observing_,
          l = obs.length;
        for (var i = 0; i < l; i++) {
          var obj = obs[i];
          if (isComputedValue(obj)) {
            if (globalState.disableErrorBoundaries) {
              obj.get();
            } else {
              try {
                obj.get();
              } catch (e) {
                // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                untrackedEnd(prevUntracked);
                allowStateReadsEnd(prevAllowStateReads);
                return true;
              }
            }
            // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
            // and `derivation` is an observer of `obj`
            // invariantShouldCompute(derivation)
            if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
              untrackedEnd(prevUntracked);
              allowStateReadsEnd(prevAllowStateReads);
              return true;
            }
          }
        }
        changeDependenciesStateTo0(derivation);
        untrackedEnd(prevUntracked);
        allowStateReadsEnd(prevAllowStateReads);
        return false;
      }
  }
}
function isComputingDerivation() {
  return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
  if (true) {
    return;
  }
  var hasObservers = atom.observers_.size > 0;
  // Should not be possible to change observed state outside strict mode, except during initialization, see #563
  if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "always")) {
    console.warn("[MobX] " + (globalState.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + atom.name_);
  }
}
function checkIfStateReadsAreAllowed(observable) {
  if (false) {}
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
  var prevAllowStateReads = allowStateReadsStart(true);
  changeDependenciesStateTo0(derivation);
  // Preallocate array; will be trimmed by bindDependencies.
  derivation.newObserving_ = new Array(
  // Reserve constant space for initial dependencies, dynamic space otherwise.
  // See https://github.com/mobxjs/mobx/pull/3833
  derivation.runId_ === 0 ? 100 : derivation.observing_.length);
  derivation.unboundDepsCount_ = 0;
  derivation.runId_ = ++globalState.runId;
  var prevTracking = globalState.trackingDerivation;
  globalState.trackingDerivation = derivation;
  globalState.inBatch++;
  var result;
  if (globalState.disableErrorBoundaries === true) {
    result = f.call(context);
  } else {
    try {
      result = f.call(context);
    } catch (e) {
      result = new CaughtException(e);
    }
  }
  globalState.inBatch--;
  globalState.trackingDerivation = prevTracking;
  bindDependencies(derivation);
  warnAboutDerivationWithoutDependencies(derivation);
  allowStateReadsEnd(prevAllowStateReads);
  return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
  if (true) {
    return;
  }
  if (derivation.observing_.length !== 0) {
    return;
  }
  if (typeof derivation.requiresObservable_ === "boolean" ? derivation.requiresObservable_ : globalState.reactionRequiresObservable) {
    console.warn("[mobx] Derivation '" + derivation.name_ + "' is created/updated without reading any observable value.");
  }
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
  // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
  var prevObserving = derivation.observing_;
  var observing = derivation.observing_ = derivation.newObserving_;
  var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
  // Go through all new observables and check diffValue: (this list can contain duplicates):
  //   0: first occurrence, change to 1 and keep it
  //   1: extra occurrence, drop it
  var i0 = 0,
    l = derivation.unboundDepsCount_;
  for (var i = 0; i < l; i++) {
    var dep = observing[i];
    if (dep.diffValue === 0) {
      dep.diffValue = 1;
      if (i0 !== i) {
        observing[i0] = dep;
      }
      i0++;
    }
    // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
    // not hitting the condition
    if (dep.dependenciesState_ > lowestNewObservingDerivationState) {
      lowestNewObservingDerivationState = dep.dependenciesState_;
    }
  }
  observing.length = i0;
  derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
  // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
  //   0: it's not in new observables, unobserve it
  //   1: it keeps being observed, don't want to notify it. change to 0
  l = prevObserving.length;
  while (l--) {
    var _dep = prevObserving[l];
    if (_dep.diffValue === 0) {
      removeObserver(_dep, derivation);
    }
    _dep.diffValue = 0;
  }
  // Go through all new observables and check diffValue: (now it should be unique)
  //   0: it was set to 0 in last loop. don't need to do anything.
  //   1: it wasn't observed, let's observe it. set back to 0
  while (i0--) {
    var _dep2 = observing[i0];
    if (_dep2.diffValue === 1) {
      _dep2.diffValue = 0;
      addObserver(_dep2, derivation);
    }
  }
  // Some new observed derivations may become stale during this derivation computation
  // so they have had no chance to propagate staleness (#916)
  if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
    derivation.dependenciesState_ = lowestNewObservingDerivationState;
    derivation.onBecomeStale_();
  }
}
function clearObserving(derivation) {
  // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
  var obs = derivation.observing_;
  derivation.observing_ = [];
  var i = obs.length;
  while (i--) {
    removeObserver(obs[i], derivation);
  }
  derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
  var prev = untrackedStart();
  try {
    return action();
  } finally {
    untrackedEnd(prev);
  }
}
function untrackedStart() {
  var prev = globalState.trackingDerivation;
  globalState.trackingDerivation = null;
  return prev;
}
function untrackedEnd(prev) {
  globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
  var prev = globalState.allowStateReads;
  globalState.allowStateReads = allowStateReads;
  return prev;
}
function allowStateReadsEnd(prev) {
  globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
  if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
    return;
  }
  derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
  var obs = derivation.observing_;
  var i = obs.length;
  while (i--) {
    obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
  }
}

/**
 * These values will persist if global state is reset
 */
var persistentKeys = ["mobxGuid", "spyListeners", "enforceActions", "computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "allowStateReads", "disableErrorBoundaries", "runId", "UNCHANGED", "useProxies"];
var MobXGlobals = function MobXGlobals() {
  /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */
  this.version = 6;
  /**
   * globally unique token to signal unchanged
   */
  this.UNCHANGED = {};
  /**
   * Currently running derivation
   */
  this.trackingDerivation = null;
  /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */
  this.trackingContext = null;
  /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */
  this.runId = 0;
  /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */
  this.mobxGuid = 0;
  /**
   * Are we in a batch block? (and how many of them)
   */
  this.inBatch = 0;
  /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */
  this.pendingUnobservations = [];
  /**
   * List of scheduled, not yet executed, reactions.
   */
  this.pendingReactions = [];
  /**
   * Are we currently processing reactions?
   */
  this.isRunningReactions = false;
  /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */
  this.allowStateChanges = false;
  /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */
  this.allowStateReads = true;
  /**
   * If strict mode is enabled, state changes are by default not allowed
   */
  this.enforceActions = true;
  /**
   * Spy callbacks
   */
  this.spyListeners = [];
  /**
   * Globally attached error handlers that react specifically to errors in reactions
   */
  this.globalReactionErrorHandlers = [];
  /**
   * Warn if computed values are accessed outside a reactive context
   */
  this.computedRequiresReaction = false;
  /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */
  this.reactionRequiresObservable = false;
  /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */
  this.observableRequiresReaction = false;
  /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */
  this.disableErrorBoundaries = false;
  /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */
  this.suppressReactionErrors = false;
  this.useProxies = true;
  /*
   * print warnings about code that would fail if proxies weren't available
   */
  this.verifyProxies = false;
  /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */
  this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/function () {
  var global = /*#__PURE__*/getGlobal();
  if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals) {
    canMergeGlobalState = false;
  }
  if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals().version) {
    canMergeGlobalState = false;
  }
  if (!canMergeGlobalState) {
    // Because this is a IIFE we need to let isolateCalled a chance to change
    // so we run it after the event loop completed at least 1 iteration
    setTimeout(function () {
      if (!isolateCalled) {
        die(35);
      }
    }, 1);
    return new MobXGlobals();
  } else if (global.__mobxGlobals) {
    global.__mobxInstanceCount += 1;
    if (!global.__mobxGlobals.UNCHANGED) {
      global.__mobxGlobals.UNCHANGED = {};
    } // make merge backward compatible
    return global.__mobxGlobals;
  } else {
    global.__mobxInstanceCount = 1;
    return global.__mobxGlobals = /*#__PURE__*/new MobXGlobals();
  }
}();
function isolateGlobalState() {
  if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) {
    die(36);
  }
  isolateCalled = true;
  if (canMergeGlobalState) {
    var global = getGlobal();
    if (--global.__mobxInstanceCount === 0) {
      global.__mobxGlobals = undefined;
    }
    globalState = new MobXGlobals();
  }
}
function getGlobalState() {
  return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
  var defaultGlobals = new MobXGlobals();
  for (var key in defaultGlobals) {
    if (persistentKeys.indexOf(key) === -1) {
      globalState[key] = defaultGlobals[key];
    }
  }
  globalState.allowStateChanges = !globalState.enforceActions;
}

function hasObservers(observable) {
  return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
  return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
  // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
  // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
  // invariantObservers(observable);
  observable.observers_.add(node);
  if (observable.lowestObserverState_ > node.dependenciesState_) {
    observable.lowestObserverState_ = node.dependenciesState_;
  }
  // invariantObservers(observable);
  // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
  // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
  // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
  // invariantObservers(observable);
  observable.observers_["delete"](node);
  if (observable.observers_.size === 0) {
    // deleting last observer
    queueForUnobservation(observable);
  }
  // invariantObservers(observable);
  // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
  if (observable.isPendingUnobservation === false) {
    // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
    observable.isPendingUnobservation = true;
    globalState.pendingUnobservations.push(observable);
  }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
  globalState.inBatch++;
}
function endBatch() {
  if (--globalState.inBatch === 0) {
    runReactions();
    // the batch is actually about to finish, all unobserving should happen here.
    var list = globalState.pendingUnobservations;
    for (var i = 0; i < list.length; i++) {
      var observable = list[i];
      observable.isPendingUnobservation = false;
      if (observable.observers_.size === 0) {
        if (observable.isBeingObserved) {
          // if this observable had reactive observers, trigger the hooks
          observable.isBeingObserved = false;
          observable.onBUO();
        }
        if (observable instanceof ComputedValue) {
          // computed values are automatically teared down when the last observer leaves
          // this process happens recursively, this computed might be the last observabe of another, etc..
          observable.suspend_();
        }
      }
    }
    globalState.pendingUnobservations = [];
  }
}
function reportObserved(observable) {
  checkIfStateReadsAreAllowed(observable);
  var derivation = globalState.trackingDerivation;
  if (derivation !== null) {
    /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */
    if (derivation.runId_ !== observable.lastAccessedBy_) {
      observable.lastAccessedBy_ = derivation.runId_;
      // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
      derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
      if (!observable.isBeingObserved && globalState.trackingContext) {
        observable.isBeingObserved = true;
        observable.onBO();
      }
    }
    return observable.isBeingObserved;
  } else if (observable.observers_.size === 0 && globalState.inBatch > 0) {
    queueForUnobservation(observable);
  }
  return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
  // invariantLOS(observable, "changed start");
  if (observable.lowestObserverState_ === IDerivationState_.STALE_) {
    return;
  }
  observable.lowestObserverState_ = IDerivationState_.STALE_;
  // Ideally we use for..of here, but the downcompiled version is really slow...
  observable.observers_.forEach(function (d) {
    if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
      if (false) {}
      d.onBecomeStale_();
    }
    d.dependenciesState_ = IDerivationState_.STALE_;
  });
  // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
  // invariantLOS(observable, "confirmed start");
  if (observable.lowestObserverState_ === IDerivationState_.STALE_) {
    return;
  }
  observable.lowestObserverState_ = IDerivationState_.STALE_;
  observable.observers_.forEach(function (d) {
    if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) {
      d.dependenciesState_ = IDerivationState_.STALE_;
      if (false) {}
    } else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
    ) {
      observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    }
  });
  // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
  // invariantLOS(observable, "maybe start");
  if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) {
    return;
  }
  observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
  observable.observers_.forEach(function (d) {
    if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
      d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
      d.onBecomeStale_();
    }
  });
  // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
  console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
  if (derivation.isTracing_ === TraceMode.BREAK) {
    var lines = [];
    printDepTree(getDependencyTree(derivation), lines, 1);
    // prettier-ignore
    new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
  }
}
function printDepTree(tree, lines, depth) {
  if (lines.length >= 1000) {
    lines.push("(and many more)");
    return;
  }
  lines.push("" + "\t".repeat(depth - 1) + tree.name);
  if (tree.dependencies) {
    tree.dependencies.forEach(function (child) {
      return printDepTree(child, lines, depth + 1);
    });
  }
}

var Reaction = /*#__PURE__*/function () {
  function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
    if (name_ === void 0) {
      name_ =  false ? 0 : "Reaction";
    }
    this.name_ = void 0;
    this.onInvalidate_ = void 0;
    this.errorHandler_ = void 0;
    this.requiresObservable_ = void 0;
    this.observing_ = [];
    // nodes we are looking at. Our value depends on these nodes
    this.newObserving_ = [];
    this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
    this.runId_ = 0;
    this.unboundDepsCount_ = 0;
    this.flags_ = 0;
    this.isTracing_ = TraceMode.NONE;
    this.name_ = name_;
    this.onInvalidate_ = onInvalidate_;
    this.errorHandler_ = errorHandler_;
    this.requiresObservable_ = requiresObservable_;
  }
  var _proto = Reaction.prototype;
  _proto.onBecomeStale_ = function onBecomeStale_() {
    this.schedule_();
  };
  _proto.schedule_ = function schedule_() {
    if (!this.isScheduled) {
      this.isScheduled = true;
      globalState.pendingReactions.push(this);
      runReactions();
    }
  }
  /**
   * internal, use schedule() if you intend to kick off a reaction
   */;
  _proto.runReaction_ = function runReaction_() {
    if (!this.isDisposed) {
      startBatch();
      this.isScheduled = false;
      var prev = globalState.trackingContext;
      globalState.trackingContext = this;
      if (shouldCompute(this)) {
        this.isTrackPending = true;
        try {
          this.onInvalidate_();
          if (false) {}
        } catch (e) {
          this.reportExceptionInDerivation_(e);
        }
      }
      globalState.trackingContext = prev;
      endBatch();
    }
  };
  _proto.track = function track(fn) {
    if (this.isDisposed) {
      return;
      // console.warn("Reaction already disposed") // Note: Not a warning / error in mobx 4 either
    }
    startBatch();
    var notify = isSpyEnabled();
    var startTime;
    if (false) {}
    this.isRunning = true;
    var prevReaction = globalState.trackingContext; // reactions could create reactions...
    globalState.trackingContext = this;
    var result = trackDerivedFunction(this, fn, undefined);
    globalState.trackingContext = prevReaction;
    this.isRunning = false;
    this.isTrackPending = false;
    if (this.isDisposed) {
      // disposed during last run. Clean up everything that was bound after the dispose call.
      clearObserving(this);
    }
    if (isCaughtException(result)) {
      this.reportExceptionInDerivation_(result.cause);
    }
    if (false) {}
    endBatch();
  };
  _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
    var _this = this;
    if (this.errorHandler_) {
      this.errorHandler_(error, this);
      return;
    }
    if (globalState.disableErrorBoundaries) {
      throw error;
    }
    var message =  false ? 0 : "[mobx] uncaught error in '" + this + "'";
    if (!globalState.suppressReactionErrors) {
      console.error(message, error);
      /** If debugging brought you here, please, read the above message :-). Tnx! */
    } else if (false) {} // prettier-ignore
    if (false) {}
    globalState.globalReactionErrorHandlers.forEach(function (f) {
      return f(error, _this);
    });
  };
  _proto.dispose = function dispose() {
    if (!this.isDisposed) {
      this.isDisposed = true;
      if (!this.isRunning) {
        // if disposed while running, clean up later. Maybe not optimal, but rare case
        startBatch();
        clearObserving(this);
        endBatch();
      }
    }
  };
  _proto.getDisposer_ = function getDisposer_(abortSignal) {
    var _this2 = this;
    var dispose = function dispose() {
      _this2.dispose();
      abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
    };
    abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
    dispose[$mobx] = this;
    return dispose;
  };
  _proto.toString = function toString() {
    return "Reaction[" + this.name_ + "]";
  };
  _proto.trace = function trace$1(enterBreakPoint) {
    if (enterBreakPoint === void 0) {
      enterBreakPoint = false;
    }
    trace(this, enterBreakPoint);
  };
  return _createClass(Reaction, [{
    key: "isDisposed",
    get: function get() {
      return getFlag(this.flags_, Reaction.isDisposedMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
    }
  }, {
    key: "isScheduled",
    get: function get() {
      return getFlag(this.flags_, Reaction.isScheduledMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
    }
  }, {
    key: "isTrackPending",
    get: function get() {
      return getFlag(this.flags_, Reaction.isTrackPendingMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
    }
  }, {
    key: "isRunning",
    get: function get() {
      return getFlag(this.flags_, Reaction.isRunningMask_);
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
    }
  }, {
    key: "diffValue",
    get: function get() {
      return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
    },
    set: function set(newValue) {
      this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
    }
  }]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
  globalState.globalReactionErrorHandlers.push(handler);
  return function () {
    var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
    if (idx >= 0) {
      globalState.globalReactionErrorHandlers.splice(idx, 1);
    }
  };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
  return f();
};
function runReactions() {
  // Trampolining, if runReactions are already running, new reactions will be picked up
  if (globalState.inBatch > 0 || globalState.isRunningReactions) {
    return;
  }
  reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
  globalState.isRunningReactions = true;
  var allReactions = globalState.pendingReactions;
  var iterations = 0;
  // While running reactions, new reactions might be triggered.
  // Hence we work with two variables and check whether
  // we converge to no remaining reactions after a while.
  while (allReactions.length > 0) {
    if (++iterations === MAX_REACTION_ITERATIONS) {
      console.error( false ? 0 : "[mobx] cycle in reaction: " + allReactions[0]);
      allReactions.splice(0); // clear reactions
    }
    var remainingReactions = allReactions.splice(0);
    for (var i = 0, l = remainingReactions.length; i < l; i++) {
      remainingReactions[i].runReaction_();
    }
  }
  globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
  var baseScheduler = reactionScheduler;
  reactionScheduler = function reactionScheduler(f) {
    return fn(function () {
      return baseScheduler(f);
    });
  };
}

function isSpyEnabled() {
  return  false && 0;
}
function spyReport(event) {
  if (true) {
    return;
  } // dead code elimination can do the rest
  if (!globalState.spyListeners.length) {
    return;
  }
  var listeners = globalState.spyListeners;
  for (var i = 0, l = listeners.length; i < l; i++) {
    listeners[i](event);
  }
}
function spyReportStart(event) {
  if (true) {
    return;
  }
  var change = _extends({}, event, {
    spyReportStart: true
  });
  spyReport(change);
}
var END_EVENT = {
  type: "report-end",
  spyReportEnd: true
};
function spyReportEnd(change) {
  if (true) {
    return;
  }
  if (change) {
    spyReport(_extends({}, change, {
      type: "report-end",
      spyReportEnd: true
    }));
  } else {
    spyReport(END_EVENT);
  }
}
function spy(listener) {
  if (true) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function () {};
  } else {}
}

var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/createActionAnnotation(ACTION_BOUND, {
  bound: true
});
var autoActionAnnotation = /*#__PURE__*/createActionAnnotation(AUTOACTION, {
  autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/createActionAnnotation(AUTOACTION_BOUND, {
  autoAction: true,
  bound: true
});
function createActionFactory(autoAction) {
  var res = function action(arg1, arg2) {
    // action(fn() {})
    if (isFunction(arg1)) {
      return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
    }
    // action("name", fn() {})
    if (isFunction(arg2)) {
      return createAction(arg1, arg2, autoAction);
    }
    // @action (2022.3 Decorators)
    if (is20223Decorator(arg2)) {
      return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
    }
    // @action
    if (isStringish(arg2)) {
      return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
    }
    // action("name") & @action("name")
    if (isStringish(arg1)) {
      return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
        name: arg1,
        autoAction: autoAction
      }));
    }
    if (false) {}
  };
  return res;
}
var action = /*#__PURE__*/createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
  return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
  return isFunction(thing) && thing.isMobxAction === true;
}

/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */
function autorun(view, opts) {
  var _opts$name, _opts, _opts2, _opts3;
  if (opts === void 0) {
    opts = EMPTY_OBJECT;
  }
  if (false) {}
  var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name :  false ? 0 : "Autorun";
  var runSync = !opts.scheduler && !opts.delay;
  var reaction;
  if (runSync) {
    // normal autorun
    reaction = new Reaction(name, function () {
      this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
  } else {
    var scheduler = createSchedulerFromOptions(opts);
    // debounced autorun
    var isScheduled = false;
    reaction = new Reaction(name, function () {
      if (!isScheduled) {
        isScheduled = true;
        scheduler(function () {
          isScheduled = false;
          if (!reaction.isDisposed) {
            reaction.track(reactionRunner);
          }
        });
      }
    }, opts.onError, opts.requiresObservable);
  }
  function reactionRunner() {
    view(reaction);
  }
  if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) {
    reaction.schedule_();
  }
  return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
  return f();
};
function createSchedulerFromOptions(opts) {
  return opts.scheduler ? opts.scheduler : opts.delay ? function (f) {
    return setTimeout(f, opts.delay);
  } : run;
}
function reaction(expression, effect, opts) {
  var _opts$name2, _opts4, _opts5;
  if (opts === void 0) {
    opts = EMPTY_OBJECT;
  }
  if (false) {}
  var name = (_opts$name2 = opts.name) != null ? _opts$name2 :  false ? 0 : "Reaction";
  var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
  var runSync = !opts.scheduler && !opts.delay;
  var scheduler = createSchedulerFromOptions(opts);
  var firstTime = true;
  var isScheduled = false;
  var value;
  var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
  var r = new Reaction(name, function () {
    if (firstTime || runSync) {
      reactionRunner();
    } else if (!isScheduled) {
      isScheduled = true;
      scheduler(reactionRunner);
    }
  }, opts.onError, opts.requiresObservable);
  function reactionRunner() {
    isScheduled = false;
    if (r.isDisposed) {
      return;
    }
    var changed = false;
    var oldValue = value;
    r.track(function () {
      var nextValue = allowStateChanges(false, function () {
        return expression(r);
      });
      changed = firstTime || !equals(value, nextValue);
      value = nextValue;
    });
    if (firstTime && opts.fireImmediately) {
      effectAction(value, oldValue, r);
    } else if (!firstTime && changed) {
      effectAction(value, oldValue, r);
    }
    firstTime = false;
  }
  if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) {
    r.schedule_();
  }
  return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
  return function () {
    try {
      return baseFn.apply(this, arguments);
    } catch (e) {
      errorHandler.call(this, e);
    }
  };
}

var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
  return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
  return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
  var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
  var cb = isFunction(arg3) ? arg3 : arg2;
  var listenersKey = hook + "L";
  if (atom[listenersKey]) {
    atom[listenersKey].add(cb);
  } else {
    atom[listenersKey] = new Set([cb]);
  }
  return function () {
    var hookListeners = atom[listenersKey];
    if (hookListeners) {
      hookListeners["delete"](cb);
      if (hookListeners.size === 0) {
        delete atom[listenersKey];
      }
    }
  };
}

var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
  if (options.isolateGlobalState === true) {
    isolateGlobalState();
  }
  var useProxies = options.useProxies,
    enforceActions = options.enforceActions;
  if (useProxies !== undefined) {
    globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
  }
  if (useProxies === "ifavailable") {
    globalState.verifyProxies = true;
  }
  if (enforceActions !== undefined) {
    var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
    globalState.enforceActions = ea;
    globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function (key) {
    if (key in options) {
      globalState[key] = !!options[key];
    }
  });
  globalState.allowStateReads = !globalState.observableRequiresReaction;
  if (false) {}
  if (options.reactionScheduler) {
    setReactionScheduler(options.reactionScheduler);
  }
}

function extendObservable(target, properties, annotations, options) {
  if (false) {}
  // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
  var descriptors = getOwnPropertyDescriptors(properties);
  initObservable(function () {
    var adm = asObservableObject(target, options)[$mobx];
    ownKeys(descriptors).forEach(function (key) {
      adm.extend_(key, descriptors[key],
      // must pass "undefined" for { key: undefined }
      !annotations ? true : key in annotations ? annotations[key] : true);
    });
  });
  return target;
}

function getDependencyTree(thing, property) {
  return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
  var result = {
    name: node.name_
  };
  if (node.observing_ && node.observing_.length > 0) {
    result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
  }
  return result;
}
function getObserverTree(thing, property) {
  return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
  var result = {
    name: node.name_
  };
  if (hasObservers(node)) {
    result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
  }
  return result;
}
function unique(list) {
  return Array.from(new Set(list));
}

var generatorId = 0;
function FlowCancellationError() {
  this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/Object.create(Error.prototype);
function isFlowCancellationError(error) {
  return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/createFlowAnnotation("flow.bound", {
  bound: true
});
var flow = /*#__PURE__*/Object.assign(function flow(arg1, arg2) {
  // @flow (2022.3 Decorators)
  if (is20223Decorator(arg2)) {
    return flowAnnotation.decorate_20223_(arg1, arg2);
  }
  // @flow
  if (isStringish(arg2)) {
    return storeAnnotation(arg1, arg2, flowAnnotation);
  }
  // flow(fn)
  if (false) {}
  var generator = arg1;
  var name = generator.name || "<unnamed flow>";
  // Implementation based on https://github.com/tj/co/blob/master/index.js
  var res = function res() {
    var ctx = this;
    var args = arguments;
    var runId = ++generatorId;
    var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
    var rejector;
    var pendingPromise = undefined;
    var promise = new Promise(function (resolve, reject) {
      var stepId = 0;
      rejector = reject;
      function onFulfilled(res) {
        pendingPromise = undefined;
        var ret;
        try {
          ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
        } catch (e) {
          return reject(e);
        }
        next(ret);
      }
      function onRejected(err) {
        pendingPromise = undefined;
        var ret;
        try {
          ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
        } catch (e) {
          return reject(e);
        }
        next(ret);
      }
      function next(ret) {
        if (isFunction(ret == null ? void 0 : ret.then)) {
          // an async iterator
          ret.then(next, reject);
          return;
        }
        if (ret.done) {
          return resolve(ret.value);
        }
        pendingPromise = Promise.resolve(ret.value);
        return pendingPromise.then(onFulfilled, onRejected);
      }
      onFulfilled(undefined); // kick off the process
    });
    promise.cancel = action(name + " - runid: " + runId + " - cancel", function () {
      try {
        if (pendingPromise) {
          cancelPromise(pendingPromise);
        }
        // Finally block can return (or yield) stuff..
        var _res = gen["return"](undefined);
        // eat anything that promise would do, it's cancelled!
        var yieldedPromise = Promise.resolve(_res.value);
        yieldedPromise.then(noop, noop);
        cancelPromise(yieldedPromise); // maybe it can be cancelled :)
        // reject our original promise
        rejector(new FlowCancellationError());
      } catch (e) {
        rejector(e); // there could be a throwing finally block
      }
    });
    return promise;
  };
  res.isMobXFlow = true;
  return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
  if (isFunction(promise.cancel)) {
    promise.cancel();
  }
}
function flowResult(result) {
  return result; // just tricking TypeScript :)
}
function isFlow(fn) {
  return (fn == null ? void 0 : fn.isMobXFlow) === true;
}

function interceptReads(thing, propOrHandler, handler) {
  var target;
  if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
    target = getAdministration(thing);
  } else if (isObservableObject(thing)) {
    if (false) {}
    target = getAdministration(thing, propOrHandler);
  } else if (false) {}
  if (false) {}
  target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
  return function () {
    target.dehancer = undefined;
  };
}

function intercept(thing, propOrHandler, handler) {
  if (isFunction(handler)) {
    return interceptProperty(thing, propOrHandler, handler);
  } else {
    return interceptInterceptable(thing, propOrHandler);
  }
}
function interceptInterceptable(thing, handler) {
  return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
  return getAdministration(thing, property).intercept_(handler);
}

function _isComputed(value, property) {
  if (property === undefined) {
    return isComputedValue(value);
  }
  if (isObservableObject(value) === false) {
    return false;
  }
  if (!value[$mobx].values_.has(property)) {
    return false;
  }
  var atom = getAtom(value, property);
  return isComputedValue(atom);
}
function isComputed(value) {
  if (false) {}
  return _isComputed(value);
}
function isComputedProp(value, propName) {
  if (false) {}
  return _isComputed(value, propName);
}

function _isObservable(value, property) {
  if (!value) {
    return false;
  }
  if (property !== undefined) {
    if (false) {}
    if (isObservableObject(value)) {
      return value[$mobx].values_.has(property);
    }
    return false;
  }
  // For first check, see #701
  return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
  if (false) {}
  return _isObservable(value);
}
function isObservableProp(value, propName) {
  if (false) {}
  return _isObservable(value, propName);
}

function keys(obj) {
  if (isObservableObject(obj)) {
    return obj[$mobx].keys_();
  }
  if (isObservableMap(obj) || isObservableSet(obj)) {
    return Array.from(obj.keys());
  }
  if (isObservableArray(obj)) {
    return obj.map(function (_, index) {
      return index;
    });
  }
  die(5);
}
function values(obj) {
  if (isObservableObject(obj)) {
    return keys(obj).map(function (key) {
      return obj[key];
    });
  }
  if (isObservableMap(obj)) {
    return keys(obj).map(function (key) {
      return obj.get(key);
    });
  }
  if (isObservableSet(obj)) {
    return Array.from(obj.values());
  }
  if (isObservableArray(obj)) {
    return obj.slice();
  }
  die(6);
}
function entries(obj) {
  if (isObservableObject(obj)) {
    return keys(obj).map(function (key) {
      return [key, obj[key]];
    });
  }
  if (isObservableMap(obj)) {
    return keys(obj).map(function (key) {
      return [key, obj.get(key)];
    });
  }
  if (isObservableSet(obj)) {
    return Array.from(obj.entries());
  }
  if (isObservableArray(obj)) {
    return obj.map(function (key, index) {
      return [index, key];
    });
  }
  die(7);
}
function set(obj, key, value) {
  if (arguments.length === 2 && !isObservableSet(obj)) {
    startBatch();
    var _values = key;
    try {
      for (var _key in _values) {
        set(obj, _key, _values[_key]);
      }
    } finally {
      endBatch();
    }
    return;
  }
  if (isObservableObject(obj)) {
    obj[$mobx].set_(key, value);
  } else if (isObservableMap(obj)) {
    obj.set(key, value);
  } else if (isObservableSet(obj)) {
    obj.add(key);
  } else if (isObservableArray(obj)) {
    if (typeof key !== "number") {
      key = parseInt(key, 10);
    }
    if (key < 0) {
      die("Invalid index: '" + key + "'");
    }
    startBatch();
    if (key >= obj.length) {
      obj.length = key + 1;
    }
    obj[key] = value;
    endBatch();
  } else {
    die(8);
  }
}
function remove(obj, key) {
  if (isObservableObject(obj)) {
    obj[$mobx].delete_(key);
  } else if (isObservableMap(obj)) {
    obj["delete"](key);
  } else if (isObservableSet(obj)) {
    obj["delete"](key);
  } else if (isObservableArray(obj)) {
    if (typeof key !== "number") {
      key = parseInt(key, 10);
    }
    obj.splice(key, 1);
  } else {
    die(9);
  }
}
function has(obj, key) {
  if (isObservableObject(obj)) {
    return obj[$mobx].has_(key);
  } else if (isObservableMap(obj)) {
    return obj.has(key);
  } else if (isObservableSet(obj)) {
    return obj.has(key);
  } else if (isObservableArray(obj)) {
    return key >= 0 && key < obj.length;
  }
  die(10);
}
function get(obj, key) {
  if (!has(obj, key)) {
    return undefined;
  }
  if (isObservableObject(obj)) {
    return obj[$mobx].get_(key);
  } else if (isObservableMap(obj)) {
    return obj.get(key);
  } else if (isObservableArray(obj)) {
    return obj[key];
  }
  die(11);
}
function apiDefineProperty(obj, key, descriptor) {
  if (isObservableObject(obj)) {
    return obj[$mobx].defineProperty_(key, descriptor);
  }
  die(39);
}
function apiOwnKeys(obj) {
  if (isObservableObject(obj)) {
    return obj[$mobx].ownKeys_();
  }
  die(38);
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
  if (isFunction(cbOrFire)) {
    return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
  } else {
    return observeObservable(thing, propOrCb, cbOrFire);
  }
}
function observeObservable(thing, listener, fireImmediately) {
  return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
  return getAdministration(thing, property).observe_(listener, fireImmediately);
}

function cache(map, key, value) {
  map.set(key, value);
  return value;
}
function toJSHelper(source, __alreadySeen) {
  if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) {
    return source;
  }
  if (isObservableValue(source) || isComputedValue(source)) {
    return toJSHelper(source.get(), __alreadySeen);
  }
  if (__alreadySeen.has(source)) {
    return __alreadySeen.get(source);
  }
  if (isObservableArray(source)) {
    var res = cache(__alreadySeen, source, new Array(source.length));
    source.forEach(function (value, idx) {
      res[idx] = toJSHelper(value, __alreadySeen);
    });
    return res;
  }
  if (isObservableSet(source)) {
    var _res = cache(__alreadySeen, source, new Set());
    source.forEach(function (value) {
      _res.add(toJSHelper(value, __alreadySeen));
    });
    return _res;
  }
  if (isObservableMap(source)) {
    var _res2 = cache(__alreadySeen, source, new Map());
    source.forEach(function (value, key) {
      _res2.set(key, toJSHelper(value, __alreadySeen));
    });
    return _res2;
  } else {
    // must be observable object
    var _res3 = cache(__alreadySeen, source, {});
    apiOwnKeys(source).forEach(function (key) {
      if (objectPrototype.propertyIsEnumerable.call(source, key)) {
        _res3[key] = toJSHelper(source[key], __alreadySeen);
      }
    });
    return _res3;
  }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */
function toJS(source, options) {
  if (false) {}
  return toJSHelper(source, new Map());
}

function trace() {
  if (true) {
    return;
  }
  var enterBreakPoint = false;
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (typeof args[args.length - 1] === "boolean") {
    enterBreakPoint = args.pop();
  }
  var derivation = getAtomFromArgs(args);
  if (!derivation) {
    return die("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
  }
  if (derivation.isTracing_ === TraceMode.NONE) {
    console.log("[mobx.trace] '" + derivation.name_ + "' tracing enabled");
  }
  derivation.isTracing_ = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
  switch (args.length) {
    case 0:
      return globalState.trackingDerivation;
    case 1:
      return getAtom(args[0]);
    case 2:
      return getAtom(args[0], args[1]);
  }
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
  if (thisArg === void 0) {
    thisArg = undefined;
  }
  startBatch();
  try {
    return action.apply(thisArg);
  } finally {
    endBatch();
  }
}

function when(predicate, arg1, arg2) {
  if (arguments.length === 1 || arg1 && typeof arg1 === "object") {
    return whenPromise(predicate, arg1);
  }
  return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
  var timeoutHandle;
  if (typeof opts.timeout === "number") {
    var error = new Error("WHEN_TIMEOUT");
    timeoutHandle = setTimeout(function () {
      if (!disposer[$mobx].isDisposed) {
        disposer();
        if (opts.onError) {
          opts.onError(error);
        } else {
          throw error;
        }
      }
    }, opts.timeout);
  }
  opts.name =  false ? 0 : "When";
  var effectAction = createAction( false ? 0 : "When-effect", effect);
  // eslint-disable-next-line
  var disposer = autorun(function (r) {
    // predicate should not change state
    var cond = allowStateChanges(false, predicate);
    if (cond) {
      r.dispose();
      if (timeoutHandle) {
        clearTimeout(timeoutHandle);
      }
      effectAction();
    }
  }, opts);
  return disposer;
}
function whenPromise(predicate, opts) {
  var _opts$signal;
  if (false) {}
  if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) {
    return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
      cancel: function cancel() {
        return null;
      }
    });
  }
  var cancel;
  var abort;
  var res = new Promise(function (resolve, reject) {
    var _opts$signal2;
    var disposer = _when(predicate, resolve, _extends({}, opts, {
      onError: reject
    }));
    cancel = function cancel() {
      disposer();
      reject(new Error("WHEN_CANCELLED"));
    };
    abort = function abort() {
      disposer();
      reject(new Error("WHEN_ABORTED"));
    };
    opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
  })["finally"](function () {
    var _opts$signal3;
    return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
  });
  res.cancel = cancel;
  return res;
}

function getAdm(target) {
  return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
  has: function has(target, name) {
    if (false) {}
    return getAdm(target).has_(name);
  },
  get: function get(target, name) {
    return getAdm(target).get_(name);
  },
  set: function set(target, name, value) {
    var _getAdm$set_;
    if (!isStringish(name)) {
      return false;
    }
    if (false) {}
    // null (intercepted) -> true (success)
    return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
  },
  deleteProperty: function deleteProperty(target, name) {
    var _getAdm$delete_;
    if (false) {}
    if (!isStringish(name)) {
      return false;
    }
    // null (intercepted) -> true (success)
    return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
  },
  defineProperty: function defineProperty(target, name, descriptor) {
    var _getAdm$definePropert;
    if (false) {}
    // null (intercepted) -> true (success)
    return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
  },
  ownKeys: function ownKeys(target) {
    if (false) {}
    return getAdm(target).ownKeys_();
  },
  preventExtensions: function preventExtensions(target) {
    die(13);
  }
};
function asDynamicObservableObject(target, options) {
  var _target$$mobx, _target$$mobx$proxy_;
  assertProxies();
  target = asObservableObject(target, options);
  return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}

function hasInterceptors(interceptable) {
  return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
  var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
  interceptors.push(handler);
  return once(function () {
    var idx = interceptors.indexOf(handler);
    if (idx !== -1) {
      interceptors.splice(idx, 1);
    }
  });
}
function interceptChange(interceptable, change) {
  var prevU = untrackedStart();
  try {
    // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
    var interceptors = [].concat(interceptable.interceptors_ || []);
    for (var i = 0, l = interceptors.length; i < l; i++) {
      change = interceptors[i](change);
      if (change && !change.type) {
        die(14);
      }
      if (!change) {
        break;
      }
    }
    return change;
  } finally {
    untrackedEnd(prevU);
  }
}

function hasListeners(listenable) {
  return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
  var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
  listeners.push(handler);
  return once(function () {
    var idx = listeners.indexOf(handler);
    if (idx !== -1) {
      listeners.splice(idx, 1);
    }
  });
}
function notifyListeners(listenable, change) {
  var prevU = untrackedStart();
  var listeners = listenable.changeListeners_;
  if (!listeners) {
    return;
  }
  listeners = listeners.slice();
  for (var i = 0, l = listeners.length; i < l; i++) {
    listeners[i](change);
  }
  untrackedEnd(prevU);
}

function makeObservable(target, annotations, options) {
  initObservable(function () {
    var _annotations;
    var adm = asObservableObject(target, options)[$mobx];
    if (false) {}
    // Default to decorators
    (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
    // Annotate
    ownKeys(annotations).forEach(function (key) {
      return adm.make_(key, annotations[key]);
    });
  });
  return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
  if (false) {}
  // Optimization: avoid visiting protos
  // Assumes that annotation.make_/.extend_ works the same for plain objects
  if (isPlainObject(target)) {
    return extendObservable(target, target, overrides, options);
  }
  initObservable(function () {
    var adm = asObservableObject(target, options)[$mobx];
    // Optimization: cache keys on proto
    // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
    if (!target[keysSymbol]) {
      var proto = Object.getPrototypeOf(target);
      var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
      keys["delete"]("constructor");
      keys["delete"]($mobx);
      addHiddenProp(proto, keysSymbol, keys);
    }
    target[keysSymbol].forEach(function (key) {
      return adm.make_(key,
      // must pass "undefined" for { key: undefined }
      !overrides ? true : key in overrides ? overrides[key] : true);
    });
  });
  return target;
}

var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
  get: function get(target, name) {
    var adm = target[$mobx];
    if (name === $mobx) {
      return adm;
    }
    if (name === "length") {
      return adm.getArrayLength_();
    }
    if (typeof name === "string" && !isNaN(name)) {
      return adm.get_(parseInt(name));
    }
    if (hasProp(arrayExtensions, name)) {
      return arrayExtensions[name];
    }
    return target[name];
  },
  set: function set(target, name, value) {
    var adm = target[$mobx];
    if (name === "length") {
      adm.setArrayLength_(value);
    }
    if (typeof name === "symbol" || isNaN(name)) {
      target[name] = value;
    } else {
      // numeric string
      adm.set_(parseInt(name), value);
    }
    return true;
  },
  preventExtensions: function preventExtensions() {
    die(15);
  }
};
var ObservableArrayAdministration = /*#__PURE__*/function () {
  function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
    if (name === void 0) {
      name =  false ? 0 : "ObservableArray";
    }
    this.owned_ = void 0;
    this.legacyMode_ = void 0;
    this.atom_ = void 0;
    this.values_ = [];
    // this is the prop that gets proxied, so can't replace it!
    this.interceptors_ = void 0;
    this.changeListeners_ = void 0;
    this.enhancer_ = void 0;
    this.dehancer = void 0;
    this.proxy_ = void 0;
    this.lastKnownLength_ = 0;
    this.owned_ = owned_;
    this.legacyMode_ = legacyMode_;
    this.atom_ = new Atom(name);
    this.enhancer_ = function (newV, oldV) {
      return enhancer(newV, oldV,  false ? 0 : "ObservableArray[..]");
    };
  }
  var _proto = ObservableArrayAdministration.prototype;
  _proto.dehanceValue_ = function dehanceValue_(value) {
    if (this.dehancer !== undefined) {
      return this.dehancer(value);
    }
    return value;
  };
  _proto.dehanceValues_ = function dehanceValues_(values) {
    if (this.dehancer !== undefined && values.length > 0) {
      return values.map(this.dehancer);
    }
    return values;
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  _proto.observe_ = function observe_(listener, fireImmediately) {
    if (fireImmediately === void 0) {
      fireImmediately = false;
    }
    if (fireImmediately) {
      listener({
        observableKind: "array",
        object: this.proxy_,
        debugObjectName: this.atom_.name_,
        type: "splice",
        index: 0,
        added: this.values_.slice(),
        addedCount: this.values_.length,
        removed: [],
        removedCount: 0
      });
    }
    return registerListener(this, listener);
  };
  _proto.getArrayLength_ = function getArrayLength_() {
    this.atom_.reportObserved();
    return this.values_.length;
  };
  _proto.setArrayLength_ = function setArrayLength_(newLength) {
    if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) {
      die("Out of range: " + newLength);
    }
    var currentLength = this.values_.length;
    if (newLength === currentLength) {
      return;
    } else if (newLength > currentLength) {
      var newItems = new Array(newLength - currentLength);
      for (var i = 0; i < newLength - currentLength; i++) {
        newItems[i] = undefined;
      } // No Array.fill everywhere...
      this.spliceWithArray_(currentLength, 0, newItems);
    } else {
      this.spliceWithArray_(newLength, currentLength - newLength);
    }
  };
  _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
    if (oldLength !== this.lastKnownLength_) {
      die(16);
    }
    this.lastKnownLength_ += delta;
    if (this.legacyMode_ && delta > 0) {
      reserveArrayBuffer(oldLength + delta + 1);
    }
  };
  _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
    var _this = this;
    checkIfStateModificationsAreAllowed(this.atom_);
    var length = this.values_.length;
    if (index === undefined) {
      index = 0;
    } else if (index > length) {
      index = length;
    } else if (index < 0) {
      index = Math.max(0, length + index);
    }
    if (arguments.length === 1) {
      deleteCount = length - index;
    } else if (deleteCount === undefined || deleteCount === null) {
      deleteCount = 0;
    } else {
      deleteCount = Math.max(0, Math.min(deleteCount, length - index));
    }
    if (newItems === undefined) {
      newItems = EMPTY_ARRAY;
    }
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        object: this.proxy_,
        type: SPLICE,
        index: index,
        removedCount: deleteCount,
        added: newItems
      });
      if (!change) {
        return EMPTY_ARRAY;
      }
      deleteCount = change.removedCount;
      newItems = change.added;
    }
    newItems = newItems.length === 0 ? newItems : newItems.map(function (v) {
      return _this.enhancer_(v, undefined);
    });
    if (this.legacyMode_ || "production" !== "production") {
      var lengthDelta = newItems.length - deleteCount;
      this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
    }
    var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
    if (deleteCount !== 0 || newItems.length !== 0) {
      this.notifyArraySplice_(index, newItems, res);
    }
    return this.dehanceValues_(res);
  };
  _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
    if (newItems.length < MAX_SPLICE_SIZE) {
      var _this$values_;
      return (_this$values_ = this.values_).splice.apply(_this$values_, [index, deleteCount].concat(newItems));
    } else {
      // The items removed by the splice
      var res = this.values_.slice(index, index + deleteCount);
      // The items that that should remain at the end of the array
      var oldItems = this.values_.slice(index + deleteCount);
      // New length is the previous length + addition count - deletion count
      this.values_.length += newItems.length - deleteCount;
      for (var i = 0; i < newItems.length; i++) {
        this.values_[index + i] = newItems[i];
      }
      for (var _i = 0; _i < oldItems.length; _i++) {
        this.values_[index + newItems.length + _i] = oldItems[_i];
      }
      return res;
    }
  };
  _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
    var notifySpy = !this.owned_ && isSpyEnabled();
    var notify = hasListeners(this);
    var change = notify || notifySpy ? {
      observableKind: "array",
      object: this.proxy_,
      type: UPDATE,
      debugObjectName: this.atom_.name_,
      index: index,
      newValue: newValue,
      oldValue: oldValue
    } : null;
    // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
    // cause any runtime overhead in development mode without NODE_ENV set, unless spying is enabled
    if (false) {}
    this.atom_.reportChanged();
    if (notify) {
      notifyListeners(this, change);
    }
    if (false) {}
  };
  _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
    var notifySpy = !this.owned_ && isSpyEnabled();
    var notify = hasListeners(this);
    var change = notify || notifySpy ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: SPLICE,
      index: index,
      removed: removed,
      added: added,
      removedCount: removed.length,
      addedCount: added.length
    } : null;
    if (false) {}
    this.atom_.reportChanged();
    // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
    if (notify) {
      notifyListeners(this, change);
    }
    if (false) {}
  };
  _proto.get_ = function get_(index) {
    if (this.legacyMode_ && index >= this.values_.length) {
      console.warn( false ? 0 : "[mobx] Out of bounds read: " + index);
      return undefined;
    }
    this.atom_.reportObserved();
    return this.dehanceValue_(this.values_[index]);
  };
  _proto.set_ = function set_(index, newValue) {
    var values = this.values_;
    if (this.legacyMode_ && index > values.length) {
      // out of bounds
      die(17, index, values.length);
    }
    if (index < values.length) {
      // update at index in range
      checkIfStateModificationsAreAllowed(this.atom_);
      var oldValue = values[index];
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          type: UPDATE,
          object: this.proxy_,
          // since "this" is the real array we need to pass its proxy
          index: index,
          newValue: newValue
        });
        if (!change) {
          return;
        }
        newValue = change.newValue;
      }
      newValue = this.enhancer_(newValue, oldValue);
      var changed = newValue !== oldValue;
      if (changed) {
        values[index] = newValue;
        this.notifyArrayChildUpdate_(index, newValue, oldValue);
      }
    } else {
      // For out of bound index, we don't create an actual sparse array,
      // but rather fill the holes with undefined (same as setArrayLength_).
      // This could be considered a bug.
      var newItems = new Array(index + 1 - values.length);
      for (var i = 0; i < newItems.length - 1; i++) {
        newItems[i] = undefined;
      } // No Array.fill everywhere...
      newItems[newItems.length - 1] = newValue;
      this.spliceWithArray_(values.length, 0, newItems);
    }
  };
  return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
  if (name === void 0) {
    name =  false ? 0 : "ObservableArray";
  }
  if (owned === void 0) {
    owned = false;
  }
  assertProxies();
  return initObservable(function () {
    var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
    addHiddenFinalProp(adm.values_, $mobx, adm);
    var proxy = new Proxy(adm.values_, arrayTraps);
    adm.proxy_ = proxy;
    if (initialValues && initialValues.length) {
      adm.spliceWithArray_(0, 0, initialValues);
    }
    return proxy;
  });
}
// eslint-disable-next-line
var arrayExtensions = {
  clear: function clear() {
    return this.splice(0);
  },
  replace: function replace(newItems) {
    var adm = this[$mobx];
    return adm.spliceWithArray_(0, adm.values_.length, newItems);
  },
  // Used by JSON.stringify
  toJSON: function toJSON() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function splice(index, deleteCount) {
    for (var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      newItems[_key - 2] = arguments[_key];
    }
    var adm = this[$mobx];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return adm.spliceWithArray_(index);
      case 2:
        return adm.spliceWithArray_(index, deleteCount);
    }
    return adm.spliceWithArray_(index, deleteCount, newItems);
  },
  spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
    return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
  },
  push: function push() {
    var adm = this[$mobx];
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }
    adm.spliceWithArray_(adm.values_.length, 0, items);
    return adm.values_.length;
  },
  pop: function pop() {
    return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
  },
  shift: function shift() {
    return this.splice(0, 1)[0];
  },
  unshift: function unshift() {
    var adm = this[$mobx];
    for (var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      items[_key3] = arguments[_key3];
    }
    adm.spliceWithArray_(0, 0, items);
    return adm.values_.length;
  },
  reverse: function reverse() {
    // reverse by default mutates in place before returning the result
    // which makes it both a 'derivation' and a 'mutation'.
    if (globalState.trackingDerivation) {
      die(37, "reverse");
    }
    this.replace(this.slice().reverse());
    return this;
  },
  sort: function sort() {
    // sort by default mutates in place before returning the result
    // which goes against all good practices. Let's not change the array in place!
    if (globalState.trackingDerivation) {
      die(37, "sort");
    }
    var copy = this.slice();
    copy.sort.apply(copy, arguments);
    this.replace(copy);
    return this;
  },
  remove: function remove(value) {
    var adm = this[$mobx];
    var idx = adm.dehanceValues_(adm.values_).indexOf(value);
    if (idx > -1) {
      this.splice(idx, 1);
      return true;
    }
    return false;
  }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */
addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
  if (typeof Array.prototype[funcName] === "function") {
    arrayExtensions[funcName] = funcFactory(funcName);
  }
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
  return function () {
    var adm = this[$mobx];
    adm.atom_.reportObserved();
    var dehancedValues = adm.dehanceValues_(adm.values_);
    return dehancedValues[funcName].apply(dehancedValues, arguments);
  };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
  return function (callback, thisArg) {
    var _this2 = this;
    var adm = this[$mobx];
    adm.atom_.reportObserved();
    var dehancedValues = adm.dehanceValues_(adm.values_);
    return dehancedValues[funcName](function (element, index) {
      return callback.call(thisArg, element, index, _this2);
    });
  };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
  return function () {
    var _this3 = this;
    var adm = this[$mobx];
    adm.atom_.reportObserved();
    var dehancedValues = adm.dehanceValues_(adm.values_);
    // #2432 - reduce behavior depends on arguments.length
    var callback = arguments[0];
    arguments[0] = function (accumulator, currentValue, index) {
      return callback(accumulator, currentValue, index, _this3);
    };
    return dehancedValues[funcName].apply(dehancedValues, arguments);
  };
}
var isObservableArrayAdministration = /*#__PURE__*/createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
  return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}

var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/function () {
  function ObservableMap(initialData, enhancer_, name_) {
    var _this = this;
    if (enhancer_ === void 0) {
      enhancer_ = deepEnhancer;
    }
    if (name_ === void 0) {
      name_ =  false ? 0 : "ObservableMap";
    }
    this.enhancer_ = void 0;
    this.name_ = void 0;
    this[$mobx] = ObservableMapMarker;
    this.data_ = void 0;
    this.hasMap_ = void 0;
    // hasMap, not hashMap >-).
    this.keysAtom_ = void 0;
    this.interceptors_ = void 0;
    this.changeListeners_ = void 0;
    this.dehancer = void 0;
    this.enhancer_ = enhancer_;
    this.name_ = name_;
    if (!isFunction(Map)) {
      die(18);
    }
    initObservable(function () {
      _this.keysAtom_ = createAtom( false ? 0 : "ObservableMap.keys()");
      _this.data_ = new Map();
      _this.hasMap_ = new Map();
      if (initialData) {
        _this.merge(initialData);
      }
    });
  }
  var _proto = ObservableMap.prototype;
  _proto.has_ = function has_(key) {
    return this.data_.has(key);
  };
  _proto.has = function has(key) {
    var _this2 = this;
    if (!globalState.trackingDerivation) {
      return this.has_(key);
    }
    var entry = this.hasMap_.get(key);
    if (!entry) {
      var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer,  false ? 0 : "ObservableMap.key?", false);
      this.hasMap_.set(key, newEntry);
      onBecomeUnobserved(newEntry, function () {
        return _this2.hasMap_["delete"](key);
      });
    }
    return entry.get();
  };
  _proto.set = function set(key, value) {
    var hasKey = this.has_(key);
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: hasKey ? UPDATE : ADD,
        object: this,
        newValue: value,
        name: key
      });
      if (!change) {
        return this;
      }
      value = change.newValue;
    }
    if (hasKey) {
      this.updateValue_(key, value);
    } else {
      this.addValue_(key, value);
    }
    return this;
  };
  _proto["delete"] = function _delete(key) {
    var _this3 = this;
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: DELETE,
        object: this,
        name: key
      });
      if (!change) {
        return false;
      }
    }
    if (this.has_(key)) {
      var notifySpy = isSpyEnabled();
      var notify = hasListeners(this);
      var _change = notify || notifySpy ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: DELETE,
        object: this,
        oldValue: this.data_.get(key).value_,
        name: key
      } : null;
      if (false) {} // TODO fix type
      transaction(function () {
        var _this3$hasMap_$get;
        _this3.keysAtom_.reportChanged();
        (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
        var observable = _this3.data_.get(key);
        observable.setNewValue_(undefined);
        _this3.data_["delete"](key);
      });
      if (notify) {
        notifyListeners(this, _change);
      }
      if (false) {}
      return true;
    }
    return false;
  };
  _proto.updateValue_ = function updateValue_(key, newValue) {
    var observable = this.data_.get(key);
    newValue = observable.prepareNewValue_(newValue);
    if (newValue !== globalState.UNCHANGED) {
      var notifySpy = isSpyEnabled();
      var notify = hasListeners(this);
      var change = notify || notifySpy ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: UPDATE,
        object: this,
        oldValue: observable.value_,
        name: key,
        newValue: newValue
      } : null;
      if (false) {} // TODO fix type
      observable.setNewValue_(newValue);
      if (notify) {
        notifyListeners(this, change);
      }
      if (false) {}
    }
  };
  _proto.addValue_ = function addValue_(key, newValue) {
    var _this4 = this;
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    transaction(function () {
      var _this4$hasMap_$get;
      var observable = new ObservableValue(newValue, _this4.enhancer_,  false ? 0 : "ObservableMap.key", false);
      _this4.data_.set(key, observable);
      newValue = observable.value_; // value might have been changed
      (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
      _this4.keysAtom_.reportChanged();
    });
    var notifySpy = isSpyEnabled();
    var notify = hasListeners(this);
    var change = notify || notifySpy ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: ADD,
      object: this,
      name: key,
      newValue: newValue
    } : null;
    if (false) {} // TODO fix type
    if (notify) {
      notifyListeners(this, change);
    }
    if (false) {}
  };
  _proto.get = function get(key) {
    if (this.has(key)) {
      return this.dehanceValue_(this.data_.get(key).get());
    }
    return this.dehanceValue_(undefined);
  };
  _proto.dehanceValue_ = function dehanceValue_(value) {
    if (this.dehancer !== undefined) {
      return this.dehancer(value);
    }
    return value;
  };
  _proto.keys = function keys() {
    this.keysAtom_.reportObserved();
    return this.data_.keys();
  };
  _proto.values = function values() {
    var self = this;
    var keys = this.keys();
    return makeIterable({
      next: function next() {
        var _keys$next = keys.next(),
          done = _keys$next.done,
          value = _keys$next.value;
        return {
          done: done,
          value: done ? undefined : self.get(value)
        };
      }
    });
  };
  _proto.entries = function entries() {
    var self = this;
    var keys = this.keys();
    return makeIterable({
      next: function next() {
        var _keys$next2 = keys.next(),
          done = _keys$next2.done,
          value = _keys$next2.value;
        return {
          done: done,
          value: done ? undefined : [value, self.get(value)]
        };
      }
    });
  };
  _proto[Symbol.iterator] = function () {
    return this.entries();
  };
  _proto.forEach = function forEach(callback, thisArg) {
    for (var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
        key = _step$value[0],
        value = _step$value[1];
      callback.call(thisArg, value, key, this);
    }
  }
  /** Merge another object into this object, returns this. */;
  _proto.merge = function merge(other) {
    var _this5 = this;
    if (isObservableMap(other)) {
      other = new Map(other);
    }
    transaction(function () {
      if (isPlainObject(other)) {
        getPlainObjectKeys(other).forEach(function (key) {
          return _this5.set(key, other[key]);
        });
      } else if (Array.isArray(other)) {
        other.forEach(function (_ref) {
          var key = _ref[0],
            value = _ref[1];
          return _this5.set(key, value);
        });
      } else if (isES6Map(other)) {
        if (!isPlainES6Map(other)) {
          die(19, other);
        }
        other.forEach(function (value, key) {
          return _this5.set(key, value);
        });
      } else if (other !== null && other !== undefined) {
        die(20, other);
      }
    });
    return this;
  };
  _proto.clear = function clear() {
    var _this6 = this;
    transaction(function () {
      untracked(function () {
        for (var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;) {
          var key = _step2.value;
          _this6["delete"](key);
        }
      });
    });
  };
  _proto.replace = function replace(values) {
    var _this7 = this;
    // Implementation requirements:
    // - respect ordering of replacement map
    // - allow interceptors to run and potentially prevent individual operations
    // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
    // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
    // - note that result map may differ from replacement map due to the interceptors
    transaction(function () {
      // Convert to map so we can do quick key lookups
      var replacementMap = convertToMap(values);
      var orderedData = new Map();
      // Used for optimization
      var keysReportChangedCalled = false;
      // Delete keys that don't exist in replacement map
      // if the key deletion is prevented by interceptor
      // add entry at the beginning of the result map
      for (var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;) {
        var key = _step3.value;
        // Concurrently iterating/deleting keys
        // iterator should handle this correctly
        if (!replacementMap.has(key)) {
          var deleted = _this7["delete"](key);
          // Was the key removed?
          if (deleted) {
            // _keysAtom.reportChanged() was already called
            keysReportChangedCalled = true;
          } else {
            // Delete prevented by interceptor
            var value = _this7.data_.get(key);
            orderedData.set(key, value);
          }
        }
      }
      // Merge entries
      for (var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;) {
        var _step4$value = _step4.value,
          _key = _step4$value[0],
          _value = _step4$value[1];
        // We will want to know whether a new key is added
        var keyExisted = _this7.data_.has(_key);
        // Add or update value
        _this7.set(_key, _value);
        // The addition could have been prevent by interceptor
        if (_this7.data_.has(_key)) {
          // The update could have been prevented by interceptor
          // and also we want to preserve existing values
          // so use value from _data map (instead of replacement map)
          var _value2 = _this7.data_.get(_key);
          orderedData.set(_key, _value2);
          // Was a new key added?
          if (!keyExisted) {
            // _keysAtom.reportChanged() was already called
            keysReportChangedCalled = true;
          }
        }
      }
      // Check for possible key order change
      if (!keysReportChangedCalled) {
        if (_this7.data_.size !== orderedData.size) {
          // If size differs, keys are definitely modified
          _this7.keysAtom_.reportChanged();
        } else {
          var iter1 = _this7.data_.keys();
          var iter2 = orderedData.keys();
          var next1 = iter1.next();
          var next2 = iter2.next();
          while (!next1.done) {
            if (next1.value !== next2.value) {
              _this7.keysAtom_.reportChanged();
              break;
            }
            next1 = iter1.next();
            next2 = iter2.next();
          }
        }
      }
      // Use correctly ordered map
      _this7.data_ = orderedData;
    });
    return this;
  };
  _proto.toString = function toString() {
    return "[object ObservableMap]";
  };
  _proto.toJSON = function toJSON() {
    return Array.from(this);
  };
  /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */
  _proto.observe_ = function observe_(listener, fireImmediately) {
    if (false) {}
    return registerListener(this, listener);
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  return _createClass(ObservableMap, [{
    key: "size",
    get: function get() {
      this.keysAtom_.reportObserved();
      return this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return "Map";
    }
  }]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
  if (isES6Map(dataStructure) || isObservableMap(dataStructure)) {
    return dataStructure;
  } else if (Array.isArray(dataStructure)) {
    return new Map(dataStructure);
  } else if (isPlainObject(dataStructure)) {
    var map = new Map();
    for (var key in dataStructure) {
      map.set(key, dataStructure[key]);
    }
    return map;
  } else {
    return die(21, dataStructure);
  }
}

var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/function () {
  function ObservableSet(initialData, enhancer, name_) {
    var _this = this;
    if (enhancer === void 0) {
      enhancer = deepEnhancer;
    }
    if (name_ === void 0) {
      name_ =  false ? 0 : "ObservableSet";
    }
    this.name_ = void 0;
    this[$mobx] = ObservableSetMarker;
    this.data_ = new Set();
    this.atom_ = void 0;
    this.changeListeners_ = void 0;
    this.interceptors_ = void 0;
    this.dehancer = void 0;
    this.enhancer_ = void 0;
    this.name_ = name_;
    if (!isFunction(Set)) {
      die(22);
    }
    this.enhancer_ = function (newV, oldV) {
      return enhancer(newV, oldV, name_);
    };
    initObservable(function () {
      _this.atom_ = createAtom(_this.name_);
      if (initialData) {
        _this.replace(initialData);
      }
    });
  }
  var _proto = ObservableSet.prototype;
  _proto.dehanceValue_ = function dehanceValue_(value) {
    if (this.dehancer !== undefined) {
      return this.dehancer(value);
    }
    return value;
  };
  _proto.clear = function clear() {
    var _this2 = this;
    transaction(function () {
      untracked(function () {
        for (var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;) {
          var value = _step.value;
          _this2["delete"](value);
        }
      });
    });
  };
  _proto.forEach = function forEach(callbackFn, thisArg) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;) {
      var value = _step2.value;
      callbackFn.call(thisArg, value, value, this);
    }
  };
  _proto.add = function add(value) {
    var _this3 = this;
    checkIfStateModificationsAreAllowed(this.atom_);
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: ADD,
        object: this,
        newValue: value
      });
      if (!change) {
        return this;
      }
      // ideally, value = change.value would be done here, so that values can be
      // changed by interceptor. Same applies for other Set and Map api's.
    }
    if (!this.has(value)) {
      transaction(function () {
        _this3.data_.add(_this3.enhancer_(value, undefined));
        _this3.atom_.reportChanged();
      });
      var notifySpy =  false && 0;
      var notify = hasListeners(this);
      var _change = notify || notifySpy ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: ADD,
        object: this,
        newValue: value
      } : null;
      if (notifySpy && "production" !== "production") {}
      if (notify) {
        notifyListeners(this, _change);
      }
      if (notifySpy && "production" !== "production") {}
    }
    return this;
  };
  _proto["delete"] = function _delete(value) {
    var _this4 = this;
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: DELETE,
        object: this,
        oldValue: value
      });
      if (!change) {
        return false;
      }
    }
    if (this.has(value)) {
      var notifySpy =  false && 0;
      var notify = hasListeners(this);
      var _change2 = notify || notifySpy ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: DELETE,
        object: this,
        oldValue: value
      } : null;
      if (notifySpy && "production" !== "production") {}
      transaction(function () {
        _this4.atom_.reportChanged();
        _this4.data_["delete"](value);
      });
      if (notify) {
        notifyListeners(this, _change2);
      }
      if (notifySpy && "production" !== "production") {}
      return true;
    }
    return false;
  };
  _proto.has = function has(value) {
    this.atom_.reportObserved();
    return this.data_.has(this.dehanceValue_(value));
  };
  _proto.entries = function entries() {
    var nextIndex = 0;
    var keys = Array.from(this.keys());
    var values = Array.from(this.values());
    return makeIterable({
      next: function next() {
        var index = nextIndex;
        nextIndex += 1;
        return index < values.length ? {
          value: [keys[index], values[index]],
          done: false
        } : {
          done: true
        };
      }
    });
  };
  _proto.keys = function keys() {
    return this.values();
  };
  _proto.values = function values() {
    this.atom_.reportObserved();
    var self = this;
    var nextIndex = 0;
    var observableValues = Array.from(this.data_.values());
    return makeIterable({
      next: function next() {
        return nextIndex < observableValues.length ? {
          value: self.dehanceValue_(observableValues[nextIndex++]),
          done: false
        } : {
          done: true
        };
      }
    });
  };
  _proto.intersection = function intersection(otherSet) {
    if (isES6Set(otherSet) && !isObservableSet(otherSet)) {
      return otherSet.intersection(this);
    } else {
      var dehancedSet = new Set(this);
      return dehancedSet.intersection(otherSet);
    }
  };
  _proto.union = function union(otherSet) {
    if (isES6Set(otherSet) && !isObservableSet(otherSet)) {
      return otherSet.union(this);
    } else {
      var dehancedSet = new Set(this);
      return dehancedSet.union(otherSet);
    }
  };
  _proto.difference = function difference(otherSet) {
    return new Set(this).difference(otherSet);
  };
  _proto.symmetricDifference = function symmetricDifference(otherSet) {
    if (isES6Set(otherSet) && !isObservableSet(otherSet)) {
      return otherSet.symmetricDifference(this);
    } else {
      var dehancedSet = new Set(this);
      return dehancedSet.symmetricDifference(otherSet);
    }
  };
  _proto.isSubsetOf = function isSubsetOf(otherSet) {
    return new Set(this).isSubsetOf(otherSet);
  };
  _proto.isSupersetOf = function isSupersetOf(otherSet) {
    return new Set(this).isSupersetOf(otherSet);
  };
  _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
    if (isES6Set(otherSet) && !isObservableSet(otherSet)) {
      return otherSet.isDisjointFrom(this);
    } else {
      var dehancedSet = new Set(this);
      return dehancedSet.isDisjointFrom(otherSet);
    }
  };
  _proto.replace = function replace(other) {
    var _this5 = this;
    if (isObservableSet(other)) {
      other = new Set(other);
    }
    transaction(function () {
      if (Array.isArray(other)) {
        _this5.clear();
        other.forEach(function (value) {
          return _this5.add(value);
        });
      } else if (isES6Set(other)) {
        _this5.clear();
        other.forEach(function (value) {
          return _this5.add(value);
        });
      } else if (other !== null && other !== undefined) {
        die("Cannot initialize set from " + other);
      }
    });
    return this;
  };
  _proto.observe_ = function observe_(listener, fireImmediately) {
    // ... 'fireImmediately' could also be true?
    if (false) {}
    return registerListener(this, listener);
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  _proto.toJSON = function toJSON() {
    return Array.from(this);
  };
  _proto.toString = function toString() {
    return "[object ObservableSet]";
  };
  _proto[Symbol.iterator] = function () {
    return this.values();
  };
  return _createClass(ObservableSet, [{
    key: "size",
    get: function get() {
      this.atom_.reportObserved();
      return this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return "Set";
    }
  }]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/createInstanceofPredicate("ObservableSet", ObservableSet);

var descriptorCache = /*#__PURE__*/Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/function () {
  function ObservableObjectAdministration(target_, values_, name_,
  // Used anytime annotation is not explicitely provided
  defaultAnnotation_) {
    if (values_ === void 0) {
      values_ = new Map();
    }
    if (defaultAnnotation_ === void 0) {
      defaultAnnotation_ = autoAnnotation;
    }
    this.target_ = void 0;
    this.values_ = void 0;
    this.name_ = void 0;
    this.defaultAnnotation_ = void 0;
    this.keysAtom_ = void 0;
    this.changeListeners_ = void 0;
    this.interceptors_ = void 0;
    this.proxy_ = void 0;
    this.isPlainObject_ = void 0;
    this.appliedAnnotations_ = void 0;
    this.pendingKeys_ = void 0;
    this.target_ = target_;
    this.values_ = values_;
    this.name_ = name_;
    this.defaultAnnotation_ = defaultAnnotation_;
    this.keysAtom_ = new Atom( false ? 0 : "ObservableObject.keys");
    // Optimization: we use this frequently
    this.isPlainObject_ = isPlainObject(this.target_);
    if (false) {}
    if (false) {}
  }
  var _proto = ObservableObjectAdministration.prototype;
  _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
    return this.values_.get(key).get();
  };
  _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
    var observable = this.values_.get(key);
    if (observable instanceof ComputedValue) {
      observable.set(newValue);
      return true;
    }
    // intercept
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: UPDATE,
        object: this.proxy_ || this.target_,
        name: key,
        newValue: newValue
      });
      if (!change) {
        return null;
      }
      newValue = change.newValue;
    }
    newValue = observable.prepareNewValue_(newValue);
    // notify spy & observers
    if (newValue !== globalState.UNCHANGED) {
      var notify = hasListeners(this);
      var notifySpy =  false && 0;
      var _change = notify || notifySpy ? {
        type: UPDATE,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: observable.value_,
        name: key,
        newValue: newValue
      } : null;
      if (false) {}
      observable.setNewValue_(newValue);
      if (notify) {
        notifyListeners(this, _change);
      }
      if (false) {}
    }
    return true;
  };
  _proto.get_ = function get_(key) {
    if (globalState.trackingDerivation && !hasProp(this.target_, key)) {
      // Key doesn't exist yet, subscribe for it in case it's added later
      this.has_(key);
    }
    return this.target_[key];
  }
  /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */;
  _proto.set_ = function set_(key, value, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    // Don't use .has(key) - we care about own
    if (hasProp(this.target_, key)) {
      // Existing prop
      if (this.values_.has(key)) {
        // Observable (can be intercepted)
        return this.setObservablePropValue_(key, value);
      } else if (proxyTrap) {
        // Non-observable - proxy
        return Reflect.set(this.target_, key, value);
      } else {
        // Non-observable
        this.target_[key] = value;
        return true;
      }
    } else {
      // New prop
      return this.extend_(key, {
        value: value,
        enumerable: true,
        writable: true,
        configurable: true
      }, this.defaultAnnotation_, proxyTrap);
    }
  }
  // Trap for "in"
  ;
  _proto.has_ = function has_(key) {
    if (!globalState.trackingDerivation) {
      // Skip key subscription outside derivation
      return key in this.target_;
    }
    this.pendingKeys_ || (this.pendingKeys_ = new Map());
    var entry = this.pendingKeys_.get(key);
    if (!entry) {
      entry = new ObservableValue(key in this.target_, referenceEnhancer,  false ? 0 : "ObservableObject.key?", false);
      this.pendingKeys_.set(key, entry);
    }
    return entry.get();
  }
  /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */;
  _proto.make_ = function make_(key, annotation) {
    if (annotation === true) {
      annotation = this.defaultAnnotation_;
    }
    if (annotation === false) {
      return;
    }
    assertAnnotable(this, annotation, key);
    if (!(key in this.target_)) {
      var _this$target_$storedA;
      // Throw on missing key, except for decorators:
      // Decorator annotations are collected from whole prototype chain.
      // When called from super() some props may not exist yet.
      // However we don't have to worry about missing prop,
      // because the decorator must have been applied to something.
      if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) {
        return; // will be annotated by subclass constructor
      } else {
        die(1, annotation.annotationType_, this.name_ + "." + key.toString());
      }
    }
    var source = this.target_;
    while (source && source !== objectPrototype) {
      var descriptor = getDescriptor(source, key);
      if (descriptor) {
        var outcome = annotation.make_(this, key, descriptor, source);
        if (outcome === 0 /* MakeResult.Cancel */) {
          return;
        }
        if (outcome === 1 /* MakeResult.Break */) {
          break;
        }
      }
      source = Object.getPrototypeOf(source);
    }
    recordAnnotationApplied(this, annotation, key);
  }
  /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */;
  _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    if (annotation === true) {
      annotation = this.defaultAnnotation_;
    }
    if (annotation === false) {
      return this.defineProperty_(key, descriptor, proxyTrap);
    }
    assertAnnotable(this, annotation, key);
    var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
    if (outcome) {
      recordAnnotationApplied(this, annotation, key);
    }
    return outcome;
  }
  /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */;
  _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      // Delete
      var deleteOutcome = this.delete_(key);
      if (!deleteOutcome) {
        // Failure or intercepted
        return deleteOutcome;
      }
      // ADD interceptor
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: key,
          type: ADD,
          newValue: descriptor.value
        });
        if (!change) {
          return null;
        }
        var newValue = change.newValue;
        if (descriptor.value !== newValue) {
          descriptor = _extends({}, descriptor, {
            value: newValue
          });
        }
      }
      // Define
      if (proxyTrap) {
        if (!Reflect.defineProperty(this.target_, key, descriptor)) {
          return false;
        }
      } else {
        defineProperty(this.target_, key, descriptor);
      }
      // Notify
      this.notifyPropertyAddition_(key, descriptor.value);
    } finally {
      endBatch();
    }
    return true;
  }
  // If original descriptor becomes relevant, move this to annotation directly
  ;
  _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      // Delete
      var deleteOutcome = this.delete_(key);
      if (!deleteOutcome) {
        // Failure or intercepted
        return deleteOutcome;
      }
      // ADD interceptor
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: key,
          type: ADD,
          newValue: value
        });
        if (!change) {
          return null;
        }
        value = change.newValue;
      }
      var cachedDescriptor = getCachedObservablePropDescriptor(key);
      var descriptor = {
        configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
        enumerable: true,
        get: cachedDescriptor.get,
        set: cachedDescriptor.set
      };
      // Define
      if (proxyTrap) {
        if (!Reflect.defineProperty(this.target_, key, descriptor)) {
          return false;
        }
      } else {
        defineProperty(this.target_, key, descriptor);
      }
      var observable = new ObservableValue(value, enhancer,  false ? 0 : "ObservableObject.key", false);
      this.values_.set(key, observable);
      // Notify (value possibly changed by ObservableValue)
      this.notifyPropertyAddition_(key, observable.value_);
    } finally {
      endBatch();
    }
    return true;
  }
  // If original descriptor becomes relevant, move this to annotation directly
  ;
  _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    try {
      startBatch();
      // Delete
      var deleteOutcome = this.delete_(key);
      if (!deleteOutcome) {
        // Failure or intercepted
        return deleteOutcome;
      }
      // ADD interceptor
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: key,
          type: ADD,
          newValue: undefined
        });
        if (!change) {
          return null;
        }
      }
      options.name || (options.name =  false ? 0 : "ObservableObject.key");
      options.context = this.proxy_ || this.target_;
      var cachedDescriptor = getCachedObservablePropDescriptor(key);
      var descriptor = {
        configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
        enumerable: false,
        get: cachedDescriptor.get,
        set: cachedDescriptor.set
      };
      // Define
      if (proxyTrap) {
        if (!Reflect.defineProperty(this.target_, key, descriptor)) {
          return false;
        }
      } else {
        defineProperty(this.target_, key, descriptor);
      }
      this.values_.set(key, new ComputedValue(options));
      // Notify
      this.notifyPropertyAddition_(key, undefined);
    } finally {
      endBatch();
    }
    return true;
  }
  /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */;
  _proto.delete_ = function delete_(key, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    // No such prop
    if (!hasProp(this.target_, key)) {
      return true;
    }
    // Intercept
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        object: this.proxy_ || this.target_,
        name: key,
        type: REMOVE
      });
      // Cancelled
      if (!change) {
        return null;
      }
    }
    // Delete
    try {
      var _this$pendingKeys_;
      startBatch();
      var notify = hasListeners(this);
      var notifySpy =  false && 0;
      var observable = this.values_.get(key);
      // Value needed for spies/listeners
      var value = undefined;
      // Optimization: don't pull the value unless we will need it
      if (!observable && (notify || notifySpy)) {
        var _getDescriptor;
        value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
      }
      // delete prop (do first, may fail)
      if (proxyTrap) {
        if (!Reflect.deleteProperty(this.target_, key)) {
          return false;
        }
      } else {
        delete this.target_[key];
      }
      // Allow re-annotating this field
      if (false) {}
      // Clear observable
      if (observable) {
        this.values_["delete"](key);
        // for computed, value is undefined
        if (observable instanceof ObservableValue) {
          value = observable.value_;
        }
        // Notify: autorun(() => obj[key]), see #1796
        propagateChanged(observable);
      }
      // Notify "keys/entries/values" observers
      this.keysAtom_.reportChanged();
      // Notify "has" observers
      // "in" as it may still exist in proto
      (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
      // Notify spies/listeners
      if (notify || notifySpy) {
        var _change2 = {
          type: REMOVE,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: value,
          name: key
        };
        if (false) {}
        if (notify) {
          notifyListeners(this, _change2);
        }
        if (false) {}
      }
    } finally {
      endBatch();
    }
    return true;
  }
  /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */;
  _proto.observe_ = function observe_(callback, fireImmediately) {
    if (false) {}
    return registerListener(this, callback);
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
    var _this$pendingKeys_2;
    var notify = hasListeners(this);
    var notifySpy =  false && 0;
    if (notify || notifySpy) {
      var change = notify || notifySpy ? {
        type: ADD,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: key,
        newValue: value
      } : null;
      if (false) {}
      if (notify) {
        notifyListeners(this, change);
      }
      if (false) {}
    }
    (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
    // Notify "keys/entries/values" observers
    this.keysAtom_.reportChanged();
  };
  _proto.ownKeys_ = function ownKeys_() {
    this.keysAtom_.reportObserved();
    return ownKeys(this.target_);
  };
  _proto.keys_ = function keys_() {
    // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
    // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
    // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
    // We choose to over-report in Object.keys(object), because:
    // - typically it's used with simple data objects
    // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
    this.keysAtom_.reportObserved();
    return Object.keys(this.target_);
  };
  return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
  var _options$name;
  if (false) {}
  if (hasProp(target, $mobx)) {
    if (false) {}
    return target;
  }
  if (false) {}
  var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name :  false ? 0 : "ObservableObject";
  var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
  addHiddenProp(target, $mobx, adm);
  return target;
}
var isObservableObjectAdministration = /*#__PURE__*/createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
  return descriptorCache[key] || (descriptorCache[key] = {
    get: function get() {
      return this[$mobx].getObservablePropValue_(key);
    },
    set: function set(value) {
      return this[$mobx].setObservablePropValue_(key, value);
    }
  });
}
function isObservableObject(thing) {
  if (isObject(thing)) {
    return isObservableObjectAdministration(thing[$mobx]);
  }
  return false;
}
function recordAnnotationApplied(adm, annotation, key) {
  var _adm$target_$storedAn;
  if (false) {}
  // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
  (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
  // Valid annotation
  if (false) {}
  /*
  // Configurable, not sealed, not frozen
  // Possibly not needed, just a little better error then the one thrown by engine.
  // Cases where this would be useful the most (subclass field initializer) are not interceptable by this.
  if (__DEV__) {
      const configurable = getDescriptor(adm.target_, key)?.configurable
      const frozen = Object.isFrozen(adm.target_)
      const sealed = Object.isSealed(adm.target_)
      if (!configurable || frozen || sealed) {
          const fieldName = `${adm.name_}.${key.toString()}`
          const requestedAnnotationType = annotation.annotationType_
          let error = `Cannot apply '${requestedAnnotationType}' to '${fieldName}':`
          if (frozen) {
              error += `\nObject is frozen.`
          }
          if (sealed) {
              error += `\nObject is sealed.`
          }
          if (!configurable) {
              error += `\nproperty is not configurable.`
              // Mention only if caused by us to avoid confusion
              if (hasProp(adm.appliedAnnotations!, key)) {
                  error += `\nTo prevent accidental re-definition of a field by a subclass, `
                  error += `all annotated fields of non-plain objects (classes) are not configurable.`
              }
          }
          die(error)
      }
  }
  */
  // Not annotated
  if (false) { var requestedAnnotationType, currentAnnotationType, fieldName; }
}

// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/function () {
  var v = false;
  var p = {};
  Object.defineProperty(p, "0", {
    set: function set() {
      v = true;
    }
  });
  /*#__PURE__*/Object.create(p)["0"] = 1;
  return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ctor.prototype, proto);
  } else if (ctor.prototype.__proto__ !== undefined) {
    ctor.prototype.__proto__ = proto;
  } else {
    ctor.prototype = proto;
  }
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/function (_StubArray) {
  function LegacyObservableArray(initialValues, enhancer, name, owned) {
    var _this;
    if (name === void 0) {
      name =  false ? 0 : "ObservableArray";
    }
    if (owned === void 0) {
      owned = false;
    }
    _this = _StubArray.call(this) || this;
    initObservable(function () {
      var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
      adm.proxy_ = _this;
      addHiddenFinalProp(_this, $mobx, adm);
      if (initialValues && initialValues.length) {
        // @ts-ignore
        _this.spliceWithArray(0, 0, initialValues);
      }
      if (safariPrototypeSetterInheritanceBug) {
        // Seems that Safari won't use numeric prototype setter until any * numeric property is
        // defined on the instance. After that it works fine, even if this property is deleted.
        Object.defineProperty(_this, "0", ENTRY_0);
      }
    });
    return _this;
  }
  _inheritsLoose(LegacyObservableArray, _StubArray);
  var _proto = LegacyObservableArray.prototype;
  _proto.concat = function concat() {
    this[$mobx].atom_.reportObserved();
    for (var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++) {
      arrays[_key] = arguments[_key];
    }
    return Array.prototype.concat.apply(this.slice(),
    //@ts-ignore
    arrays.map(function (a) {
      return isObservableArray(a) ? a.slice() : a;
    }));
  };
  _proto[Symbol.iterator] = function () {
    var self = this;
    var nextIndex = 0;
    return makeIterable({
      next: function next() {
        return nextIndex < self.length ? {
          value: self[nextIndex++],
          done: false
        } : {
          done: true,
          value: undefined
        };
      }
    });
  };
  return _createClass(LegacyObservableArray, [{
    key: "length",
    get: function get() {
      return this[$mobx].getArrayLength_();
    },
    set: function set(newLength) {
      this[$mobx].setArrayLength_(newLength);
    }
  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return "Array";
    }
  }]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function (_ref) {
  var prop = _ref[0],
    fn = _ref[1];
  if (prop !== "concat") {
    addHiddenProp(LegacyObservableArray.prototype, prop, fn);
  }
});
function createArrayEntryDescriptor(index) {
  return {
    enumerable: false,
    configurable: true,
    get: function get() {
      return this[$mobx].get_(index);
    },
    set: function set(value) {
      this[$mobx].set_(index, value);
    }
  };
}
function createArrayBufferItem(index) {
  defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
  if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++) {
      createArrayBufferItem(index);
    }
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
  }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
  return new LegacyObservableArray(initialValues, enhancer, name);
}

function getAtom(thing, property) {
  if (typeof thing === "object" && thing !== null) {
    if (isObservableArray(thing)) {
      if (property !== undefined) {
        die(23);
      }
      return thing[$mobx].atom_;
    }
    if (isObservableSet(thing)) {
      return thing.atom_;
    }
    if (isObservableMap(thing)) {
      if (property === undefined) {
        return thing.keysAtom_;
      }
      var observable = thing.data_.get(property) || thing.hasMap_.get(property);
      if (!observable) {
        die(25, property, getDebugName(thing));
      }
      return observable;
    }
    if (isObservableObject(thing)) {
      if (!property) {
        return die(26);
      }
      var _observable = thing[$mobx].values_.get(property);
      if (!_observable) {
        die(27, property, getDebugName(thing));
      }
      return _observable;
    }
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
      return thing;
    }
  } else if (isFunction(thing)) {
    if (isReaction(thing[$mobx])) {
      // disposer function
      return thing[$mobx];
    }
  }
  die(28);
}
function getAdministration(thing, property) {
  if (!thing) {
    die(29);
  }
  if (property !== undefined) {
    return getAdministration(getAtom(thing, property));
  }
  if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
    return thing;
  }
  if (isObservableMap(thing) || isObservableSet(thing)) {
    return thing;
  }
  if (thing[$mobx]) {
    return thing[$mobx];
  }
  die(24, thing);
}
function getDebugName(thing, property) {
  var named;
  if (property !== undefined) {
    named = getAtom(thing, property);
  } else if (isAction(thing)) {
    return thing.name;
  } else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) {
    named = getAdministration(thing);
  } else {
    // valid for arrays as well
    named = getAtom(thing);
  }
  return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */
function initObservable(cb) {
  var derivation = untrackedStart();
  var allowStateChanges = allowStateChangesStart(true);
  startBatch();
  try {
    return cb();
  } finally {
    endBatch();
    allowStateChangesEnd(allowStateChanges);
    untrackedEnd(derivation);
  }
}

var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
  if (depth === void 0) {
    depth = -1;
  }
  return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
  // Identical objects are equal. `0 === -0`, but they aren't identical.
  // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
  if (a === b) {
    return a !== 0 || 1 / a === 1 / b;
  }
  // `null` or `undefined` only equal to itself (strict comparison).
  if (a == null || b == null) {
    return false;
  }
  // `NaN`s are equivalent, but non-reflexive.
  if (a !== a) {
    return b !== b;
  }
  // Exhaust primitive checks
  var type = typeof a;
  if (type !== "function" && type !== "object" && typeof b != "object") {
    return false;
  }
  // Compare `[[Class]]` names.
  var className = toString.call(a);
  if (className !== toString.call(b)) {
    return false;
  }
  switch (className) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
      // equivalent to `new String("5")`.
      return "" + a === "" + b;
    case "[object Number]":
      // `NaN`s are equivalent, but non-reflexive.
      // Object(NaN) is equivalent to NaN.
      if (+a !== +a) {
        return +b !== +b;
      }
      // An `egal` comparison is performed for other numeric values.
      return +a === 0 ? 1 / +a === 1 / b : +a === +b;
    case "[object Date]":
    case "[object Boolean]":
      // Coerce dates and booleans to numeric primitive values. Dates are compared by their
      // millisecond representations. Note that invalid dates with millisecond representations
      // of `NaN` are not equivalent.
      return +a === +b;
    case "[object Symbol]":
      return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
    case "[object Map]":
    case "[object Set]":
      // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
      // Hide this extra level by increasing the depth.
      if (depth >= 0) {
        depth++;
      }
      break;
  }
  // Unwrap any wrapped objects.
  a = unwrap(a);
  b = unwrap(b);
  var areArrays = className === "[object Array]";
  if (!areArrays) {
    if (typeof a != "object" || typeof b != "object") {
      return false;
    }
    // Objects with different constructors are not equivalent, but `Object`s or `Array`s
    // from different frames are.
    var aCtor = a.constructor,
      bCtor = b.constructor;
    if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) {
      return false;
    }
  }
  if (depth === 0) {
    return false;
  } else if (depth < 0) {
    depth = -1;
  }
  // Assume equality for cyclic structures. The algorithm for detecting cyclic
  // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
  // Initializing stack of traversed objects.
  // It's done here since we only need them for objects and arrays comparison.
  aStack = aStack || [];
  bStack = bStack || [];
  var length = aStack.length;
  while (length--) {
    // Linear search. Performance is inversely proportional to the number of
    // unique nested structures.
    if (aStack[length] === a) {
      return bStack[length] === b;
    }
  }
  // Add the first object to the stack of traversed objects.
  aStack.push(a);
  bStack.push(b);
  // Recursively compare objects and arrays.
  if (areArrays) {
    // Compare array lengths to determine if a deep comparison is necessary.
    length = a.length;
    if (length !== b.length) {
      return false;
    }
    // Deep compare the contents, ignoring non-numeric properties.
    while (length--) {
      if (!eq(a[length], b[length], depth - 1, aStack, bStack)) {
        return false;
      }
    }
  } else {
    // Deep compare objects.
    var keys = Object.keys(a);
    var key;
    length = keys.length;
    // Ensure that both objects contain the same number of properties before comparing deep equality.
    if (Object.keys(b).length !== length) {
      return false;
    }
    while (length--) {
      // Deep compare each member
      key = keys[length];
      if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) {
        return false;
      }
    }
  }
  // Remove the first object from the stack of traversed objects.
  aStack.pop();
  bStack.pop();
  return true;
}
function unwrap(a) {
  if (isObservableArray(a)) {
    return a.slice();
  }
  if (isES6Map(a) || isObservableMap(a)) {
    return Array.from(a.entries());
  }
  if (isES6Set(a) || isObservableSet(a)) {
    return Array.from(a.entries());
  }
  return a;
}

function makeIterable(iterator) {
  iterator[Symbol.iterator] = getSelf;
  return iterator;
}
function getSelf() {
  return this;
}

function isAnnotation(thing) {
  return (
    // Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_)
  );
}

/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
["Symbol", "Map", "Set"].forEach(function (m) {
  var g = getGlobal();
  if (typeof g[m] === "undefined") {
    die("MobX requires global '" + m + "' to be available or polyfilled");
  }
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
  // See: https://github.com/andykog/mobx-devtools/
  __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
      getDebugName: getDebugName
    },
    $mobx: $mobx
  });
}


//# sourceMappingURL=mobx.esm.js.map


/***/ }),

/***/ 17265:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(23034);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 5821:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(17265)();
}


/***/ }),

/***/ 23034:
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 71358:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(19491);
var parse = __webpack_require__(22509);
var formats = __webpack_require__(9082);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 33726:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/** @license React v0.0.0-experimental-4ead6b530
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(81724),m=__webpack_require__(46084),u=__webpack_require__(39856);function w(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(w(227));var ba=new Set,ca={};function da(a,b){ea(a,b);ea(a+"Capture",b)}
function ea(a,b){ca[a]=b;for(a=0;a<b.length;a++)ba.add(b[a])}
var fa=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ha=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ia=Object.prototype.hasOwnProperty,
ja={},ka={};function la(a){if(ia.call(ka,a))return!0;if(ia.call(ja,a))return!1;if(ha.test(a))return ka[a]=!0;ja[a]=!0;return!1}function ma(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function na(a,b,c,d){if(null===b||"undefined"===typeof b||ma(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function A(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new A(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new A(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new A(a,2,!1,a.toLowerCase(),null,!1,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new A(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new A(a,3,!1,a.toLowerCase(),null,!1,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new A(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){C[a]=new A(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new A(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){C[a]=new A(a,5,!1,a.toLowerCase(),null,!1,!1)});var oa=/[\-:]([a-z])/g;function pa(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(oa,
pa);C[b]=new A(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(oa,pa);C[b]=new A(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(oa,pa);C[b]=new A(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new A(a,1,!1,a.toLowerCase(),null,!1,!1)});
C.xlinkHref=new A("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){C[a]=new A(a,1,!1,a.toLowerCase(),null,!0,!0)});
function qa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(na(b,c,e,d)&&(c=null),d||null===e?la(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var ra=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,sa=60103,ta=60106,ua=60107,va=60108,wa=60114,xa=60109,ya=60110,Aa=60112,Ba=60113,Ca=60120,Da=60115,Ea=60116,Fa=60121,Ga=60128,Ha=60129,Ia=60130,Ja=60131;
if("function"===typeof Symbol&&Symbol.for){var D=Symbol.for;sa=D("react.element");ta=D("react.portal");ua=D("react.fragment");va=D("react.strict_mode");wa=D("react.profiler");xa=D("react.provider");ya=D("react.context");Aa=D("react.forward_ref");Ba=D("react.suspense");Ca=D("react.suspense_list");Da=D("react.memo");Ea=D("react.lazy");Fa=D("react.block");D("react.scope");Ga=D("react.opaque.id");Ha=D("react.debug_trace_mode");Ia=D("react.offscreen");Ja=D("react.legacy_hidden")}
var Ka="function"===typeof Symbol&&Symbol.iterator;function La(a){if(null===a||"object"!==typeof a)return null;a=Ka&&a[Ka]||a["@@iterator"];return"function"===typeof a?a:null}var Ma;function Na(a){if(void 0===Ma)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);Ma=b&&b[1]||""}return"\n"+Ma+a}var Oa=!1;
function Pa(a,b){if(!a||Oa)return"";Oa=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[])}catch(k){var d=k}Reflect.construct(a,[],b)}else{try{b.call()}catch(k){d=k}a.call(b.prototype)}else{try{throw Error();}catch(k){d=k}a()}}catch(k){if(k&&d&&"string"===typeof k.stack){for(var e=k.stack.split("\n"),
f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h])return"\n"+e[g].replace(" at new "," at ");while(1<=g&&0<=h)}break}}}finally{Oa=!1,Error.prepareStackTrace=c}return(a=a?a.displayName||a.name:"")?Na(a):""}
function Qa(a){switch(a.tag){case 5:return Na(a.type);case 16:return Na("Lazy");case 13:return Na("Suspense");case 19:return Na("SuspenseList");case 0:case 2:case 15:return a=Pa(a.type,!1),a;case 11:return a=Pa(a.type.render,!1),a;case 22:return a=Pa(a.type._render,!1),a;case 1:return a=Pa(a.type,!0),a;default:return""}}
function Ra(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ua:return"Fragment";case ta:return"Portal";case wa:return"Profiler";case va:return"StrictMode";case Ba:return"Suspense";case Ca:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ya:return(a.displayName||"Context")+".Consumer";case xa:return(a._context.displayName||"Context")+".Provider";case Aa:var b=a.render;b=b.displayName||b.name||"";
return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");case Da:return Ra(a.type);case Fa:return Ra(a._render);case Ea:b=a._payload;a=a._init;try{return Ra(a(b))}catch(c){}}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Ta(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a))}function Wa(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
function Ya(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function $a(a,b){b=b.checked;null!=b&&qa(a,"checked",b,!1)}
function ab(a,b){$a(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?bb(a,b.type,c):b.hasOwnProperty("defaultValue")&&bb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function cb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function bb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function db(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function eb(a,b){a=m({children:void 0},b);if(b=db(b.children))a.children=b;return a}
function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(w(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(w(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(w(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:Sa(c)}}
function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var kb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function lb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function mb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?lb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var nb,ob=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==kb.svg||"innerHTML"in a)a.innerHTML=b;else{nb=nb||document.createElement("div");nb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=nb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},rb=["Webkit","ms","Moz","O"];Object.keys(qb).forEach(function(a){rb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qb[b]=qb[a]})});function sb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qb.hasOwnProperty(a)&&qb[a]?(""+b).trim():b+"px"}
function tb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=sb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ub=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function vb(a,b){if(b){if(ub[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(w(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(w(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(w(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(w(62));}}
function wb(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(w(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b))}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a])}}function Gb(a,b){return a(b)}function Hb(a,b,c,d,e){return a(b,c,d,e)}function Ib(){}var Jb=Gb,Kb=!1,Lb=!1;function Mb(){if(null!==zb||null!==Ab)Ib(),Fb()}
function Nb(a,b,c){if(Lb)return a(b,c);Lb=!0;try{return Jb(a,b,c)}finally{Lb=!1,Mb()}}
function Ob(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==
typeof c)throw Error(w(231,b,typeof c));return c}var Pb=!1;if(fa)try{var Qb={};Object.defineProperty(Qb,"passive",{get:function(){Pb=!0}});window.addEventListener("test",Qb,Qb);window.removeEventListener("test",Qb,Qb)}catch(a){Pb=!1}function Rb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var Sb=!1,Tb=null,Ub=!1,Vb=null,Wb={onError:function(a){Sb=!0;Tb=a}};function Xb(a,b,c,d,e,f,g,h,k){Sb=!1;Tb=null;Rb.apply(Wb,arguments)}
function Yb(a,b,c,d,e,f,g,h,k){Xb.apply(this,arguments);if(Sb){if(Sb){var l=Tb;Sb=!1;Tb=null}else throw Error(w(198));Ub||(Ub=!0,Vb=l)}}function Zb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.flags&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function $b(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function ac(a){if(Zb(a)!==a)throw Error(w(188));}
function bc(a){var b=a.alternate;if(!b){b=Zb(a);if(null===b)throw Error(w(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return ac(e),a;if(f===d)return ac(e),b;f=f.sibling}throw Error(w(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(w(189));}}if(c.alternate!==d)throw Error(w(190));}if(3!==c.tag)throw Error(w(188));return c.stateNode.current===c?a:b}function cc(a){a=bc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function dc(a,b){for(var c=a.alternate;null!==b;){if(b===a||b===c)return!0;b=b.return}return!1}var ec,fc,gc,hc,ic,jc,kc=!1,lc=[],mc=null,nc=null,oc=null,pc=new Map,qc=new Map,rc=[],sc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function tc(a,b,c,d,e){return{blockedOn:a,domEventName:b,eventSystemFlags:c|16,nativeEvent:e,targetContainers:[d]}}function uc(a,b,c,d,e){a=tc(a,b,c,d,e);lc.push(a);if(1===lc.length)for(;null!==a.blockedOn;){b=Cb(a.blockedOn);if(null===b)break;ec(b);if(null===a.blockedOn)vc();else break}}
function wc(a,b){switch(a){case "focusin":case "focusout":mc=null;break;case "dragenter":case "dragleave":nc=null;break;case "mouseover":case "mouseout":oc=null;break;case "pointerover":case "pointerout":pc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":qc.delete(b.pointerId)}}
function xc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=tc(b,c,d,e,f),null!==b&&(b=Cb(b),null!==b&&gc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
function yc(a,b,c,d,e){switch(b){case "focusin":return mc=xc(mc,a,b,c,d,e),!0;case "dragenter":return nc=xc(nc,a,b,c,d,e),!0;case "mouseover":return oc=xc(oc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;pc.set(f,xc(pc.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,qc.set(f,xc(qc.get(f)||null,a,b,c,d,e)),!0}return!1}
function zc(a){var b=Ac(a.target);if(null!==b){var c=Zb(b);if(null!==c)if(b=c.tag,13===b){if(b=$b(c),null!==b){a.blockedOn=b;jc(a.lanePriority,function(){u.unstable_runWithPriority(a.priority,function(){hc(c)})});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}
function Bc(a){if(null!==a.blockedOn)return!1;for(var b=a.targetContainers;0<b.length;){var c=Cc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c)return b=Cb(c),null!==b&&gc(b),a.blockedOn=c,!1;b.shift()}return!0}function Dc(a,b,c){Bc(a)&&c.delete(b)}
function vc(){for(kc=!1;0<lc.length;){var a=lc[0];if(null!==a.blockedOn){a=Cb(a.blockedOn);null!==a&&fc(a);break}for(var b=a.targetContainers;0<b.length;){var c=Cc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c){a.blockedOn=c;break}b.shift()}null===a.blockedOn&&lc.shift()}null!==mc&&Bc(mc)&&(mc=null);null!==nc&&Bc(nc)&&(nc=null);null!==oc&&Bc(oc)&&(oc=null);pc.forEach(Dc);qc.forEach(Dc)}
function Ec(a,b){a.blockedOn===b&&(a.blockedOn=null,kc||(kc=!0,u.unstable_scheduleCallback(u.unstable_NormalPriority,vc)))}
function Fc(a){function b(b){return Ec(b,a)}if(0<lc.length){Ec(lc[0],a);for(var c=1;c<lc.length;c++){var d=lc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==mc&&Ec(mc,a);null!==nc&&Ec(nc,a);null!==oc&&Ec(oc,a);pc.forEach(b);qc.forEach(b);for(c=0;c<rc.length;c++)d=rc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<rc.length&&(c=rc[0],null===c.blockedOn);)zc(c),null===c.blockedOn&&rc.shift()}
function Gc(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Hc={animationend:Gc("Animation","AnimationEnd"),animationiteration:Gc("Animation","AnimationIteration"),animationstart:Gc("Animation","AnimationStart"),transitionend:Gc("Transition","TransitionEnd")},Ic={},Jc={};
fa&&(Jc=document.createElement("div").style,"AnimationEvent"in window||(delete Hc.animationend.animation,delete Hc.animationiteration.animation,delete Hc.animationstart.animation),"TransitionEvent"in window||delete Hc.transitionend.transition);function Kc(a){if(Ic[a])return Ic[a];if(!Hc[a])return a;var b=Hc[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Jc)return Ic[a]=b[c];return a}
var Lc=Kc("animationend"),Mc=Kc("animationiteration"),Nc=Kc("animationstart"),Oc=Kc("transitionend"),Pc=new Map,Qc=new Map,Rc=["abort","abort",Lc,"animationEnd",Mc,"animationIteration",Nc,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart",
"lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking","seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",Oc,"transitionEnd","waiting","waiting"];function Sc(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1];e="on"+(e[0].toUpperCase()+e.slice(1));Qc.set(d,b);Pc.set(d,e);da(e,[d])}}var Tc=u.unstable_now;Tc();var Uc=0,E=8;
function Vc(a){if(0!==(1&a))return E=15,1;if(0!==(2&a))return E=14,2;if(0!==(4&a))return E=13,4;var b=24&a;if(0!==b)return E=12,b;if(0!==(a&32))return E=11,32;b=192&a;if(0!==b)return E=10,b;if(0!==(a&256))return E=9,256;b=3584&a;if(0!==b)return E=8,b;if(0!==(a&4096))return E=7,4096;b=4186112&a;if(0!==b)return E=6,b;b=62914560&a;if(0!==b)return E=5,b;if(a&67108864)return E=4,67108864;if(0!==(a&134217728))return E=3,134217728;b=805306368&a;if(0!==b)return E=2,b;if(0!==(1073741824&a))return E=1,1073741824;
E=8;return a}function Wc(a){switch(a){case 99:return 15;case 98:return 10;case 97:case 96:return 8;case 95:return 2;default:return 0}}function Xc(a){switch(a){case 15:case 14:return 99;case 13:case 12:case 11:case 10:return 98;case 9:case 8:case 7:case 6:case 4:case 5:return 97;case 3:case 2:case 1:return 95;case 0:return 90;default:throw Error(w(358,a));}}
function Yc(a,b){var c=a.pendingLanes;if(0===c)return E=0;var d=0,e=0,f=a.expiredLanes,g=a.suspendedLanes,h=a.pingedLanes;if(0!==f)d=f,e=E=15;else if(f=c&134217727,0!==f){var k=f&~g;0!==k?(d=Vc(k),e=E):(h&=f,0!==h&&(d=Vc(h),e=E))}else f=c&~g,0!==f?(d=Vc(f),e=E):0!==h&&(d=Vc(h),e=E);if(0===d)return 0;d=31-Zc(d);d=c&((0>d?0:1<<d)<<1)-1;if(0!==b&&b!==d&&0===(b&g)){Vc(b);if(e<=E)return b;E=e}b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-Zc(b),e=1<<c,d|=a[c],b&=~e;return d}
function $c(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function ad(a,b){switch(a){case 15:return 1;case 14:return 2;case 12:return a=bd(24&~b),0===a?ad(10,b):a;case 10:return a=bd(192&~b),0===a?ad(8,b):a;case 8:return a=bd(3584&~b),0===a&&(a=bd(4186112&~b),0===a&&(a=512)),a;case 2:return b=bd(805306368&~b),0===b&&(b=268435456),b}throw Error(w(358,a));}function bd(a){return a&-a}
function cd(a,b,c){a.pendingLanes|=b;var d=b-1;a.suspendedLanes&=d;a.pingedLanes&=d;a=a.eventTimes;b=31-Zc(b);a[b]=c}var Zc=Math.clz32?Math.clz32:dd,ed=Math.log,fd=Math.LN2;function dd(a){return 0===a?32:31-(ed(a)/fd|0)|0}var gd=u.unstable_UserBlockingPriority,hd=u.unstable_runWithPriority,id=!0;function jd(a,b,c,d){Kb||Ib();var e=kd,f=Kb;Kb=!0;try{Hb(e,a,b,c,d)}finally{(Kb=f)||Mb()}}function ld(a,b,c,d){hd(gd,kd.bind(null,a,b,c,d))}
function kd(a,b,c,d){if(id){var e;if((e=0===(b&4))&&0<lc.length&&-1<sc.indexOf(a))uc(null,a,b,c,d);else{var f=Cc(a,b,c,d);if(null===f)e&&wc(a,d);else{if(e){if(-1<sc.indexOf(a)){uc(f,a,b,c,d);return}if(yc(f,a,b,c,d))return;wc(a,d)}md(a,b,d,null,c)}}}}
function Cc(a,b,c,d){var e=xb(d);e=Ac(e);if(null!==e){var f=Zb(e);if(null===f)e=null;else{var g=f.tag;if(13===g){e=$b(f);if(null!==e)return e;e=null}else if(3===g){if(f.stateNode.hydrate)return 3===f.tag?f.stateNode.containerInfo:null;e=null}else f!==e&&(e=null)}}md(a,b,d,e,c);return null}var nd=null,od=null,pd=null;
function qd(){if(pd)return pd;var a,b=od,c=b.length,d,e="value"in nd?nd.value:nd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return pd=e.slice(a,1<d?1-d:void 0)}function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function sd(){return!0}function td(){return!1}
function ud(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?sd:td;this.isPropagationStopped=td;return this}m(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
(a.returnValue=!1),this.isDefaultPrevented=sd)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=sd)},persist:function(){},isPersistent:sd});return b}
var vd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},wd=ud(vd),xd=m({},vd,{view:0,detail:0}),yd=ud(xd),zd,Ad,Bd,Dd=m({},xd,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:Cd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
a)return a.movementX;a!==Bd&&(Bd&&"mousemove"===a.type?(zd=a.screenX-Bd.screenX,Ad=a.screenY-Bd.screenY):Ad=zd=0,Bd=a);return zd},movementY:function(a){return"movementY"in a?a.movementY:Ad}}),Ed=ud(Dd),Fd=m({},Dd,{dataTransfer:0}),Gd=ud(Fd),Hd=m({},xd,{relatedTarget:0}),Id=ud(Hd),Jd=m({},vd,{animationName:0,elapsedTime:0,pseudoElement:0}),Kd=ud(Jd),Ld=m({},vd,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Md=ud(Ld),Nd=m({},vd,{data:0}),Od=ud(Nd),Pd={Esc:"Escape",
Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Qd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Rd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rd[a])?!!b[a]:!1}function Cd(){return Sd}
var Td=m({},xd,{key:function(a){if(a.key){var b=Pd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Qd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:Cd,charCode:function(a){return"keypress"===a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Ud=ud(Td),Vd=m({},Dd,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Wd=ud(Vd),Xd=m({},xd,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:Cd}),Yd=ud(Xd),Zd=m({},vd,{propertyName:0,elapsedTime:0,pseudoElement:0}),$d=ud(Zd),ae=m({},Dd,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),be=ud(ae),ce=[9,13,27,32],de=fa&&"CompositionEvent"in window,ee=null;fa&&"documentMode"in document&&(ee=document.documentMode);var fe=fa&&"TextEvent"in window&&!ee,ge=fa&&(!de||ee&&8<ee&&11>=ee),he=String.fromCharCode(32),ie=!1;
function je(a,b){switch(a){case "keyup":return-1!==ce.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return!0;default:return!1}}function ke(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var le=!1;function me(a,b){switch(a){case "compositionend":return ke(b);case "keypress":if(32!==b.which)return null;ie=!0;return he;case "textInput":return a=b.data,a===he&&ie?null:a;default:return null}}
function ne(a,b){if(le)return"compositionend"===a||!de&&je(a,b)?(a=qd(),pd=od=nd=null,le=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return ge&&"ko"!==b.locale?null:b.data;default:return null}}
var oe={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function pe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!oe[a.type]:"textarea"===b?!0:!1}function qe(a,b,c,d){Eb(d);b=re(b,"onChange");0<b.length&&(c=new wd("onChange","change",null,c,d),a.push({event:c,listeners:b}))}var se=null,te=null;function ue(a){ve(a,0)}function we(a){var b=xe(a);if(Wa(b))return a}
function ye(a,b){if("change"===a)return b}var ze=!1;if(fa){var Ae;if(fa){var Be="oninput"in document;if(!Be){var Ce=document.createElement("div");Ce.setAttribute("oninput","return;");Be="function"===typeof Ce.oninput}Ae=Be}else Ae=!1;ze=Ae&&(!document.documentMode||9<document.documentMode)}function De(){se&&(se.detachEvent("onpropertychange",Ee),te=se=null)}function Ee(a){if("value"===a.propertyName&&we(te)){var b=[];qe(b,te,a,xb(a));a=ue;if(Kb)a(b);else{Kb=!0;try{Gb(a,b)}finally{Kb=!1,Mb()}}}}
function Fe(a,b,c){"focusin"===a?(De(),se=b,te=c,se.attachEvent("onpropertychange",Ee)):"focusout"===a&&De()}function Ge(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return we(te)}function He(a,b){if("click"===a)return we(b)}function Ie(a,b){if("input"===a||"change"===a)return we(b)}function Je(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var Ke="function"===typeof Object.is?Object.is:Je,Le=Object.prototype.hasOwnProperty;
function Me(a,b){if(Ke(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!Le.call(b,c[d])||!Ke(a[c[d]],b[c[d]]))return!1;return!0}function Ne(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Oe(a,b){var c=Ne(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Ne(c)}}function Pe(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Pe(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Qe(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xa(a.document)}return b}function Re(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Se=fa&&"documentMode"in document&&11>=document.documentMode,Te=null,Ue=null,Ve=null,We=!1;
function Xe(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;We||null==Te||Te!==Xa(d)||(d=Te,"selectionStart"in d&&Re(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Ve&&Me(Ve,d)||(Ve=d,d=re(Ue,"onSelect"),0<d.length&&(b=new wd("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Te)))}
Sc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),
0);Sc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);Sc(Rc,2);for(var Ye="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),Ze=0;Ze<Ye.length;Ze++)Qc.set(Ye[Ze],0);ea("onMouseEnter",["mouseout","mouseover"]);
ea("onMouseLeave",["mouseout","mouseover"]);ea("onPointerEnter",["pointerout","pointerover"]);ea("onPointerLeave",["pointerout","pointerover"]);da("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));da("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));da("onBeforeInput",["compositionend","keypress","textInput","paste"]);da("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));da("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var $e="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),af=new Set("cancel close invalid load scroll toggle".split(" ").concat($e));
function bf(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Yb(d,b,void 0,a);a.currentTarget=null}
function ve(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;bf(e,h,l);f=k}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;bf(e,h,l);f=k}}}if(Ub)throw a=Vb,Ub=!1,Vb=null,a;}
function F(a,b){var c=cf(b),d=a+"__bubble";c.has(d)||(df(b,a,2,!1),c.add(d))}var ef="_reactListening"+Math.random().toString(36).slice(2);function ff(a){a[ef]||(a[ef]=!0,ba.forEach(function(b){af.has(b)||gf(b,!1,a,null);gf(b,!0,a,null)}))}
function gf(a,b,c,d){var e=4<arguments.length&&void 0!==arguments[4]?arguments[4]:0,f=c;"selectionchange"===a&&9!==c.nodeType&&(f=c.ownerDocument);if(null!==d&&!b&&af.has(a)){if("scroll"!==a)return;e|=2;f=d}var g=cf(f),h=a+"__"+(b?"capture":"bubble");g.has(h)||(b&&(e|=4),df(f,a,e,b),g.add(h))}
function df(a,b,c,d){var e=Qc.get(b);switch(void 0===e?2:e){case 0:e=jd;break;case 1:e=ld;break;default:e=kd}c=e.bind(null,b,c,a);e=void 0;!Pb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1)}
function md(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return}for(;null!==h;){g=Ac(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode}}d=d.return}Nb(function(){var d=f,e=xb(c),g=[];
a:{var h=Pc.get(a);if(void 0!==h){var k=wd,y=a;switch(a){case "keypress":if(0===rd(c))break a;case "keydown":case "keyup":k=Ud;break;case "focusin":y="focus";k=Id;break;case "focusout":y="blur";k=Id;break;case "beforeblur":case "afterblur":k=Id;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Ed;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
Gd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Yd;break;case Lc:case Mc:case Nc:k=Kd;break;case Oc:k=$d;break;case "scroll":k=yd;break;case "wheel":k=be;break;case "copy":case "cut":case "paste":k=Md;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Wd}var v=0!==(b&4),I=!v&&"scroll"===a,x=v?null!==h?h+"Capture":null:h;v=[];for(var r=d,p;null!==
r;){p=r;var q=p.stateNode;5===p.tag&&null!==q&&(p=q,null!==x&&(q=Ob(r,x),null!=q&&v.push(hf(r,q,p))));if(I)break;r=r.return}0<v.length&&(h=new k(h,y,null,c,e),g.push({event:h,listeners:v}))}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&0===(b&16)&&(y=c.relatedTarget||c.fromElement)&&(Ac(y)||y[jf]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(y=c.relatedTarget||c.toElement,k=d,y=y?Ac(y):null,null!==
y&&(I=Zb(y),y!==I||5!==y.tag&&6!==y.tag))y=null}else k=null,y=d;if(k!==y){v=Ed;q="onMouseLeave";x="onMouseEnter";r="mouse";if("pointerout"===a||"pointerover"===a)v=Wd,q="onPointerLeave",x="onPointerEnter",r="pointer";I=null==k?h:xe(k);p=null==y?h:xe(y);h=new v(q,r+"leave",k,c,e);h.target=I;h.relatedTarget=p;q=null;Ac(e)===d&&(v=new v(x,r+"enter",y,c,e),v.target=p,v.relatedTarget=I,q=v);I=q;if(k&&y)b:{v=k;x=y;r=0;for(p=v;p;p=kf(p))r++;p=0;for(q=x;q;q=kf(q))p++;for(;0<r-p;)v=kf(v),r--;for(;0<p-r;)x=
kf(x),p--;for(;r--;){if(v===x||null!==x&&v===x.alternate)break b;v=kf(v);x=kf(x)}v=null}else v=null;null!==k&&lf(g,h,k,v,!1);null!==y&&null!==I&&lf(g,I,y,v,!0)}}}a:{h=d?xe(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var K=ye;else if(pe(h))if(ze)K=Ie;else{K=Ge;var L=Fe}else(k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(K=He);if(K&&(K=K(a,d))){qe(g,K,c,e);break a}L&&L(a,h,d);"focusout"===a&&(L=h._wrapperState)&&
L.controlled&&"number"===h.type&&bb(h,"number",h.value)}L=d?xe(d):window;switch(a){case "focusin":if(pe(L)||"true"===L.contentEditable)Te=L,Ue=d,Ve=null;break;case "focusout":Ve=Ue=Te=null;break;case "mousedown":We=!0;break;case "contextmenu":case "mouseup":case "dragend":We=!1;Xe(g,c,e);break;case "selectionchange":if(Se)break;case "keydown":case "keyup":Xe(g,c,e)}var Q;if(de)b:{switch(a){case "compositionstart":var M="onCompositionStart";break b;case "compositionend":M="onCompositionEnd";break b;
case "compositionupdate":M="onCompositionUpdate";break b}M=void 0}else le?je(a,c)&&(M="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(M="onCompositionStart");M&&(ge&&"ko"!==c.locale&&(le||"onCompositionStart"!==M?"onCompositionEnd"===M&&le&&(Q=qd()):(nd=e,od="value"in nd?nd.value:nd.textContent,le=!0)),L=re(d,M),0<L.length&&(M=new Od(M,a,null,c,e),g.push({event:M,listeners:L}),Q?M.data=Q:(Q=ke(c),null!==Q&&(M.data=Q))));if(Q=fe?me(a,c):ne(a,c))d=re(d,"onBeforeInput"),0<d.length&&(e=new Od("onBeforeInput",
"beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=Q)}ve(g,b)})}function hf(a,b,c){return{instance:a,listener:b,currentTarget:c}}function re(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Ob(a,c),null!=f&&d.unshift(hf(a,f,e)),f=Ob(a,b),null!=f&&d.push(hf(a,f,e)));a=a.return}return d}function kf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
function lf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Ob(c,f),null!=k&&g.unshift(hf(c,k,h))):e||(k=Ob(c,f),null!=k&&g.push(hf(c,k,h))));c=c.return}0!==g.length&&a.push({event:b,listeners:g})}function mf(){}var nf=null,of=null;function pf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function qf(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var rf="function"===typeof setTimeout?setTimeout:void 0,sf="function"===typeof clearTimeout?clearTimeout:void 0;
function tf(a,b){var c=b,d=0;do{var e=c.nextSibling;a.removeChild(c);if(e&&8===e.nodeType)if(c=e.data,"/$"===c){if(0===d){a.removeChild(e);Fc(b);return}d--}else"$"!==c&&"$?"!==c&&"$!"!==c||d++;c=e}while(c);Fc(b)}function uf(a){1===a.nodeType?a.textContent="":9===a.nodeType&&(a=a.body,null!=a&&(a.textContent=""))}function vf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break;if(8===b&&(b=a.data,"$"===b||"$!"===b||"$?"===b))break}return a}
function wf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--}else"/$"===c&&b++}a=a.previousSibling}return null}var xf=0;function yf(a){return{$$typeof:Ga,toString:a,valueOf:a}}var zf=Math.random().toString(36).slice(2),Af="__reactFiber$"+zf,Bf="__reactProps$"+zf,jf="__reactContainer$"+zf,Cf="__reactEvents$"+zf;
function Ac(a){var b=a[Af];if(b)return b;for(var c=a.parentNode;c;){if(b=c[jf]||c[Af]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=wf(a);null!==a;){if(c=a[Af])return c;a=wf(a)}return b}a=c;c=a.parentNode}return null}function Cb(a){a=a[Af]||a[jf];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(w(33));}function Db(a){return a[Bf]||null}
function cf(a){var b=a[Cf];void 0===b&&(b=a[Cf]=new Set);return b}var Df=[],Ef=-1;function Ff(a){return{current:a}}function G(a){0>Ef||(a.current=Df[Ef],Df[Ef]=null,Ef--)}function H(a,b){Ef++;Df[Ef]=a.current;a.current=b}var Gf={},J=Ff(Gf),Hf=Ff(!1),If=Gf;
function Jf(a,b){var c=a.type.contextTypes;if(!c)return Gf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function Kf(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Lf(){G(Hf);G(J)}function Mf(a,b,c){if(J.current!==Gf)throw Error(w(168));H(J,b);H(Hf,c)}
function Nf(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(w(108,Ra(b)||"Unknown",e));return m({},c,d)}function Of(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Gf;If=J.current;H(J,a);H(Hf,Hf.current);return!0}
function Pf(a,b,c){var d=a.stateNode;if(!d)throw Error(w(169));c?(a=Nf(a,b,If),d.__reactInternalMemoizedMergedChildContext=a,G(Hf),G(J),H(J,a)):G(Hf);H(Hf,c)}
var Qf=null,Rf=null,Sf=u.unstable_runWithPriority,Tf=u.unstable_scheduleCallback,Uf=u.unstable_cancelCallback,Vf=u.unstable_shouldYield,Wf=u.unstable_requestPaint,Xf=u.unstable_now,Yf=u.unstable_getCurrentPriorityLevel,Zf=u.unstable_ImmediatePriority,$f=u.unstable_UserBlockingPriority,ag=u.unstable_NormalPriority,bg=u.unstable_LowPriority,cg=u.unstable_IdlePriority,dg={},eg=void 0!==Wf?Wf:function(){},fg=null,gg=null,hg=!1,ig=Xf(),N=1E4>ig?Xf:function(){return Xf()-ig};
function jg(){switch(Yf()){case Zf:return 99;case $f:return 98;case ag:return 97;case bg:return 96;case cg:return 95;default:throw Error(w(332));}}function kg(a){switch(a){case 99:return Zf;case 98:return $f;case 97:return ag;case 96:return bg;case 95:return cg;default:throw Error(w(332));}}function lg(a,b){a=kg(a);return Sf(a,b)}function mg(a,b,c){a=kg(a);return Tf(a,b,c)}function ng(){if(null!==gg){var a=gg;gg=null;Uf(a)}og()}
function og(){if(!hg&&null!==fg){hg=!0;var a=0;try{var b=fg;lg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});fg=null}catch(c){throw null!==fg&&(fg=fg.slice(a+1)),Tf(Zf,ng),c;}finally{hg=!1}}}var pg=ra.ReactCurrentBatchConfig;function qg(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}var rg=Ff(null),sg=null,tg=null,ug=null;function vg(){ug=tg=sg=null}
function wg(a){var b=rg.current;G(rg);a.type._context._currentValue=b}function xg(a,b){for(;null!==a;){var c=a.alternate;if((a.childLanes&b)===b)if(null===c||(c.childLanes&b)===b)break;else c.childLanes|=b;else a.childLanes|=b,null!==c&&(c.childLanes|=b);a=a.return}}function yg(a,b){sg=a;ug=tg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(zg=!0),a.firstContext=null)}
function Ag(a,b){if(ug!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)ug=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===tg){if(null===sg)throw Error(w(308));tg=b;sg.dependencies={lanes:0,firstContext:b,responders:null}}else tg=tg.next=b}return a._currentValue}var Bg=!1;function Cg(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null},effects:null}}
function Dg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects})}function Eg(a,b){return{eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}function Fg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function Gg(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next}while(null!==c);null===f?e=f=b:f=f.next=b}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
b;c.lastBaseUpdate=b}
function Hg(a,b,c,d){var e=a.updateQueue;Bg=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var n=a.alternate;if(null!==n){n=n.updateQueue;var z=n.lastBaseUpdate;z!==g&&(null===z?n.firstBaseUpdate=l:z.next=l,n.lastBaseUpdate=k)}}if(null!==f){z=e.baseState;g=0;n=l=k=null;do{h=f.lane;var t=f.eventTime;if((d&h)===h){null!==n&&(n=n.next={eventTime:t,lane:0,tag:f.tag,payload:f.payload,callback:f.callback,
next:null});a:{var B=a,y=f;h=b;t=c;switch(y.tag){case 1:B=y.payload;if("function"===typeof B){z=B.call(t,z,h);break a}z=B;break a;case 3:B.flags=B.flags&-4097|64;case 0:B=y.payload;h="function"===typeof B?B.call(t,z,h):B;if(null===h||void 0===h)break a;z=m({},z,h);break a;case 2:Bg=!0}}null!==f.callback&&(a.flags|=32,h=e.effects,null===h?e.effects=[f]:h.push(f))}else t={eventTime:t,lane:h,tag:f.tag,payload:f.payload,callback:f.callback,next:null},null===n?(l=n=t,k=z):n=n.next=t,g|=h;f=f.next;if(null===
f)if(h=e.shared.pending,null===h)break;else f=h.next,h.next=null,e.lastBaseUpdate=h,e.shared.pending=null}while(1);null===n&&(k=z);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=n;Ig|=g;a.lanes=g;a.memoizedState=z}}function Jg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(w(191,e));e.call(d)}}}var Kg=(new aa.Component).refs;
function Lg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c)}
var Pg={isMounted:function(a){return(a=a._reactInternals)?Zb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=Mg(),e=Ng(a),f=Eg(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Fg(a,f);Og(a,e,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=Mg(),e=Ng(a),f=Eg(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Fg(a,f);Og(a,e,d)},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=Mg(),d=Ng(a),e=Eg(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=
b);Fg(a,e);Og(a,d,c)}};function Qg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Me(c,d)||!Me(e,f):!0}
function Rg(a,b,c){var d=!1,e=Gf;var f=b.contextType;"object"===typeof f&&null!==f?f=Ag(f):(e=Kf(b)?If:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Jf(a,e):Gf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Pg;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Sg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Pg.enqueueReplaceState(b,b.state,null)}
function Tg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Kg;Cg(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=Ag(f):(f=Kf(b)?If:J.current,e.context=Jf(a,f));Hg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Lg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Pg.enqueueReplaceState(e,e.state,null),Hg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4)}var Ug=Array.isArray;
function Vg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(w(309));var d=c.stateNode}if(!d)throw Error(w(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Kg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(w(284));if(!c._owner)throw Error(w(290,a));}return a}
function Wg(a,b){if("textarea"!==a.type)throw Error(w(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b));}function Xg(a){try{var b=a._init;return b(a._payload)}catch(c){return a}}
function Yg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.flags=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Zg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags=2,
c):d;b.flags=2;return c}function g(b){a&&null===b.alternate&&(b.flags=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=$g(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b){if(b.elementType===c.type){var f=e(b,c.props);f.ref=Vg(a,b,c);f.return=a;return f}if(22===b.tag&&(f=c.type,f.$$typeof===Ea&&(f=Xg(f)),f.$$typeof===Fa&&f._render===b.type._render))return b=e(b,c.props),b.return=a,b.type=f,b}f=ah(c.type,c.key,c.props,null,a.mode,d);f.ref=Vg(a,b,
c);f.return=a;return f}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=ch(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=$g(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case sa:return c=
ah(b.type,b.key,b.props,null,a.mode,c),c.ref=Vg(a,null,b),c.return=a,c;case ta:return b=bh(b,a.mode,c),b.return=a,b;case Ea:var d=b._init;return z(a,d(b._payload),c)}if(Ug(b)||La(b))return b=ch(b,a.mode,c,null),b.return=a,b;Wg(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case sa:return c.key===e?c.type===ua?n(a,b,c.props.children,d,e):k(a,b,c,d):null;
case ta:return c.key===e?l(a,b,c,d):null;case Ea:return e=c._init,t(a,b,e(c._payload),d)}if(Ug(c)||La(c))return null!==e?null:n(a,b,c,d,null);Wg(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case sa:return a=a.get(null===d.key?c:d.key)||null,d.type===ua?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case ta:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e);case Ea:var f=
d._init;return B(a,b,c,f(d._payload),e)}if(Ug(d)||La(d))return a=a.get(c)||null,n(b,a,d,e,null);Wg(b,d)}return null}function y(e,g,h,k){for(var l=null,r=null,p=g,x=g=0,q=null;null!==p&&x<h.length;x++){p.index>x?(q=p,p=null):q=p.sibling;var n=t(e,p,h[x],k);if(null===n){null===p&&(p=q);break}a&&p&&null===n.alternate&&b(e,p);g=f(n,g,x);null===r?l=n:r.sibling=n;r=n;p=q}if(x===h.length)return c(e,p),l;if(null===p){for(;x<h.length;x++)p=z(e,h[x],k),null!==p&&(g=f(p,g,x),null===r?l=p:r.sibling=p,r=p);return l}for(p=
d(e,p);x<h.length;x++)q=B(p,e,x,h[x],k),null!==q&&(a&&null!==q.alternate&&p.delete(null===q.key?x:q.key),g=f(q,g,x),null===r?l=q:r.sibling=q,r=q);a&&p.forEach(function(a){return b(e,a)});return l}function v(e,g,h,k){var l=La(h);if("function"!==typeof l)throw Error(w(150));h=l.call(h);if(null==h)throw Error(w(151));for(var p=l=null,r=g,x=g=0,q=null,n=h.next();null!==r&&!n.done;x++,n=h.next()){r.index>x?(q=r,r=null):q=r.sibling;var v=t(e,r,n.value,k);if(null===v){null===r&&(r=q);break}a&&r&&null===
v.alternate&&b(e,r);g=f(v,g,x);null===p?l=v:p.sibling=v;p=v;r=q}if(n.done)return c(e,r),l;if(null===r){for(;!n.done;x++,n=h.next())n=z(e,n.value,k),null!==n&&(g=f(n,g,x),null===p?l=n:p.sibling=n,p=n);return l}for(r=d(e,r);!n.done;x++,n=h.next())n=B(r,e,x,n.value,k),null!==n&&(a&&null!==n.alternate&&r.delete(null===n.key?x:n.key),g=f(n,g,x),null===p?l=n:p.sibling=n,p=n);a&&r.forEach(function(a){return b(e,a)});return l}function I(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ua&&null===f.key;
k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case sa:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ua){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;case 22:if(l=f.type,l.$$typeof===Ea&&(l=Xg(l)),l.$$typeof===Fa&&l._render===k.type._render){c(a,k.sibling);d=e(k,f.props);d.type=l;d.return=a;a=d;break a}default:if(k.elementType===f.type){c(a,k.sibling);d=e(k,f.props);d.ref=Vg(a,k,f);d.return=a;a=d;break a}}c(a,
k);break}else b(a,k);k=k.sibling}f.type===ua?(d=ch(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ah(f.type,f.key,f.props,null,a.mode,h),h.ref=Vg(a,d,f),h.return=a,a=h)}return g(a);case ta:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bh(f,a.mode,h);d.return=a;a=d}return g(a);case Ea:return k=
f._init,I(a,d,k(f._payload),h)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=$g(f,a.mode,h),d.return=a,a=d),g(a);if(Ug(f))return y(a,d,f,h);if(La(f))return v(a,d,f,h);l&&Wg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 22:case 0:case 11:case 15:throw Error(w(152,Ra(a.type)||"Component"));}return c(a,d)}return I}var dh=Yg(!0),eh=Yg(!1),fh={},gh=Ff(fh),hh=Ff(fh),ih=Ff(fh);
function jh(a){if(a===fh)throw Error(w(174));return a}function kh(a,b){H(ih,b);H(hh,a);H(gh,fh);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:mb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=mb(b,a)}G(gh);H(gh,b)}function lh(){G(gh);G(hh);G(ih)}function mh(a){jh(ih.current);var b=jh(gh.current);var c=mb(b,a.type);b!==c&&(H(hh,a),H(gh,c))}function nh(a){hh.current===a&&(G(gh),G(hh))}var O=Ff(0);
function oh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}var ph=null,qh=null,rh=!1;
function sh(a,b){var c=th(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.flags=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function uh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return b=8!==b.nodeType?null:b,null!==b?(a.memoizedState={dehydrated:b,retryLane:1073741824},c=th(18,null,null,0),c.stateNode=b,c.return=a,a.child=c,!0):!1;default:return!1}}
function vh(a){if(rh){var b=qh;if(b){var c=b;if(!uh(a,b)){b=vf(c.nextSibling);if(!b||!uh(a,b)){a.flags=a.flags&-1025|2;rh=!1;ph=a;return}sh(ph,c)}ph=a;qh=vf(b.firstChild)}else a.flags=a.flags&-1025|2,rh=!1,ph=a}}function wh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ph=a}
function xh(a){if(a!==ph)return!1;if(!rh)return wh(a),rh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!qf(b,a.memoizedProps))for(b=qh;b;)sh(a,b),b=vf(b.nextSibling);wh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(w(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){qh=vf(a.nextSibling);break a}b--}else"$"!==c&&"$!"!==c&&"$?"!==c||b++}a=a.nextSibling}qh=null}}else qh=ph?vf(a.stateNode.nextSibling):null;return!0}
function yh(){qh=ph=null;rh=!1}var zh=[];function Ah(){for(var a=0;a<zh.length;a++)zh[a]._workInProgressVersionPrimary=null;zh.length=0}var Bh=ra.ReactCurrentDispatcher,Ch=ra.ReactCurrentBatchConfig,Dh=0,P=null,R=null,S=null,Eh=!1,Fh=!1;function Gh(){throw Error(w(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!Ke(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){Dh=f;P=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;Bh.current=null===a||null===a.memoizedState?Jh:Kh;a=c(d,e);if(Fh){f=0;do{Fh=!1;if(!(25>f))throw Error(w(301));f+=1;S=R=null;b.updateQueue=null;Bh.current=Lh;a=c(d,e)}while(Fh)}Bh.current=Mh;b=null!==R&&null!==R.next;Dh=0;S=R=P=null;Eh=!1;if(b)throw Error(w(300));return a}function Nh(a,b,c){b.updateQueue=a.updateQueue;b.flags&=-517;a.lanes&=~c}
function Oh(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===S?P.memoizedState=S=a:S=S.next=a;return S}function Ph(){if(null===R){var a=P.alternate;a=null!==a?a.memoizedState:null}else a=R.next;var b=null===S?P.memoizedState:S.next;if(null!==b)S=b,R=a;else{if(null===a)throw Error(w(310));R=a;a={memoizedState:R.memoizedState,baseState:R.baseState,baseQueue:R.baseQueue,queue:R.queue,next:null};null===S?P.memoizedState=S=a:S=S.next=a}return S}
function Qh(a,b){return"function"===typeof b?b(a):b}
function Rh(a){var b=Ph(),c=b.queue;if(null===c)throw Error(w(311));c.lastRenderedReducer=a;var d=R,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.lane;if((Dh&l)===l)null!==h&&(h=h.next={lane:0,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),d=k.eagerReducer===a?k.eagerState:a(d,k.action);else{var n={lane:l,action:k.action,eagerReducer:k.eagerReducer,
eagerState:k.eagerState,next:null};null===h?(g=h=n,f=d):h=h.next=n;P.lanes|=l;Ig|=l}k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;Ke(d,b.memoizedState)||(zg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function Sh(a){var b=Ph(),c=b.queue;if(null===c)throw Error(w(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);Ke(f,b.memoizedState)||(zg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function Th(a,b,c){var d=b._getVersion;d=d(b._source);var e=b._workInProgressVersionPrimary;if(null!==e)a=e===d;else if(a=a.mutableReadLanes,a=(Dh&a)===a)b._workInProgressVersionPrimary=d,zh.push(b);if(a)return c(b._source);zh.push(b);throw Error(w(350));}
function Uh(a,b,c,d){var e=T;if(null===e)throw Error(w(349));var f=b._getVersion,g=f(b._source),h=Bh.current,k=h.useState(function(){return Th(e,b,c)}),l=k[1],n=k[0];k=S;var z=a.memoizedState,t=z.refs,B=t.getSnapshot,y=z.source;z=z.subscribe;var v=P;a.memoizedState={refs:t,source:b,subscribe:d};h.useEffect(function(){t.getSnapshot=c;t.setSnapshot=l;var a=f(b._source);if(!Ke(g,a)){a=c(b._source);Ke(n,a)||(l(a),a=Ng(v),e.mutableReadLanes|=a&e.pendingLanes);a=e.mutableReadLanes;e.entangledLanes|=a;for(var d=
e.entanglements,h=a;0<h;){var k=31-Zc(h),q=1<<k;d[k]|=a;h&=~q}}},[c,b,d]);h.useEffect(function(){return d(b._source,function(){var a=t.getSnapshot,c=t.setSnapshot;try{c(a(b._source));var d=Ng(v);e.mutableReadLanes|=d&e.pendingLanes}catch(p){c(function(){throw p;})}})},[b,d]);Ke(B,c)&&Ke(y,b)&&Ke(z,d)||(a={pending:null,dispatch:null,lastRenderedReducer:Qh,lastRenderedState:n},a.dispatch=l=Vh.bind(null,P,a),k.queue=a,k.baseQueue=null,n=Th(e,b,c),k.memoizedState=k.baseState=n);return n}
function Wh(a,b,c){var d=Ph();return Uh(d,a,b,c)}function Xh(a){var b=Oh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:Qh,lastRenderedState:a};a=a.dispatch=Vh.bind(null,P,a);return[b.memoizedState,a]}
function Yh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=P.updateQueue;null===b?(b={lastEffect:null},P.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function Zh(a){var b=Oh();a={current:a};return b.memoizedState=a}function $h(){return Ph().memoizedState}function ai(a,b,c,d){var e=Oh();P.flags|=a;e.memoizedState=Yh(1|b,c,void 0,void 0===d?null:d)}
function bi(a,b,c,d){var e=Ph();d=void 0===d?null:d;var f=void 0;if(null!==R){var g=R.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Yh(b,c,f,d);return}}P.flags|=a;e.memoizedState=Yh(1|b,c,f,d)}function ci(a,b){return ai(516,4,a,b)}function di(a,b){return bi(516,4,a,b)}function ei(a,b){return bi(4,2,a,b)}function fi(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}
function gi(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return bi(4,2,fi.bind(null,b,a),c)}function hi(){}function ii(a,b){var c=Ph();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}function ji(a,b){var c=Ph();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}
function ki(a,b){var c=jg();lg(98>c?98:c,function(){a(!0)});lg(97<c?97:c,function(){var c=Ch.transition;Ch.transition=1;try{a(!1),b()}finally{Ch.transition=c}})}
function Vh(a,b,c){var d=Mg(),e=Ng(a),f={lane:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.pending;null===g?f.next=f:(f.next=g.next,g.next=f);b.pending=f;g=a.alternate;if(a===P||null!==g&&g===P)Fh=Eh=!0;else{if(0===a.lanes&&(null===g||0===g.lanes)&&(g=b.lastRenderedReducer,null!==g))try{var h=b.lastRenderedState,k=g(h,c);f.eagerReducer=g;f.eagerState=k;if(Ke(k,h))return}catch(l){}finally{}Og(a,e,d)}}
var Mh={readContext:Ag,useCallback:Gh,useContext:Gh,useEffect:Gh,useImperativeHandle:Gh,useLayoutEffect:Gh,useMemo:Gh,useReducer:Gh,useRef:Gh,useState:Gh,useDebugValue:Gh,useDeferredValue:Gh,useTransition:Gh,useMutableSource:Gh,useOpaqueIdentifier:Gh,unstable_isNewReconciler:!1},Jh={readContext:Ag,useCallback:function(a,b){Oh().memoizedState=[a,void 0===b?null:b];return a},useContext:Ag,useEffect:ci,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return ai(4,2,fi.bind(null,
b,a),c)},useLayoutEffect:function(a,b){return ai(4,2,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Oh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Vh.bind(null,P,a);return[d.memoizedState,a]},useRef:Zh,useState:Xh,useDebugValue:hi,useDeferredValue:function(a){var b=Xh(a),c=b[0],d=b[1];ci(function(){var b=Ch.transition;
Ch.transition=1;try{d(a)}finally{Ch.transition=b}},[a]);return c},useTransition:function(){var a=Xh(!1),b=a[0];a=ki.bind(null,a[1]);Zh(a);return[a,b]},useMutableSource:function(a,b,c){var d=Oh();d.memoizedState={refs:{getSnapshot:b,setSnapshot:null},source:a,subscribe:c};return Uh(d,a,b,c)},useOpaqueIdentifier:function(){if(rh){var a=!1,b=yf(function(){a||(a=!0,c("r:"+(xf++).toString(36)));throw Error(w(355));}),c=Xh(b)[1];0===(P.mode&2)&&(P.flags|=516,Yh(5,function(){c("r:"+(xf++).toString(36))},
void 0,null));return b}b="r:"+(xf++).toString(36);Xh(b);return b},unstable_isNewReconciler:!1},Kh={readContext:Ag,useCallback:ii,useContext:Ag,useEffect:di,useImperativeHandle:gi,useLayoutEffect:ei,useMemo:ji,useReducer:Rh,useRef:$h,useState:function(){return Rh(Qh)},useDebugValue:hi,useDeferredValue:function(a){var b=Rh(Qh),c=b[0],d=b[1];di(function(){var b=Ch.transition;Ch.transition=1;try{d(a)}finally{Ch.transition=b}},[a]);return c},useTransition:function(){var a=Rh(Qh)[0];return[$h().current,
a]},useMutableSource:Wh,useOpaqueIdentifier:function(){return Rh(Qh)[0]},unstable_isNewReconciler:!1},Lh={readContext:Ag,useCallback:ii,useContext:Ag,useEffect:di,useImperativeHandle:gi,useLayoutEffect:ei,useMemo:ji,useReducer:Sh,useRef:$h,useState:function(){return Sh(Qh)},useDebugValue:hi,useDeferredValue:function(a){var b=Sh(Qh),c=b[0],d=b[1];di(function(){var b=Ch.transition;Ch.transition=1;try{d(a)}finally{Ch.transition=b}},[a]);return c},useTransition:function(){var a=Sh(Qh)[0];return[$h().current,
a]},useMutableSource:Wh,useOpaqueIdentifier:function(){return Sh(Qh)[0]},unstable_isNewReconciler:!1},li=ra.ReactCurrentOwner,zg=!1;function U(a,b,c,d){b.child=null===a?eh(b,null,c,d):dh(b,a.child,c,d)}function mi(a,b,c,d,e){c=c.render;var f=b.ref;yg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!zg)return Nh(a,b,e),ni(a,b,e);b.flags|=1;U(a,b,d,e);return b.child}
function oi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!pi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,qi(a,b,g,d,e,f);a=ah(c.type,null,d,b,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(0===(e&f)&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:Me,c(e,d)&&a.ref===b.ref))return ni(a,b,f);b.flags|=1;a=Zg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function qi(a,b,c,d,e,f){if(null!==a&&Me(a.memoizedProps,d)&&a.ref===b.ref)if(zg=!1,0!==(f&e))0!==(a.flags&16384)&&(zg=!0);else return b.lanes=a.lanes,ni(a,b,f);return ri(a,b,c,d,f)}
function si(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode||"unstable-defer-without-hiding"===d.mode)if(0===(b.mode&4))b.memoizedState={baseLanes:0},ti(b,c);else if(0!==(c&1073741824))b.memoizedState={baseLanes:0},ti(b,null!==f?f.baseLanes:c);else return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a},ti(b,a),null;else null!==f?(d=f.baseLanes|c,b.memoizedState=null):d=c,ti(b,d);U(a,b,e,c);return b.child}
function ui(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=128}function ri(a,b,c,d,e){var f=Kf(c)?If:J.current;f=Jf(b,f);yg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!zg)return Nh(a,b,e),ni(a,b,e);b.flags|=1;U(a,b,c,e);return b.child}function vi(a,b,c,d,e){var f=c._render;c=c._data;yg(b,e);d=Ih(a,b,f,d,c,e);if(null!==a&&!zg)return Nh(a,b,e),ni(a,b,e);b.flags|=1;U(a,b,d,e);return b.child}
function wi(a,b,c,d,e){if(Kf(c)){var f=!0;Of(b)}else f=!1;yg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),Rg(b,c,d),Tg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=Ag(l):(l=Kf(c)?If:J.current,l=Jf(b,l));var n=c.getDerivedStateFromProps,z="function"===typeof n||"function"===typeof g.getSnapshotBeforeUpdate;z||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Sg(b,g,d,l);Bg=!1;var t=b.memoizedState;g.state=t;Hg(b,d,g,e);k=b.memoizedState;h!==d||t!==k||Hf.current||Bg?("function"===typeof n&&(Lg(b,c,n,d),k=b.memoizedState),(h=Bg||Qg(b,c,h,d,t,k,l))?(z||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.flags|=4)):("function"===typeof g.componentDidMount&&(b.flags|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4),d=!1)}else{g=b.stateNode;Dg(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:qg(b.type,h);g.props=l;z=b.pendingProps;t=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=Ag(k):(k=Kf(c)?If:J.current,k=Jf(b,k));var B=c.getDerivedStateFromProps;(n="function"===typeof B||
"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==z||t!==k)&&Sg(b,g,d,k);Bg=!1;t=b.memoizedState;g.state=t;Hg(b,d,g,e);var y=b.memoizedState;h!==z||t!==y||Hf.current||Bg?("function"===typeof B&&(Lg(b,c,B,d),y=b.memoizedState),(l=Bg||Qg(b,c,l,d,t,y,k))?(n||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&
g.componentWillUpdate(d,y,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&t===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&t===a.memoizedState||(b.flags|=256),b.memoizedProps=d,b.memoizedState=y),g.props=d,g.state=y,g.context=
k,d=l):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&t===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&t===a.memoizedState||(b.flags|=256),d=!1)}return xi(a,b,c,d,f,e)}
function xi(a,b,c,d,e,f){ui(a,b);var g=0!==(b.flags&64);if(!d&&!g)return e&&Pf(b,c,!1),ni(a,b,f);d=b.stateNode;li.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=dh(b,a.child,null,f),b.child=dh(b,null,h,f)):U(a,b,h,f);b.memoizedState=d.state;e&&Pf(b,c,!0);return b.child}function yi(a){var b=a.stateNode;b.pendingContext?Mf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Mf(a,b.context,!1);kh(a,b.containerInfo)}
var zi={dehydrated:null,retryLane:0};
function Ai(a,b,c){var d=b.pendingProps,e=O.current,f=!1,g=0!==(b.flags&64),h;(h=g)||(h=null!==a&&null===a.memoizedState?!1:0!==(e&2));h?(f=!0,b.flags&=-65):null!==a&&null===a.memoizedState||void 0===d.fallback||!0===d.unstable_avoidThisFallback||(e|=1);H(O,e&1);if(null===a){if(void 0!==d.fallback&&(vh(b),a=b.memoizedState,null!==a&&(a=a.dehydrated,null!==a)))return 0===(b.mode&2)?b.lanes=1:"$!"===a.data?b.lanes=256:b.lanes=1073741824,null;a=d.children;var k=d.fallback;return f?(a=Bi(b,a,k,c),b.child.memoizedState=
{baseLanes:c},b.memoizedState=zi,a):"number"===typeof d.unstable_expectedLoadTime?(a=Bi(b,a,k,c),b.child.memoizedState={baseLanes:c},b.memoizedState=zi,b.lanes=33554432,a):Ci(b,a,c)}e=a.memoizedState;if(null!==e){h=e.dehydrated;if(null!==h){if(g){if(null!==b.memoizedState)return b.child=a.child,b.flags|=64,null;f=d.fallback;k=b.mode;d=Di(d.children,k,0,null);f=ch(f,k,c,null);f.flags|=2;d.return=b;f.return=b;d.sibling=f;b.child=d;0!==(b.mode&2)&&dh(b,a.child,null,c);b.child.memoizedState={baseLanes:c};
b.memoizedState=zi;return f}if(0!==(V&64)||0===(b.mode&2)||"$!"===h.data)b=Ei(a,b,c);else if(d=0!==(c&a.childLanes),zg||d){d=T;if(null!==d){Vc(c);switch(E){case 15:case 14:k=0;break;case 13:case 12:k=4;break;case 11:case 10:k=32;break;case 9:case 8:k=256;break;case 7:case 6:k=4096;break;case 5:k=4096;break;case 4:k=67108864;break;case 3:case 2:k=134217728;break;case 1:case 0:k=0;break;default:throw Error(w(360,k));}d=0!==(k&(d.suspendedLanes|c))?0:k;0!==d&&d!==e.retryLane&&(e.retryLane=d,Og(a,d,-1))}Fi();
b=Ei(a,b,c)}else"$?"===h.data?(b.flags|=64,b.child=a.child,b=Gi.bind(null,a),h._reactRetry=b,b=null):(qh=vf(h.nextSibling),wh(b),rh=!0,b=Ci(b,b.pendingProps.children,c),b.flags|=1024);return b}if(f)return d=Hi(a,b,d.children,d.fallback,c),f=b.child,k=a.child.memoizedState,f.memoizedState=null===k?{baseLanes:c}:{baseLanes:k.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=zi,d;c=Ii(a,b,d.children,c);b.memoizedState=null;return c}if(f)return d=Hi(a,b,d.children,d.fallback,c),f=b.child,k=a.child.memoizedState,
f.memoizedState=null===k?{baseLanes:c}:{baseLanes:k.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=zi,d;c=Ii(a,b,d.children,c);b.memoizedState=null;return c}function Ci(a,b,c){b=Di({mode:"visible",children:b},a.mode,c,null);b.return=a;return a.child=b}function Bi(a,b,c,d){var e=a.mode,f=a.child;b={mode:"hidden",children:b};0===(e&2)&&null!==f?(f.childLanes=0,f.pendingProps=b):f=Di(b,e,0,null);c=ch(c,e,d,null);f.return=a;c.return=a;f.sibling=c;a.child=f;return c}
function Ii(a,b,c,d){var e=a.child;a=e.sibling;c=Zg(e,{mode:"visible",children:c});0===(b.mode&2)&&(c.lanes=d);c.return=b;c.sibling=null;null!==a&&(a.nextEffect=null,a.flags=8,b.firstEffect=b.lastEffect=a);return b.child=c}
function Hi(a,b,c,d,e){var f=b.mode,g=a.child;a=g.sibling;var h={mode:"hidden",children:c};0===(f&2)&&b.child!==g?(c=b.child,c.childLanes=0,c.pendingProps=h,g=c.lastEffect,null!==g?(b.firstEffect=c.firstEffect,b.lastEffect=g,g.nextEffect=null):b.firstEffect=b.lastEffect=null):c=Zg(g,h);null!==a?d=Zg(a,d):(d=ch(d,f,e,null),d.flags|=2);d.return=b;c.return=b;c.sibling=d;b.child=c;return d}
function Ei(a,b,c){dh(b,a.child,null,c);a=Ci(b,b.pendingProps.children,c);a.flags|=2;b.memoizedState=null;return a}function Ji(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);xg(a.return,b)}function Ki(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailMode=e,g.lastEffect=f)}
function Li(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;U(a,b,d.children,c);d=O.current;if(0!==(d&2))d=d&1|2,b.flags|=64;else{if(null!==a&&0!==(a.flags&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&Ji(a,c);else if(19===a.tag)Ji(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}H(O,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===oh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ki(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===oh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ki(b,!0,c,null,f,b.lastEffect);break;case "together":Ki(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function ni(a,b,c){null!==a&&(b.dependencies=a.dependencies);Ig|=b.lanes;if(0!==(c&b.childLanes)){if(null!==a&&b.child!==a.child)throw Error(w(153));if(null!==b.child){a=b.child;c=Zg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Zg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}return null}var Mi,Ni,Oi,Pi;
Mi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ni=function(){};
Oi=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;jh(gh.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "option":e=eb(a,e);d=eb(a,d);f=[];break;case "select":e=m({},e,{value:void 0});d=m({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=mf)}vb(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===
l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&(c||(c={}),c[g]="")}else"dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ca.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||
(c={}),c[g]=k[g])}else c||(f||(f=[]),f.push(l,c)),c=k;else"dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ca.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&F("scroll",a),f||h===k||(f=[])):"object"===typeof k&&null!==k&&k.$$typeof===Ga?k.toString():(f=f||[]).push(l,k))}c&&(f=f||[]).push("style",
c);var l=f;if(b.updateQueue=l)b.flags|=4}};Pi=function(a,b,c,d){c!==d&&(b.flags|=4)};function Qi(a,b){if(!rh)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Ri(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return Kf(b.type)&&Lf(),null;case 3:lh();G(Hf);G(J);Ah();d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)xh(b)?b.flags|=4:d.hydrate||(b.flags|=256);Ni(b);return null;case 5:nh(b);var e=jh(ih.current);c=b.type;if(null!==a&&null!=b.stateNode)Oi(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=128);else{if(!d){if(null===
b.stateNode)throw Error(w(166));return null}a=jh(gh.current);if(xh(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[Af]=b;d[Bf]=f;switch(c){case "dialog":F("cancel",d);F("close",d);break;case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<$e.length;a++)F($e[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "details":F("toggle",d);break;case "input":Za(d,f);F("invalid",d);break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);break;case "textarea":hb(d,f),F("invalid",d)}vb(c,f);a=null;for(var g in f)f.hasOwnProperty(g)&&(e=f[g],"children"===g?"string"===typeof e?d.textContent!==e&&(a=["children",e]):"number"===typeof e&&d.textContent!==""+e&&(a=["children",""+e]):ca.hasOwnProperty(g)&&null!=e&&"onScroll"===g&&F("scroll",d));switch(c){case "input":Va(d);cb(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=
mf)}d=a;b.updateQueue=d;null!==d&&(b.flags|=4)}else{g=9===e.nodeType?e:e.ownerDocument;a===kb.html&&(a=lb(c));a===kb.html?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[Af]=b;a[Bf]=d;Mi(a,b,!1,!1);b.stateNode=a;g=wb(c,d);switch(c){case "dialog":F("cancel",a);F("close",a);
e=d;break;case "iframe":case "object":case "embed":F("load",a);e=d;break;case "video":case "audio":for(e=0;e<$e.length;e++)F($e[e],a);e=d;break;case "source":F("error",a);e=d;break;case "img":case "image":case "link":F("error",a);F("load",a);e=d;break;case "details":F("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);F("invalid",a);break;case "option":e=eb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=m({},d,{value:void 0});F("invalid",a);break;case "textarea":hb(a,d);e=
gb(a,d);F("invalid",a);break;default:e=d}vb(c,e);var h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?tb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&ob(a,k)):"children"===f?"string"===typeof k?("textarea"!==c||""!==k)&&pb(a,k):"number"===typeof k&&pb(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ca.hasOwnProperty(f)?null!=k&&"onScroll"===f&&F("scroll",a):null!=k&&qa(a,f,k,g))}switch(c){case "input":Va(a);cb(a,d,!1);
break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof e.onClick&&(a.onclick=mf)}pf(c,d)&&(b.flags|=4)}null!==b.ref&&(b.flags|=128)}return null;case 6:if(a&&null!=b.stateNode)Pi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(w(166));
c=jh(ih.current);jh(gh.current);xh(b)?(d=b.stateNode,c=b.memoizedProps,d[Af]=b,d.nodeValue!==c&&(b.flags|=4)):(d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[Af]=b,b.stateNode=d)}return null;case 13:G(O);d=b.memoizedState;if(null!==d&&null!==d.dehydrated){if(null===a){if(!xh(b))throw Error(w(318));d=b.memoizedState;d=null!==d?d.dehydrated:null;if(!d)throw Error(w(317));d[Af]=b}else yh(),0===(b.flags&64)&&(b.memoizedState=null),b.flags|=4;return null}if(0!==(b.flags&64))return b.lanes=c,
b;d=null!==d;c=!1;null===a?void 0!==b.memoizedProps.fallback&&xh(b):c=null!==a.memoizedState;d&&!c&&0!==(b.mode&2)&&(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(O.current&1)?0===W&&(W=3):Fi());if(d||c)b.flags|=4;return null;case 4:return lh(),Ni(b),null===a&&ff(b.stateNode.containerInfo),null;case 10:return wg(b),null;case 17:return Kf(b.type)&&Lf(),null;case 19:G(O);d=b.memoizedState;if(null===d)return null;f=0!==(b.flags&64);g=d.rendering;if(null===g)if(f)Qi(d,!1);else{if(0!==
W||null!==a&&0!==(a.flags&64))for(a=b.child;null!==a;){g=oh(a);if(null!==g){b.flags|=64;Qi(d,!1);f=g.updateQueue;null!==f&&(b.updateQueue=f,b.flags|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=2,f.nextEffect=null,f.firstEffect=null,f.lastEffect=null,g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,
f.lanes=g.lanes,f.child=g.child,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;H(O,O.current&1|2);return b.child}a=a.sibling}null!==d.tail&&N()>Si&&(b.flags|=64,f=!0,Qi(d,!1),b.lanes=33554432)}else{if(!f)if(a=oh(g),null!==a){if(b.flags|=64,f=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Qi(d,!0),null===d.tail&&"hidden"===d.tailMode&&
!g.alternate&&!rh)return b=b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*N()-d.renderingStartTime>Si&&1073741824!==c&&(b.flags|=64,f=!0,Qi(d,!1),b.lanes=33554432);d.isBackwards?(g.sibling=b.child,b.child=g):(c=d.last,null!==c?c.sibling=g:b.child=g,d.last=g)}return null!==d.tail?(c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=N(),c.sibling=null,b=O.current,H(O,f?b&1|2:b&1),c):null;case 22:return null;case 23:case 24:return Ti(),null!==a&&
null!==a.memoizedState!==(null!==b.memoizedState)&&"unstable-defer-without-hiding"!==d.mode&&(b.flags|=4),null}throw Error(w(156,b.tag));}
function Ui(a){switch(a.tag){case 1:Kf(a.type)&&Lf();var b=a.flags;return b&4096?(a.flags=b&-4097|64,a):null;case 3:lh();G(Hf);G(J);Ah();b=a.flags;if(0!==(b&64))throw Error(w(285));a.flags=b&-4097|64;return a;case 5:return nh(a),null;case 13:G(O);b=a.memoizedState;if(null!==b&&null!==b.dehydrated){if(null===a.alternate)throw Error(w(340));yh()}b=a.flags;return b&4096?(a.flags=b&-4097|64,a):null;case 19:return G(O),null;case 4:return lh(),null;case 10:return wg(a),null;case 23:case 24:return Ti(),
null;default:return null}}function Vi(a,b){try{var c="",d=b;do c+=Qa(d),d=d.return;while(d);var e=c}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack}return{value:a,source:b,stack:e}}function Wi(a,b){try{console.error(b.value)}catch(c){setTimeout(function(){throw c;})}}var Xi="function"===typeof WeakMap?WeakMap:Map;function Yi(a,b,c){c=Eg(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Zi||(Zi=!0,$i=d);Wi(a,b)};return c}
function aj(a,b,c){c=Eg(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Wi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===bj?bj=new Set([this]):bj.add(this),Wi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}var cj="function"===typeof WeakSet?WeakSet:Set;
function dj(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){ej(a,c)}else b.current=null}function fj(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.flags&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:qg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:b.flags&256&&uf(b.stateNode.containerInfo);return;case 5:case 6:case 4:case 17:return}throw Error(w(163));}
function gj(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{if(3===(a.tag&3)){var d=a.create;a.destroy=d()}a=a.next}while(a!==b)}b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{var e=a;d=e.next;e=e.tag;0!==(e&4)&&0!==(e&1)&&(hj(c,a),ij(c,a));a=d}while(a!==b)}return;case 1:a=c.stateNode;c.flags&4&&(null===b?a.componentDidMount():(d=c.elementType===c.type?b.memoizedProps:qg(c.type,b.memoizedProps),a.componentDidUpdate(d,
b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)));b=c.updateQueue;null!==b&&Jg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Jg(c,b,a)}return;case 5:a=c.stateNode;null===b&&c.flags&4&&pf(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Fc(c))));
return;case 19:case 17:case 20:case 21:case 23:case 24:return}throw Error(w(163));}
function jj(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d=d.style,"function"===typeof d.setProperty?d.setProperty("display","none","important"):d.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=sb("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if((23!==c.tag&&24!==c.tag||null===c.memoizedState||c===a)&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===
a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function kj(a,b){if(Rf&&"function"===typeof Rf.onCommitFiberUnmount)try{Rf.onCommitFiberUnmount(Qf,b)}catch(f){}switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var c=a=a.next;do{var d=c,e=d.destroy;d=d.tag;if(void 0!==e)if(0!==(d&4))hj(b,c);else{d=b;try{e()}catch(f){ej(d,f)}}c=c.next}while(c!==a)}break;case 1:dj(b);a=b.stateNode;if("function"===typeof a.componentWillUnmount)try{a.props=b.memoizedProps,a.state=b.memoizedState,a.componentWillUnmount()}catch(f){ej(b,
f)}break;case 5:dj(b);break;case 4:lj(a,b)}}function mj(a){a.alternate=null;a.child=null;a.dependencies=null;a.firstEffect=null;a.lastEffect=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.return=null;a.updateQueue=null}function nj(a){return 5===a.tag||3===a.tag||4===a.tag}
function oj(a){a:{for(var b=a.return;null!==b;){if(nj(b))break a;b=b.return}throw Error(w(160));}var c=b;b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(w(161));}c.flags&16&&(pb(b,""),c.flags&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||nj(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.flags&2)continue b;if(null===
c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.flags&2)){c=c.stateNode;break a}}d?pj(a,c,b):qj(a,c,b)}
function pj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=mf));else if(4!==d&&(a=a.child,null!==a))for(pj(a,b,c),a=a.sibling;null!==a;)pj(a,b,c),a=a.sibling}
function qj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(qj(a,b,c),a=a.sibling;null!==a;)qj(a,b,c),a=a.sibling}
function lj(a,b){for(var c=b,d=!1,e,f;;){if(!d){d=c.return;a:for(;;){if(null===d)throw Error(w(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag){a:for(var g=a,h=c,k=h;;)if(kj(g,k),null!==k.child&&4!==k.tag)k.child.return=k,k=k.child;else{if(k===h)break a;for(;null===k.sibling;){if(null===k.return||k.return===h)break a;k=k.return}k.sibling.return=k.return;k=k.sibling}f?(g=e,h=c.stateNode,
8===g.nodeType?g.parentNode.removeChild(h):g.removeChild(h)):e.removeChild(c.stateNode)}else if(18===c.tag)f?(g=e,h=c.stateNode,8===g.nodeType?tf(g.parentNode,h):1===g.nodeType&&tf(g,h),Fc(g)):tf(e,c.stateNode);else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(kj(a,c),null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=
c.return;c=c.sibling}}
function rj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:var c=b.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do 3===(d.tag&3)&&(a=d.destroy,d.destroy=void 0,void 0!==a&&a()),d=d.next;while(d!==c)}return;case 1:return;case 5:c=b.stateNode;if(null!=c){d=b.memoizedProps;var e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Bf]=d;"input"===a&&"radio"===d.type&&null!=d.name&&$a(c,d);wb(a,e);b=wb(a,d);for(e=0;e<f.length;e+=
2){var g=f[e],h=f[e+1];"style"===g?tb(c,h):"dangerouslySetInnerHTML"===g?ob(c,h):"children"===g?pb(c,h):qa(c,g,h,b)}switch(a){case "input":ab(c,d);break;case "textarea":ib(c,d);break;case "select":a=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?fb(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?fb(c,!!d.multiple,d.defaultValue,!0):fb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(w(162));b.stateNode.nodeValue=
b.memoizedProps;return;case 3:c=b.stateNode;c.hydrate&&(c.hydrate=!1,Fc(c.containerInfo));return;case 12:return;case 13:null!==b.memoizedState&&(sj=N(),jj(b.child,!0));tj(b);return;case 19:tj(b);return;case 17:return;case 23:case 24:jj(b,null!==b.memoizedState);return}throw Error(w(163));}function tj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new cj);b.forEach(function(b){var d=uj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
function vj(a,b){return null!==a&&(a=a.memoizedState,null===a||null!==a.dehydrated)?(b=b.memoizedState,null!==b&&null===b.dehydrated):!1}var wj=Math.ceil,xj=ra.ReactCurrentDispatcher,yj=ra.ReactCurrentOwner,V=0,T=null,X=null,Y=0,zj=0,Aj=Ff(0),W=0,Bj=null,Cj=0,Ig=0,Dj=0,Ej=0,Fj=null,sj=0,Si=Infinity;function Gj(){Si=N()+500}var Z=null,Zi=!1,$i=null,bj=null,Hj=!1,Ij=null,Jj=90,Kj=[],Lj=[],Mj=null,Nj=0,Oj=null,Pj=-1,Qj=0,Rj=0,Sj=null,Tj=!1;function Mg(){return 0!==(V&48)?N():-1!==Pj?Pj:Pj=N()}
function Ng(a){a=a.mode;if(0===(a&2))return 1;if(0===(a&4))return 99===jg()?1:2;0===Qj&&(Qj=Cj);if(0!==pg.transition){0!==Rj&&(Rj=null!==Fj?Fj.pendingLanes:0);a=Qj;var b=4186112&~Rj;b&=-b;0===b&&(a=4186112&~a,b=a&-a,0===b&&(b=8192));return b}a=jg();0!==(V&4)&&98===a?a=ad(12,Qj):(a=Wc(a),a=ad(a,Qj));return a}
function Og(a,b,c){if(50<Nj)throw Nj=0,Oj=null,Error(w(185));a=Uj(a,b);if(null===a)return null;cd(a,b,c);a===T&&(Dj|=b,4===W&&Vj(a,Y));var d=jg();1===b?0!==(V&8)&&0===(V&48)?Wj(a):(Xj(a,c),0===V&&(Gj(),ng())):(0===(V&4)||98!==d&&99!==d||(null===Mj?Mj=new Set([a]):Mj.add(a)),Xj(a,c));Fj=a}function Uj(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}
function Xj(a,b){for(var c=a.callbackNode,d=a.suspendedLanes,e=a.pingedLanes,f=a.expirationTimes,g=a.pendingLanes;0<g;){var h=31-Zc(g),k=1<<h,l=f[h];if(-1===l){if(0===(k&d)||0!==(k&e)){l=b;Vc(k);var n=E;f[h]=10<=n?l+250:6<=n?l+5E3:-1}}else l<=b&&(a.expiredLanes|=k);g&=~k}d=Yc(a,a===T?Y:0);b=E;if(0===d)null!==c&&(c!==dg&&Uf(c),a.callbackNode=null,a.callbackPriority=0);else{if(null!==c){if(a.callbackPriority===b)return;c!==dg&&Uf(c)}15===b?(c=Wj.bind(null,a),null===fg?(fg=[c],gg=Tf(Zf,og)):fg.push(c),
c=dg):14===b?c=mg(99,Wj.bind(null,a)):(c=Xc(b),c=mg(c,Yj.bind(null,a)));a.callbackPriority=b;a.callbackNode=c}}
function Yj(a){Pj=-1;Rj=Qj=0;if(0!==(V&48))throw Error(w(327));var b=a.callbackNode;if(Zj()&&a.callbackNode!==b)return null;var c=Yc(a,a===T?Y:0);if(0===c)return null;var d=c;var e=V;V|=16;var f=ak();if(T!==a||Y!==d)Gj(),bk(a,d);do try{ck();break}catch(h){dk(a,h)}while(1);vg();xj.current=f;V=e;null!==X?d=0:(T=null,Y=0,d=W);if(0!==(Cj&Dj))bk(a,0);else if(0!==d){2===d&&(V|=64,a.hydrate&&(a.hydrate=!1,uf(a.containerInfo)),c=$c(a),0!==c&&(d=ek(a,c)));if(1===d)throw b=Bj,bk(a,0),Vj(a,c),Xj(a,N()),b;a.finishedWork=
a.current.alternate;a.finishedLanes=c;switch(d){case 0:case 1:throw Error(w(345));case 2:fk(a);break;case 3:Vj(a,c);if((c&62914560)===c&&(d=sj+500-N(),10<d)){if(0!==Yc(a,0))break;e=a.suspendedLanes;if((e&c)!==c){Mg();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=rf(fk.bind(null,a),d);break}fk(a);break;case 4:Vj(a,c);if((c&4186112)===c)break;d=a.eventTimes;for(e=-1;0<c;){var g=31-Zc(c);f=1<<g;g=d[g];g>e&&(e=g);c&=~f}c=e;c=N()-c;c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>
c?4320:1960*wj(c/1960))-c;if(10<c){a.timeoutHandle=rf(fk.bind(null,a),c);break}fk(a);break;case 5:fk(a);break;default:throw Error(w(329));}}Xj(a,N());return a.callbackNode===b?Yj.bind(null,a):null}function Vj(a,b){b&=~Ej;b&=~Dj;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-Zc(b),d=1<<c;a[c]=-1;b&=~d}}
function Wj(a){if(0!==(V&48))throw Error(w(327));Zj();if(a===T&&0!==(a.expiredLanes&Y)){var b=Y;var c=ek(a,b);0!==(Cj&Dj)&&(b=Yc(a,b),c=ek(a,b))}else b=Yc(a,0),c=ek(a,b);0!==a.tag&&2===c&&(V|=64,a.hydrate&&(a.hydrate=!1,uf(a.containerInfo)),b=$c(a),0!==b&&(c=ek(a,b)));if(1===c)throw c=Bj,bk(a,0),Vj(a,b),Xj(a,N()),c;a.finishedWork=a.current.alternate;a.finishedLanes=b;fk(a);Xj(a,N());return null}
function gk(){if(null!==Mj){var a=Mj;Mj=null;a.forEach(function(a){a.expiredLanes|=24&a.pendingLanes;Xj(a,N())})}ng()}function hk(a,b){var c=V;V|=1;try{return a(b)}finally{V=c,0===V&&(Gj(),ng())}}function ik(a,b){var c=V;V&=-2;V|=8;try{return a(b)}finally{V=c,0===V&&(Gj(),ng())}}function jk(a,b){var c=V;if(0!==(c&48))return a(b);V|=1;try{if(a)return lg(99,a.bind(null,b))}finally{V=c,ng()}}function ti(a,b){H(Aj,zj);zj|=b;Cj|=b}function Ti(){zj=Aj.current;G(Aj)}
function bk(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,sf(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Lf();break;case 3:lh();G(Hf);G(J);Ah();break;case 5:nh(d);break;case 4:lh();break;case 13:G(O);break;case 19:G(O);break;case 10:wg(d);break;case 23:case 24:Ti()}c=c.return}T=a;X=Zg(a.current,null);Y=zj=Cj=b;W=0;Bj=null;Ej=Dj=Ig=0}
function dk(a,b){do{var c=X;try{vg();Bh.current=Mh;if(Eh){for(var d=P.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next}Eh=!1}Dh=0;S=R=P=null;Fh=!1;yj.current=null;if(null===c||null===c.return){W=1;Bj=b;X=null;break}a:{var f=a,g=c.return,h=c,k=b;b=Y;h.flags|=2048;h.firstEffect=h.lastEffect=null;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k;if(0===(h.mode&2)){var n=h.alternate;n?(h.updateQueue=n.updateQueue,h.memoizedState=n.memoizedState,h.lanes=n.lanes):
(h.updateQueue=null,h.memoizedState=null)}var z=0!==(O.current&1),t=g;do{var B;if(B=13===t.tag){var y=t.memoizedState;if(null!==y)B=null!==y.dehydrated?!0:!1;else{var v=t.memoizedProps;B=void 0===v.fallback?!1:!0!==v.unstable_avoidThisFallback?!0:z?!1:!0}}if(B){var I=t.updateQueue;if(null===I){var x=new Set;x.add(l);t.updateQueue=x}else I.add(l);if(0===(t.mode&2)){t.flags|=64;h.flags|=16384;h.flags&=-2981;if(1===h.tag)if(null===h.alternate)h.tag=17;else{var r=Eg(-1,1);r.tag=2;Fg(h,r)}h.lanes|=1;break a}k=
void 0;h=b;var p=f.pingCache;null===p?(p=f.pingCache=new Xi,k=new Set,p.set(l,k)):(k=p.get(l),void 0===k&&(k=new Set,p.set(l,k)));if(!k.has(h)){k.add(h);var q=kk.bind(null,f,l,h);l.then(q,q)}t.flags|=4096;t.lanes=b;break a}t=t.return}while(null!==t);k=Error((Ra(h.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.")}5!==W&&(W=2);k=Vi(k,h);t=
g;do{switch(t.tag){case 3:f=k;t.flags|=4096;b&=-b;t.lanes|=b;var K=Yi(t,f,b);Gg(t,K);break a;case 1:f=k;var L=t.type,Q=t.stateNode;if(0===(t.flags&64)&&("function"===typeof L.getDerivedStateFromError||null!==Q&&"function"===typeof Q.componentDidCatch&&(null===bj||!bj.has(Q)))){t.flags|=4096;b&=-b;t.lanes|=b;var M=aj(t,f,b);Gg(t,M);break a}}t=t.return}while(null!==t)}lk(c)}catch(za){b=za;X===c&&null!==c&&(X=c=c.return);continue}break}while(1)}
function ak(){var a=xj.current;xj.current=Mh;return null===a?Mh:a}function Fi(){if(0===W||3===W)W=4;null===T||0===(Ig&134217727)&&0===(Dj&134217727)||Vj(T,Y)}function ek(a,b){var c=V;V|=16;var d=ak();T===a&&Y===b||bk(a,b);do try{mk();break}catch(e){dk(a,e)}while(1);vg();V=c;xj.current=d;if(null!==X)throw Error(w(261));T=null;Y=0;return W}function mk(){for(;null!==X;)nk(X)}function ck(){for(;null!==X&&!Vf();)nk(X)}
function nk(a){var b=ok(a.alternate,a,zj);a.memoizedProps=a.pendingProps;null===b?lk(a):X=b;yj.current=null}
function lk(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&2048)){c=Ri(c,b,zj);if(null!==c){X=c;return}c=b;if(24!==c.tag&&23!==c.tag||null===c.memoizedState||0!==(zj&1073741824)||0===(c.mode&4)){for(var d=0,e=c.child;null!==e;)d|=e.lanes|e.childLanes,e=e.sibling;c.childLanes=d}null!==a&&0===(a.flags&2048)&&(null===a.firstEffect&&(a.firstEffect=b.firstEffect),null!==b.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=b.firstEffect),a.lastEffect=b.lastEffect),1<b.flags&&(null!==
a.lastEffect?a.lastEffect.nextEffect=b:a.firstEffect=b,a.lastEffect=b))}else{c=Ui(b);if(null!==c){c.flags&=2047;X=c;return}null!==a&&(a.firstEffect=a.lastEffect=null,a.flags|=2048)}b=b.sibling;if(null!==b){X=b;return}X=b=a}while(null!==b);0===W&&(W=5)}function fk(a){var b=jg();lg(99,pk.bind(null,a,b));return null}
function pk(a,b){do Zj();while(null!==Ij);if(0!==(V&48))throw Error(w(327));var c=a.finishedWork;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(w(177));a.callbackNode=null;var d=c.lanes|c.childLanes,e=d,f=a.pendingLanes&~e;a.pendingLanes=e;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=e;a.mutableReadLanes&=e;a.entangledLanes&=e;e=a.entanglements;for(var g=a.eventTimes,h=a.expirationTimes;0<f;){var k=31-Zc(f),l=1<<k;e[k]=0;g[k]=-1;h[k]=-1;f&=~l}null!==
Mj&&0===(d&24)&&Mj.has(a)&&Mj.delete(a);a===T&&(X=T=null,Y=0);1<c.flags?null!==c.lastEffect?(c.lastEffect.nextEffect=c,d=c.firstEffect):d=c:d=c.firstEffect;if(null!==d){e=V;V|=32;yj.current=null;nf=id;g=Qe();if(Re(g)){if("selectionStart"in g)h={start:g.selectionStart,end:g.selectionEnd};else a:if(h=(h=g.ownerDocument)&&h.defaultView||window,(l=h.getSelection&&h.getSelection())&&0!==l.rangeCount){h=l.anchorNode;f=l.anchorOffset;k=l.focusNode;l=l.focusOffset;try{h.nodeType,k.nodeType}catch(za){h=null;
break a}var n=0,z=-1,t=-1,B=0,y=0,v=g,I=null;b:for(;;){for(var x;;){v!==h||0!==f&&3!==v.nodeType||(z=n+f);v!==k||0!==l&&3!==v.nodeType||(t=n+l);3===v.nodeType&&(n+=v.nodeValue.length);if(null===(x=v.firstChild))break;I=v;v=x}for(;;){if(v===g)break b;I===h&&++B===f&&(z=n);I===k&&++y===l&&(t=n);if(null!==(x=v.nextSibling))break;v=I;I=v.parentNode}v=x}h=-1===z||-1===t?null:{start:z,end:t}}else h=null;h=h||{start:0,end:0}}else h=null;of={focusedElem:g,selectionRange:h};id=!1;Sj=null;Tj=!1;Z=d;do try{qk()}catch(za){if(null===
Z)throw Error(w(330));ej(Z,za);Z=Z.nextEffect}while(null!==Z);Sj=null;Z=d;do try{for(g=a;null!==Z;){var r=Z.flags;r&16&&pb(Z.stateNode,"");if(r&128){var p=Z.alternate;if(null!==p){var q=p.ref;null!==q&&("function"===typeof q?q(null):q.current=null)}}switch(r&1038){case 2:oj(Z);Z.flags&=-3;break;case 6:oj(Z);Z.flags&=-3;rj(Z.alternate,Z);break;case 1024:Z.flags&=-1025;break;case 1028:Z.flags&=-1025;rj(Z.alternate,Z);break;case 4:rj(Z.alternate,Z);break;case 8:h=Z;lj(g,h);var K=h.alternate;mj(h);null!==
K&&mj(K)}Z=Z.nextEffect}}catch(za){if(null===Z)throw Error(w(330));ej(Z,za);Z=Z.nextEffect}while(null!==Z);q=of;p=Qe();r=q.focusedElem;g=q.selectionRange;if(p!==r&&r&&r.ownerDocument&&Pe(r.ownerDocument.documentElement,r)){null!==g&&Re(r)&&(p=g.start,q=g.end,void 0===q&&(q=p),"selectionStart"in r?(r.selectionStart=p,r.selectionEnd=Math.min(q,r.value.length)):(q=(p=r.ownerDocument||document)&&p.defaultView||window,q.getSelection&&(q=q.getSelection(),h=r.textContent.length,K=Math.min(g.start,h),g=void 0===
g.end?K:Math.min(g.end,h),!q.extend&&K>g&&(h=g,g=K,K=h),h=Oe(r,K),f=Oe(r,g),h&&f&&(1!==q.rangeCount||q.anchorNode!==h.node||q.anchorOffset!==h.offset||q.focusNode!==f.node||q.focusOffset!==f.offset)&&(p=p.createRange(),p.setStart(h.node,h.offset),q.removeAllRanges(),K>g?(q.addRange(p),q.extend(f.node,f.offset)):(p.setEnd(f.node,f.offset),q.addRange(p))))));p=[];for(q=r;q=q.parentNode;)1===q.nodeType&&p.push({element:q,left:q.scrollLeft,top:q.scrollTop});"function"===typeof r.focus&&r.focus();for(r=
0;r<p.length;r++)q=p[r],q.element.scrollLeft=q.left,q.element.scrollTop=q.top}id=!!nf;of=nf=null;a.current=c;Z=d;do try{for(r=a;null!==Z;){var L=Z.flags;L&36&&gj(r,Z.alternate,Z);if(L&128){p=void 0;var Q=Z.ref;if(null!==Q){var M=Z.stateNode;switch(Z.tag){case 5:p=M;break;default:p=M}"function"===typeof Q?Q(p):Q.current=p}}Z=Z.nextEffect}}catch(za){if(null===Z)throw Error(w(330));ej(Z,za);Z=Z.nextEffect}while(null!==Z);Z=null;eg();V=e}else a.current=c;if(Hj)Hj=!1,Ij=a,Jj=b;else for(Z=d;null!==Z;)b=
Z.nextEffect,Z.nextEffect=null,Z.flags&8&&(L=Z,L.sibling=null,L.stateNode=null),Z=b;d=a.pendingLanes;0===d&&(bj=null);1===d?a===Oj?Nj++:(Nj=0,Oj=a):Nj=0;c=c.stateNode;if(Rf&&"function"===typeof Rf.onCommitFiberRoot)try{Rf.onCommitFiberRoot(Qf,c,void 0,64===(c.current.flags&64))}catch(za){}Xj(a,N());if(Zi)throw Zi=!1,a=$i,$i=null,a;if(0!==(V&8))return null;ng();return null}
function qk(){for(;null!==Z;){var a=Z.alternate;Tj||null===Sj||(0!==(Z.flags&8)?dc(Z,Sj)&&(Tj=!0):13===Z.tag&&vj(a,Z)&&dc(Z,Sj)&&(Tj=!0));var b=Z.flags;0!==(b&256)&&fj(a,Z);0===(b&512)||Hj||(Hj=!0,mg(97,function(){Zj();return null}));Z=Z.nextEffect}}function Zj(){if(90!==Jj){var a=97<Jj?97:Jj;Jj=90;return lg(a,rk)}return!1}function ij(a,b){Kj.push(b,a);Hj||(Hj=!0,mg(97,function(){Zj();return null}))}function hj(a,b){Lj.push(b,a);Hj||(Hj=!0,mg(97,function(){Zj();return null}))}
function rk(){if(null===Ij)return!1;var a=Ij;Ij=null;if(0!==(V&48))throw Error(w(331));var b=V;V|=32;var c=Lj;Lj=[];for(var d=0;d<c.length;d+=2){var e=c[d],f=c[d+1],g=e.destroy;e.destroy=void 0;if("function"===typeof g)try{g()}catch(k){if(null===f)throw Error(w(330));ej(f,k)}}c=Kj;Kj=[];for(d=0;d<c.length;d+=2){e=c[d];f=c[d+1];try{var h=e.create;e.destroy=h()}catch(k){if(null===f)throw Error(w(330));ej(f,k)}}for(h=a.current.firstEffect;null!==h;)a=h.nextEffect,h.nextEffect=null,h.flags&8&&(h.sibling=
null,h.stateNode=null),h=a;V=b;ng();return!0}function sk(a,b,c){b=Vi(c,b);b=Yi(a,b,1);Fg(a,b);b=Mg();a=Uj(a,1);null!==a&&(cd(a,1,b),Xj(a,b))}
function ej(a,b){if(3===a.tag)sk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){sk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===bj||!bj.has(d))){a=Vi(b,a);var e=aj(c,a,1);Fg(c,e);e=Mg();c=Uj(c,1);if(null!==c)cd(c,1,e),Xj(c,e);else if("function"===typeof d.componentDidCatch&&(null===bj||!bj.has(d)))try{d.componentDidCatch(b,a)}catch(f){}break}}c=c.return}}
function kk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=Mg();a.pingedLanes|=a.suspendedLanes&c;T===a&&(Y&c)===c&&(4===W||3===W&&(Y&62914560)===Y&&500>N()-sj?bk(a,0):Ej|=c);Xj(a,b)}function tk(a,b){0===b&&(b=a.mode,0===(b&2)?b=1:0===(b&4)?b=99===jg()?1:2:(0===Qj&&(Qj=Cj),b=bd(62914560&~Qj),0===b&&(b=4194304)));var c=Mg();a=Uj(a,b);null!==a&&(cd(a,b,c),Xj(a,c))}function Gi(a){var b=a.memoizedState,c=0;null!==b&&(c=b.retryLane);tk(a,c)}
function uj(a,b){var c=0;switch(a.tag){case 13:var d=a.stateNode;var e=a.memoizedState;null!==e&&(c=e.retryLane);break;case 19:d=a.stateNode;break;default:throw Error(w(314));}null!==d&&d.delete(b);tk(a,c)}var ok;
ok=function(a,b,c){var d=b.lanes;if(null!==a)if(a.memoizedProps!==b.pendingProps||Hf.current)zg=!0;else if(0!==(c&d))zg=0!==(a.flags&16384)?!0:!1;else{zg=!1;switch(b.tag){case 3:yi(b);yh();break;case 5:mh(b);break;case 1:Kf(b.type)&&Of(b);break;case 4:kh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;var e=b.type._context;H(rg,e._currentValue);e._currentValue=d;break;case 13:d=b.memoizedState;if(null!==d){if(null!==d.dehydrated)return H(O,O.current&1),b.flags|=64,null;if(0!==(c&
b.child.childLanes))return Ai(a,b,c);H(O,O.current&1);b=ni(a,b,c);return null!==b?b.sibling:null}H(O,O.current&1);break;case 19:d=0!==(c&b.childLanes);if(0!==(a.flags&64)){if(d)return Li(a,b,c);b.flags|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);H(O,O.current);if(d)break;else return null;case 23:case 24:return b.lanes=0,si(a,b,c)}return ni(a,b,c)}else zg=!1;b.lanes=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);a=b.pendingProps;
e=Jf(b,J.current);yg(b,c);e=Ih(null,b,d,a,e,c);b.flags|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(Kf(d)){var f=!0;Of(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;Cg(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Lg(b,d,g,a);e.updater=Pg;b.stateNode=e;e._reactInternals=b;Tg(b,d,a,c);b=xi(null,b,d,!0,f,c)}else b.tag=0,U(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;
a:{null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);a=b.pendingProps;f=e._init;e=f(e._payload);b.type=e;f=b.tag=uk(e);g=qg(e,a);switch(f){case 0:b=ri(null,b,e,g,c);break a;case 1:b=wi(null,b,e,g,c);break a;case 11:b=mi(null,b,e,g,c);break a;case 14:b=oi(null,b,e,qg(e.type,g),d,c);break a;case 22:b=vi(null,b,e,a,c);break a}throw Error(w(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:qg(d,e),ri(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:qg(d,e),wi(a,b,d,e,c);case 3:yi(b);d=b.updateQueue;if(null===a||null===d)throw Error(w(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;Dg(a,b);Hg(b,d,null,c);d=b.memoizedState.element;if(d===e)yh(),b=ni(a,b,c);else{e=b.stateNode;if(f=e.hydrate)qh=vf(b.stateNode.containerInfo.firstChild),ph=b,f=rh=!0;if(f){a=e.mutableSourceEagerHydrationData;if(null!=a)for(e=0;e<a.length;e+=2)f=a[e],f._workInProgressVersionPrimary=a[e+1],zh.push(f);c=eh(b,null,d,c);for(b.child=c;c;)c.flags=c.flags&
-3|1024,c=c.sibling}else U(a,b,d,c),yh();b=b.child}return b;case 5:return mh(b),null===a&&vh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,qf(d,e)?g=null:null!==f&&qf(d,f)&&(b.flags|=16),ui(a,b),U(a,b,g,c),b.child;case 6:return null===a&&vh(b),null;case 13:return Ai(a,b,c);case 4:return kh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=dh(b,null,d,c):U(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:qg(d,e),mi(a,b,d,e,c);
case 7:return U(a,b,b.pendingProps,c),b.child;case 8:return U(a,b,b.pendingProps.children,c),b.child;case 12:return U(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;H(rg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=Ke(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!Hf.current){b=ni(a,b,c);break a}}else for(g=b.child,
null!==g&&(g.return=b);null!==g;){var k=g.dependencies;if(null!==k){h=g.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===g.tag&&(l=Eg(-1,c&-c),l.tag=2,Fg(g,l));g.lanes|=c;l=g.alternate;null!==l&&(l.lanes|=c);xg(g.return,c);k.lanes|=c;break}l=l.next}}else if(10===g.tag)h=g.type===b.type?null:g.child;else if(18===g.tag){h=g.return;if(null===h)throw Error(w(341));h.lanes|=c;k=h.alternate;null!==k&&(k.lanes|=c);xg(h,c);h=g.sibling}else h=g.child;if(null!==h)h.return=
g;else for(h=g;null!==h;){if(h===b){h=null;break}g=h.sibling;if(null!==g){g.return=h.return;h=g;break}h=h.return}g=h}U(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,yg(b,c),e=Ag(e,f.unstable_observedBits),d=d(e),b.flags|=1,U(a,b,d,c),b.child;case 14:return e=b.type,f=qg(e,b.pendingProps),f=qg(e.type,f),oi(a,b,e,f,d,c);case 15:return qi(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:qg(d,e),null!==a&&(a.alternate=
null,b.alternate=null,b.flags|=2),b.tag=1,Kf(d)?(a=!0,Of(b)):a=!1,yg(b,c),Rg(b,d,e),Tg(b,d,e,c),xi(null,b,d,!0,a,c);case 19:return Li(a,b,c);case 22:return vi(a,b,b.type,b.pendingProps,c);case 23:return si(a,b,c);case 24:return si(a,b,c)}throw Error(w(156,b.tag));};
function vk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.flags=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childLanes=this.lanes=0;this.alternate=null}function th(a,b,c,d){return new vk(a,b,c,d)}function pi(a){a=a.prototype;return!(!a||!a.isReactComponent)}
function uk(a){if("function"===typeof a)return pi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Aa)return 11;if(a===Da)return 14;if(a===Fa)return 22}return 2}
function Zg(a,b){var c=a.alternate;null===c?(c=th(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ah(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)pi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ua:return ch(c.children,e,f,b);case Ha:g=8;e|=16;break;case va:g=8;e|=1;break;case wa:return a=th(12,c,b,e|8),a.elementType=wa,a.type=wa,a.lanes=f,a;case Ba:return a=th(13,c,b,e),a.type=Ba,a.elementType=Ba,a.lanes=f,a;case Ca:return a=th(19,c,b,e),a.elementType=Ca,a.lanes=f,a;case Ia:return Di(c,e,f,b);case Ja:return a=th(24,c,b,e),a.elementType=Ja,a.lanes=f,a;default:if("object"===
typeof a&&null!==a)switch(a.$$typeof){case xa:g=10;break a;case ya:g=9;break a;case Aa:g=11;break a;case Da:g=14;break a;case Ea:g=16;d=null;break a;case Fa:g=22;break a}throw Error(w(130,null==a?a:typeof a,""));}b=th(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function ch(a,b,c,d){a=th(7,a,d,b);a.lanes=c;return a}function Di(a,b,c,d){a=th(23,a,d,b);a.elementType=Ia;a.lanes=c;return a}function $g(a,b,c){a=th(6,a,null,b);a.lanes=c;return a}
function bh(a,b,c){b=th(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function wk(a,b,c){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=0;this.eventTimes=Array(31).fill(0);this.expirationTimes=Array(31).fill(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=Array(31).fill(0);this.mutableSourceEagerHydrationData=
null}function xk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:ta,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
function yk(a,b,c,d){var e=b.current,f=Mg(),g=Ng(e);a:if(c){c=c._reactInternals;b:{if(Zb(c)!==c||1!==c.tag)throw Error(w(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(Kf(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(w(171));}if(1===c.tag){var k=c.type;if(Kf(k)){c=Nf(c,k,h);break a}}c=h}else c=Gf;null===b.context?b.context=c:b.pendingContext=c;b=Eg(f,g);b.payload={element:a};d=void 0===d?null:d;null!==
d&&(b.callback=d);Fg(e,b);Og(e,g,f);return g}function zk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Ak(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b}}function Bk(a,b){Ak(a,b);(a=a.alternate)&&Ak(a,b)}function Ck(a,b){var c=Uc;try{return Uc=a,b()}finally{Uc=c}}function Dk(){return null}function Ek(a,b){this._internalRoot=Fk(a,2,b)}
function Gk(a,b,c){this._internalRoot=Fk(a,b,c)}Ek.prototype.render=Gk.prototype.render=function(a){yk(a,this._internalRoot,null,null)};Ek.prototype.unmount=Gk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;yk(null,a,null,function(){b[jf]=null})};
function Fk(a,b,c){var d=null!=c&&null!=c.hydrationOptions&&c.hydrationOptions.mutableSources||null;c=new wk(a,b,null!=c&&!0===c.hydrate);b=th(3,null,null,2===b?7:1===b?3:0);c.current=b;b.stateNode=c;Cg(b);a[jf]=c.current;ff(8===a.nodeType?a.parentNode:a);if(d)for(a=0;a<d.length;a++){b=d[a];var e=b._getVersion;e=e(b._source);null==c.mutableSourceEagerHydrationData?c.mutableSourceEagerHydrationData=[b,e]:c.mutableSourceEagerHydrationData.push(b,e)}return c}
function Hk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function Ik(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Gk(a,0,b?{hydrate:!0}:void 0)}
function Jk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=zk(g);h.call(a)}}yk(b,g,a,e)}else{f=c._reactRootContainer=Ik(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=zk(g);k.call(a)}}ik(function(){yk(b,g,a,e)})}return zk(g)}
ec=function(a){switch(a.tag){case 3:var b=a.stateNode;if(b.hydrate){var c=Vc(b.pendingLanes);b.expiredLanes|=c&b.pendingLanes;Xj(b,N());0===(V&48)&&(Gj(),ng())}break;case 13:var d=Mg();jk(function(){return Og(a,1,d)});Bk(a,4)}};fc=function(a){if(13===a.tag){var b=Mg();Og(a,4,b);Bk(a,4)}};gc=function(a){if(13===a.tag){var b=Mg();Og(a,67108864,b);Bk(a,67108864)}};hc=function(a){if(13===a.tag){var b=Mg(),c=Ng(a);Og(a,c,b);Bk(a,c)}};ic=function(){return Uc};jc=Ck;
yb=function(a,b,c){switch(b){case "input":ab(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(w(90));Wa(d);ab(d,e)}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1)}};Gb=hk;
Hb=function(a,b,c,d,e){var f=V;V|=4;try{return lg(98,a.bind(null,b,c,d,e))}finally{V=f,0===V&&(Gj(),ng())}};Ib=function(){0===(V&49)&&(gk(),Zj())};Jb=function(a,b){var c=V;V|=2;try{return a(b)}finally{V=c,0===V&&(Gj(),ng())}};function Kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!Hk(b))throw Error(w(200));return xk(a,b,null,c)}
var Lk={Events:[Cb,xe,Db,Eb,Fb,Zj,{current:!1}]},Mk={findFiberByHostInstance:Ac,bundleType:0,version:"17.0.0-alpha.0-experimental-4ead6b530",rendererPackageName:"react-dom"};
var Nk={bundleType:Mk.bundleType,version:Mk.version,rendererPackageName:Mk.rendererPackageName,rendererConfig:Mk.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ra.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=cc(a);return null===a?null:a.stateNode},findFiberByHostInstance:Mk.findFiberByHostInstance||
Dk,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var Ok=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!Ok.isDisabled&&Ok.supportsFiber)try{Qf=Ok.inject(Nk),Rf=Ok}catch(a){}}exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=Lk;exports.createPortal=Kk;
exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(w(188));throw Error(w(268,Object.keys(a)));}a=cc(b);a=null===a?null:a.stateNode;return a};exports.flushSync=jk;exports.hydrate=function(a,b,c){if(!Hk(b))throw Error(w(200));return Jk(null,a,b,!0,c)};exports.render=function(a,b,c){if(!Hk(b))throw Error(w(200));return Jk(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!Hk(a))throw Error(w(40));return a._reactRootContainer?(ik(function(){Jk(null,null,a,!1,function(){a._reactRootContainer=null;a[jf]=null})}),!0):!1};exports.unstable_batchedUpdates=hk;exports.unstable_createBlockingRoot=function(a,b){if(!Hk(a))throw Error(w(299));return new Gk(a,1,b)};exports.unstable_createPortal=function(a,b){return Kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_createRoot=function(a,b){if(!Hk(a))throw Error(w(299));return new Ek(a,b)};exports.unstable_flushControlled=function(a){var b=V;V|=1;try{lg(99,a)}finally{V=b,0===V&&(Gj(),ng())}};exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!Hk(c))throw Error(w(200));if(null==a||void 0===a._reactInternals)throw Error(w(38));return Jk(a,b,c,!1,d)};exports.unstable_runWithPriority=Ck;
exports.unstable_scheduleHydration=function(a){if(a){var b=u.unstable_getCurrentPriorityLevel(),c=ic();a={blockedOn:null,target:a,priority:b,lanePriority:c};for(c=0;c<rc.length&&!(b<=rc[c].priority);c++);rc.splice(c,0,a);0===c&&zc(a)}};exports.version="17.0.0-alpha.0-experimental-4ead6b530";


/***/ }),

/***/ 23882:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {}
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(33726);
} else {}


/***/ }),

/***/ 80849:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GlobalHotKeys: () => (/* binding */ GlobalHotKeys$1),
/* harmony export */   HotKeys: () => (/* binding */ HotKeys),
/* harmony export */   IgnoreKeys: () => (/* binding */ IgnoreKeys),
/* harmony export */   configure: () => (/* binding */ configure),
/* harmony export */   getApplicationKeyMap: () => (/* binding */ getApplicationKeyMap)
/* harmony export */ });
/* unused harmony exports ObserveKeys, withHotKeys, withIgnoreKeys, withObserveKeys, recordKeyCombination */
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5821);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);
/**
 * ISC License
 *
 * Copyright (c) 2018, Aleck Greenham
 *
 * Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */




function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function arrayFrom(a){return Array.isArray(a)?a:a?[a]:[]}

function nop(a){return a}

function dictionaryFrom(a){var b=!(1<arguments.length&&arguments[1]!==void 0)||arguments[1],c=2<arguments.length&&arguments[2]!==void 0?arguments[2]:nop,d=3<arguments.length&&arguments[3]!==void 0?arguments[3]:{},e=function(){return "function"==typeof b?b:function(){return b}}();return arrayFrom(a).reduce(function(a,b){return a[c(b)]=e(b),a},d)}

var objectValues = (function(a){return Object.keys(a).map(function(b){return a[b]})});

var _defaultConfiguration={logLevel:"warn",defaultKeyEvent:"keydown",defaultComponent:"div",defaultTabIndex:"-1",ignoreTags:["input","select","textarea"],ignoreKeymapAndHandlerChangesByDefault:!0,ignoreEventsCondition:function c(a){var b=a.target;if(b&&b.tagName){var d=b.tagName.toLowerCase();return Configuration.option("_ignoreTagsDict")[d]||b.isContentEditable}return !1},ignoreRepeatedEventsWhenKeyHeldDown:!0,simulateMissingKeyPressEvents:!0,stopEventPropagationAfterHandling:!0,stopEventPropagationAfterIgnoring:!0,allowCombinationSubmatches:!1,customKeyCodes:{}},_configuration=_objectSpread({},_defaultConfiguration);_configuration._ignoreTagsDict=dictionaryFrom(_configuration.ignoreTags);var Configuration=function(){function a(){_classCallCheck(this,a);}return _createClass(a,null,[{key:"init",value:function e(a){var b=this,c=a.ignoreTags,d=a.customKeyCodes;c&&(a._ignoreTagsDict=dictionaryFrom(a.ignoreTags)),d&&(a._customKeyNamesDict=dictionaryFrom(objectValues(a.customKeyCodes))),-1!==["verbose","debug","info"].indexOf(a.logLevel)&&console.warn("React HotKeys: You have requested log level '".concat(a.logLevel,"' but for performance reasons, logging below severity level 'warning' is disabled in production. Please use the development build for complete logs.")),Object.keys(a).forEach(function(c){b.set(c,a[c]);});}},{key:"set",value:function c(a,b){_configuration[a]=b;}},{key:"reset",value:function b(a){_configuration[a]=_defaultConfiguration[a];}},{key:"option",value:function b(a){return _configuration[a]}}]),a}();

function backwardsCompatibleContext(a,b){var c=b.deprecatedAPI,d=c.contextTypes,e=c.childContextTypes,f=b.newAPI.contextType;if("undefined"==typeof react__WEBPACK_IMPORTED_MODULE_0__.createContext)a.contextTypes=d,a.childContextTypes=e,a.prototype.getChildContext=function(){return this._manager.childContext};else{var g=react__WEBPACK_IMPORTED_MODULE_0__.createContext(f);a.contextType=g,a.prototype._originalRender=a.prototype.render,a.prototype.render=function(){var a=this._originalRender();return a?react__WEBPACK_IMPORTED_MODULE_0__.createElement(g.Provider,{value:this._manager.childContext},a):null};}return a}

function isUndefined(a){return "undefined"==typeof a}

var Logger=function(){function a(){var b=this,c=0<arguments.length&&void 0!==arguments[0]?arguments[0]:"warn";_classCallCheck(this,a),_defineProperty(this,"verbose",this.noop),_defineProperty(this,"debug",this.noop),_defineProperty(this,"info",this.noop),_defineProperty(this,"warn",this.noop),_defineProperty(this,"error",this.noop),this.logLevel=this.constructor.levels[c];for(var d,e=["error","warn","info","debug","verbose"],f=function(){var a=e[g];if(b.logLevel<b.constructor.levels[a])return {v:void 0};var c=-1===["debug","verbose"].indexOf(a)?console[a]:console.log;b[a]=function(){for(var a=arguments.length,b=Array(a),d=0;d<a;d++)b[d]=arguments[d];var e=b.map(function(a){return "function"==typeof a?a():a});c.apply(void 0,_toConsumableArray(e));};},g=0;g<e.length;g++)if(d=f(),"object"===_typeof(d))return d.v}return _createClass(a,[{key:"noop",value:function a(){}}]),a}();_defineProperty(Logger,"logIcons",["\uD83D\uDCD5","\uD83D\uDCD7","\uD83D\uDCD8","\uD83D\uDCD9"]),_defineProperty(Logger,"componentIcons",["\uD83D\uDD3A","\u2B50\uFE0F","\uD83D\uDD37","\uD83D\uDD36","\u2B1B\uFE0F"]),_defineProperty(Logger,"eventIcons",["\u2764\uFE0F","\uD83D\uDC9A","\uD83D\uDC99","\uD83D\uDC9B","\uD83D\uDC9C","\uD83E\uDDE1"]),_defineProperty(Logger,"levels",{none:0,error:1,warn:2,info:3,debug:4,verbose:5});

var KeyEventType={keydown:0,keypress:1,keyup:2};

var KeyEventSequenceIndex={previous:0,current:1};

var ShiftedKeysDictionary={"`":["~"],1:["!"],2:["@","\""],3:["#","\xA3"],4:["$"],5:["%"],6:["^"],7:["&"],8:["*"],9:["("],0:[")"],"-":["_"],"=":["plus"],";":[":"],"'":["\"","@"],",":["<"],".":[">"],"/":["?"],"\\":["|"],"[":["{"],"]":["}"],"#":["~"]};

function fallbackToTransformedSelf(a,b,c){return a[b]||[1===b.length?b[c]():b]}

function resolveShiftedAlias(a){return fallbackToTransformedSelf(ShiftedKeysDictionary,a,"toUpperCase")}

function hasKey(a,b){return a.hasOwnProperty(b)}

function invertArrayDictionary(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{};return Object.keys(a).reduce(function(c,d){var e=a[d];return e.forEach(function(a){hasKey(c,a)||(c[a]=[]),c[a].push(d);}),b.includeOriginal&&(!hasKey(c,d)&&(c[d]=[]),c[d]=[].concat(_toConsumableArray(c[d]),_toConsumableArray(e))),c},{})}

var UnshiftedKeysDictionary=invertArrayDictionary(ShiftedKeysDictionary);

function resolveUnshiftedAlias(a){return fallbackToTransformedSelf(UnshiftedKeysDictionary,a,"toLowerCase")}

var KeyOSAndLayoutAliasesDictionary={};var KeyOSAndLayoutAliasesDictionary$1 = invertArrayDictionary(KeyOSAndLayoutAliasesDictionary,{includeOriginal:!0});

function isString(a){return "string"==typeof a}

function stripSuperfluousWhitespace(a){return isString(a)?a.trim().replace(/\s+/g," "):a}

var MousetrapToReactKeyNamesDictionary={tab:"Tab",capslock:"CapsLock",shift:"Shift",meta:"Meta",alt:"Alt",ctrl:"Control",space:" ",spacebar:" ",escape:"Escape",esc:"Escape",left:"ArrowLeft",right:"ArrowRight",up:"ArrowUp",down:"ArrowDown",return:"Enter",del:"Delete",command:"Meta",option:"Alt",enter:"Enter",backspace:"Backspace",ins:"Insert",pageup:"PageUp",pagedown:"PageDown",end:"End",home:"Home",contextmenu:"ContextMenu",numlock:"Clear"};

var KeyShorthandDictionary={cmd:"Meta"};

var AltShiftedKeysDictionary={"`":["`"],1:["\u2044"],2:["\u20AC"],3:["\u2039"],4:["\u203A"],5:["\uFB01"],6:["\uFB02"],7:["\u2021"],8:["\xB0"],9:["\xB7"],0:["\u201A"],"-":["\u2014"],"=":["\xB1"],a:["\xC5"],b:["\u0131"],c:["\xC7"],d:["\xCE"],e:["\xB4"],f:["\xCF"],g:["\u02DD"],h:["\xD3"],i:["\u02C6"],j:["\xD4"],k:["\uF8FF"],l:["\xD2"],m:["\xC2"],n:["\u02DC"],o:["\xD8"],p:["\u03C0"],q:["\u0152"],r:["\u2030"],s:["\xCD"],t:["\xCE"],u:["\xA8"],v:["\u25CA"],w:["\u201E"],x:["\u02DB"],y:["\xC1"],z:["\xB8"],"[":["\u201D"],"]":["\u2019"],"\\":["\xBB"],"'":["\xC6"],";":["\xDA"],",":["\xAF"],".":["\u02D8"]};

var UnaltShiftedKeysDictionary=invertArrayDictionary(AltShiftedKeysDictionary);

function resolveUnaltShiftedAlias(a){return UnaltShiftedKeysDictionary[a]||resolveUnshiftedAlias(a)}

function standardizeKeyName(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{shift:!1,alt:!1},c=a.toLowerCase(),d=MousetrapToReactKeyNamesDictionary[c]||KeyShorthandDictionary[c]||(a.match(/^f\d+$/)?a.toUpperCase():a);return b.shift?b.alt?resolveUnaltShiftedAlias(d):resolveUnshiftedAlias(d):d}

var translateToKey={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};

var NonPrintableKeysDictionary=dictionaryFrom(objectValues(translateToKey));

function isNonPrintableKeyName(a){return !!NonPrintableKeysDictionary[a]}

function isCustomKeyName(a){return Configuration.option("_customKeyNamesDict")[a]}

function isValidKey(a){return isNonPrintableKeyName(a)||String.fromCharCode(a.charCodeAt(0))===a||isCustomKeyName(a)}var InvalidKeyNameError=function(a){function b(){var a,c;_classCallCheck(this,b);for(var d=arguments.length,e=Array(d),f=0;f<d;f++)e[f]=arguments[f];return c=_possibleConstructorReturn(this,(a=_getPrototypeOf(b)).call.apply(a,[this].concat(e))),_defineProperty(_assertThisInitialized(_assertThisInitialized(c)),"name","InvalidKeyNameError"),c}return _inherits(b,a),b}(_wrapNativeSuper(Error));

function normalizedCombinationId(a){return Object.keys(a).sort(function(c,a){return c.length===a.length?c<a?-1:c>a?1:0:a.length-c.length}).join("+")}

var KeySequenceParser=function(){function a(){_classCallCheck(this,a);}return _createClass(a,null,[{key:"parse",value:function k(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},c=stripSuperfluousWhitespace(a),d=c.split(" ");try{var e=d.slice(0,d.length-1),f=d[d.length-1],g=e.map(function(a){var c=parseCombination(a,b);return normalizedCombinationId(c)}).join(" "),h=parseCombination(f,b),i=normalizedCombinationId(h),j={id:i,keyDictionary:h,keyEventType:b.keyEventType,size:Object.keys(h).length};return {sequence:{prefix:g,size:e.length+1},combination:j}}catch(a){return {sequence:null,combination:null}}}}]),a}();function parseCombination(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{},c=-1!==a.indexOf(/[sS]hift/),d=-1!==a.indexOf(/[aA]lt/);return a.replace(/^\+|(\s|[^+]\+)\+/,"$1plus").split("+").reduce(function(a,e){var f=standardizeKeyName(e,{shift:c,alt:d});if(b.ensureValidKeys&&!isValidKey(f))throw new InvalidKeyNameError;return a[f]=!0,a},{})}

var AltedKeysDictionary={"`":["`"],1:["\xA1"],2:["\u2122"],3:["\xA3"],4:["\xA2"],5:["\u221E"],6:["\xA7"],7:["\xB6"],8:["\u2022"],9:["\xAA"],0:["\xBA"],"-":["\u2013"],"=":["\u2260"],a:["\xE5"],b:["\u222B"],c:["\xE7"],d:["\u2202"],e:["\xB4"],f:["\u0192"],g:["\xA9"],h:["\u02D9"],i:["\u02C6"],j:["\u2206"],k:["\u02DA"],l:["\xAC"],m:["\xB5"],n:["\u02DC"],o:["\xF8"],p:["\u03C0"],q:["\u0153"],r:["\xAE"],s:["\xDF"],t:["\u2020"],u:["\xA8"],v:["\u221A"],w:["\u2211"],x:["\u2248"],y:["\xA5"],z:["\u03A9"],"[":["\u201C"],"]":["\u2018"],"\\":["\xAB"],"'":["\xE6"],";":["\u2026"],",":["\u2264"],".":["\u2265"],"/":["\xF7"]};

var UnaltedKeysDictionary=invertArrayDictionary(AltedKeysDictionary);

function resolveUnaltedAlias(a){return UnaltedKeysDictionary[a]||[a]}

function resolveAltedAlias(a){return AltedKeysDictionary[a]||[a]}

function resolveAltShiftedAlias(a){return AltShiftedKeysDictionary[a]||[a]}

function isObject(a){return !Array.isArray(a)&&"object"===_typeof(a)&&null!==a}

function size(a){return isObject(a)?Object.keys(a).length:a.length}

function distinct(a){return Object.keys(dictionaryFrom(a))}

function buildShiftedKeyAliases(a,b){return a?[].concat(_toConsumableArray(resolveAltShiftedAlias(b)),_toConsumableArray(resolveUnaltShiftedAlias(b)),[b]):[].concat(_toConsumableArray(resolveShiftedAlias(b)),_toConsumableArray(resolveUnshiftedAlias(b)),[b])}function buildAltKeyAliases(a){return [].concat(_toConsumableArray(resolveAltedAlias(a)),_toConsumableArray(resolveUnaltedAlias(a)),[a])}function buildOSAndKeyboardLayoutAliases(a){var b=KeyOSAndLayoutAliasesDictionary$1[a];return b?[a].concat(_toConsumableArray(b)):[a]}function buildKeyAliasList(a,b){var c=a.Shift,d=a.Alt,e=function(){return c?buildShiftedKeyAliases(d,b):d?buildAltKeyAliases(b):buildOSAndKeyboardLayoutAliases(b)}();return distinct(e)}function buildKeyCombinationPermutations(a){return Object.keys(a).reduce(function(b,c){var d=buildKeyAliasList(a,c);return 0===size(b)?d.map(function(a){return _defineProperty({},a,!0)}):d.reduce(function(a,c){return a.concat(b.map(function(a){return _objectSpread({},a,_defineProperty({},c,!0))}))},[])},[])}var KeyCombinationSerializer=function(){function a(){_classCallCheck(this,a);}return _createClass(a,null,[{key:"serialize",value:function c(a){var b=buildKeyCombinationPermutations(a);return b.map(normalizedCombinationId)}},{key:"isValidKeySerialization",value:function b(a){return !!(0<a.length)&&!!KeySequenceParser.parse(a,{ensureValidKeys:!0}).combination}}]),a}();

function resolveKeyAlias(a){return KeyOSAndLayoutAliasesDictionary$1[a]||[a]}

function applicableAliasFunctions(a){return a.Shift?a.Alt?[resolveAltShiftedAlias,resolveUnaltShiftedAlias]:[resolveShiftedAlias,resolveUnshiftedAlias]:a.Alt?[resolveAltedAlias,resolveUnaltedAlias]:[nop$1,nop$1]}function nop$1(a){return [a]}

var KeyEventState={unseen:0,seen:1,simulated:2};

var KeyEventStateArrayManager=function(){function a(){_classCallCheck(this,a);}return _createClass(a,null,[{key:"newRecord",value:function d(a,b){var c=[KeyEventState.unseen,KeyEventState.unseen,KeyEventState.unseen];if(!isUndefined(a))for(var e=0;e<=a;e++)c[e]=b;return c}},{key:"setBit",value:function d(a,b,c){return a[b]=c,a}},{key:"clone",value:function d(a){for(var b=this.newRecord(),c=0;c<a.length;c++)b[c]=a[c];return b}}]),a}();

function isEmpty(a){return isObject(a)?0===Object.keys(a).length:!a||0===a.length}

function lazyLoadAttribute(a,b,c){return a[b]||(a[b]="function"==typeof c?c():c),a[b]}

var ModifierFlagsDictionary={Shift:["shiftKey"],Meta:["metaKey"],Control:["ctrlKey"],Alt:["altKey"]};

function stateFromEvent(a){return a.simulated?KeyEventState.simulated:KeyEventState.seen}

var KeyCombination=function(){function a(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};_classCallCheck(this,a),this.keyStates=b,this.isEnding=!1,this._keyAliases=void 0,this._ids=void 0;}return _createClass(a,[{key:"getNormalizedKeyName",value:function d(a){var b=this.keyStates[a];if(b)return a;var c=this.keyAliases[a];return c?c:a}},{key:"hasEnded",value:function a(){return isEmpty(this.keysStillPressedDict())}},{key:"addKey",value:function c(a,b){this._setKeyState(a,[KeyEventStateArrayManager.newRecord(),KeyEventStateArrayManager.newRecord(KeyEventType.keydown,b)]);}},{key:"setKeyState",value:function g(a,b,c){var d=this._getKeyState(a);if(this.isKeyIncluded(a)){var e=KeyEventStateArrayManager.clone(d[1]),f=KeyEventStateArrayManager.clone(e);KeyEventStateArrayManager.setBit(f,b,c),this._setKeyState(a,[e,f]);}else this.addKey(a,c);b===KeyEventType.keyup&&(this.isEnding=!0);}},{key:"keysStillPressedDict",value:function b(){var a=this;return this.keys.reduce(function(b,c){return a.isKeyStillPressed(c)&&(b[c]=a._getKeyState(c)),b},{})}},{key:"isKeyIncluded",value:function b(a){return !!this._getKeyState(a)}},{key:"isKeyStillPressed",value:function b(a){return this.isEventTriggered(a,KeyEventType.keypress)&&!this.isKeyReleased(a)}},{key:"isKeyReleased",value:function b(a){return this.isEventTriggered(a,KeyEventType.keyup)}},{key:"isEventTriggered",value:function c(a,b){return this._getKeyStateType(a,KeyEventSequenceIndex.current,b)}},{key:"wasEventPreviouslyTriggered",value:function c(a,b){return this._getKeyStateType(a,KeyEventSequenceIndex.previous,b)}},{key:"isKeyPressSimulated",value:function b(a){return this.isEventTriggered(a,KeyEventType.keypress)===KeyEventState.simulated}},{key:"isKeyUpSimulated",value:function b(a){return this.isEventTriggered(a,KeyEventType.keyup)===KeyEventState.simulated}},{key:"resolveModifierFlagDiscrepancies",value:function e(a,b,c){var d=this;Object.keys(ModifierFlagsDictionary).forEach(function(e){if(b!==e||c!==KeyEventType.keyup){var f=d.isKeyStillPressed(e);ModifierFlagsDictionary[e].forEach(function(b){!1===a[b]&&f&&d.setKeyState(e,KeyEventType.keyup,stateFromEvent(a)),!0!==a[b]||f||d.setKeyState(e,KeyEventType.keydown,stateFromEvent(a));});}});}},{key:"_getKeyStateType",value:function e(a,b,c){var d=this._getKeyState(a);return d&&d[b][c]}},{key:"_getKeyState",value:function d(a){var b=this.keyStates[a];if(b)return b;var c=this.keyAliases[a];if(c)return this.keyStates[c]}},{key:"_setKeyState",value:function d(a,b){var c=this.getNormalizedKeyName(a);this.keyStates[c]=b,delete this._keyAliases,delete this._ids;}},{key:"ids",get:function b(){var a=this;return lazyLoadAttribute(this,"_ids",function(){return KeyCombinationSerializer.serialize(a.keyStates)})}},{key:"keyAliases",get:function b(){var a=this;return lazyLoadAttribute(this,"_keyAliases",function(){return buildKeyAliases(a.keyStates)})}},{key:"keys",get:function a(){return Object.keys(this.keyStates)}}]),a}();function buildKeyAliases(a){return Object.keys(a).reduce(function(b,c){return resolveKeyAlias(c).forEach(function(d){applicableAliasFunctions(a).forEach(function(a){a(d).forEach(function(a){(a!==c||c!==d)&&(b[a]=c);});});}),b},{})}

var KeyCombinationDecorator=function(){function a(b){_classCallCheck(this,a),this._keyCombination=b;}return _createClass(a,[{key:"describe",value:function a(){return this._keyCombination.ids[0]}},{key:"asKeyDictionary",value:function a(){return dictionaryFrom(this._keyCombination.keys)}},{key:"toJSON",value:function a(){return {keys:this._keyCombination.keyStates,ids:this._keyCombination.ids,keyAliases:this._keyCombination.keyAliases}}}]),a}();

var KeyCombinationIterator=function(){function a(b){_classCallCheck(this,a),this._keyCombination=b;}return _createClass(a,[{key:"any",value:function a(){return 0<this._getKeys().length}},{key:"forEachKey",value:function b(a){return this._getKeys().forEach(a)}},{key:"some",value:function b(a){return this._getKeys().some(a)}},{key:"_getKeys",value:function a(){return this._keyCombination.keys}},{key:"numberOfKeys",get:function a(){return size(this._getKeys())}}]),a}();

var KeyHistory=function(){function a(b){var c=b.maxLength,d=1<arguments.length&&void 0!==arguments[1]?arguments[1]:null;_classCallCheck(this,a),this._combinations=[],this._maxLength=c,d?this._push(d):this._push(new KeyCombination);}return _createClass(a,[{key:"getPreviousCombinations",value:function b(a){return this._combinations.slice(-(a+1),-1)}},{key:"any",value:function a(){return this._combinations.some(function(a){return new KeyCombinationIterator(a).any()})}},{key:"addKeyToCurrentCombination",value:function d(a,b,c){this._ensureInitialKeyCombination(),this.currentCombination.setKeyState(a,b,c);}},{key:"startNewKeyCombination",value:function d(a,b){this._ensureInitialKeyCombination();var c=new KeyCombination(this.currentCombination.keysStillPressedDict());c.addKey(a,b),this._push(c);}},{key:"toJSON",value:function a(){return this._combinations.map(function(a){return new KeyCombinationDecorator(a).toJSON()})}},{key:"_ensureInitialKeyCombination",value:function a(){0===this.length&&this._push(new KeyCombination);}},{key:"_push",value:function b(a){this._trimHistory(),this._combinations.push(a);}},{key:"_trimHistory",value:function a(){for(;this.length>this._maxLength;)this._shift();}},{key:"_shift",value:function a(){this._combinations.shift();}},{key:"length",get:function a(){return this._combinations.length}},{key:"currentCombination",get:function a(){return this._combinations[this.length-1]}},{key:"maxLength",set:function b(a){this._maxLength=a,this._trimHistory();}}]),a}();

var Registry=function(){function a(){_classCallCheck(this,a),this._registry={};}return _createClass(a,[{key:"get",value:function b(a){return this._registry[a]}},{key:"set",value:function c(a,b){this._registry[a]=b;}},{key:"remove",value:function b(a){delete this._registry[a];}},{key:"toJSON",value:function a(){return this._registry}}]),a}();

function without(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:[],c=2<arguments.length&&arguments[2]!==void 0?arguments[2]:{},d=dictionaryFrom(arrayFrom(b),function(a){return {value:a}});return Array.isArray(a)?a.reduce(function(a,b){return d[b]&&(c.stringifyFirst||d[b].value===b)||a.push(b),a},[]):isObject(a)?Object.keys(a).reduce(function(b,c){return d[c]||(b[c]=a[c]),b},{}):a}

var ComponentTree=function(a){function b(){var a;return _classCallCheck(this,b),a=_possibleConstructorReturn(this,_getPrototypeOf(b).call(this)),a.clearRootId(),a}return _inherits(b,a),_createClass(b,[{key:"hasRoot",value:function a(){return !this.isRootId(null)}},{key:"isRootId",value:function b(a){return a===this.rootId}},{key:"clearRootId",value:function a(){this.rootId=null;}},{key:"add",value:function d(a,c){_get(_getPrototypeOf(b.prototype),"set",this).call(this,a,{childIds:[],parentId:null,keyMap:c});}},{key:"update",value:function e(a,c){var d=_get(_getPrototypeOf(b.prototype),"get",this).call(this,a);_get(_getPrototypeOf(b.prototype),"set",this).call(this,a,_objectSpread({},d,{keyMap:c}));}},{key:"setParent",value:function c(a,b){isUndefined(b)?this.rootId=a:(this.get(a).parentId=b,this._addChildId(b,a));}},{key:"remove",value:function d(a){var c=this._getParentId(a);this._removeChildId(c,a),_get(_getPrototypeOf(b.prototype),"remove",this).call(this,a);}},{key:"_getParentId",value:function c(a){var b=this.get(a);return b&&b.parentId}},{key:"_addChildId",value:function c(a,b){this.get(a).childIds.push(b);}},{key:"_removeChildId",value:function d(a,b){var c=this.get(a);c&&(c.childIds=without(c.childIds,b));}}]),b}(Registry);

function removeAtIndex(a,b){return [].concat(_toConsumableArray(a.slice(0,b)),_toConsumableArray(a.slice(b+1)))}

var ComponentOptionsListIterator=function(){function a(b){_classCallCheck(this,a),this._list=b,this.position=-1;}return _createClass(a,[{key:"getComponent",value:function a(){return this._list.getAtPosition(this.position)}},{key:"next",value:function a(){return this.position+1<this._list.length?(this.position++,this.getComponent()):null}}]),a}();

var ComponentOptionsList=function(){function a(){_classCallCheck(this,a),this._list=[],this._idToIndex={},this.longestSequence=1,this._longestSequenceComponentId=null,this._keyMapEventRecord=KeyEventStateArrayManager.newRecord();}return _createClass(a,[{key:"add",value:function g(a,b,c,d){if(this.containsId(a))return this.update(a,b,c,d);var e=this._build(a,b,c,d);this._list.push(e);var f=this.length-1;return this._idToIndex[a]=f}},{key:"containsId",value:function b(a){return !!this.getById(a)}},{key:"getById",value:function b(a){return this.getAtPosition(this.getPositionById(a))}},{key:"getPositionById",value:function b(a){return this._idToIndex[a]}},{key:"update",value:function h(a,b,c,d){var e=this._isUpdatingComponentWithLongestSequence(a),f=this.longestSequence,g=this._build(a,b,c,d);e&&g.sequenceLength!==f&&(g.sequenceLength>f?this.longestSequence=g.sequenceLength:this._recalculateLongestSequence()),this._list[this.getPositionById(a)]=g;}},{key:"remove",value:function c(a){var b=this._isUpdatingComponentWithLongestSequence(a);this.removeAtPosition(this.getPositionById(a)),b&&this._recalculateLongestSequence();}},{key:"isRoot",value:function b(a){return this.getPositionById(a)>=this.length-1}},{key:"anyActionsForEventType",value:function b(a){return !!this._keyMapEventRecord[a]}},{key:"getAtPosition",value:function b(a){return this._list[a]}},{key:"removeAtPosition",value:function b(a){this._list=removeAtIndex(this._list,a);for(var c=a;c<this.length;)this._idToIndex[this.getAtPosition(c).componentId]=c,c++;}},{key:"toJSON",value:function a(){return this._list}},{key:"_build",value:function f(a,b,c,d){var e=this._buildActionDictionary(b,d,a);return {actions:e,handlers:c,componentId:a,options:d}}},{key:"_isUpdatingComponentWithLongestSequence",value:function b(a){return a===this._getLongestSequenceComponentId()}},{key:"_getLongestSequenceComponentId",value:function a(){return this._longestSequenceComponentId}},{key:"_recalculateLongestSequence",value:function d(){for(var e=this.iterator;e.next();){var a=e.getComponent(),b=a.longestSequence,c=a.componentId;b>this.longestSequence&&(this._longestSequenceComponentId=c,this.longestSequence=b);}}},{key:"_buildActionDictionary",value:function e(a,b,c){var d=this;return Object.keys(a).reduce(function(e,f){var g=a[f],h=function(){return isObject(g)&&hasKey(g,"sequences")?arrayFrom(g.sequences):arrayFrom(g)}();return h.forEach(function(a){var g=normalizeActionOptions(a,b),h=g.keySequence,i=g.keyEventType;d._addActionOptions(e,c,f,h,i);}),e},{})}},{key:"_addActionOptions",value:function i(a,b,c,d,e){var f=KeySequenceParser.parse(d,{keyEventType:e}),g=f.sequence,h=f.combination;g.size>this.longestSequence&&(this.longestSequence=g.size,this._longestSequenceComponentId=b),this._keyMapEventRecord[e]=KeyEventState.seen,a[c]||(a[c]=[]),a[c].push(_objectSpread({prefix:g.prefix,actionName:c,sequenceLength:g.size},h));}},{key:"iterator",get:function a(){return new ComponentOptionsListIterator(this)}},{key:"length",get:function a(){return this._list.length}}]),a}();function normalizeActionOptions(a,b){if(isObject(a)){var c=a.sequence,d=a.action;return {keySequence:c,keyEventType:isUndefined(d)?KeyEventType[b.defaultKeyEvent]:KeyEventType[d]}}return {keySequence:a,keyEventType:KeyEventType[b.defaultKeyEvent]}}

function indexFromEnd(a,b){return a[a.length-(b+1)]}

for(var KeysWithKeyUpHiddenByCmd={Enter:!0,Backspace:!0,ArrowRight:!0,ArrowLeft:!0,ArrowUp:!0,ArrowDown:!0,CapsLock:!0},i=1;13>i;i++)KeysWithKeyUpHiddenByCmd["F".concat(i)]=!0;

function keyupIsHiddenByCmd(a){return 1===a.length||hasKey(KeysWithKeyUpHiddenByCmd,a)}

var KeyCombinationMatcher=function(){function a(){_classCallCheck(this,a),this._actionConfigs={},this._order=null;}return _createClass(a,[{key:"addMatch",value:function f(a,b){if(this._includesMatcherForCombination(a.id)){var c=a.keyEventType,d=a.actionName,e=a.id;this._addHandlerToActionConfig(e,{keyEventType:c,actionName:d,handler:b});}else this._addNewActionConfig(a,b);}},{key:"findMatch",value:function l(a,b,c){var d=this;lazyLoadAttribute(this,"order",function(){return d._setOrder()});var e=!0,f=!1,g=void 0;try{for(var h,i=this._order[Symbol.iterator]();!(e=(h=i.next()).done);e=!0){var j=h.value,k=this._actionConfigs[j];if(this._matchesActionConfig(a,b,c,k))return k}}catch(a){f=!0,g=a;}finally{try{e||null==i.return||i.return();}finally{if(f)throw g}}return null}},{key:"toJSON",value:function a(){return {actionConfigs:this._actionConfigs,order:this._order}}},{key:"_matchesActionConfig",value:function h(a,b,c,d){if(!canBeMatched(a,d)||!d.events[c])return !1;var e=!1,f=Object.keys(d.keyDictionary),g=f.every(function(d){return !!a.isEventTriggered(d,c)&&(b&&b===a.getNormalizedKeyName(d)&&(e=!a.wasEventPreviouslyTriggered(d,c)),!0)});return g&&e}},{key:"_setOrder",value:function b(){var a=objectValues(this._actionConfigs).reduce(function(a,b){var c=b.id,d=b.size;return a[d]||(a[d]=[]),a[d].push(c),a},{});this._order=Object.keys(a).sort(function(c,a){return a-c}).reduce(function(b,c){return b.concat(a[c])},[]);}},{key:"_addNewActionConfig",value:function j(a,b){var c=a.prefix,d=a.sequenceLength,e=a.id,f=a.keyDictionary,g=a.size,h=a.keyEventType,i=a.actionName;this._setCombinationMatcher(e,{prefix:c,sequenceLength:d,id:e,keyDictionary:f,size:g,events:{}}),this._addHandlerToActionConfig(e,{keyEventType:h,actionName:i,handler:b});}},{key:"_addHandlerToActionConfig",value:function g(a,b){var c=b.keyEventType,d=b.actionName,e=b.handler,f=this._getCombinationMatcher(a);this._setCombinationMatcher(a,_objectSpread({},f,{events:_objectSpread({},f.events,_defineProperty({},c,{actionName:d,handler:e}))}));}},{key:"_setCombinationMatcher",value:function c(a,b){this._actionConfigs[a]=b;}},{key:"_getCombinationMatcher",value:function b(a){return this._actionConfigs[a]}},{key:"_includesMatcherForCombination",value:function b(a){return !!this._getCombinationMatcher(a)}}]),a}();function canBeMatched(a,b){var c=size(b.keyDictionary),d=new KeyCombinationIterator(a),e=b.keyDictionary.Meta&&keyUpIsBeingHidden(a);return Configuration.option("allowCombinationSubmatches")||e?d.numberOfKeys>=c:d.numberOfKeys===c}function keyUpIsBeingHidden(a){return !!a.isKeyStillPressed("Meta")&&new KeyCombinationIterator(a).some(function(a){return keyupIsHiddenByCmd(a)})}

function updateIndexCounters(a,b){for(var c=0,d=!0;d&&c<a.length;){var e=indexFromEnd(a,c),f=(e+1)%(indexFromEnd(b,c)||1);a[a.length-(c+1)]=f,d=0==f,d&&c++;}return c===a.length}var KeyHistoryMatcher=function(){function a(){_classCallCheck(this,a),this._combinationMatchers={},this._eventRecord=KeyEventStateArrayManager.newRecord();}return _createClass(a,[{key:"addMatch",value:function d(a,b){var c=this._getOrCreateCombinationMatcher(a.prefix);c.addMatch(a,b),KeyEventStateArrayManager.setBit(this._eventRecord,a.keyEventType,KeyEventState.seen),(!this.longestSequence||this.longestSequence<a.sequenceLength)&&(this.longestSequence=a.sequenceLength);}},{key:"findMatch",value:function e(a,b,c){var d=this._findCombinationMatcher(a);return d?d.findMatch(a.currentCombination,a.currentCombination.getNormalizedKeyName(b),c):null}},{key:"hasMatchesForEventType",value:function b(a){return !!this._eventRecord[a]}},{key:"toJSON",value:function b(){var a=this;return Object.keys(this._combinationMatchers).reduce(function(b,c){var d=a._combinationMatchers[c];return b[c]=d.toJSON(),b},{})}},{key:"_getOrCreateCombinationMatcher",value:function b(a){return lazyLoadAttribute(this._combinationMatchers,a,function(){return new KeyCombinationMatcher})}},{key:"_findCombinationMatcher",value:function h(a){var b=a.getPreviousCombinations(this.longestSequence-1);if(0===b.length)return this._combinationMatchers[""];var c=b.map(function(a){return a.ids}),d=c.map(function(a){return a.length}),e=Array(c.length).fill(0);do{var f=e.map(function(a,b){return c[b][a]}),g=f.join(" ");if(this._combinationMatchers[g])return this._combinationMatchers[g]}while(!updateIndexCounters(e,d));return this._combinationMatchers[""]}}]),a}();

function printComponent(a){return JSON.stringify(a,componentAttributeSerializer,4)}function componentAttributeSerializer(a,b){return "function"==typeof b?b.toString():b}

function describeKeyEventType(a){switch(parseInt(a,10)){case 0:return "keydown";case 1:return "keypress";default:return "keyup";}}

var ActionResolver=function(){function a(b,c,d){_classCallCheck(this,a),this.logger=d,this._eventStrategy=c,this._keyMapMatchers=[],this._unmatchedHandlerStatus=[],this._handlersDictionary={},this._keySequencesDictionary={};for(var g=b.iterator;g.next();){var e=g.getComponent(),f=e.handlers;this._unmatchedHandlerStatus.push([Object.keys(f).length,{}]),this._keyMapMatchers.push(new KeyHistoryMatcher);}this._componentList=b,this._componentListIterator=b.iterator;}return _createClass(a,[{key:"getKeyHistoryMatcher",value:function b(a){if(this._componentHasUnmatchedHandlers(a))for(;this._componentListIterator.next();)this._addHandlersFromComponent(),this._addActionsFromComponent();return this._getKeyHistoryMatcher(a)}},{key:"componentHasActionsBoundToEventType",value:function c(a,b){return this.getKeyHistoryMatcher(a).hasMatchesForEventType(b)}},{key:"findMatchingKeySequenceInComponent",value:function e(a,b,c,d){return this.componentHasActionsBoundToEventType(a,d)?this.getKeyHistoryMatcher(a).findMatch(b,c,d):null}},{key:"callClosestMatchingHandler",value:function i(a,b,c,d,e){for(var f,g=this,h=function(){var d=g.getKeyHistoryMatcher(e),f=g._eventStrategy.componentList.getAtPosition(e),h=f.componentId;var i=g._eventStrategy.keyHistory,j=i.currentCombination,k=g.findMatchingKeySequenceInComponent(e,i,b,c);return k?(g._handleMatchFound(j,k,c,h,a,e),{v:!0}):void(g._handleMatchNotFound(j,e,c,h),e++)};e<=d;)if(f=h(),"object"===_typeof(f))return f.v}},{key:"_handleMatchNotFound",value:function f(a,b,c,d){var e=new KeyCombinationDecorator(a);if(this.componentHasActionsBoundToEventType(b,c));}},{key:"_handleMatchFound",value:function i(a,b,c,d,e,f){var g=new KeyCombinationDecorator(a),h=b.events[c];if(Configuration.option("allowCombinationSubmatches")){var j=KeyCombinationSerializer.serialize(b.keyDictionary);}h.handler(e),Configuration.option("stopEventPropagationAfterHandling")&&this._eventStrategy.stopEventPropagation(e,f);}},{key:"_getKeyHistoryMatcher",value:function b(a){return this._keyMapMatchers[a]}},{key:"_addActionsFromComponent",value:function d(){var a=this,b=this._componentListIterator.getComponent(),c=b.actions;Object.keys(c).forEach(function(b){a._buildActionMatchers(b,c[b]);});}},{key:"_buildActionMatchers",value:function e(a,b){var c=this,d=this._positionsOfComponentsWithHandlersFor(a);return !!d&&(this._registerActionWithMatcher(d,a,b),d.forEach(function(b){var d=c._getUnmatchedHandlerStatus(b),e=d[1];e[a]||(e[a]=!0,d[0]--);}),!0)}},{key:"_positionsOfComponentsWithHandlersFor",value:function b(a){return this._handlersDictionary[a]}},{key:"_registerActionWithMatcher",value:function h(a,b,c){var d=this,e=a[0],f=this._componentList.getAtPosition(e).handlers[b],g=this._getKeyHistoryMatcher(e);return c.forEach(function(a){var b=a.prefix,c=a.id,h=a.keyEventType,i=[b,c].join(" ");return !d._isClosestHandlerAlreadyFoundFor(i,h)&&void(g.addMatch(a,f),d._recordHandlerFoundFor(i,[e,h]))}),!0}},{key:"_addHandlersFromComponent",value:function d(){var a=this,b=this._componentListIterator.getComponent(),c=b.handlers;Object.keys(c).forEach(function(b){a._addHandler(b);});}},{key:"_addHandler",value:function b(a){lazyLoadAttribute(this._handlersDictionary,a,[]),this._handlersDictionary[a].push(this._componentListIterator.position);}},{key:"_recordHandlerFoundFor",value:function c(a,b){lazyLoadAttribute(this._keySequencesDictionary,a,[]),this._keySequencesDictionary[a].push(b);}},{key:"_componentHasUnmatchedHandlers",value:function b(a){return 0<this._getUnmatchedHandlerStatus(a)[0]}},{key:"_getUnmatchedHandlerStatus",value:function b(a){return this._unmatchedHandlerStatus[a]}},{key:"_isClosestHandlerAlreadyFoundFor",value:function d(a,b){var c=this._keySequencesDictionary[a]||[];return c.some(function(a){return a[1]===b})}}]),a}();

var AbstractKeyEventStrategy=function(){function a(){var c=1<arguments.length?arguments[1]:void 0;_classCallCheck(this,a),this.logger=null,this.componentId=-1,this.keyEventManager=c,this.componentTree=new ComponentTree,this._simulator=null,this._reset(),this.resetKeyHistory();}return _createClass(a,[{key:"_reset",value:function a(){this.componentList=new ComponentOptionsList,this._actionResolver=null;}},{key:"_recalculate",value:function a(){this._actionResolver=null,this.keyHistory.maxLength=this.componentList.longestSequence;}},{key:"resetKeyHistory",value:function b(){var a=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};this._simulator&&this._simulator.clear(),this._keyHistory=this.keyHistory.any()&&!a.force?new KeyHistory({maxLength:this.componentList.longestSequence},new KeyCombination(this)):this._newKeyHistory();}},{key:"_newKeyHistory",value:function a(){return new KeyHistory({maxLength:this.componentList.longestSequence})}},{key:"registerKeyMap",value:function c(a){return this.componentId+=1,this.componentTree.add(this.componentId,a),this.componentId}},{key:"reregisterKeyMap",value:function c(a,b){this.componentTree.update(a,b);}},{key:"registerComponentMount",value:function d(a,b){this.componentTree.setParent(a,b),void 0;}},{key:"deregisterKeyMap",value:function c(a){this.componentTree.remove(a),this.componentTree.isRootId(a)&&this.componentTree.clearRootId();}},{key:"_addComponent",value:function f(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},e=4<arguments.length?arguments[4]:void 0;this.componentList.add(a,b,c,e),this._recalculate(),this.logger.logComponentOptions(a,this.componentList.getById(a));}},{key:"_updateComponent",value:function e(a,b,c,d){this.componentList.update(a,b,c,d),this._recalculate(),this.logger.logComponentOptions(a,this.componentList.getById(a));}},{key:"_describeCurrentCombination",value:function b(){var a=new KeyCombinationDecorator(this.currentCombination);return a.describe()}},{key:"_recordKeyDown",value:function f(a,b,c){var d=stateFromEvent(a),e=this.currentCombination;e.isKeyIncluded(b)||e.isEnding?this._startAndLogNewKeyCombination(c,b,d):this._recordNewKeyInCombination(b,KeyEventType.keydown,d,c);}},{key:"_startAndLogNewKeyCombination",value:function d(a,b,c){this.keyHistory.startNewKeyCombination(b,c),this.logger.logKeyHistory(this.keyHistory,a);}},{key:"_recordNewKeyInCombination",value:function e(a,b,c,d){this.keyHistory.addKeyToCurrentCombination(a,b,c),this.logger.logKeyHistory(this.keyHistory,d);}},{key:"_isIgnoringRepeatedEvent",value:function e(a,b,c,d){return !!(a.repeat&&Configuration.option("ignoreRepeatedEventsWhenKeyHeldDown"))&&(this.logger.logIgnoredKeyEvent(a,b,c,"it was a repeated event",d),!0)}},{key:"keyHistory",get:function b(){var a=this;return lazyLoadAttribute(this,"_keyHistory",function(){return a._newKeyHistory()})}},{key:"actionResolver",get:function b(){var a=this;return lazyLoadAttribute(this,"_actionResolver",function(){return new ActionResolver(a.componentList,a,a.logger)})}},{key:"currentCombination",get:function a(){return this.keyHistory.currentCombination}}]),a}();

function getEventCharCode(a){var b,c=a.keyCode;return "charCode"in a?(b=a.charCode,0===b&&13===c&&(b=13)):b=c,10===b&&(b=13),32<=b||13===b?b:0}

var normalizeKey={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"};function reactsGetEventKey(a){if(a.key){var b=normalizeKey[a.key]||a.key;if("Unidentified"!==b)return b}if("keypress"===a.type){var c=getEventCharCode(a);return 13===c?"Enter":String.fromCharCode(c)}return "keydown"===a.type||"keyup"===a.type?translateToKey[a.keyCode]||"Unidentified":""}

function keyNameFromEvent(a){var b=Configuration.option("customKeyCodes"),c=a.keyCode||a.charCode;return hasKey(b,c)?b[c]:a.nativeEvent?a.key:reactsGetEventKey(a)}function getKeyName(a){var b=keyNameFromEvent(a);return "+"===b?"plus":b}

function isCmdKey(a){return "Meta"===a}

function describeKeyEvent(a,b,c){var d="'".concat(b,"' ").concat(describeKeyEventType(c));return a.simulated?"(simulated) ".concat(d):d}

var EventResponse={unseen:0,ignored:1,seen:2,recorded:3,handled:4};

var KeyEventCounter=function(){function a(){_classCallCheck(this,a);}return _createClass(a,null,[{key:"incrementId",value:function a(){this._id=this.id+1;}},{key:"id",get:function a(){return lazyLoadAttribute(this,"_id",0),this._id}}]),a}();

var EventPropagator=function(){function a(b){_classCallCheck(this,a),this._componentList=b,this._previousPropagation=null,this._reset();}return _createClass(a,[{key:"_reset",value:function a(){this.previousPosition=-1,this._position=-1,this._actionHandled=!1,this._ignoreEvent=!1,this._observeIgnoredEvents=!1,this._stopping=!1,this._componentId=null,this._key=null,this._type=null;}},{key:"isFirstPropagationStep",value:function b(){var a=this.previousPosition;return -1===a||a>=this._position}},{key:"isForKey",value:function b(a){return this._key===a}},{key:"isForEventType",value:function b(a){return this._type===a}},{key:"startNewPropagationStep",value:function e(a,b,c,d){return this._position=this._componentList.getPositionById(a),this._componentId=a,this.isFirstPropagationStep()&&(KeyEventCounter.incrementId(),this._key=b.key,this._type=d),!(b.repeat&&Configuration.option("ignoreRepeatedEventsWhenKeyHeldDown"))||(this.ignoreEvent(b),!1)}},{key:"finishPropagationStep",value:function a(){this.isStopped()||this._componentList.isRoot(this._componentId)?(this._previousPropagation=this._clone(),this._reset()):this.previousPosition=this._position;}},{key:"observeIgnoredEvents",value:function a(){this._observeIgnoredEvents=!0;}},{key:"ignoreEvent",value:function b(a){return this._ignoreEvent=!0,!!(this.isIgnoringEvent()&&Configuration.option("stopEventPropagationAfterIgnoring"))&&(this.stop(a),this.finishPropagationStep(),!0)}},{key:"isIgnoringEvent",value:function a(){return !this._observeIgnoredEvents&&this._ignoreEvent}},{key:"isStopped",value:function a(){return this._stopping}},{key:"stop",value:function b(a){return !this.isStopped()&&(this._stopping=!0,a.simulated||a.stopPropagation(),!0)}},{key:"isPendingPropagation",value:function b(){var a=this.previousPosition;return -1!==a&&a+1<this._position}},{key:"isHandled",value:function a(){return this._actionHandled}},{key:"setHandled",value:function a(){this._actionHandled=!0;}},{key:"_clone",value:function e(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},c=b.copyState,d=new a(this._componentList);return d.logger=this.logger,(void 0===c||c)&&Object.assign(d,this),d}},{key:"previousPropagation",get:function b(){var a=this;return lazyLoadAttribute(this,"_previousPropagation",function(){return a._clone({copyState:!1})})}}]),a}();

function hasKeyPressEvent(a){return !isNonPrintableKeyName(a)}

var AbstractKeyEventSimulator=function(){function a(b){_classCallCheck(this,a),this._keyEventStrategy=b,this.clear();}return _createClass(a,[{key:"clear",value:function a(){this.keypressEventsToSimulate=[],this.keyupEventsToSimulate=[];}},{key:"cloneAndMergeEvent",value:function d(a,b){var c=Object.keys(ModifierFlagsDictionary).reduce(function(b,c){return b[c]=a[c],b},{});return _objectSpread({},c,b)}},{key:"_shouldSimulate",value:function e(a,b){var c=hasKeyPressEvent(b),d=this._keyEventStrategy.currentCombination;return a===KeyEventType.keypress?!c||c&&d.isKeyStillPressed("Meta"):a===KeyEventType.keyup&&keyupIsHiddenByCmd(b)&&d.isKeyReleased("Meta")}}]),a}();

var FocusOnlyKeyEventSimulator=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,_getPrototypeOf(b).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:"handleKeyPressSimulation",value:function b(a){this._handleEventSimulation("keypressEventsToSimulate","simulatePendingKeyPressEvents",_objectSpread({eventType:KeyEventType.keypress},a));}},{key:"handleKeyUpSimulation",value:function b(a){this._handleEventSimulation("keyupEventsToSimulate","simulatePendingKeyUpEvents",_objectSpread({eventType:KeyEventType.keyup},a));}},{key:"_handleEventSimulation",value:function j(a,b,c){var d=c.event,e=c.eventType,f=c.key,g=c.focusTreeId,h=c.componentId,i=c.options;if(this._shouldSimulate(e,f)&&Configuration.option("simulateMissingKeyPressEvents")){var k=this.cloneAndMergeEvent(d,{key:f,simulated:!0});this[a].push({event:k,focusTreeId:g,componentId:h,options:i});}(this._keyEventStrategy.componentList.isRoot(h)||this._keyEventStrategy.eventPropagator.isStopped())&&this._shouldSimulateEventsImmediately()&&this._keyEventStrategy[b]();}},{key:"simulatePendingKeyPressEvents",value:function a(){this._simulatePendingKeyEvents("keypressEventsToSimulate","handleKeyPress");}},{key:"simulatePendingKeyUpEvents",value:function a(){this._simulatePendingKeyEvents("keyupEventsToSimulate","handleKeyUp");}},{key:"_simulatePendingKeyEvents",value:function d(a,b){var c=this;0<this[a].length&&KeyEventCounter.incrementId(),this[a].forEach(function(a){var d=a.event,e=a.focusTreeId,f=a.componentId,g=a.options;c._keyEventStrategy[b](d,e,f,g);}),this[a]=[];}},{key:"_shouldSimulateEventsImmediately",value:function a(){return this._keyEventStrategy.shouldSimulateEventsImmediately()}}]),b}(AbstractKeyEventSimulator);

var FocusTree=function(){function a(){_classCallCheck(this,a),this.id=0;}return _createClass(a,[{key:"isNewerThan",value:function b(a){return this.id!==a}},{key:"new",value:function a(){this.id+=1;}}]),a}();

var EventStrategyLogger=function(a){function b(a,c){var d;return _classCallCheck(this,b),d=_possibleConstructorReturn(this,_getPrototypeOf(b).call(this,a)),d._eventStrategy=c,d}return _inherits(b,a),_createClass(b,[{key:"nonKeyEventPrefix",value:function c(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};return this.keyEventPrefix(a,_objectSpread({},b,{eventId:!1}))}},{key:"logComponentOptions",value:function c(a,b){this.verbose(this.nonKeyEventPrefix(a),"New component options:\n",function(){return printComponent(b)});}},{key:"logKeyHistory",value:function c(a,b){this.verbose(this.keyEventPrefix(b),function(){return "Key history: ".concat(printComponent(a.toJSON()),".")});}}]),b}(Logger);

var FocusOnlyLogger=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,_getPrototypeOf(b).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:"keyEventPrefix",value:function i(a){var c=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},d=_get(_getPrototypeOf(b.prototype),"constructor",this).logIcons,e=_get(_getPrototypeOf(b.prototype),"constructor",this).eventIcons,f=_get(_getPrototypeOf(b.prototype),"constructor",this).componentIcons,g="HotKeys (";if(!1!==c.focusTreeId){var j=isUndefined(c.focusTreeId)?this._eventStrategy.focusTreeId:c.focusTreeId;g+="F".concat(j).concat(d[j%d.length],"-");}g+="C".concat(a).concat(f[a%f.length]);var h=this._eventStrategy.componentList.getPositionById(a);if(isUndefined(h)||(g+="-P".concat(h).concat(f[h%f.length])),!1!==c.eventId){var k=isUndefined(c.eventId)?KeyEventCounter.id:c.eventId;g+="-E".concat(k).concat(e[k%e.length]);}return "".concat(g,"):")}},{key:"logIgnoredKeyEvent",value:function f(a,b,c,d,e){this.logIgnoredEvent(describeKeyEvent(a,b,c),d,e);}},{key:"logIgnoredEvent",value:function d(a,b,c){this.debug(this.keyEventPrefix(c),"Ignored ".concat(a," because ").concat(b,"."));}},{key:"logAlreadySimulatedEvent",value:function e(a,b,c,d){this.logIgnoredKeyEvent(a,b,c,"it was not expected, and has already been simulated",d);}}]),b}(EventStrategyLogger);

var FocusOnlyKeyEventStrategy=function(a){function b(){var a,c=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},d=1<arguments.length?arguments[1]:void 0;return _classCallCheck(this,b),a=_possibleConstructorReturn(this,_getPrototypeOf(b).call(this,c,d)),a.logger=new FocusOnlyLogger(c.logLevel||"warn",_assertThisInitialized(_assertThisInitialized(a))),a.eventPropagator.logger=a.logger,a.focusTree=new FocusTree,a._simulator=new FocusOnlyKeyEventSimulator(_assertThisInitialized(_assertThisInitialized(a))),a}return _inherits(b,a),_createClass(b,[{key:"_reset",value:function a(){_get(_getPrototypeOf(b.prototype),"_reset",this).call(this),this._simulator&&this._simulator.clear(),this.focusTree&&this.focusTree.new(),this.eventPropagator=new EventPropagator(this.componentList),this.eventPropagator.logger=this.logger;}},{key:"enableHotKeys",value:function e(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},d=3<arguments.length?arguments[3]:void 0;if(this.resetOnNextFocus&&(this._reset(),this.resetOnNextFocus=!1),!this.componentList.containsId(a))return this._addComponent(a,b,c,"Focused",d),this.focusTree.id}},{key:"updateEnabledHotKeys",value:function f(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{},e=4<arguments.length?arguments[4]:void 0;this.focusTree.isNewerThan(a)||!this.componentList.containsId(b)||this._updateComponent(b,c,d,e);}},{key:"disableHotKeys",value:function d(a,b){this.resetOnNextFocus=!0;var c=this.eventPropagator.isPendingPropagation();return c}},{key:"handleKeyDown",value:function f(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{},e=getKeyName(a);if(this.focusTree.isNewerThan(b))return this.logger.logIgnoredKeyEvent(a,e,KeyEventType.keydown,"it had an old focus tree id: ".concat(b),c),this.eventPropagator.ignoreEvent(a),!0;if(this._isIgnoringRepeatedEvent(a,e,KeyEventType.keydown,c))return !1;if(this.eventPropagator.startNewPropagationStep(c,a,e,KeyEventType.keydown)){var g=this._howToHandleKeyEvent(a,b,c,e,d,KeyEventType.keydown);g===EventResponse.handled&&(this._recordKeyDown(a,e,c),this._callHandlerIfActionNotHandled(a,e,KeyEventType.keydown,c,b)),this._simulator.handleKeyPressSimulation({event:a,key:e,focusTreeId:b,componentId:c,options:d}),this.eventPropagator.finishPropagationStep();}return !1}},{key:"_howToHandleKeyEvent",value:function g(a,b,c,d,e,f){if(this.eventPropagator.isFirstPropagationStep()){if(e.ignoreEventsCondition(a)&&this.eventPropagator.ignoreEvent(a))return this._eventIsToBeIgnored(a,c,d,f);this.currentCombination.resolveModifierFlagDiscrepancies(a,d,f);}else if(this.eventPropagator.isIgnoringEvent())return this._eventIsToBeIgnored(a,c,d,f);return EventResponse.handled}},{key:"_eventIsToBeIgnored",value:function e(a,b,c,d){return this.logger.logIgnoredKeyEvent(a,c,d,"ignoreEventsFilter rejected it",b),EventResponse.ignored}},{key:"handleKeyPress",value:function g(a,b,c,d){var e=getKeyName(a);if(this._isIgnoringRepeatedEvent(a,e,KeyEventType.keypress,c))return !1;if(this.currentCombination.isKeyPressSimulated(e))return this._ignoreAlreadySimulatedEvent(a,e,KeyEventType.keypress,c),!1;var f=this.focusTree.isNewerThan(b);if(this.eventPropagator.startNewPropagationStep(c,a,e,KeyEventType.keypress)){var h=this._howToHandleKeyEvent(a,b,c,e,d,KeyEventType.keypress);this.eventPropagator.isFirstPropagationStep(c)&&this.currentCombination.isKeyIncluded(e)&&this._recordNewKeyInCombination(e,KeyEventType.keypress,stateFromEvent(a),c),h===EventResponse.handled&&this._callHandlerIfActionNotHandled(a,e,KeyEventType.keypress,c,b),this.eventPropagator.finishPropagationStep();}return f}},{key:"handleKeyUp",value:function h(a,b,c,d){var e=getKeyName(a);if(this.currentCombination.isKeyUpSimulated(e))return this._ignoreAlreadySimulatedEvent(a,e,KeyEventType.keyup,c),!1;var f=this.focusTree.isNewerThan(b),g=this.eventPropagator;if(g.startNewPropagationStep(c,a,e,KeyEventType.keyup)){var i=this._howToHandleKeyEvent(a,b,c,e,d,KeyEventType.keyup);g.isFirstPropagationStep(c)&&this.currentCombination.isKeyIncluded(e)&&this._recordNewKeyInCombination(e,KeyEventType.keyup,stateFromEvent(a),c),i===EventResponse.handled&&this._callHandlerIfActionNotHandled(a,e,KeyEventType.keyup,c,b),this._simulateKeyUpEventsHiddenByCmd(a,e,b,c,d),g.finishPropagationStep();}return f}},{key:"_ignoreAlreadySimulatedEvent",value:function e(a,b,c,d){this.logger.logAlreadySimulatedEvent(a,b,c,d),this.eventPropagator.ignoreEvent(a);}},{key:"closeHangingKeyCombination",value:function d(a,b){var c=this.currentCombination;c.isKeyIncluded(a)&&!c.isEventTriggered(a,b)&&c.setKeyState(a,b,KeyEventState.simulated);}},{key:"_simulateKeyUpEventsHiddenByCmd",value:function g(a,b,c,d,e){var f=this;if(isCmdKey(b)){var h=new KeyCombinationIterator(this.currentCombination);h.forEachKey(function(b){isCmdKey(b)||f._simulator.handleKeyUpSimulation({event:a,key:b,focusTreeId:c,componentId:d,options:e});});}}},{key:"stopEventPropagation",value:function c(a,b){this.eventPropagator.stop(a)&&void 0;}},{key:"simulatePendingKeyPressEvents",value:function a(){this._simulator.simulatePendingKeyPressEvents();}},{key:"simulatePendingKeyUpEvents",value:function a(){this._simulator.simulatePendingKeyUpEvents();}},{key:"shouldSimulateEventsImmediately",value:function a(){return !this.keyEventManager.isGlobalListenersBound()}},{key:"_callHandlerIfActionNotHandled",value:function k(a,b,c,d,e){var f=describeKeyEventType(c),g=this._describeCurrentCombination();if(!this.componentList.anyActionsForEventType(c))return void this.logger.logIgnoredEvent("'".concat(g,"' ").concat(f),"it doesn't have any ".concat(f," handlers"),d);if(this.eventPropagator.isHandled())this.logger.logIgnoredEvent("'".concat(g,"' ").concat(f),"it has already been handled",d);else{var h=this.eventPropagator.previousPosition,i=this.componentList.getPositionById(d),j=this.actionResolver.callClosestMatchingHandler(a,b,c,i,-1===h?0:h);j&&this.eventPropagator.setHandled();}}}]),b}(AbstractKeyEventStrategy);

function findableCollectionContains(a,b,c){return c.stringifyFirst?!isUndefined(a.find(function(a){return a.toString()===b.toString()})):-1!==a.indexOf(b)}function nonCollectionContains(a,b,c){return c.stringifyFirst?a.toString()===b.toString():a===b}function contains(a,b){var c=2<arguments.length&&arguments[2]!==void 0?arguments[2]:{};return Array.isArray(a)||isString(a)?findableCollectionContains(a,b,c):isObject(a)?hasKey(a,b):nonCollectionContains(a,b,c)}

var GlobalKeyEventSimulator=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,_getPrototypeOf(b).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:"handleKeyPressSimulation",value:function b(a){this._handleEventSimulation("handleKeyPress",_objectSpread({eventType:KeyEventType.keypress},a));}},{key:"handleKeyUpSimulation",value:function b(a){this._handleEventSimulation("handleKeyUp",_objectSpread({eventType:KeyEventType.keyup},a));}},{key:"_handleEventSimulation",value:function f(a,b){var c=b.event,d=b.eventType,e=b.key;if(this._shouldSimulate(d,e)&&Configuration.option("simulateMissingKeyPressEvents")){var g=this.cloneAndMergeEvent(c,{key:e,simulated:!0});this._keyEventStrategy[a](g);}}}]),b}(AbstractKeyEventSimulator);

function capitalize(a){return a.replace(/\b\w/g,function(a){return a.toUpperCase()})}

function normalizeEventName(a){return "".concat(capitalize(a.slice(0,3))).concat(capitalize(a.slice(3)))}

var GlobalEventListenerAdaptor=function(){function a(b,c){var d=c.logger;_classCallCheck(this,a),this._listenersBound=!1,this.logger=d,this._eventStrategy=b;}return _createClass(a,[{key:"isListenersBound",value:function a(){return this._listenersBound}},{key:"unbindListeners",value:function b(){var a=this;objectValues(KeyEventType).forEach(function(b){var c=describeKeyEventType(b);delete document["on".concat(c)],a._logHandlerStateChange("Removed",c);}),this._listenersBound=!1;}},{key:"bindListeners",value:function b(){var a=this;objectValues(KeyEventType).forEach(function(b){var c=describeKeyEventType(b);document["on".concat(c)]=function(b){a._eventStrategy["handle".concat(normalizeEventName(c))](b);},a._logHandlerStateChange("Bound",c);}),this._listenersBound=!0;}},{key:"_logHandlerStateChange",value:function c(a,b){}}]),a}();

var GlobalLogger=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,_getPrototypeOf(b).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:"keyEventPrefix",value:function h(a){var c=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},d=_get(_getPrototypeOf(b.prototype),"constructor",this).eventIcons,e=_get(_getPrototypeOf(b.prototype),"constructor",this).componentIcons,f="HotKeys (GLOBAL";if(!isUndefined(a))return "".concat(f,"-C").concat(a).concat(e[a%e.length],"):");if(!1===c.eventId)return "".concat(f,"):");var g=isUndefined(c.eventId)?KeyEventCounter.id:c.eventId;return "".concat(f,"-E").concat(g).concat(d[g%d.length],"):")}},{key:"logIgnoredKeyEvent",value:function f(a,b,c,d,e){this.logIgnoredEvent(describeKeyEvent(a,b,c),d,e);}},{key:"logIgnoredEvent",value:function d(a,b,c){this.debug(this.keyEventPrefix(c),"Ignored ".concat(a," because ").concat(b,"."));}},{key:"logEventRejectedByFilter",value:function e(a,b,c,d){this.logIgnoredKeyEvent(a,b,c,"ignoreEventsFilter rejected it",d);}},{key:"logEventAlreadySimulated",value:function e(a,b,c,d){this.logIgnoredKeyEvent(a,b,c,"it was not expected, and has already been simulated",d);}}]),b}(EventStrategyLogger);

var GlobalKeyEventStrategy=function(a){function b(){var a,c=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},d=1<arguments.length?arguments[1]:void 0;return _classCallCheck(this,b),a=_possibleConstructorReturn(this,_getPrototypeOf(b).call(this,c,d)),a.logger=new GlobalLogger(c.logLevel||"warn",_assertThisInitialized(_assertThisInitialized(a))),a.eventOptions={ignoreEventsCondition:Configuration.option("ignoreEventsCondition")},a.listeners=new Registry,a._simulator=new GlobalKeyEventSimulator(_assertThisInitialized(_assertThisInitialized(a))),a._listenerAdaptor=new GlobalEventListenerAdaptor(_assertThisInitialized(_assertThisInitialized(a)),{logger:a.logger}),a}return _inherits(b,a),_createClass(b,[{key:"enableHotKeys",value:function f(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},d=3<arguments.length?arguments[3]:void 0,e=4<arguments.length?arguments[4]:void 0;this.eventOptions=e,this._addComponent(a,b,c,"Mounted",d);}},{key:"updateEnabledHotKeys",value:function f(a){var b=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},d=3<arguments.length?arguments[3]:void 0,e=4<arguments.length?arguments[4]:void 0;this.eventOptions=e,this._updateComponent(a,b,c,d);}},{key:"disableHotKeys",value:function b(a){this.componentList.remove(a),this._recalculate();}},{key:"_recalculate",value:function a(){_get(_getPrototypeOf(b.prototype),"_recalculate",this).call(this),this._updateDocumentHandlers();}},{key:"_updateDocumentHandlers",value:function c(){var a=this._shouldListenersBeBound(),b=this.isListenersBound();!b&&a?this._listenerAdaptor.bindListeners():b&&!a&&this._listenerAdaptor.unbindListeners();}},{key:"isListenersBound",value:function a(){return this._listenerAdaptor.isListenersBound()}},{key:"_shouldListenersBeBound",value:function a(){return 0!==this.componentList.length||this.listeners.get("keyCombination")}},{key:"handleKeyDown",value:function d(a){var b=getKeyName(a);if(!this._isIgnoringRepeatedEvent(a,b,KeyEventType.keydown)){this.currentCombination.resolveModifierFlagDiscrepancies(a,b,KeyEventType.keydown);var c=this._howReactAppRespondedTo(a,b,KeyEventType.keydown);return c===EventResponse.unseen&&this.eventOptions.ignoreEventsCondition(a)?void this.logger.logEventRejectedByFilter(a,b,KeyEventType.keydown):void(c!==EventResponse.ignored&&this._recordKeyDown(a,b),this._callHandlerIfNeeded(c,a,b,KeyEventType.keydown),this.keyEventManager.simulatePendingKeyPressEvents(),this._simulator.handleKeyPressSimulation({event:a,key:b}))}}},{key:"_howReactAppRespondedTo",value:function e(a,b,c){var d=this.keyEventManager.reactAppHistoryWithEvent(b,c);return d===EventResponse.handled?this.logger.logIgnoredKeyEvent(a,b,c,"React app has already handled it"):d===EventResponse.ignored?this.logger.logIgnoredKeyEvent(a,b,c,"React app has declared it should be ignored"):d===EventResponse.seen?void 0:(KeyEventCounter.incrementId(),void 0),d}},{key:"handleKeyPress",value:function d(a){var b=getKeyName(a);if(!this._isIgnoringRepeatedEvent(a,b,KeyEventType.keypress)){if(this.currentCombination.isKeyPressSimulated(b))return void this.logger.logEventAlreadySimulated(a,b,KeyEventType.keypress);var c=this._howReactAppRespondedTo(a,b,KeyEventType.keypress);return this.currentCombination.isKeyIncluded(b)&&this._recordNewKeyInCombination(b,KeyEventType.keypress,stateFromEvent(a)),c===EventResponse.unseen&&(this.keyEventManager.closeHangingKeyCombination(b,KeyEventType.keypress),this.eventOptions.ignoreEventsCondition(a))?void this.logger.logEventRejectedByFilter(a,b,KeyEventType.keypress):void this._callHandlerIfNeeded(c,a,b,KeyEventType.keypress)}}},{key:"_callHandlerIfNeeded",value:function e(a,b,c,d){contains([EventResponse.ignored,EventResponse.handled],a)||this._callHandlerIfExists(b,c,d);}},{key:"handleKeyUp",value:function d(a){var b=getKeyName(a);if(this.currentCombination.isKeyUpSimulated(b))return void this.logger.logEventAlreadySimulated(a,b,KeyEventType.keyup);var c=this._howReactAppRespondedTo(a,b,KeyEventType.keyup);this.currentCombination.isKeyIncluded(b)&&this._recordNewKeyInCombination(b,KeyEventType.keyup,stateFromEvent(a)),c===EventResponse.unseen?(this.keyEventManager.closeHangingKeyCombination(b,KeyEventType.keyup),this.eventOptions.ignoreEventsCondition(a)?this.logger.logIgnoredKeyEvent(a,b,KeyEventType.keyup,"ignoreEventsFilter rejected it"):this._callHandlerIfNeeded(c,a,b,KeyEventType.keyup)):this._callHandlerIfNeeded(c,a,b,KeyEventType.keyup),this._simulateKeyUpEventsHiddenByCmd(a,b),this._callKeyCombinationCallbackIfDefined();}},{key:"_simulateKeyUpEventsHiddenByCmd",value:function d(a,b){var c=this;if(isCmdKey(b)){this.keyEventManager.simulatePendingKeyUpEvents();var e=new KeyCombinationIterator(this.currentCombination);e.forEachKey(function(b){isCmdKey(b)||c._simulator.handleKeyUpSimulation({event:a,key:b});});}}},{key:"_callKeyCombinationCallbackIfDefined",value:function a(){if(this.listeners.get("keyCombination")&&this.currentCombination.hasEnded()){var b=new KeyCombinationDecorator(this.currentCombination);this.listeners.get("keyCombination")({keys:b.asKeyDictionary(),id:b.describe()});}}},{key:"_callHandlerIfExists",value:function f(a,b,c){var d=describeKeyEventType(c),e=this._describeCurrentCombination();return this.componentList.anyActionsForEventType(c)?void(this._callClosestMatchingHandler(a,b,c)):void this.logger.logIgnoredEvent("'".concat(e,"' ").concat(d),"it doesn't have any ".concat(d," handlers"))}},{key:"_callClosestMatchingHandler",value:function d(a,b,c){for(var e,f=this.componentList.iterator;f.next();)if(e=this.actionResolver.callClosestMatchingHandler(a,b,c,f.position,0),e)return void void 0}},{key:"stopEventPropagation",value:function c(a,b){a.simulated||a.stopPropagation();}},{key:"addKeyCombinationListener",value:function d(a){var b=this,c=function(){b.listeners.remove("keyCombination");};return this.listeners.set("keyCombination",function(b){a(b),c();}),this._updateDocumentHandlers(),c}}]),b}(AbstractKeyEventStrategy);

function copyAttributes(a,b,c){return c.forEach(function(c){hasKey(a,c)&&(b[c]=a[c]);}),b}

var SEQUENCE_ATTRIBUTES=["sequence","action"],KEYMAP_ATTRIBUTES=["name","description","group"];function createSequenceFromConfig(a){return arrayFrom(a).map(function(a){return isObject(a)?copyAttributes(a,{},SEQUENCE_ATTRIBUTES):{sequence:a}})}function normalizeActionDefinition(a,b,c){var d=a[b];c[b]={},isObject(d)?hasKey(d,"sequences")?(copyAttributes(d,c[b],KEYMAP_ATTRIBUTES),c[b].sequences=createSequenceFromConfig(d.sequences)):(copyAttributes(d,c[b],KEYMAP_ATTRIBUTES),c[b].sequences=[copyAttributes(d,{},SEQUENCE_ATTRIBUTES)]):c[b].sequences=createSequenceFromConfig(d);}var ApplicationKeyMapBuilder=function(){function a(b){_classCallCheck(this,a),this._componentTree=b;}return _createClass(a,[{key:"build",value:function a(){return this._componentTree.hasRoot()?this._build([this._componentTree.rootId],{}):{}}},{key:"_build",value:function d(a,b){var c=this;return a.forEach(function(a){var d=c._componentTree.get(a),e=d.childIds,f=d.keyMap;f&&Object.keys(f).forEach(function(a){normalizeActionDefinition(f,a,b);}),c._build(e,b);}),b}}]),a}();

var KeyEventManager=function(){function a(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};_classCallCheck(this,a);var c=Configuration.option("logLevel");this.logger=b.logger||new Logger(c),this.focusOnlyEventStrategy=new FocusOnlyKeyEventStrategy({configuration:b,logLevel:c},this),this.globalEventStrategy=new GlobalKeyEventStrategy({configuration:b,logLevel:c},this),this.mountedComponentsCount=0,this._blurHandler=this._clearKeyHistory.bind(this);}return _createClass(a,null,[{key:"getInstance",value:function c(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return lazyLoadAttribute(this,"instance",function(){return new a(b)})}},{key:"getFocusOnlyEventStrategy",value:function a(){return this.getInstance().focusOnlyEventStrategy}},{key:"getGlobalEventStrategy",value:function a(){return this.getInstance().globalEventStrategy}}]),_createClass(a,[{key:"registerComponentMount",value:function c(a,b){return this._incrementComponentCount(),this.focusOnlyEventStrategy.registerComponentMount(a,b)}},{key:"registerComponentUnmount",value:function a(){this._decrementComponentCount();}},{key:"_incrementComponentCount",value:function b(){var a=this.mountedComponentsCount;this.mountedComponentsCount+=1,0===a&&1===this.mountedComponentsCount&&window.addEventListener("blur",this._blurHandler);}},{key:"_decrementComponentCount",value:function b(){var a=this.mountedComponentsCount;this.mountedComponentsCount-=1,1===a&&0===this.mountedComponentsCount&&window.removeEventListener("blur",this._blurHandler);}},{key:"_clearKeyHistory",value:function a(){this.focusOnlyEventStrategy.resetKeyHistory({force:!0}),this.globalEventStrategy.resetKeyHistory({force:!0});}},{key:"registerGlobalComponentUnmount",value:function a(){this._decrementComponentCount();}},{key:"registerGlobalComponentMount",value:function c(a,b){return this._incrementComponentCount(),this.globalEventStrategy.registerComponentMount(a,b)}},{key:"addKeyCombinationListener",value:function b(a){return this.globalEventStrategy.addKeyCombinationListener(a)}},{key:"ignoreEvent",value:function b(a){this.focusOnlyEventStrategy.eventPropagator.ignoreEvent(a);}},{key:"observeIgnoredEvents",value:function b(a){this.focusOnlyEventStrategy.eventPropagator.observeIgnoredEvents(a);}},{key:"closeHangingKeyCombination",value:function c(a,b){this.focusOnlyEventStrategy.closeHangingKeyCombination(a,b);}},{key:"reactAppHistoryWithEvent",value:function d(a,b){var c=this.focusOnlyEventStrategy.eventPropagator.previousPropagation;return c.isForKey(a)&&c.isForEventType(b)?c.isHandled()?EventResponse.handled:c.isIgnoringEvent()?EventResponse.ignored:EventResponse.seen:EventResponse.unseen}},{key:"simulatePendingKeyPressEvents",value:function a(){this.focusOnlyEventStrategy.simulatePendingKeyPressEvents();}},{key:"simulatePendingKeyUpEvents",value:function a(){this.focusOnlyEventStrategy.simulatePendingKeyUpEvents();}},{key:"isGlobalListenersBound",value:function a(){return this.globalEventStrategy.isListenersBound()}},{key:"applicationKeyMap",get:function a(){return [this.globalEventStrategy,this.focusOnlyEventStrategy].reduce(function(a,b){var c=new ApplicationKeyMapBuilder(b.componentTree),d=c.build();return _objectSpread({},a,d)},{})}}]),a}();

function wrapPropInFunction(a,b){return "function"==typeof a?function(c){a(c),b(c);}:b}function getComponentOptions(){return {defaultKeyEvent:Configuration.option("defaultKeyEvent")}}function getEventOptions(){return {ignoreEventsCondition:Configuration.option("ignoreEventsCondition")}}var FocusOnlyComponentManager=function(){function a(b,c){var d=c.keyMap;_classCallCheck(this,a),this._hotKeysOptions=b,this.id=KeyEventManager.getFocusOnlyEventStrategy().registerKeyMap(d),this.childContext={hotKeysParentId:this.id},this._focusTreeIds=[];}return _createClass(a,[{key:"getComponentProps",value:function d(a){var b=this,c={onFocus:wrapPropInFunction(a.onFocus,function(){return b.enableHotKeys(a)}),onBlur:wrapPropInFunction(a.onBlur,function(){return b.disableHotKeys(a)}),tabIndex:Configuration.option("defaultTabIndex")};return this._shouldBindKeyListeners(a)&&(c.onKeyDown=function(a){return b._delegateEventToManager(a,"handleKeyDown")},c.onKeyPress=function(a){return b._delegateEventToManager(a,"handleKeyPress")},c.onKeyUp=function(a){return b._delegateEventToManager(a,"handleKeyUp")}),c}},{key:"_shouldBindKeyListeners",value:function c(a){var b=this._getKeyMap(a);return !isEmpty(b)||a.root}},{key:"addHotKeys",value:function c(a){var b=KeyEventManager.getInstance();b.registerComponentMount(this.id,a);}},{key:"enableHotKeys",value:function c(a){a.onFocus&&a.onFocus.apply(a,arguments);var b=KeyEventManager.getFocusOnlyEventStrategy().enableHotKeys(this.id,this._getKeyMap(a),this._getHandlers(a),getComponentOptions());isUndefined(b)||this._focusTreeIdsPush(b),this._setFocused(!0);}},{key:"updateHotKeys",value:function e(a){var b=KeyEventManager.getFocusOnlyEventStrategy();if(b.reregisterKeyMap(this.id,a.keyMap),this._componentIsFocused()&&(a.allowChanges||!Configuration.option("ignoreKeymapAndHandlerChangesByDefault"))){var c=a.keyMap,d=a.handlers;b.updateEnabledHotKeys(this.focusTreeId,this.id,c,d,getComponentOptions());}}},{key:"disableHotKeys",value:function c(a){a.onBlur&&a.onBlur.apply(a,arguments);var b=KeyEventManager.getFocusOnlyEventStrategy().disableHotKeys(this.focusTreeId,this.id);b||this._focusTreeIdsShift(),this._setFocused(!1);}},{key:"removeKeyMap",value:function c(a){var b=KeyEventManager.getFocusOnlyEventStrategy();b.deregisterKeyMap(this.id),KeyEventManager.getInstance().registerComponentUnmount(),this.disableHotKeys(a);}},{key:"_componentIsFocused",value:function a(){return !0===this._focused}},{key:"_focusTreeIdsPush",value:function b(a){this._focusTreeIds.push(a);}},{key:"_focusTreeIdsShift",value:function a(){this._focusTreeIds.shift();}},{key:"_setFocused",value:function b(a){this._focused=a;}},{key:"_delegateEventToManager",value:function d(a,b){var c=KeyEventManager.getFocusOnlyEventStrategy()[b](a,this.focusTreeId,this.id,getEventOptions());c&&this._focusTreeIdsShift();}},{key:"_mergeWithOptions",value:function c(a,b){return _objectSpread({},this._hotKeysOptions[a]||{},b[a]||{})}},{key:"_getHandlers",value:function b(a){return this._mergeWithOptions("handlers",a)}},{key:"_getKeyMap",value:function b(a){return this._mergeWithOptions("keyMap",a)}},{key:"focusTreeId",get:function a(){return this._focusTreeIds[0]}}]),a}();

var propTypes={keyMap:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),handlers:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),onFocus:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),onBlur:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),allowChanges:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),root:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool)};function provideWithContext(a){return backwardsCompatibleContext(a,{deprecatedAPI:{contextTypes:{hotKeysParentId:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)},childContextTypes:{hotKeysParentId:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)}},newAPI:{contextType:{hotKeysParentId:void 0}}})}function componentFactory(a){var b,c,d=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{};return c=b=function(b){function c(a){var b;return _classCallCheck(this,c),b=_possibleConstructorReturn(this,_getPrototypeOf(c).call(this,a)),b._manager=new FocusOnlyComponentManager(d,a),b}return _inherits(c,b),_createClass(c,[{key:"componentDidMount",value:function a(){this._manager.addHotKeys(this.context.hotKeysParentId);}},{key:"componentDidUpdate",value:function a(){this._manager.updateHotKeys(this.props);}},{key:"componentWillUnmount",value:function a(){this._manager.removeKeyMap(this.props);}},{key:"render",value:function h(){var b=this.props,c=b.keyMap,d=b.handlers,e=b.allowChanges,f=b.root,g=_objectWithoutProperties(b,["keyMap","handlers","allowChanges","root"]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(a,_extends({hotKeys:this._manager.getComponentProps(this.props)},g))}}]),c}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent),_defineProperty(b,"propTypes",propTypes),c}function withHotKeys(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{};return provideWithContext(componentFactory(a,b))}

var HotKeysWrapper=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,_getPrototypeOf(b).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:"render",value:function g(){var a=this.props,b=a.hotKeys,c=a.innerRef,d=a.component,e=_objectWithoutProperties(a,["hotKeys","innerRef","component"]),f=d||Configuration.option("defaultComponent");return react__WEBPACK_IMPORTED_MODULE_0__.createElement(f,_objectSpread({},b,{ref:c},e))}}]),b}(react__WEBPACK_IMPORTED_MODULE_0__.Component),HotKeys=withHotKeys(HotKeysWrapper);HotKeys.propTypes={innerRef:prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),(prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)])};

var GlobalComponentManager=function(){function a(b){_classCallCheck(this,a),this.id=KeyEventManager.getGlobalEventStrategy().registerKeyMap(b),this.childContext={globalHotKeysParentId:this.id};}return _createClass(a,null,[{key:"_getComponentOptions",value:function a(){return {defaultKeyEvent:Configuration.option("defaultKeyEvent")}}},{key:"_getEventOptions",value:function a(){return {ignoreEventsCondition:Configuration.option("ignoreEventsCondition")}}}]),_createClass(a,[{key:"addHotKeys",value:function g(b,c){var d=b.keyMap,e=b.handlers,f=c.globalHotKeysParentId;KeyEventManager.getInstance().registerGlobalComponentMount(this.id,f),KeyEventManager.getGlobalEventStrategy().enableHotKeys(this.id,d,e,a._getComponentOptions(),a._getEventOptions());}},{key:"updateHotKeys",value:function f(b){var c=KeyEventManager.getGlobalEventStrategy();if(c.reregisterKeyMap(this.id,b.keyMap),b.allowChanges||!Configuration.option("ignoreKeymapAndHandlerChangesByDefault")){var d=b.keyMap,e=b.handlers;c.updateEnabledHotKeys(this.id,d,e,a._getComponentOptions(),a._getEventOptions());}}},{key:"removeKeyMap",value:function b(){var a=KeyEventManager.getGlobalEventStrategy();a.deregisterKeyMap(this.id),a.disableHotKeys(this.id),KeyEventManager.getInstance().registerGlobalComponentUnmount();}}]),a}();

var GlobalHotKeys=function(a){function b(a){var c;return _classCallCheck(this,b),c=_possibleConstructorReturn(this,_getPrototypeOf(b).call(this,a)),c._manager=new GlobalComponentManager(a.keyMap),c}return _inherits(b,a),_createClass(b,[{key:"render",value:function a(){return this.props.children||null}},{key:"componentDidMount",value:function a(){this._manager.addHotKeys(this.props,this.context);}},{key:"componentDidUpdate",value:function a(){this._manager.updateHotKeys(this.props);}},{key:"componentWillUnmount",value:function a(){this._manager.removeKeyMap();}}]),b}(react__WEBPACK_IMPORTED_MODULE_0__.Component);_defineProperty(GlobalHotKeys,"propTypes",{keyMap:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),handlers:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),allowChanges:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool)});var GlobalHotKeys$1 = backwardsCompatibleContext(GlobalHotKeys,{deprecatedAPI:{contextTypes:{globalHotKeysParentId:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)},childContextTypes:{globalHotKeysParentId:(prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)}},newAPI:{contextType:{globalHotKeysParentId:void 0}}});

var HotKeysIgnoreOverrideManager=function(){function a(b){_classCallCheck(this,a),this._handleKeyEvent=this._handleKeyEvent.bind(this),this._eventManagerMethod=b;}return _createClass(a,[{key:"getComponentProps",value:function c(a){var b=this;return {onKeyDown:this._handleKeyEvent,onKeyPress:this._handleKeyEvent,onKeyUp:this._handleKeyEvent,onFocus:function c(){return b._reloadDictionaries(a())}}}},{key:"_reloadDictionaries",value:function d(a){var b=a.only,c=a.except;this._onlyDict=keyDictionary(b),this._exceptDict=keyDictionary(c);}},{key:"_handleKeyEvent",value:function b(a){this._shouldIgnoreEvent(a)&&KeyEventManager.getInstance()[this._eventManagerMethod](a);}},{key:"_shouldIgnoreEvent",value:function c(a){var b=a.key;return isEmpty(this._onlyDict)?!!isEmpty(this._exceptDict)||!hasKey(this._exceptDict,b):isEmpty(this._exceptDict)?hasKey(this._onlyDict,b):hasKey(this._onlyDict,b)&&!hasKey(this._exceptDict,b)}}]),a}();function keyDictionary(a){return arrayFrom(a).reduce(function(a,b){var c=standardizeKeyName(b);if(!isValidKey(c))throw new InvalidKeyNameError(b);return dictionaryFrom([resolveAltShiftedAlias,resolveUnaltShiftedAlias,resolveShiftedAlias,resolveUnshiftedAlias,resolveAltedAlias,resolveUnaltedAlias],!0,function(a){return a(c)},a),a},{})}

var propTypes$1={only:prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_1___default().string))]),except:prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_1___default().string))])};function withHotKeysIgnoreOverride(a){var b,c,d=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{only:[],except:[]},e=2<arguments.length?arguments[2]:void 0;return c=b=function(b){function c(a){var b;return _classCallCheck(this,c),b=_possibleConstructorReturn(this,_getPrototypeOf(c).call(this,a)),b._manager=new HotKeysIgnoreOverrideManager(e),b}return _inherits(c,b),_createClass(c,[{key:"render",value:function g(){var b=this,c=this.props,d=c.only,e=c.except,f=_objectWithoutProperties(c,["only","except"]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(a,_extends({hotKeys:this._manager.getComponentProps(function(){return b.props})},f))}}]),c}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent),_defineProperty(b,"propTypes",propTypes$1),_defineProperty(b,"defaultProps",d),c}

function overrideComponent(a){var b,c;return c=b=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,_getPrototypeOf(b).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:"render",value:function e(){var a=this.props,b=a.hotKeys,c=_objectWithoutProperties(a,["hotKeys"]),d=c.component||Configuration.option("defaultComponent");return react__WEBPACK_IMPORTED_MODULE_0__.createElement(d,_objectSpread({},b,c))}}]),b}(react__WEBPACK_IMPORTED_MODULE_0__.Component),_defineProperty(b,"displayName",a),c}

var IgnoreKeys = withHotKeysIgnoreOverride(overrideComponent("IgnoreKeys"),{},"ignoreEvent");

var ObserveKeys = withHotKeysIgnoreOverride(overrideComponent("ObserveKeys"),{},"observeIgnoredEvents");

function withIgnoreKeys(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{only:[],except:[]};return withHotKeysIgnoreOverride(a,b,"ignoreEvent")}

function withObserveKeys(a){var b=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{only:[],except:[]};return withHotKeysIgnoreOverride(a,b,"observeIgnoredEvents")}

function configure(){var a=0<arguments.length&&arguments[0]!==void 0?arguments[0]:{};Configuration.init(a);}

function getApplicationKeyMap(){return KeyEventManager.getInstance().applicationKeyMap}

function recordKeyCombination(a){var b=KeyEventManager.getInstance();return b.addKeyCombinationListener(a)}




/***/ }),

/***/ 49596:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(80849);
} else {}


/***/ }),

/***/ 17020:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(35360);
} else {}


/***/ }),

/***/ 81724:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(78391);
} else {}


/***/ }),

/***/ 63200:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Cd: () => (/* binding */ DebugEngine),
/* harmony export */   I4: () => (/* binding */ styled),
/* harmony export */   K6: () => (/* binding */ withWrapper),
/* harmony export */   Kq: () => (/* binding */ Provider),
/* harmony export */   _F: () => (/* binding */ withStyle),
/* harmony export */   c6: () => (/* binding */ useStyletron),
/* harmony export */   kO: () => (/* binding */ createStyled)
/* harmony export */ });
/* unused harmony exports withTransform, withStyleDeep, autoComposeShallow, autoComposeDeep, staticComposeShallow, staticComposeDeep, dynamicComposeShallow, dynamicComposeDeep, createShallowMergeReducer, createDeepMergeReducer, composeStatic, composeDynamic, createStyledElementComponent, resolveStyle */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81724);
/* harmony import */ var styletron_standard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94740);



/* eslint-env browser */

/* global module */
function addDebugMetadata(instance, stackIndex) {
  var _ref = new Error("stacktrace source"),
      stack = _ref.stack,
      stacktrace = _ref.stacktrace,
      message = _ref.message;

  instance.debug = {
    stackInfo: {
      stack: stack,
      stacktrace: stacktrace,
      message: message
    },
    stackIndex: stackIndex
  };
} // DEVTOOLS SETUP

var setupDevtoolsExtension = function setupDevtoolsExtension() {
  var atomicMap = {};
  var extensionsMap = new Map();
  var stylesMap = new Map();

  var getStyles = function getStyles(className) {
    var styles = {};

    if (typeof className !== "string") {
      return styles;
    }

    if (stylesMap.has(className)) {
      styles.styles = stylesMap.get(className);
      var classList = className.split(" ");

      if (classList.length) {
        var classes = {};
        classList.forEach(function (singleClassName) {
          classes[singleClassName] = atomicMap[singleClassName];
        });
        styles.classes = classes;
      }

      if (extensionsMap.has(className)) {
        var extension = extensionsMap.get(className);
        styles.extends = extension;
      }

      return styles;
    }
  };

  window.__STYLETRON_DEVTOOLS__ = {
    atomicMap: atomicMap,
    extensionsMap: extensionsMap,
    stylesMap: stylesMap,
    getStyles: getStyles
  };
};

var BrowserDebugEngine =
/*#__PURE__*/
function () {
  function BrowserDebugEngine(worker) {
    if (!worker) {
      var workerBlob = new Blob(["importScripts(\"https://unpkg.com/css-to-js-sourcemap-worker@2.0.5/worker.js\")"], {
        type: "application/javascript"
      });
      worker = new Worker(URL.createObjectURL(workerBlob));
      worker.postMessage({
        id: "init_wasm",
        url: "https://unpkg.com/css-to-js-sourcemap-worker@2.0.5/mappings.wasm"
      });
      worker.postMessage({
        id: "set_render_interval",
        interval: 120
      });

      if (false) {}
    }

    this.worker = worker;
    this.counter = 0;

    this.worker.onmessage = function (msg) {
      var _msg$data = msg.data,
          id = _msg$data.id,
          css = _msg$data.css;

      if (id === "render_css" && css) {
        var style = document.createElement("style");
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
      }
    };
  }

  var _proto = BrowserDebugEngine.prototype;

  _proto.debug = function debug(_ref2) {
    var stackIndex = _ref2.stackIndex,
        stackInfo = _ref2.stackInfo;
    var className = "__debug-" + this.counter++;
    this.worker.postMessage({
      id: "add_mapped_class",
      className: className,
      stackInfo: stackInfo,
      stackIndex: stackIndex
    });
    return className;
  };

  return BrowserDebugEngine;
}();

var DebugEngine = BrowserDebugEngine;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* eslint-env browser */

/* eslint-disable no-unused-vars, no-redeclare, no-shadow */
var noopEngine = {
  renderStyle: function renderStyle() {
    return "";
  },
  renderKeyframes: function renderKeyframes() {
    return "";
  },
  renderFontFace: function renderFontFace() {
    return "";
  }
};
var StyletronContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(noopEngine);
var HydrationContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(false);
var DebugEngineContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();
var ThemeContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();

var DevProvider =
/*#__PURE__*/
(/* unused pure expression or super */ null && (function (_React$Component) {
  _inheritsLoose(DevProvider, _React$Component);

  function DevProvider(props) {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.state = {
      hydrating: Boolean(props.debugAfterHydration)
    };
    return _this;
  }

  var _proto = DevProvider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    {
      if (this.state.hydrating === true) {
        this.setState({
          hydrating: false
        });
      }
    }
  };

  _proto.render = function render() {
    return createElement(StyletronContext.Provider, {
      value: this.props.value
    }, createElement(DebugEngineContext.Provider, {
      value: this.props.debug
    }, createElement(HydrationContext.Provider, {
      value: this.state.hydrating
    }, this.props.children)));
  };

  return DevProvider;
}(Component)));

var Provider =  false ? 0 : StyletronContext.Provider;

if (false) {}

function checkNoopEngine(engine) {
  // if no engine provided, we default to no-op, handy for tests
  // however, print a warning in other envs
  if (true) {
    engine === noopEngine && // eslint-disable-next-line no-console
    console.warn( false ? 0 : "Styletron Provider is not set up. Defaulting to no-op.");
  }
}

function useStyletron() {
  var styletronEngine = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StyletronContext);
  var debugEngine = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(DebugEngineContext);
  var hydrating = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HydrationContext);
  checkNoopEngine(styletronEngine);
  var debugClassName = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)("");
  var prevDebugClassNameDeps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([]);
  return [function css(style) {
    var className = (0,styletron_standard__WEBPACK_IMPORTED_MODULE_1__/* .driver */ .Bd)(style, styletronEngine);

    if (true) {
      return className;
    }

    var _ref = new Error("stacktrace source"),
        stack = _ref.stack,
        message = _ref.message;

    var nextDeps = [debugEngine, hydrating];

    if (prevDebugClassNameDeps.current[0] !== nextDeps[0] || prevDebugClassNameDeps.current[1] !== nextDeps[1]) {
      if (debugEngine && !hydrating) {
        debugClassName.current = debugEngine.debug({
          stackInfo: {
            stack: stack,
            message: message
          },
          stackIndex: 1
        });
      }

      prevDebugClassNameDeps.current = nextDeps;
    }

    if (debugClassName.current) {
      return debugClassName.current + " " + className;
    }

    return className;
  }];
}
function createStyled(_ref2) {
  var getInitialStyle$$1 = _ref2.getInitialStyle,
      driver$$1 = _ref2.driver,
      wrapper = _ref2.wrapper;

  function styled(base, styleArg) {
    if (false) {}

    var baseStyletron = {
      reducers: [],
      base: base,
      driver: driver$$1,
      getInitialStyle: getInitialStyle$$1,
      wrapper: wrapper
    };

    if (false) {}

    return createStyledElementComponent(autoComposeShallow(baseStyletron, styleArg));
  }

  return styled;
}
var styled = createStyled({
  getInitialStyle: styletron_standard__WEBPACK_IMPORTED_MODULE_1__/* .getInitialStyle */ .ws,
  driver: styletron_standard__WEBPACK_IMPORTED_MODULE_1__/* .driver */ .Bd,
  wrapper: function wrapper(Component$$1) {
    return Component$$1;
  }
});
function withTransform(component, transformer) {
  var styletron = component.__STYLETRON__;

  if (false) {}

  return createStyledElementComponent(composeDynamic(styletron, transformer));
}
var withStyle = withStyleDeep;
function withStyleDeep(component, styleArg) {
  var styletron = component.__STYLETRON__;

  if (false) {}

  if (false) {} else {
    return createStyledElementComponent(autoComposeDeep(styletron, styleArg));
  }
}
function withWrapper(component, wrapper) {
  var styletron = component.__STYLETRON__;

  if (false) {}

  var composed = {
    getInitialStyle: styletron.getInitialStyle,
    base: styletron.base,
    driver: styletron.driver,
    wrapper: wrapper,
    reducers: styletron.reducers
  };

  if (false) {}

  return createStyledElementComponent(composed);
}
function autoComposeShallow(styletron, styleArg) {
  if (typeof styleArg === "function") {
    return dynamicComposeShallow(styletron, styleArg);
  }

  return staticComposeShallow(styletron, styleArg);
}

function addExtension(composed, component, styleArg) {
  return Object.assign({}, composed, {
    ext: {
      with: styleArg,
      name: component.displayName,
      base: component.__STYLETRON__.base,
      getInitialStyle: component.__STYLETRON__.reducers.length ? component.__STYLETRON__.reducers[0].reducer : component.__STYLETRON__.getInitialStyle
    }
  });
}

function autoComposeDeep(styletron, styleArg) {
  if (typeof styleArg === "function") {
    return dynamicComposeDeep(styletron, styleArg);
  }

  return staticComposeDeep(styletron, styleArg);
}
function staticComposeShallow(styletron, style) {
  return composeStatic(styletron, createShallowMergeReducer(style));
}
function staticComposeDeep(styletron, style) {
  return composeStatic(styletron, createDeepMergeReducer(style));
}
function dynamicComposeShallow(styletron, styleFn) {
  return composeDynamic(styletron, function (style, props) {
    return shallowMerge(style, styleFn(props));
  });
}
function dynamicComposeDeep(styletron, styleFn) {
  return composeDynamic(styletron, function (style, props) {
    return deepMerge(style, styleFn(props));
  });
}
function createShallowMergeReducer(style) {
  return {
    reducer: function reducer(inputStyle) {
      return shallowMerge(inputStyle, style);
    },
    assignmentCommutative: true,
    factory: createShallowMergeReducer,
    style: style
  };
}
function createDeepMergeReducer(style) {
  return {
    reducer: function reducer(inputStyle) {
      return deepMerge(inputStyle, style);
    },
    assignmentCommutative: true,
    factory: createDeepMergeReducer,
    style: style
  };
}
function composeStatic(styletron, reducerContainer) {
  if (styletron.reducers.length === 0) {
    var style = reducerContainer.reducer(styletron.getInitialStyle());
    var result = {
      reducers: styletron.reducers,
      base: styletron.base,
      driver: styletron.driver,
      wrapper: styletron.wrapper,
      getInitialStyle: function getInitialStyle$$1() {
        return style;
      }
    };

    if (false) {}

    return result;
  } else {
    var last = styletron.reducers[0];

    if (last.assignmentCommutative === true && reducerContainer.assignmentCommutative === true) {
      var composed = reducerContainer.reducer(last.style);
      var _result = {
        getInitialStyle: styletron.getInitialStyle,
        base: styletron.base,
        driver: styletron.driver,
        wrapper: styletron.wrapper,
        reducers: [last.factory(composed)].concat(styletron.reducers.slice(1))
      };

      if (false) {}

      return _result;
    }

    return composeDynamic(styletron, reducerContainer.reducer);
  }
}
function composeDynamic(styletron, reducer) {
  var composed = {
    getInitialStyle: styletron.getInitialStyle,
    base: styletron.base,
    driver: styletron.driver,
    wrapper: styletron.wrapper,
    reducers: [{
      assignmentCommutative: false,
      reducer: reducer
    }].concat(styletron.reducers)
  };

  if (false) {}

  return composed;
}
function createStyledElementComponent(styletron) {
  var reducers = styletron.reducers,
      base = styletron.base,
      driver$$1 = styletron.driver,
      wrapper = styletron.wrapper,
      getInitialStyle$$1 = styletron.getInitialStyle,
      ext = styletron.ext;

  if (false) { var debugStackInfo, debugStackIndex; }

  if (false) { var debugClassName; }

  var StyledElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
    var styletron = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StyletronContext);
    var debugEngine = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(DebugEngineContext);
    var hydrating = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HydrationContext);
    checkNoopEngine(styletron);
    var elementProps = omitPrefixedKeys(props);
    var style = resolveStyle(getInitialStyle$$1, reducers, props);

    if (props.$style) {
      if (typeof props.$style === "function") {
        style = deepMerge(style, props.$style(props));
      } else {
        style = deepMerge(style, props.$style);
      }
    }

    var styleClassString = driver$$1(style, styletron);
    var Element = props.$as ? props.$as : base;
    elementProps.className = props.className ? props.className + " " + styleClassString : styleClassString;

    if (false) { var joined; }

    if (false) {}

    if (props.$ref) {
      // eslint-disable-next-line no-console
      console.warn("The prop `$ref` has been deprecated. Use `ref` instead. Refs are now forwarded with React.forwardRef.");
    }

    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Element, _extends({}, elementProps, {
      ref: ref || props.$ref
    }));
  });
  var Wrapped = wrapper(StyledElement);
  Wrapped.__STYLETRON__ = {
    base: base,
    reducers: reducers,
    driver: driver$$1,
    wrapper: wrapper,
    getInitialStyle: getInitialStyle$$1
  };

  if (false) { var displayName; }

  return Wrapped;
} // Utility functions

function resolveStyle(getInitialStyle$$1, reducers, props) {
  var result = getInitialStyle$$1();
  var i = reducers.length;

  while (i--) {
    // Cast to allow passing unused props param in case of static reducer
    var reducer = reducers[i].reducer;
    result = reducer(result, props);
  }

  return result;
}

function isObject(x) {
  return _typeof(x) === "object" && x !== null;
}

function omitPrefixedKeys(source) {
  var result = {};

  for (var key in source) {
    if (key[0] !== "$") {
      result[key] = source[key];
    }
  }

  return result;
}

function deepMerge(a, b) {
  var result = assign({}, a);

  for (var key in b) {
    var val = b[key];

    if (isObject(val) && isObject(a[key])) {
      result[key] = deepMerge(a[key], val);
    } else {
      result[key] = val;
    }
  }

  return result;
}

function shallowMerge(a, b) {
  return assign(assign({}, a), b);
}

function assign(target, source) {
  for (var key in source) {
    target[key] = source[key];
  }

  return target;
}


//# sourceMappingURL=browser.es5.es.js.map


/***/ }),

/***/ 94740:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bd: () => (/* binding */ driver),
/* harmony export */   ws: () => (/* binding */ getInitialStyle)
/* harmony export */ });
/* unused harmony export renderDeclarativeRules */
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Note: $Shape is needed to make polymorphic withStyle refinements work correctly
// It seems functions satisfy this type without $Shape
// See: https://github.com/facebook/flow/issues/6784
//
//
//
//
//
//
function driver(style, styletron) {
  var tx = renderDeclarativeRules(style, styletron);
  return styletron.renderStyle(tx);
}
function getInitialStyle() {
  return {};
}
function renderDeclarativeRules(style, styletron) {
  for (var key in style) {
    var val = style[key];

    if (key === "animationName" && typeof val !== "string") {
      style.animationName = styletron.renderKeyframes(val);
      continue;
    }

    if (key === "fontFamily" && typeof val !== "string") {
      if (Array.isArray(val)) {
        var result = "";

        for (var _iterator = val, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var _font = _ref;

          if (_typeof(_font) === "object") {
            result += styletron.renderFontFace(_font) + ",";
          } else if (typeof _font === "string") {
            result += _font + ",";
          }
        }

        style.fontFamily = result.slice(0, -1);
        continue;
      } else if (val === void 0) {
        continue;
      } else {
        style.fontFamily = styletron.renderFontFace(val);
        continue;
      }
    }

    if (_typeof(val) === "object" && val !== null) {
      renderDeclarativeRules(val, styletron);
    }
  }

  return style;
}


//# sourceMappingURL=browser.es5.es.js.map


/***/ }),

/***/ 96176:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(81724);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 24089:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(96176);
} else {}


/***/ }),

/***/ 65959:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   __addDisposableResource: () => (/* binding */ __addDisposableResource),
/* harmony export */   __assign: () => (/* binding */ __assign),
/* harmony export */   __asyncDelegator: () => (/* binding */ __asyncDelegator),
/* harmony export */   __asyncGenerator: () => (/* binding */ __asyncGenerator),
/* harmony export */   __asyncValues: () => (/* binding */ __asyncValues),
/* harmony export */   __await: () => (/* binding */ __await),
/* harmony export */   __awaiter: () => (/* binding */ __awaiter),
/* harmony export */   __classPrivateFieldGet: () => (/* binding */ __classPrivateFieldGet),
/* harmony export */   __classPrivateFieldIn: () => (/* binding */ __classPrivateFieldIn),
/* harmony export */   __classPrivateFieldSet: () => (/* binding */ __classPrivateFieldSet),
/* harmony export */   __createBinding: () => (/* binding */ __createBinding),
/* harmony export */   __decorate: () => (/* binding */ __decorate),
/* harmony export */   __disposeResources: () => (/* binding */ __disposeResources),
/* harmony export */   __esDecorate: () => (/* binding */ __esDecorate),
/* harmony export */   __exportStar: () => (/* binding */ __exportStar),
/* harmony export */   __extends: () => (/* binding */ __extends),
/* harmony export */   __generator: () => (/* binding */ __generator),
/* harmony export */   __importDefault: () => (/* binding */ __importDefault),
/* harmony export */   __importStar: () => (/* binding */ __importStar),
/* harmony export */   __makeTemplateObject: () => (/* binding */ __makeTemplateObject),
/* harmony export */   __metadata: () => (/* binding */ __metadata),
/* harmony export */   __param: () => (/* binding */ __param),
/* harmony export */   __propKey: () => (/* binding */ __propKey),
/* harmony export */   __read: () => (/* binding */ __read),
/* harmony export */   __rest: () => (/* binding */ __rest),
/* harmony export */   __rewriteRelativeImportExtension: () => (/* binding */ __rewriteRelativeImportExtension),
/* harmony export */   __runInitializers: () => (/* binding */ __runInitializers),
/* harmony export */   __setFunctionName: () => (/* binding */ __setFunctionName),
/* harmony export */   __spread: () => (/* binding */ __spread),
/* harmony export */   __spreadArray: () => (/* binding */ __spreadArray),
/* harmony export */   __spreadArrays: () => (/* binding */ __spreadArrays),
/* harmony export */   __values: () => (/* binding */ __values),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ })

}]);